import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  activity_layout_type_enum: any;
  assignment_activity_type_enum: any;
  assignment_block_type_enum: any;
  block_list_item_type_enum: any;
  block_type_enum: any;
  calendar_event_type_enum: any;
  class_type_enum: any;
  float8: any;
  installment_discounttype_enum: any;
  installment_status_enum: any;
  invoice_status_enum: any;
  jsonb: any;
  lecture_status_enum: any;
  media_type_enum: any;
  numeric: any;
  organization_tier_enum: any;
  organization_type_enum: any;
  payment_paymentmethod_enum: any;
  progression_status_enum: any;
  question_type_enum: any;
  school_fee_type_enum: any;
  timestamptz: any;
  user_block_type_enum: any;
  user_gender_enum: any;
  user_language_enum: any;
  user_lecture_status_enum: any;
  user_role_enum: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type FileOutput = {
  __typename?: 'FileOutput';
  fileUrl: Scalars['String'];
};

export type ImageUpload = {
  __typename?: 'ImageUpload';
  id: Scalars['String'];
  uploadURL: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type ListCognitoOutput = {
  __typename?: 'ListCognitoOutput';
  PaginationToken?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UsersCognitoOutput>>>;
};

export type NavigateLessonOutput = {
  __typename?: 'NavigateLessonOutput';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  checkpoint?: Maybe<Checkpoint>;
  checkpointId?: Maybe<Scalars['Int']>;
  completed?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lesson?: Maybe<Lesson>;
  lessonId?: Maybe<Scalars['Int']>;
  level?: Maybe<Level>;
  levelId?: Maybe<Scalars['Int']>;
  started?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
};


export type ResetCheckpointOutput = {
  __typename?: 'ResetCheckpointOutput';
  id?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type UserCognitoAttributes = {
  __typename?: 'UserCognitoAttributes';
  Name: Scalars['String'];
  Value: Scalars['String'];
};

export type UserProfileOutput = {
  __typename?: 'UserProfileOutput';
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  language: Scalars['String'];
  last_name: Scalars['String'];
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type UsersCognitoOutput = {
  __typename?: 'UsersCognitoOutput';
  Attributes?: Maybe<Array<Maybe<UserCognitoAttributes>>>;
  UserCreateDate?: Maybe<Scalars['Date']>;
  UserLastModifiedDate?: Maybe<Scalars['Date']>;
  UserStatus: Scalars['String'];
  Username: Scalars['String'];
};

/** columns and relationships of "activity" */
export type Activity = {
  __typename?: 'activity';
  /** An array relationship */
  activity_layouts: Array<Activity_Layout>;
  /** An aggregate relationship */
  activity_layouts_aggregate: Activity_Layout_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  /** An object relationship */
  checkpoint?: Maybe<Checkpoint>;
  checkpointId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lesson?: Maybe<Lesson>;
  lessonId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  /** An array relationship */
  user_blocks: Array<User_Block>;
  /** An aggregate relationship */
  user_blocks_aggregate: User_Block_Aggregate;
};


/** columns and relationships of "activity" */
export type ActivityActivity_LayoutsArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityActivity_Layouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityUser_BlocksArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityUser_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};

/** aggregated selection of "activity" */
export type Activity_Aggregate = {
  __typename?: 'activity_aggregate';
  aggregate?: Maybe<Activity_Aggregate_Fields>;
  nodes: Array<Activity>;
};

export type Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Activity_Aggregate_Bool_Exp_Count>;
};

export type Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activity" */
export type Activity_Aggregate_Fields = {
  __typename?: 'activity_aggregate_fields';
  avg?: Maybe<Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Activity_Max_Fields>;
  min?: Maybe<Activity_Min_Fields>;
  stddev?: Maybe<Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Sum_Fields>;
  var_pop?: Maybe<Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Var_Samp_Fields>;
  variance?: Maybe<Activity_Variance_Fields>;
};


/** aggregate fields of "activity" */
export type Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activity" */
export type Activity_Aggregate_Order_By = {
  avg?: InputMaybe<Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activity_Max_Order_By>;
  min?: InputMaybe<Activity_Min_Order_By>;
  stddev?: InputMaybe<Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Activity_Sum_Order_By>;
  var_pop?: InputMaybe<Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "activity" */
export type Activity_Arr_Rel_Insert_Input = {
  data: Array<Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type Activity_Avg_Fields = {
  __typename?: 'activity_avg_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "activity" */
export type Activity_Avg_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "activity". All fields are combined with a logical 'AND'. */
export type Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Bool_Exp>>;
  _not?: InputMaybe<Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Bool_Exp>>;
  activity_layouts?: InputMaybe<Activity_Layout_Bool_Exp>;
  activity_layouts_aggregate?: InputMaybe<Activity_Layout_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  checkpoint?: InputMaybe<Checkpoint_Bool_Exp>;
  checkpointId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lesson?: InputMaybe<Lesson_Bool_Exp>;
  lessonId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_blocks?: InputMaybe<User_Block_Bool_Exp>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "activity" */
export const enum Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_24625a1d6b1b089c8ae206fe467 = 'PK_24625a1d6b1b089c8ae206fe467',
  /** unique or primary key constraint on columns "uid" */
  Uq_804f724ffb008308fe737b45cee = 'UQ_804f724ffb008308fe737b45cee'
};

/** input type for incrementing numeric columns in table "activity" */
export type Activity_Inc_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity" */
export type Activity_Insert_Input = {
  activity_layouts?: InputMaybe<Activity_Layout_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  checkpoint?: InputMaybe<Checkpoint_Obj_Rel_Insert_Input>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lesson?: InputMaybe<Lesson_Obj_Rel_Insert_Input>;
  lessonId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_blocks?: InputMaybe<User_Block_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "activity_layout" */
export type Activity_Layout = {
  __typename?: 'activity_layout';
  /** An object relationship */
  activity: Activity;
  activityId: Scalars['Int'];
  /** An object relationship */
  block?: Maybe<Block>;
  blockId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  isStatic: Scalars['Boolean'];
  order: Scalars['Int'];
  size: Scalars['String'];
  type?: Maybe<Scalars['activity_layout_type_enum']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "activity_layout" */
export type Activity_Layout_Aggregate = {
  __typename?: 'activity_layout_aggregate';
  aggregate?: Maybe<Activity_Layout_Aggregate_Fields>;
  nodes: Array<Activity_Layout>;
};

export type Activity_Layout_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Activity_Layout_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Activity_Layout_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Activity_Layout_Aggregate_Bool_Exp_Count>;
};

export type Activity_Layout_Aggregate_Bool_Exp_Bool_And = {
  arguments: Activity_Layout_Select_Column_Activity_Layout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Layout_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Layout_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Activity_Layout_Select_Column_Activity_Layout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Layout_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Layout_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Activity_Layout_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activity_layout" */
export type Activity_Layout_Aggregate_Fields = {
  __typename?: 'activity_layout_aggregate_fields';
  avg?: Maybe<Activity_Layout_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Activity_Layout_Max_Fields>;
  min?: Maybe<Activity_Layout_Min_Fields>;
  stddev?: Maybe<Activity_Layout_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Layout_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Layout_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Layout_Sum_Fields>;
  var_pop?: Maybe<Activity_Layout_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Layout_Var_Samp_Fields>;
  variance?: Maybe<Activity_Layout_Variance_Fields>;
};


/** aggregate fields of "activity_layout" */
export type Activity_Layout_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activity_layout" */
export type Activity_Layout_Aggregate_Order_By = {
  avg?: InputMaybe<Activity_Layout_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activity_Layout_Max_Order_By>;
  min?: InputMaybe<Activity_Layout_Min_Order_By>;
  stddev?: InputMaybe<Activity_Layout_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Activity_Layout_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Activity_Layout_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Activity_Layout_Sum_Order_By>;
  var_pop?: InputMaybe<Activity_Layout_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Activity_Layout_Var_Samp_Order_By>;
  variance?: InputMaybe<Activity_Layout_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "activity_layout" */
export type Activity_Layout_Arr_Rel_Insert_Input = {
  data: Array<Activity_Layout_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_Layout_On_Conflict>;
};

/** aggregate avg on columns */
export type Activity_Layout_Avg_Fields = {
  __typename?: 'activity_layout_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "activity_layout" */
export type Activity_Layout_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "activity_layout". All fields are combined with a logical 'AND'. */
export type Activity_Layout_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Layout_Bool_Exp>>;
  _not?: InputMaybe<Activity_Layout_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Layout_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  block?: InputMaybe<Block_Bool_Exp>;
  blockId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isStatic?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Activity_Layout_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_layout" */
export const enum Activity_Layout_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_845857592e3dfb85704bad4765a = 'PK_845857592e3dfb85704bad4765a',
  /** unique or primary key constraint on columns "uid" */
  UqCeaf8e2cecbf20c08a5706fca65 = 'UQ_ceaf8e2cecbf20c08a5706fca65'
};

/** input type for incrementing numeric columns in table "activity_layout" */
export type Activity_Layout_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  blockId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity_layout" */
export type Activity_Layout_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['Int']>;
  block?: InputMaybe<Block_Obj_Rel_Insert_Input>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['activity_layout_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Activity_Layout_Max_Fields = {
  __typename?: 'activity_layout_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['activity_layout_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "activity_layout" */
export type Activity_Layout_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activity_Layout_Min_Fields = {
  __typename?: 'activity_layout_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['activity_layout_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "activity_layout" */
export type Activity_Layout_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activity_layout" */
export type Activity_Layout_Mutation_Response = {
  __typename?: 'activity_layout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Layout>;
};

/** on_conflict condition type for table "activity_layout" */
export type Activity_Layout_On_Conflict = {
  constraint: Activity_Layout_Constraint;
  update_columns?: Array<Activity_Layout_Update_Column>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_layout". */
export type Activity_Layout_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityId?: InputMaybe<Order_By>;
  block?: InputMaybe<Block_Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isStatic?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_layout */
export type Activity_Layout_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "activity_layout" */
export const enum Activity_Layout_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  BlockId = 'blockId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsStatic = 'isStatic',
  /** column name */
  Order = 'order',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "activity_layout_aggregate_bool_exp_bool_and_arguments_columns" columns of table "activity_layout" */
export const enum Activity_Layout_Select_Column_Activity_Layout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsStatic = 'isStatic'
};

/** select "activity_layout_aggregate_bool_exp_bool_or_arguments_columns" columns of table "activity_layout" */
export const enum Activity_Layout_Select_Column_Activity_Layout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsStatic = 'isStatic'
};

/** input type for updating data in table "activity_layout" */
export type Activity_Layout_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['activity_layout_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Activity_Layout_Stddev_Fields = {
  __typename?: 'activity_layout_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "activity_layout" */
export type Activity_Layout_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Activity_Layout_Stddev_Pop_Fields = {
  __typename?: 'activity_layout_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "activity_layout" */
export type Activity_Layout_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Activity_Layout_Stddev_Samp_Fields = {
  __typename?: 'activity_layout_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "activity_layout" */
export type Activity_Layout_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "activity_layout" */
export type Activity_Layout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Layout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Layout_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['activity_layout_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Activity_Layout_Sum_Fields = {
  __typename?: 'activity_layout_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "activity_layout" */
export type Activity_Layout_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "activity_layout_type_enum". All fields are combined with logical 'AND'. */
export type Activity_Layout_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _gt?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _gte?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _in?: InputMaybe<Array<Scalars['activity_layout_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _lte?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _neq?: InputMaybe<Scalars['activity_layout_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['activity_layout_type_enum']>>;
};

/** update columns of table "activity_layout" */
export const enum Activity_Layout_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  BlockId = 'blockId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsStatic = 'isStatic',
  /** column name */
  Order = 'order',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Activity_Layout_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Layout_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Layout_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Layout_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Layout_Var_Pop_Fields = {
  __typename?: 'activity_layout_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "activity_layout" */
export type Activity_Layout_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Activity_Layout_Var_Samp_Fields = {
  __typename?: 'activity_layout_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "activity_layout" */
export type Activity_Layout_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Activity_Layout_Variance_Fields = {
  __typename?: 'activity_layout_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "activity_layout" */
export type Activity_Layout_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Activity_Max_Fields = {
  __typename?: 'activity_max_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "activity" */
export type Activity_Max_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activity_Min_Fields = {
  __typename?: 'activity_min_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "activity" */
export type Activity_Min_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activity" */
export type Activity_Mutation_Response = {
  __typename?: 'activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity>;
};

/** input type for inserting object relation for remote table "activity" */
export type Activity_Obj_Rel_Insert_Input = {
  data: Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};

/** on_conflict condition type for table "activity" */
export type Activity_On_Conflict = {
  constraint: Activity_Constraint;
  update_columns?: Array<Activity_Update_Column>;
  where?: InputMaybe<Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "activity". */
export type Activity_Order_By = {
  activity_layouts_aggregate?: InputMaybe<Activity_Layout_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  checkpoint?: InputMaybe<Checkpoint_Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson?: InputMaybe<Lesson_Order_By>;
  lessonId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Order_By>;
};

/** primary key columns input for table: activity */
export type Activity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "activity" */
export const enum Activity_Select_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "activity" */
export const enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "activity" */
export const enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "activity" */
export type Activity_Set_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Activity_Stddev_Fields = {
  __typename?: 'activity_stddev_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "activity" */
export type Activity_Stddev_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Activity_Stddev_Pop_Fields = {
  __typename?: 'activity_stddev_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "activity" */
export type Activity_Stddev_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Activity_Stddev_Samp_Fields = {
  __typename?: 'activity_stddev_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "activity" */
export type Activity_Stddev_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "activity" */
export type Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Stream_Cursor_Value_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Activity_Sum_Fields = {
  __typename?: 'activity_sum_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "activity" */
export type Activity_Sum_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "activity" */
export const enum Activity_Update_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Var_Pop_Fields = {
  __typename?: 'activity_var_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "activity" */
export type Activity_Var_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Activity_Var_Samp_Fields = {
  __typename?: 'activity_var_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "activity" */
export type Activity_Var_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Activity_Variance_Fields = {
  __typename?: 'activity_variance_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "activity" */
export type Activity_Variance_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "assignment" */
export type Assignment = {
  __typename?: 'assignment';
  /** An array relationship */
  assignment_activities: Array<Assignment_Activity>;
  /** An aggregate relationship */
  assignment_activities_aggregate: Assignment_Activity_Aggregate;
  classCourseId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  class_course?: Maybe<Class_Course>;
  created_at: Scalars['timestamptz'];
  deadline?: Maybe<Scalars['timestamptz']>;
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lecture?: Maybe<Lecture>;
  lectureId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_assignments: Array<User_Assignment>;
  /** An aggregate relationship */
  user_assignments_aggregate: User_Assignment_Aggregate;
};


/** columns and relationships of "assignment" */
export type AssignmentAssignment_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentAssignment_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentUser_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentUser_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};

/** columns and relationships of "assignment_activity" */
export type Assignment_Activity = {
  __typename?: 'assignment_activity';
  /** An object relationship */
  assignment: Assignment;
  assignmentId: Scalars['Int'];
  /** An array relationship */
  assignment_blocks: Array<Assignment_Block>;
  /** An aggregate relationship */
  assignment_blocks_aggregate: Assignment_Block_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['assignment_activity_type_enum']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_assignment_activities: Array<User_Assignment_Activity>;
  /** An aggregate relationship */
  user_assignment_activities_aggregate: User_Assignment_Activity_Aggregate;
};


/** columns and relationships of "assignment_activity" */
export type Assignment_ActivityAssignment_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "assignment_activity" */
export type Assignment_ActivityAssignment_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "assignment_activity" */
export type Assignment_ActivityUser_Assignment_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "assignment_activity" */
export type Assignment_ActivityUser_Assignment_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};

/** aggregated selection of "assignment_activity" */
export type Assignment_Activity_Aggregate = {
  __typename?: 'assignment_activity_aggregate';
  aggregate?: Maybe<Assignment_Activity_Aggregate_Fields>;
  nodes: Array<Assignment_Activity>;
};

export type Assignment_Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assignment_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assignment_Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assignment_Activity_Aggregate_Bool_Exp_Count>;
};

export type Assignment_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assignment_Activity_Select_Column_Assignment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assignment_Activity_Select_Column_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignment_activity" */
export type Assignment_Activity_Aggregate_Fields = {
  __typename?: 'assignment_activity_aggregate_fields';
  avg?: Maybe<Assignment_Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assignment_Activity_Max_Fields>;
  min?: Maybe<Assignment_Activity_Min_Fields>;
  stddev?: Maybe<Assignment_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Activity_Sum_Fields>;
  var_pop?: Maybe<Assignment_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Activity_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Activity_Variance_Fields>;
};


/** aggregate fields of "assignment_activity" */
export type Assignment_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assignment_activity" */
export type Assignment_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Activity_Max_Order_By>;
  min?: InputMaybe<Assignment_Activity_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignment_activity" */
export type Assignment_Activity_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Activity_Avg_Fields = {
  __typename?: 'assignment_activity_avg_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assignment_activity" */
export type Assignment_Activity_Avg_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment_activity". All fields are combined with a logical 'AND'. */
export type Assignment_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Activity_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Activity_Bool_Exp>>;
  assignment?: InputMaybe<Assignment_Bool_Exp>;
  assignmentId?: InputMaybe<Int_Comparison_Exp>;
  assignment_blocks?: InputMaybe<Assignment_Block_Bool_Exp>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Assignment_Activity_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "assignment_activity" */
export const enum Assignment_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_952ff39cb2ccef1f234ffc5e93b = 'PK_952ff39cb2ccef1f234ffc5e93b',
  /** unique or primary key constraint on columns "uid" */
  Uq_2afce672d808259fc4cf98b40e6 = 'UQ_2afce672d808259fc4cf98b40e6'
};

/** input type for incrementing numeric columns in table "assignment_activity" */
export type Assignment_Activity_Inc_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "assignment_activity" */
export type Assignment_Activity_Insert_Input = {
  assignment?: InputMaybe<Assignment_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['Int']>;
  assignment_blocks?: InputMaybe<Assignment_Block_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assignment_Activity_Max_Fields = {
  __typename?: 'assignment_activity_max_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['assignment_activity_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assignment_activity" */
export type Assignment_Activity_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Activity_Min_Fields = {
  __typename?: 'assignment_activity_min_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['assignment_activity_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assignment_activity" */
export type Assignment_Activity_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_activity" */
export type Assignment_Activity_Mutation_Response = {
  __typename?: 'assignment_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Activity>;
};

/** input type for inserting object relation for remote table "assignment_activity" */
export type Assignment_Activity_Obj_Rel_Insert_Input = {
  data: Assignment_Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Activity_On_Conflict>;
};

/** on_conflict condition type for table "assignment_activity" */
export type Assignment_Activity_On_Conflict = {
  constraint: Assignment_Activity_Constraint;
  update_columns?: Array<Assignment_Activity_Update_Column>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_activity". */
export type Assignment_Activity_Order_By = {
  assignment?: InputMaybe<Assignment_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Order_By>;
};

/** primary key columns input for table: assignment_activity */
export type Assignment_Activity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "assignment_activity" */
export const enum Assignment_Activity_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "assignment_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assignment_activity" */
export const enum Assignment_Activity_Select_Column_Assignment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "assignment_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assignment_activity" */
export const enum Assignment_Activity_Select_Column_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "assignment_activity" */
export type Assignment_Activity_Set_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Assignment_Activity_Stddev_Fields = {
  __typename?: 'assignment_activity_stddev_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assignment_activity" */
export type Assignment_Activity_Stddev_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Activity_Stddev_Pop_Fields = {
  __typename?: 'assignment_activity_stddev_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assignment_activity" */
export type Assignment_Activity_Stddev_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Activity_Stddev_Samp_Fields = {
  __typename?: 'assignment_activity_stddev_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assignment_activity" */
export type Assignment_Activity_Stddev_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment_activity" */
export type Assignment_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Activity_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Assignment_Activity_Sum_Fields = {
  __typename?: 'assignment_activity_sum_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "assignment_activity" */
export type Assignment_Activity_Sum_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "assignment_activity_type_enum". All fields are combined with logical 'AND'. */
export type Assignment_Activity_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _gt?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _gte?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _in?: InputMaybe<Array<Scalars['assignment_activity_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _lte?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _neq?: InputMaybe<Scalars['assignment_activity_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['assignment_activity_type_enum']>>;
};

/** update columns of table "assignment_activity" */
export const enum Assignment_Activity_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Assignment_Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Activity_Var_Pop_Fields = {
  __typename?: 'assignment_activity_var_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assignment_activity" */
export type Assignment_Activity_Var_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Activity_Var_Samp_Fields = {
  __typename?: 'assignment_activity_var_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assignment_activity" */
export type Assignment_Activity_Var_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Activity_Variance_Fields = {
  __typename?: 'assignment_activity_variance_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assignment_activity" */
export type Assignment_Activity_Variance_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregated selection of "assignment" */
export type Assignment_Aggregate = {
  __typename?: 'assignment_aggregate';
  aggregate?: Maybe<Assignment_Aggregate_Fields>;
  nodes: Array<Assignment>;
};

export type Assignment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assignment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assignment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assignment_Aggregate_Bool_Exp_Count>;
};

export type Assignment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assignment_Select_Column_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assignment_Select_Column_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignment" */
export type Assignment_Aggregate_Fields = {
  __typename?: 'assignment_aggregate_fields';
  avg?: Maybe<Assignment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assignment_Max_Fields>;
  min?: Maybe<Assignment_Min_Fields>;
  stddev?: Maybe<Assignment_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Sum_Fields>;
  var_pop?: Maybe<Assignment_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Variance_Fields>;
};


/** aggregate fields of "assignment" */
export type Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assignment" */
export type Assignment_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Max_Order_By>;
  min?: InputMaybe<Assignment_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignment" */
export type Assignment_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Avg_Fields = {
  __typename?: 'assignment_avg_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assignment" */
export type Assignment_Avg_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "assignment_block" */
export type Assignment_Block = {
  __typename?: 'assignment_block';
  activityId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  assignment_activity?: Maybe<Assignment_Activity>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  quiz?: Maybe<Quiz>;
  quizId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  text?: Maybe<Text>;
  textId?: Maybe<Scalars['Int']>;
  type: Scalars['assignment_block_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "assignment_block" */
export type Assignment_BlockConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "assignment_block" */
export type Assignment_Block_Aggregate = {
  __typename?: 'assignment_block_aggregate';
  aggregate?: Maybe<Assignment_Block_Aggregate_Fields>;
  nodes: Array<Assignment_Block>;
};

export type Assignment_Block_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp_Count>;
};

export type Assignment_Block_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assignment_Block_Select_Column_Assignment_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Block_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assignment_Block_Select_Column_Assignment_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignment_Block_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assignment_Block_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignment_block" */
export type Assignment_Block_Aggregate_Fields = {
  __typename?: 'assignment_block_aggregate_fields';
  avg?: Maybe<Assignment_Block_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assignment_Block_Max_Fields>;
  min?: Maybe<Assignment_Block_Min_Fields>;
  stddev?: Maybe<Assignment_Block_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Block_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Block_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Block_Sum_Fields>;
  var_pop?: Maybe<Assignment_Block_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Block_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Block_Variance_Fields>;
};


/** aggregate fields of "assignment_block" */
export type Assignment_Block_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assignment_block" */
export type Assignment_Block_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Block_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Block_Max_Order_By>;
  min?: InputMaybe<Assignment_Block_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Block_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Block_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Block_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Block_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Block_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Block_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Block_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Assignment_Block_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "assignment_block" */
export type Assignment_Block_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Block_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Block_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Block_Avg_Fields = {
  __typename?: 'assignment_block_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assignment_block" */
export type Assignment_Block_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment_block". All fields are combined with a logical 'AND'. */
export type Assignment_Block_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Block_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Block_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Block_Bool_Exp>>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  assignment_activity?: InputMaybe<Assignment_Activity_Bool_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  mediaId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  quiz?: InputMaybe<Quiz_Bool_Exp>;
  quizId?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<Text_Bool_Exp>;
  textId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Assignment_Block_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_block" */
export const enum Assignment_Block_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_54ca6f7fb96310cd8610c33cfb9 = 'PK_54ca6f7fb96310cd8610c33cfb9',
  /** unique or primary key constraint on columns "uid" */
  UqFfbd233f37ea5982e8abff79155 = 'UQ_ffbd233f37ea5982e8abff79155'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Assignment_Block_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Assignment_Block_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Assignment_Block_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "assignment_block" */
export type Assignment_Block_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "assignment_block" */
export type Assignment_Block_Insert_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  assignment_activity?: InputMaybe<Assignment_Activity_Obj_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quiz?: InputMaybe<Quiz_Obj_Rel_Insert_Input>;
  quizId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Text_Obj_Rel_Insert_Input>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Assignment_Block_Max_Fields = {
  __typename?: 'assignment_block_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['assignment_block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assignment_block" */
export type Assignment_Block_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Block_Min_Fields = {
  __typename?: 'assignment_block_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['assignment_block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assignment_block" */
export type Assignment_Block_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_block" */
export type Assignment_Block_Mutation_Response = {
  __typename?: 'assignment_block_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Block>;
};

/** on_conflict condition type for table "assignment_block" */
export type Assignment_Block_On_Conflict = {
  constraint: Assignment_Block_Constraint;
  update_columns?: Array<Assignment_Block_Update_Column>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_block". */
export type Assignment_Block_Order_By = {
  activityId?: InputMaybe<Order_By>;
  assignment_activity?: InputMaybe<Assignment_Activity_Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quiz?: InputMaybe<Quiz_Order_By>;
  quizId?: InputMaybe<Order_By>;
  text?: InputMaybe<Text_Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_block */
export type Assignment_Block_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Assignment_Block_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "assignment_block" */
export const enum Assignment_Block_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "assignment_block_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assignment_block" */
export const enum Assignment_Block_Select_Column_Assignment_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "assignment_block_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assignment_block" */
export const enum Assignment_Block_Select_Column_Assignment_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "assignment_block" */
export type Assignment_Block_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Assignment_Block_Stddev_Fields = {
  __typename?: 'assignment_block_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assignment_block" */
export type Assignment_Block_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Block_Stddev_Pop_Fields = {
  __typename?: 'assignment_block_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assignment_block" */
export type Assignment_Block_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Block_Stddev_Samp_Fields = {
  __typename?: 'assignment_block_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assignment_block" */
export type Assignment_Block_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment_block" */
export type Assignment_Block_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Block_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Block_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['assignment_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Assignment_Block_Sum_Fields = {
  __typename?: 'assignment_block_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "assignment_block" */
export type Assignment_Block_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "assignment_block_type_enum". All fields are combined with logical 'AND'. */
export type Assignment_Block_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _gt?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _gte?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _in?: InputMaybe<Array<Scalars['assignment_block_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _lte?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _neq?: InputMaybe<Scalars['assignment_block_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['assignment_block_type_enum']>>;
};

/** update columns of table "assignment_block" */
export const enum Assignment_Block_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Assignment_Block_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Assignment_Block_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Assignment_Block_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Assignment_Block_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Assignment_Block_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Block_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Assignment_Block_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Block_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Block_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Block_Var_Pop_Fields = {
  __typename?: 'assignment_block_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assignment_block" */
export type Assignment_Block_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Block_Var_Samp_Fields = {
  __typename?: 'assignment_block_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assignment_block" */
export type Assignment_Block_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Block_Variance_Fields = {
  __typename?: 'assignment_block_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assignment_block" */
export type Assignment_Block_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment". All fields are combined with a logical 'AND'. */
export type Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Bool_Exp>>;
  assignment_activities?: InputMaybe<Assignment_Activity_Bool_Exp>;
  assignment_activities_aggregate?: InputMaybe<Assignment_Activity_Aggregate_Bool_Exp>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deadline?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lecture?: InputMaybe<Lecture_Bool_Exp>;
  lectureId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_assignments?: InputMaybe<User_Assignment_Bool_Exp>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "assignment" */
export const enum Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_43c2f5a3859f54cedafb270f37e = 'PK_43c2f5a3859f54cedafb270f37e',
  /** unique or primary key constraint on columns "uid" */
  Uq_713c4a9d6f2b75c730ff983afc3 = 'UQ_713c4a9d6f2b75c730ff983afc3'
};

/** input type for incrementing numeric columns in table "assignment" */
export type Assignment_Inc_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "assignment" */
export type Assignment_Insert_Input = {
  assignment_activities?: InputMaybe<Assignment_Activity_Arr_Rel_Insert_Input>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lecture?: InputMaybe<Lecture_Obj_Rel_Insert_Input>;
  lectureId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_assignments?: InputMaybe<User_Assignment_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assignment_Max_Fields = {
  __typename?: 'assignment_max_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deadline?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assignment" */
export type Assignment_Max_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Min_Fields = {
  __typename?: 'assignment_min_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deadline?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assignment" */
export type Assignment_Min_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment" */
export type Assignment_Mutation_Response = {
  __typename?: 'assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment>;
};

/** input type for inserting object relation for remote table "assignment" */
export type Assignment_Obj_Rel_Insert_Input = {
  data: Assignment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};

/** on_conflict condition type for table "assignment" */
export type Assignment_On_Conflict = {
  constraint: Assignment_Constraint;
  update_columns?: Array<Assignment_Update_Column>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment". */
export type Assignment_Order_By = {
  assignment_activities_aggregate?: InputMaybe<Assignment_Activity_Aggregate_Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lecture?: InputMaybe<Lecture_Order_By>;
  lectureId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Order_By>;
};

/** primary key columns input for table: assignment */
export type Assignment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "assignment" */
export const enum Assignment_Select_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Published = 'published',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "assignment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assignment" */
export const enum Assignment_Select_Column_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Published = 'published'
};

/** select "assignment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assignment" */
export const enum Assignment_Select_Column_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Published = 'published'
};

/** input type for updating data in table "assignment" */
export type Assignment_Set_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Assignment_Stddev_Fields = {
  __typename?: 'assignment_stddev_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assignment" */
export type Assignment_Stddev_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Stddev_Pop_Fields = {
  __typename?: 'assignment_stddev_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assignment" */
export type Assignment_Stddev_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Stddev_Samp_Fields = {
  __typename?: 'assignment_stddev_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assignment" */
export type Assignment_Stddev_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment" */
export type Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Stream_Cursor_Value_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Assignment_Sum_Fields = {
  __typename?: 'assignment_sum_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "assignment" */
export type Assignment_Sum_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "assignment" */
export const enum Assignment_Update_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Published = 'published',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Assignment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Var_Pop_Fields = {
  __typename?: 'assignment_var_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assignment" */
export type Assignment_Var_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Var_Samp_Fields = {
  __typename?: 'assignment_var_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assignment" */
export type Assignment_Var_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Variance_Fields = {
  __typename?: 'assignment_variance_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assignment" */
export type Assignment_Variance_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "block" */
export type Block = {
  __typename?: 'block';
  /** An object relationship */
  activity: Activity;
  activityId: Scalars['Int'];
  /** An array relationship */
  activity_layouts: Array<Activity_Layout>;
  /** An aggregate relationship */
  activity_layouts_aggregate: Activity_Layout_Aggregate;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  dnd?: Maybe<Dnd>;
  dndId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  fill_blank?: Maybe<Fill_Blank>;
  id: Scalars['Int'];
  /** An object relationship */
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  quiz?: Maybe<Quiz>;
  quizId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  text?: Maybe<Text>;
  textId?: Maybe<Scalars['Int']>;
  type: Scalars['block_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_blocks: Array<User_Block>;
  /** An aggregate relationship */
  user_blocks_aggregate: User_Block_Aggregate;
};


/** columns and relationships of "block" */
export type BlockActivity_LayoutsArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


/** columns and relationships of "block" */
export type BlockActivity_Layouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


/** columns and relationships of "block" */
export type BlockConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "block" */
export type BlockUser_BlocksArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


/** columns and relationships of "block" */
export type BlockUser_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};

/** aggregated selection of "block" */
export type Block_Aggregate = {
  __typename?: 'block_aggregate';
  aggregate?: Maybe<Block_Aggregate_Fields>;
  nodes: Array<Block>;
};

export type Block_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Block_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Block_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Block_Aggregate_Bool_Exp_Count>;
};

export type Block_Aggregate_Bool_Exp_Bool_And = {
  arguments: Block_Select_Column_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Block_Select_Column_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "block" */
export type Block_Aggregate_Fields = {
  __typename?: 'block_aggregate_fields';
  avg?: Maybe<Block_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Block_Max_Fields>;
  min?: Maybe<Block_Min_Fields>;
  stddev?: Maybe<Block_Stddev_Fields>;
  stddev_pop?: Maybe<Block_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Block_Stddev_Samp_Fields>;
  sum?: Maybe<Block_Sum_Fields>;
  var_pop?: Maybe<Block_Var_Pop_Fields>;
  var_samp?: Maybe<Block_Var_Samp_Fields>;
  variance?: Maybe<Block_Variance_Fields>;
};


/** aggregate fields of "block" */
export type Block_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "block" */
export type Block_Aggregate_Order_By = {
  avg?: InputMaybe<Block_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Block_Max_Order_By>;
  min?: InputMaybe<Block_Min_Order_By>;
  stddev?: InputMaybe<Block_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Block_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Block_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Block_Sum_Order_By>;
  var_pop?: InputMaybe<Block_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Block_Var_Samp_Order_By>;
  variance?: InputMaybe<Block_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Block_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "block" */
export type Block_Arr_Rel_Insert_Input = {
  data: Array<Block_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_On_Conflict>;
};

/** aggregate avg on columns */
export type Block_Avg_Fields = {
  __typename?: 'block_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "block" */
export type Block_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "block". All fields are combined with a logical 'AND'. */
export type Block_Bool_Exp = {
  _and?: InputMaybe<Array<Block_Bool_Exp>>;
  _not?: InputMaybe<Block_Bool_Exp>;
  _or?: InputMaybe<Array<Block_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  activity_layouts?: InputMaybe<Activity_Layout_Bool_Exp>;
  activity_layouts_aggregate?: InputMaybe<Activity_Layout_Aggregate_Bool_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  dnd?: InputMaybe<Dnd_Bool_Exp>;
  dndId?: InputMaybe<Int_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  fileId?: InputMaybe<Int_Comparison_Exp>;
  fillBlankId?: InputMaybe<Int_Comparison_Exp>;
  fill_blank?: InputMaybe<Fill_Blank_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  mediaId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  quiz?: InputMaybe<Quiz_Bool_Exp>;
  quizId?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<Text_Bool_Exp>;
  textId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Block_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_blocks?: InputMaybe<User_Block_Bool_Exp>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "block" */
export const enum Block_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkD0925763efb591c2e2ffb267572 = 'PK_d0925763efb591c2e2ffb267572',
  /** unique or primary key constraint on columns "uid" */
  UqB0819d896379aa6d3e83b487246 = 'UQ_b0819d896379aa6d3e83b487246'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Block_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Block_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Block_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "block" */
export type Block_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "block" */
export type Block_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['Int']>;
  activity_layouts?: InputMaybe<Activity_Layout_Arr_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dnd?: InputMaybe<Dnd_Obj_Rel_Insert_Input>;
  dndId?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  fill_blank?: InputMaybe<Fill_Blank_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quiz?: InputMaybe<Quiz_Obj_Rel_Insert_Input>;
  quizId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Text_Obj_Rel_Insert_Input>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_blocks?: InputMaybe<User_Block_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "block_list_item" */
export type Block_List_Item = {
  __typename?: 'block_list_item';
  /** An array relationship */
  block_list_item_workspaces: Array<Block_List_Item_Workspace>;
  /** An aggregate relationship */
  block_list_item_workspaces_aggregate: Block_List_Item_Workspace_Aggregate;
  /** An array relationship */
  block_tags: Array<Block_Tag>;
  /** An aggregate relationship */
  block_tags_aggregate: Block_Tag_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  dnd?: Maybe<Dnd>;
  dndId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  fill_blank?: Maybe<Fill_Blank>;
  id: Scalars['Int'];
  /** An object relationship */
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  /** An object relationship */
  quiz?: Maybe<Quiz>;
  quizId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  text?: Maybe<Text>;
  textId?: Maybe<Scalars['Int']>;
  type: Scalars['block_list_item_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "block_list_item" */
export type Block_List_ItemBlock_List_Item_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


/** columns and relationships of "block_list_item" */
export type Block_List_ItemBlock_List_Item_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


/** columns and relationships of "block_list_item" */
export type Block_List_ItemBlock_TagsArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


/** columns and relationships of "block_list_item" */
export type Block_List_ItemBlock_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};

/** aggregated selection of "block_list_item" */
export type Block_List_Item_Aggregate = {
  __typename?: 'block_list_item_aggregate';
  aggregate?: Maybe<Block_List_Item_Aggregate_Fields>;
  nodes: Array<Block_List_Item>;
};

export type Block_List_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp_Count>;
};

export type Block_List_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Block_List_Item_Select_Column_Block_List_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_List_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Block_List_Item_Select_Column_Block_List_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_List_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "block_list_item" */
export type Block_List_Item_Aggregate_Fields = {
  __typename?: 'block_list_item_aggregate_fields';
  avg?: Maybe<Block_List_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Block_List_Item_Max_Fields>;
  min?: Maybe<Block_List_Item_Min_Fields>;
  stddev?: Maybe<Block_List_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Block_List_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Block_List_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Block_List_Item_Sum_Fields>;
  var_pop?: Maybe<Block_List_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Block_List_Item_Var_Samp_Fields>;
  variance?: Maybe<Block_List_Item_Variance_Fields>;
};


/** aggregate fields of "block_list_item" */
export type Block_List_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "block_list_item" */
export type Block_List_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Block_List_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Block_List_Item_Max_Order_By>;
  min?: InputMaybe<Block_List_Item_Min_Order_By>;
  stddev?: InputMaybe<Block_List_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Block_List_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Block_List_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Block_List_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Block_List_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Block_List_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Block_List_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "block_list_item" */
export type Block_List_Item_Arr_Rel_Insert_Input = {
  data: Array<Block_List_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_List_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Block_List_Item_Avg_Fields = {
  __typename?: 'block_list_item_avg_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "block_list_item" */
export type Block_List_Item_Avg_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "block_list_item". All fields are combined with a logical 'AND'. */
export type Block_List_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Block_List_Item_Bool_Exp>>;
  _not?: InputMaybe<Block_List_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Block_List_Item_Bool_Exp>>;
  block_list_item_workspaces?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  block_list_item_workspaces_aggregate?: InputMaybe<Block_List_Item_Workspace_Aggregate_Bool_Exp>;
  block_tags?: InputMaybe<Block_Tag_Bool_Exp>;
  block_tags_aggregate?: InputMaybe<Block_Tag_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  dnd?: InputMaybe<Dnd_Bool_Exp>;
  dndId?: InputMaybe<Int_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  fileId?: InputMaybe<Int_Comparison_Exp>;
  fillBlankId?: InputMaybe<Int_Comparison_Exp>;
  fill_blank?: InputMaybe<Fill_Blank_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  mediaId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  quiz?: InputMaybe<Quiz_Bool_Exp>;
  quizId?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<Text_Bool_Exp>;
  textId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Block_List_Item_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "block_list_item" */
export const enum Block_List_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkA627279811007b297cbbc811cd8 = 'PK_a627279811007b297cbbc811cd8',
  /** unique or primary key constraint on columns "uid" */
  UqE0043914976c1ed00f3b3f31f69 = 'UQ_e0043914976c1ed00f3b3f31f69'
};

/** input type for incrementing numeric columns in table "block_list_item" */
export type Block_List_Item_Inc_Input = {
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "block_list_item" */
export type Block_List_Item_Insert_Input = {
  block_list_item_workspaces?: InputMaybe<Block_List_Item_Workspace_Arr_Rel_Insert_Input>;
  block_tags?: InputMaybe<Block_Tag_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dnd?: InputMaybe<Dnd_Obj_Rel_Insert_Input>;
  dndId?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  fill_blank?: InputMaybe<Fill_Blank_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quiz?: InputMaybe<Quiz_Obj_Rel_Insert_Input>;
  quizId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Text_Obj_Rel_Insert_Input>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_list_item_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Block_List_Item_Max_Fields = {
  __typename?: 'block_list_item_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['block_list_item_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "block_list_item" */
export type Block_List_Item_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Block_List_Item_Min_Fields = {
  __typename?: 'block_list_item_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['block_list_item_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "block_list_item" */
export type Block_List_Item_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "block_list_item" */
export type Block_List_Item_Mutation_Response = {
  __typename?: 'block_list_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Block_List_Item>;
};

/** input type for inserting object relation for remote table "block_list_item" */
export type Block_List_Item_Obj_Rel_Insert_Input = {
  data: Block_List_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_List_Item_On_Conflict>;
};

/** on_conflict condition type for table "block_list_item" */
export type Block_List_Item_On_Conflict = {
  constraint: Block_List_Item_Constraint;
  update_columns?: Array<Block_List_Item_Update_Column>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "block_list_item". */
export type Block_List_Item_Order_By = {
  block_list_item_workspaces_aggregate?: InputMaybe<Block_List_Item_Workspace_Aggregate_Order_By>;
  block_tags_aggregate?: InputMaybe<Block_Tag_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  dnd?: InputMaybe<Dnd_Order_By>;
  dndId?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  fill_blank?: InputMaybe<Fill_Blank_Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quiz?: InputMaybe<Quiz_Order_By>;
  quizId?: InputMaybe<Order_By>;
  text?: InputMaybe<Text_Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: block_list_item */
export type Block_List_Item_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "block_list_item" */
export const enum Block_List_Item_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "block_list_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "block_list_item" */
export const enum Block_List_Item_Select_Column_Block_List_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "block_list_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "block_list_item" */
export const enum Block_List_Item_Select_Column_Block_List_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "block_list_item" */
export type Block_List_Item_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_list_item_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Block_List_Item_Stddev_Fields = {
  __typename?: 'block_list_item_stddev_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "block_list_item" */
export type Block_List_Item_Stddev_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Block_List_Item_Stddev_Pop_Fields = {
  __typename?: 'block_list_item_stddev_pop_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "block_list_item" */
export type Block_List_Item_Stddev_Pop_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Block_List_Item_Stddev_Samp_Fields = {
  __typename?: 'block_list_item_stddev_samp_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "block_list_item" */
export type Block_List_Item_Stddev_Samp_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "block_list_item" */
export type Block_List_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Block_List_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Block_List_Item_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_list_item_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Block_List_Item_Sum_Fields = {
  __typename?: 'block_list_item_sum_fields';
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "block_list_item" */
export type Block_List_Item_Sum_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "block_list_item_type_enum". All fields are combined with logical 'AND'. */
export type Block_List_Item_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _gt?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _gte?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _in?: InputMaybe<Array<Scalars['block_list_item_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _lte?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _neq?: InputMaybe<Scalars['block_list_item_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['block_list_item_type_enum']>>;
};

/** update columns of table "block_list_item" */
export const enum Block_List_Item_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Block_List_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Block_List_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Block_List_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Block_List_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Block_List_Item_Var_Pop_Fields = {
  __typename?: 'block_list_item_var_pop_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "block_list_item" */
export type Block_List_Item_Var_Pop_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Block_List_Item_Var_Samp_Fields = {
  __typename?: 'block_list_item_var_samp_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "block_list_item" */
export type Block_List_Item_Var_Samp_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Block_List_Item_Variance_Fields = {
  __typename?: 'block_list_item_variance_fields';
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "block_list_item" */
export type Block_List_Item_Variance_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** columns and relationships of "block_list_item_workspace" */
export type Block_List_Item_Workspace = {
  __typename?: 'block_list_item_workspace';
  blockListItemId: Scalars['Int'];
  /** An object relationship */
  block_list_item: Block_List_Item;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspace;
  workspaceId: Scalars['Int'];
};

/** aggregated selection of "block_list_item_workspace" */
export type Block_List_Item_Workspace_Aggregate = {
  __typename?: 'block_list_item_workspace_aggregate';
  aggregate?: Maybe<Block_List_Item_Workspace_Aggregate_Fields>;
  nodes: Array<Block_List_Item_Workspace>;
};

export type Block_List_Item_Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Block_List_Item_Workspace_Aggregate_Bool_Exp_Count>;
};

export type Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: Block_List_Item_Workspace_Select_Column_Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Block_List_Item_Workspace_Select_Column_Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_List_Item_Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "block_list_item_workspace" */
export type Block_List_Item_Workspace_Aggregate_Fields = {
  __typename?: 'block_list_item_workspace_aggregate_fields';
  avg?: Maybe<Block_List_Item_Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Block_List_Item_Workspace_Max_Fields>;
  min?: Maybe<Block_List_Item_Workspace_Min_Fields>;
  stddev?: Maybe<Block_List_Item_Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<Block_List_Item_Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Block_List_Item_Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<Block_List_Item_Workspace_Sum_Fields>;
  var_pop?: Maybe<Block_List_Item_Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<Block_List_Item_Workspace_Var_Samp_Fields>;
  variance?: Maybe<Block_List_Item_Workspace_Variance_Fields>;
};


/** aggregate fields of "block_list_item_workspace" */
export type Block_List_Item_Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<Block_List_Item_Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Block_List_Item_Workspace_Max_Order_By>;
  min?: InputMaybe<Block_List_Item_Workspace_Min_Order_By>;
  stddev?: InputMaybe<Block_List_Item_Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Block_List_Item_Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Block_List_Item_Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Block_List_Item_Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<Block_List_Item_Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Block_List_Item_Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<Block_List_Item_Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Arr_Rel_Insert_Input = {
  data: Array<Block_List_Item_Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_List_Item_Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type Block_List_Item_Workspace_Avg_Fields = {
  __typename?: 'block_list_item_workspace_avg_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Avg_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "block_list_item_workspace". All fields are combined with a logical 'AND'. */
export type Block_List_Item_Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<Block_List_Item_Workspace_Bool_Exp>>;
  _not?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<Block_List_Item_Workspace_Bool_Exp>>;
  blockListItemId?: InputMaybe<Int_Comparison_Exp>;
  block_list_item?: InputMaybe<Block_List_Item_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workspace?: InputMaybe<Workspace_Bool_Exp>;
  workspaceId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "block_list_item_workspace" */
export const enum Block_List_Item_Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_853bdcc58438baaaba457f24ec7 = 'PK_853bdcc58438baaaba457f24ec7',
  /** unique or primary key constraint on columns "uid" */
  Uq_71ab2f8ce1fef7ebed55f543300 = 'UQ_71ab2f8ce1fef7ebed55f543300',
  /** unique or primary key constraint on columns "blockListItemId", "workspaceId" */
  IndexBlockListItemWorkspace = 'index_block_list_item_workspace'
};

/** input type for incrementing numeric columns in table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Inc_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Insert_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  block_list_item?: InputMaybe<Block_List_Item_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace?: InputMaybe<Workspace_Obj_Rel_Insert_Input>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Block_List_Item_Workspace_Max_Fields = {
  __typename?: 'block_list_item_workspace_max_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Max_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Block_List_Item_Workspace_Min_Fields = {
  __typename?: 'block_list_item_workspace_min_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Min_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Mutation_Response = {
  __typename?: 'block_list_item_workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Block_List_Item_Workspace>;
};

/** on_conflict condition type for table "block_list_item_workspace" */
export type Block_List_Item_Workspace_On_Conflict = {
  constraint: Block_List_Item_Workspace_Constraint;
  update_columns?: Array<Block_List_Item_Workspace_Update_Column>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "block_list_item_workspace". */
export type Block_List_Item_Workspace_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  block_list_item?: InputMaybe<Block_List_Item_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspace?: InputMaybe<Workspace_Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: block_list_item_workspace */
export type Block_List_Item_Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "block_list_item_workspace" */
export const enum Block_List_Item_Workspace_Select_Column {
  /** column name */
  BlockListItemId = 'blockListItemId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

/** select "block_list_item_workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "block_list_item_workspace" */
export const enum Block_List_Item_Workspace_Select_Column_Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "block_list_item_workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "block_list_item_workspace" */
export const enum Block_List_Item_Workspace_Select_Column_Block_List_Item_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Set_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Block_List_Item_Workspace_Stddev_Fields = {
  __typename?: 'block_list_item_workspace_stddev_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Stddev_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Block_List_Item_Workspace_Stddev_Pop_Fields = {
  __typename?: 'block_list_item_workspace_stddev_pop_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Stddev_Pop_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Block_List_Item_Workspace_Stddev_Samp_Fields = {
  __typename?: 'block_list_item_workspace_stddev_samp_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Stddev_Samp_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Block_List_Item_Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Block_List_Item_Workspace_Stream_Cursor_Value_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Block_List_Item_Workspace_Sum_Fields = {
  __typename?: 'block_list_item_workspace_sum_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Sum_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** update columns of table "block_list_item_workspace" */
export const enum Block_List_Item_Workspace_Update_Column {
  /** column name */
  BlockListItemId = 'blockListItemId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

export type Block_List_Item_Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Block_List_Item_Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Block_List_Item_Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: Block_List_Item_Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Block_List_Item_Workspace_Var_Pop_Fields = {
  __typename?: 'block_list_item_workspace_var_pop_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Var_Pop_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Block_List_Item_Workspace_Var_Samp_Fields = {
  __typename?: 'block_list_item_workspace_var_samp_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Var_Samp_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Block_List_Item_Workspace_Variance_Fields = {
  __typename?: 'block_list_item_workspace_variance_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "block_list_item_workspace" */
export type Block_List_Item_Workspace_Variance_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Block_Max_Fields = {
  __typename?: 'block_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "block" */
export type Block_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Block_Min_Fields = {
  __typename?: 'block_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "block" */
export type Block_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "block" */
export type Block_Mutation_Response = {
  __typename?: 'block_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Block>;
};

/** input type for inserting object relation for remote table "block" */
export type Block_Obj_Rel_Insert_Input = {
  data: Block_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_On_Conflict>;
};

/** on_conflict condition type for table "block" */
export type Block_On_Conflict = {
  constraint: Block_Constraint;
  update_columns?: Array<Block_Update_Column>;
  where?: InputMaybe<Block_Bool_Exp>;
};

/** Ordering options when selecting data from "block". */
export type Block_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityId?: InputMaybe<Order_By>;
  activity_layouts_aggregate?: InputMaybe<Activity_Layout_Aggregate_Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  dnd?: InputMaybe<Dnd_Order_By>;
  dndId?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  fill_blank?: InputMaybe<Fill_Blank_Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  mediaId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quiz?: InputMaybe<Quiz_Order_By>;
  quizId?: InputMaybe<Order_By>;
  text?: InputMaybe<Text_Order_By>;
  textId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Order_By>;
};

/** primary key columns input for table: block */
export type Block_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Block_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "block" */
export const enum Block_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "block_aggregate_bool_exp_bool_and_arguments_columns" columns of table "block" */
export const enum Block_Select_Column_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "block_aggregate_bool_exp_bool_or_arguments_columns" columns of table "block" */
export const enum Block_Select_Column_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "block" */
export type Block_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Block_Stddev_Fields = {
  __typename?: 'block_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "block" */
export type Block_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Block_Stddev_Pop_Fields = {
  __typename?: 'block_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "block" */
export type Block_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Block_Stddev_Samp_Fields = {
  __typename?: 'block_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "block" */
export type Block_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "block" */
export type Block_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Block_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Block_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  textId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Block_Sum_Fields = {
  __typename?: 'block_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  dndId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  textId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "block" */
export type Block_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** columns and relationships of "block_tag" */
export type Block_Tag = {
  __typename?: 'block_tag';
  blockListItemId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  block_list_item?: Maybe<Block_List_Item>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['Int']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "block_tag" */
export type Block_Tag_Aggregate = {
  __typename?: 'block_tag_aggregate';
  aggregate?: Maybe<Block_Tag_Aggregate_Fields>;
  nodes: Array<Block_Tag>;
};

export type Block_Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Block_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Block_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Block_Tag_Aggregate_Bool_Exp_Count>;
};

export type Block_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Block_Tag_Select_Column_Block_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Block_Tag_Select_Column_Block_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Block_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Block_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Block_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "block_tag" */
export type Block_Tag_Aggregate_Fields = {
  __typename?: 'block_tag_aggregate_fields';
  avg?: Maybe<Block_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Block_Tag_Max_Fields>;
  min?: Maybe<Block_Tag_Min_Fields>;
  stddev?: Maybe<Block_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Block_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Block_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Block_Tag_Sum_Fields>;
  var_pop?: Maybe<Block_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Block_Tag_Var_Samp_Fields>;
  variance?: Maybe<Block_Tag_Variance_Fields>;
};


/** aggregate fields of "block_tag" */
export type Block_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Block_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "block_tag" */
export type Block_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Block_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Block_Tag_Max_Order_By>;
  min?: InputMaybe<Block_Tag_Min_Order_By>;
  stddev?: InputMaybe<Block_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Block_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Block_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Block_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Block_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Block_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Block_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "block_tag" */
export type Block_Tag_Arr_Rel_Insert_Input = {
  data: Array<Block_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Block_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Block_Tag_Avg_Fields = {
  __typename?: 'block_tag_avg_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "block_tag" */
export type Block_Tag_Avg_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "block_tag". All fields are combined with a logical 'AND'. */
export type Block_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Block_Tag_Bool_Exp>>;
  _not?: InputMaybe<Block_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Block_Tag_Bool_Exp>>;
  blockListItemId?: InputMaybe<Int_Comparison_Exp>;
  block_list_item?: InputMaybe<Block_List_Item_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tagId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "block_tag" */
export const enum Block_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkA3ebbbe5a9fc692decaa58540ae = 'PK_a3ebbbe5a9fc692decaa58540ae',
  /** unique or primary key constraint on columns "uid" */
  Uq_42423eeddfe604e7c5404d5cc46 = 'UQ_42423eeddfe604e7c5404d5cc46'
};

/** input type for incrementing numeric columns in table "block_tag" */
export type Block_Tag_Inc_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "block_tag" */
export type Block_Tag_Insert_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  block_list_item?: InputMaybe<Block_List_Item_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Block_Tag_Max_Fields = {
  __typename?: 'block_tag_max_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "block_tag" */
export type Block_Tag_Max_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Block_Tag_Min_Fields = {
  __typename?: 'block_tag_min_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "block_tag" */
export type Block_Tag_Min_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "block_tag" */
export type Block_Tag_Mutation_Response = {
  __typename?: 'block_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Block_Tag>;
};

/** on_conflict condition type for table "block_tag" */
export type Block_Tag_On_Conflict = {
  constraint: Block_Tag_Constraint;
  update_columns?: Array<Block_Tag_Update_Column>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "block_tag". */
export type Block_Tag_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  block_list_item?: InputMaybe<Block_List_Item_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: block_tag */
export type Block_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "block_tag" */
export const enum Block_Tag_Select_Column {
  /** column name */
  BlockListItemId = 'blockListItemId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "block_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "block_tag" */
export const enum Block_Tag_Select_Column_Block_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "block_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "block_tag" */
export const enum Block_Tag_Select_Column_Block_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "block_tag" */
export type Block_Tag_Set_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Block_Tag_Stddev_Fields = {
  __typename?: 'block_tag_stddev_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "block_tag" */
export type Block_Tag_Stddev_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Block_Tag_Stddev_Pop_Fields = {
  __typename?: 'block_tag_stddev_pop_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "block_tag" */
export type Block_Tag_Stddev_Pop_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Block_Tag_Stddev_Samp_Fields = {
  __typename?: 'block_tag_stddev_samp_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "block_tag" */
export type Block_Tag_Stddev_Samp_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "block_tag" */
export type Block_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Block_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Block_Tag_Stream_Cursor_Value_Input = {
  blockListItemId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Block_Tag_Sum_Fields = {
  __typename?: 'block_tag_sum_fields';
  blockListItemId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "block_tag" */
export type Block_Tag_Sum_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** update columns of table "block_tag" */
export const enum Block_Tag_Update_Column {
  /** column name */
  BlockListItemId = 'blockListItemId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Block_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Block_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Block_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Block_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Block_Tag_Var_Pop_Fields = {
  __typename?: 'block_tag_var_pop_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "block_tag" */
export type Block_Tag_Var_Pop_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Block_Tag_Var_Samp_Fields = {
  __typename?: 'block_tag_var_samp_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "block_tag" */
export type Block_Tag_Var_Samp_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Block_Tag_Variance_Fields = {
  __typename?: 'block_tag_variance_fields';
  blockListItemId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "block_tag" */
export type Block_Tag_Variance_Order_By = {
  blockListItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "block_type_enum". All fields are combined with logical 'AND'. */
export type Block_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['block_type_enum']>;
  _gt?: InputMaybe<Scalars['block_type_enum']>;
  _gte?: InputMaybe<Scalars['block_type_enum']>;
  _in?: InputMaybe<Array<Scalars['block_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['block_type_enum']>;
  _lte?: InputMaybe<Scalars['block_type_enum']>;
  _neq?: InputMaybe<Scalars['block_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['block_type_enum']>>;
};

/** update columns of table "block" */
export const enum Block_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  TextId = 'textId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Block_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Block_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Block_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Block_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Block_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Block_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Block_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Block_Set_Input>;
  /** filter the rows which have to be updated */
  where: Block_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Block_Var_Pop_Fields = {
  __typename?: 'block_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "block" */
export type Block_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Block_Var_Samp_Fields = {
  __typename?: 'block_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "block" */
export type Block_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Block_Variance_Fields = {
  __typename?: 'block_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  textId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "block" */
export type Block_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  textId?: InputMaybe<Order_By>;
};

/** columns and relationships of "calendar_event" */
export type Calendar_Event = {
  __typename?: 'calendar_event';
  /** An object relationship */
  calendar_event_recurring_event?: Maybe<Recurring_Event>;
  color?: Maybe<Scalars['String']>;
  createdById: Scalars['Int'];
  /** An object relationship */
  createdByUser: User;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  duration: Scalars['Int'];
  end_date: Scalars['timestamptz'];
  /** An object relationship */
  event_classroom?: Maybe<Event_Classroom>;
  /** An array relationship */
  event_classrooms: Array<Event_Classroom>;
  /** An aggregate relationship */
  event_classrooms_aggregate: Event_Classroom_Aggregate;
  id: Scalars['Int'];
  isVirtual: Scalars['Boolean'];
  /** An object relationship */
  lecture?: Maybe<Lecture>;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  recurringEventId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  recurring_event_calendar_event?: Maybe<Recurring_Event>;
  start_date: Scalars['timestamptz'];
  title: Scalars['String'];
  type: Scalars['calendar_event_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_events: Array<User_Event>;
  /** An aggregate relationship */
  user_events_aggregate: User_Event_Aggregate;
};


/** columns and relationships of "calendar_event" */
export type Calendar_EventEvent_ClassroomsArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


/** columns and relationships of "calendar_event" */
export type Calendar_EventEvent_Classrooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


/** columns and relationships of "calendar_event" */
export type Calendar_EventUser_EventsArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


/** columns and relationships of "calendar_event" */
export type Calendar_EventUser_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};

/** aggregated selection of "calendar_event" */
export type Calendar_Event_Aggregate = {
  __typename?: 'calendar_event_aggregate';
  aggregate?: Maybe<Calendar_Event_Aggregate_Fields>;
  nodes: Array<Calendar_Event>;
};

export type Calendar_Event_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp_Count>;
};

export type Calendar_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: Calendar_Event_Select_Column_Calendar_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Calendar_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Calendar_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Calendar_Event_Select_Column_Calendar_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Calendar_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Calendar_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Calendar_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calendar_event" */
export type Calendar_Event_Aggregate_Fields = {
  __typename?: 'calendar_event_aggregate_fields';
  avg?: Maybe<Calendar_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Calendar_Event_Max_Fields>;
  min?: Maybe<Calendar_Event_Min_Fields>;
  stddev?: Maybe<Calendar_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Calendar_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Calendar_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Calendar_Event_Sum_Fields>;
  var_pop?: Maybe<Calendar_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Calendar_Event_Var_Samp_Fields>;
  variance?: Maybe<Calendar_Event_Variance_Fields>;
};


/** aggregate fields of "calendar_event" */
export type Calendar_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "calendar_event" */
export type Calendar_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Calendar_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Calendar_Event_Max_Order_By>;
  min?: InputMaybe<Calendar_Event_Min_Order_By>;
  stddev?: InputMaybe<Calendar_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Calendar_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Calendar_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Calendar_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Calendar_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Calendar_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Calendar_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "calendar_event" */
export type Calendar_Event_Arr_Rel_Insert_Input = {
  data: Array<Calendar_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Calendar_Event_On_Conflict>;
};

/** aggregate avg on columns */
export type Calendar_Event_Avg_Fields = {
  __typename?: 'calendar_event_avg_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "calendar_event" */
export type Calendar_Event_Avg_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "calendar_event". All fields are combined with a logical 'AND'. */
export type Calendar_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Calendar_Event_Bool_Exp>>;
  _not?: InputMaybe<Calendar_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Calendar_Event_Bool_Exp>>;
  calendar_event_recurring_event?: InputMaybe<Recurring_Event_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_classroom?: InputMaybe<Event_Classroom_Bool_Exp>;
  event_classrooms?: InputMaybe<Event_Classroom_Bool_Exp>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isVirtual?: InputMaybe<Boolean_Comparison_Exp>;
  lecture?: InputMaybe<Lecture_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  recurringEventId?: InputMaybe<Int_Comparison_Exp>;
  recurring_event_calendar_event?: InputMaybe<Recurring_Event_Bool_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Calendar_Event_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_events?: InputMaybe<User_Event_Bool_Exp>;
  user_events_aggregate?: InputMaybe<User_Event_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "calendar_event" */
export const enum Calendar_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_176fe24e6eb48c3fef696c7641f = 'PK_176fe24e6eb48c3fef696c7641f',
  /** unique or primary key constraint on columns "uid" */
  Uq_6fdc6431c71314b87fae301922f = 'UQ_6fdc6431c71314b87fae301922f'
};

/** input type for incrementing numeric columns in table "calendar_event" */
export type Calendar_Event_Inc_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recurringEventId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "calendar_event" */
export type Calendar_Event_Insert_Input = {
  calendar_event_recurring_event?: InputMaybe<Recurring_Event_Obj_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  event_classroom?: InputMaybe<Event_Classroom_Obj_Rel_Insert_Input>;
  event_classrooms?: InputMaybe<Event_Classroom_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  lecture?: InputMaybe<Lecture_Obj_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recurringEventId?: InputMaybe<Scalars['Int']>;
  recurring_event_calendar_event?: InputMaybe<Recurring_Event_Obj_Rel_Insert_Input>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['calendar_event_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_events?: InputMaybe<User_Event_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Calendar_Event_Max_Fields = {
  __typename?: 'calendar_event_max_fields';
  color?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  recurringEventId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['calendar_event_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "calendar_event" */
export type Calendar_Event_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Calendar_Event_Min_Fields = {
  __typename?: 'calendar_event_min_fields';
  color?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  recurringEventId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['calendar_event_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "calendar_event" */
export type Calendar_Event_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "calendar_event" */
export type Calendar_Event_Mutation_Response = {
  __typename?: 'calendar_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Calendar_Event>;
};

/** input type for inserting object relation for remote table "calendar_event" */
export type Calendar_Event_Obj_Rel_Insert_Input = {
  data: Calendar_Event_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Calendar_Event_On_Conflict>;
};

/** on_conflict condition type for table "calendar_event" */
export type Calendar_Event_On_Conflict = {
  constraint: Calendar_Event_Constraint;
  update_columns?: Array<Calendar_Event_Update_Column>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "calendar_event". */
export type Calendar_Event_Order_By = {
  calendar_event_recurring_event?: InputMaybe<Recurring_Event_Order_By>;
  color?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  event_classroom?: InputMaybe<Event_Classroom_Order_By>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isVirtual?: InputMaybe<Order_By>;
  lecture?: InputMaybe<Lecture_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
  recurring_event_calendar_event?: InputMaybe<Recurring_Event_Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_events_aggregate?: InputMaybe<User_Event_Aggregate_Order_By>;
};

/** primary key columns input for table: calendar_event */
export type Calendar_Event_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "calendar_event" */
export const enum Calendar_Event_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsVirtual = 'isVirtual',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  RecurringEventId = 'recurringEventId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "calendar_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "calendar_event" */
export const enum Calendar_Event_Select_Column_Calendar_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsVirtual = 'isVirtual'
};

/** select "calendar_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "calendar_event" */
export const enum Calendar_Event_Select_Column_Calendar_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsVirtual = 'isVirtual'
};

/** input type for updating data in table "calendar_event" */
export type Calendar_Event_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recurringEventId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['calendar_event_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Calendar_Event_Stddev_Fields = {
  __typename?: 'calendar_event_stddev_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "calendar_event" */
export type Calendar_Event_Stddev_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Calendar_Event_Stddev_Pop_Fields = {
  __typename?: 'calendar_event_stddev_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "calendar_event" */
export type Calendar_Event_Stddev_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Calendar_Event_Stddev_Samp_Fields = {
  __typename?: 'calendar_event_stddev_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "calendar_event" */
export type Calendar_Event_Stddev_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "calendar_event" */
export type Calendar_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Calendar_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Calendar_Event_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recurringEventId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['calendar_event_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Calendar_Event_Sum_Fields = {
  __typename?: 'calendar_event_sum_fields';
  createdById?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  recurringEventId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "calendar_event" */
export type Calendar_Event_Sum_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "calendar_event_type_enum". All fields are combined with logical 'AND'. */
export type Calendar_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _gt?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _gte?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _in?: InputMaybe<Array<Scalars['calendar_event_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _lte?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _neq?: InputMaybe<Scalars['calendar_event_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['calendar_event_type_enum']>>;
};

/** update columns of table "calendar_event" */
export const enum Calendar_Event_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsVirtual = 'isVirtual',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  RecurringEventId = 'recurringEventId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Calendar_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Calendar_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Calendar_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Calendar_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Calendar_Event_Var_Pop_Fields = {
  __typename?: 'calendar_event_var_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "calendar_event" */
export type Calendar_Event_Var_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Calendar_Event_Var_Samp_Fields = {
  __typename?: 'calendar_event_var_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "calendar_event" */
export type Calendar_Event_Var_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Calendar_Event_Variance_Fields = {
  __typename?: 'calendar_event_variance_fields';
  createdById?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  recurringEventId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "calendar_event" */
export type Calendar_Event_Variance_Order_By = {
  createdById?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  recurringEventId?: InputMaybe<Order_By>;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  /** An array relationship */
  course_categories: Array<Course_Category>;
  /** An aggregate relationship */
  course_categories_aggregate: Course_Category_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "category" */
export type CategoryCourse_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryCourse_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};

/** aggregated selection of "category" */
export type Category_Aggregate = {
  __typename?: 'category_aggregate';
  aggregate?: Maybe<Category_Aggregate_Fields>;
  nodes: Array<Category>;
};

export type Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Category_Aggregate_Bool_Exp_Count>;
};

export type Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Category_Select_Column_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Category_Select_Column_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "category" */
export type Category_Aggregate_Fields = {
  __typename?: 'category_aggregate_fields';
  avg?: Maybe<Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Category_Max_Fields>;
  min?: Maybe<Category_Min_Fields>;
  stddev?: Maybe<Category_Stddev_Fields>;
  stddev_pop?: Maybe<Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Category_Stddev_Samp_Fields>;
  sum?: Maybe<Category_Sum_Fields>;
  var_pop?: Maybe<Category_Var_Pop_Fields>;
  var_samp?: Maybe<Category_Var_Samp_Fields>;
  variance?: Maybe<Category_Variance_Fields>;
};


/** aggregate fields of "category" */
export type Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category" */
export type Category_Aggregate_Order_By = {
  avg?: InputMaybe<Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Category_Max_Order_By>;
  min?: InputMaybe<Category_Min_Order_By>;
  stddev?: InputMaybe<Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Category_Sum_Order_By>;
  var_pop?: InputMaybe<Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "category" */
export type Category_Arr_Rel_Insert_Input = {
  data: Array<Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Category_Avg_Fields = {
  __typename?: 'category_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "category" */
export type Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type Category_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Bool_Exp>>;
  _not?: InputMaybe<Category_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Bool_Exp>>;
  course_categories?: InputMaybe<Course_Category_Bool_Exp>;
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "category" */
export const enum Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_9c4e4a89e3674fc9f382d733f03 = 'PK_9c4e4a89e3674fc9f382d733f03',
  /** unique or primary key constraint on columns "uid" */
  Uq_5c1f57a0b653c037769afd964f2 = 'UQ_5c1f57a0b653c037769afd964f2'
};

/** input type for incrementing numeric columns in table "category" */
export type Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "category" */
export type Category_Insert_Input = {
  course_categories?: InputMaybe<Course_Category_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Category_Max_Fields = {
  __typename?: 'category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "category" */
export type Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Category_Min_Fields = {
  __typename?: 'category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "category" */
export type Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category" */
export type Category_Mutation_Response = {
  __typename?: 'category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category>;
};

/** input type for inserting object relation for remote table "category" */
export type Category_Obj_Rel_Insert_Input = {
  data: Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** on_conflict condition type for table "category" */
export type Category_On_Conflict = {
  constraint: Category_Constraint;
  update_columns?: Array<Category_Update_Column>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** Ordering options when selecting data from "category". */
export type Category_Order_By = {
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category */
export type Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "category" */
export const enum Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "category" */
export const enum Category_Select_Column_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "category" */
export const enum Category_Select_Column_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "category" */
export type Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Category_Stddev_Fields = {
  __typename?: 'category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "category" */
export type Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Category_Stddev_Pop_Fields = {
  __typename?: 'category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "category" */
export type Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Category_Stddev_Samp_Fields = {
  __typename?: 'category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "category" */
export type Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "category" */
export type Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Category_Sum_Fields = {
  __typename?: 'category_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "category" */
export type Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "category" */
export const enum Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Category_Var_Pop_Fields = {
  __typename?: 'category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "category" */
export type Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Category_Var_Samp_Fields = {
  __typename?: 'category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "category" */
export type Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Category_Variance_Fields = {
  __typename?: 'category_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "category" */
export type Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "checkpoint" */
export type Checkpoint = {
  __typename?: 'checkpoint';
  /** An array relationship */
  activities: Array<Activity>;
  /** An aggregate relationship */
  activities_aggregate: Activity_Aggregate;
  /** An array relationship */
  checkpoint_attempts: Array<Checkpoint_Attempts>;
  /** An aggregate relationship */
  checkpoint_attempts_aggregate: Checkpoint_Attempts_Aggregate;
  coefficient: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lesson?: Maybe<Lesson>;
  lessonId?: Maybe<Scalars['Int']>;
  max_attempts: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_checkpoints: Array<User_Checkpoint>;
  /** An aggregate relationship */
  user_checkpoints_aggregate: User_Checkpoint_Aggregate;
};


/** columns and relationships of "checkpoint" */
export type CheckpointActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointCheckpoint_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointCheckpoint_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointUser_CheckpointsArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


/** columns and relationships of "checkpoint" */
export type CheckpointUser_Checkpoints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};

/** aggregated selection of "checkpoint" */
export type Checkpoint_Aggregate = {
  __typename?: 'checkpoint_aggregate';
  aggregate?: Maybe<Checkpoint_Aggregate_Fields>;
  nodes: Array<Checkpoint>;
};

export type Checkpoint_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Checkpoint_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Checkpoint_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Checkpoint_Aggregate_Bool_Exp_Count>;
};

export type Checkpoint_Aggregate_Bool_Exp_Bool_And = {
  arguments: Checkpoint_Select_Column_Checkpoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkpoint_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Checkpoint_Select_Column_Checkpoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkpoint_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Checkpoint_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkpoint" */
export type Checkpoint_Aggregate_Fields = {
  __typename?: 'checkpoint_aggregate_fields';
  avg?: Maybe<Checkpoint_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Checkpoint_Max_Fields>;
  min?: Maybe<Checkpoint_Min_Fields>;
  stddev?: Maybe<Checkpoint_Stddev_Fields>;
  stddev_pop?: Maybe<Checkpoint_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Checkpoint_Stddev_Samp_Fields>;
  sum?: Maybe<Checkpoint_Sum_Fields>;
  var_pop?: Maybe<Checkpoint_Var_Pop_Fields>;
  var_samp?: Maybe<Checkpoint_Var_Samp_Fields>;
  variance?: Maybe<Checkpoint_Variance_Fields>;
};


/** aggregate fields of "checkpoint" */
export type Checkpoint_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Checkpoint_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkpoint" */
export type Checkpoint_Aggregate_Order_By = {
  avg?: InputMaybe<Checkpoint_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Checkpoint_Max_Order_By>;
  min?: InputMaybe<Checkpoint_Min_Order_By>;
  stddev?: InputMaybe<Checkpoint_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Checkpoint_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Checkpoint_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Checkpoint_Sum_Order_By>;
  var_pop?: InputMaybe<Checkpoint_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Checkpoint_Var_Samp_Order_By>;
  variance?: InputMaybe<Checkpoint_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "checkpoint" */
export type Checkpoint_Arr_Rel_Insert_Input = {
  data: Array<Checkpoint_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Checkpoint_On_Conflict>;
};

/** columns and relationships of "checkpoint_attempts" */
export type Checkpoint_Attempts = {
  __typename?: 'checkpoint_attempts';
  /** An object relationship */
  checkpoint?: Maybe<Checkpoint>;
  checkpointId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "checkpoint_attempts" */
export type Checkpoint_Attempts_Aggregate = {
  __typename?: 'checkpoint_attempts_aggregate';
  aggregate?: Maybe<Checkpoint_Attempts_Aggregate_Fields>;
  nodes: Array<Checkpoint_Attempts>;
};

export type Checkpoint_Attempts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Checkpoint_Attempts_Aggregate_Bool_Exp_Count>;
};

export type Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Checkpoint_Attempts_Select_Column_Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Checkpoint_Attempts_Select_Column_Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkpoint_Attempts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkpoint_attempts" */
export type Checkpoint_Attempts_Aggregate_Fields = {
  __typename?: 'checkpoint_attempts_aggregate_fields';
  avg?: Maybe<Checkpoint_Attempts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Checkpoint_Attempts_Max_Fields>;
  min?: Maybe<Checkpoint_Attempts_Min_Fields>;
  stddev?: Maybe<Checkpoint_Attempts_Stddev_Fields>;
  stddev_pop?: Maybe<Checkpoint_Attempts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Checkpoint_Attempts_Stddev_Samp_Fields>;
  sum?: Maybe<Checkpoint_Attempts_Sum_Fields>;
  var_pop?: Maybe<Checkpoint_Attempts_Var_Pop_Fields>;
  var_samp?: Maybe<Checkpoint_Attempts_Var_Samp_Fields>;
  variance?: Maybe<Checkpoint_Attempts_Variance_Fields>;
};


/** aggregate fields of "checkpoint_attempts" */
export type Checkpoint_Attempts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Aggregate_Order_By = {
  avg?: InputMaybe<Checkpoint_Attempts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Checkpoint_Attempts_Max_Order_By>;
  min?: InputMaybe<Checkpoint_Attempts_Min_Order_By>;
  stddev?: InputMaybe<Checkpoint_Attempts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Checkpoint_Attempts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Checkpoint_Attempts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Checkpoint_Attempts_Sum_Order_By>;
  var_pop?: InputMaybe<Checkpoint_Attempts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Checkpoint_Attempts_Var_Samp_Order_By>;
  variance?: InputMaybe<Checkpoint_Attempts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "checkpoint_attempts" */
export type Checkpoint_Attempts_Arr_Rel_Insert_Input = {
  data: Array<Checkpoint_Attempts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Checkpoint_Attempts_On_Conflict>;
};

/** aggregate avg on columns */
export type Checkpoint_Attempts_Avg_Fields = {
  __typename?: 'checkpoint_attempts_avg_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Avg_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "checkpoint_attempts". All fields are combined with a logical 'AND'. */
export type Checkpoint_Attempts_Bool_Exp = {
  _and?: InputMaybe<Array<Checkpoint_Attempts_Bool_Exp>>;
  _not?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  _or?: InputMaybe<Array<Checkpoint_Attempts_Bool_Exp>>;
  checkpoint?: InputMaybe<Checkpoint_Bool_Exp>;
  checkpointId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkpoint_attempts" */
export const enum Checkpoint_Attempts_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDd050bc4db11acb573826020561 = 'PK_dd050bc4db11acb573826020561',
  /** unique or primary key constraint on columns "uid" */
  Uq_6b1ec04c652bd3d45e8561700d1 = 'UQ_6b1ec04c652bd3d45e8561700d1'
};

/** input type for incrementing numeric columns in table "checkpoint_attempts" */
export type Checkpoint_Attempts_Inc_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "checkpoint_attempts" */
export type Checkpoint_Attempts_Insert_Input = {
  checkpoint?: InputMaybe<Checkpoint_Obj_Rel_Insert_Input>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Checkpoint_Attempts_Max_Fields = {
  __typename?: 'checkpoint_attempts_max_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Max_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Checkpoint_Attempts_Min_Fields = {
  __typename?: 'checkpoint_attempts_min_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Min_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkpoint_attempts" */
export type Checkpoint_Attempts_Mutation_Response = {
  __typename?: 'checkpoint_attempts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Checkpoint_Attempts>;
};

/** on_conflict condition type for table "checkpoint_attempts" */
export type Checkpoint_Attempts_On_Conflict = {
  constraint: Checkpoint_Attempts_Constraint;
  update_columns?: Array<Checkpoint_Attempts_Update_Column>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};

/** Ordering options when selecting data from "checkpoint_attempts". */
export type Checkpoint_Attempts_Order_By = {
  checkpoint?: InputMaybe<Checkpoint_Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkpoint_attempts */
export type Checkpoint_Attempts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "checkpoint_attempts" */
export const enum Checkpoint_Attempts_Select_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "checkpoint_attempts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "checkpoint_attempts" */
export const enum Checkpoint_Attempts_Select_Column_Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "checkpoint_attempts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "checkpoint_attempts" */
export const enum Checkpoint_Attempts_Select_Column_Checkpoint_Attempts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "checkpoint_attempts" */
export type Checkpoint_Attempts_Set_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Checkpoint_Attempts_Stddev_Fields = {
  __typename?: 'checkpoint_attempts_stddev_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Stddev_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Checkpoint_Attempts_Stddev_Pop_Fields = {
  __typename?: 'checkpoint_attempts_stddev_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Stddev_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Checkpoint_Attempts_Stddev_Samp_Fields = {
  __typename?: 'checkpoint_attempts_stddev_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Stddev_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "checkpoint_attempts" */
export type Checkpoint_Attempts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Checkpoint_Attempts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Checkpoint_Attempts_Stream_Cursor_Value_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Checkpoint_Attempts_Sum_Fields = {
  __typename?: 'checkpoint_attempts_sum_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Sum_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "checkpoint_attempts" */
export const enum Checkpoint_Attempts_Update_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type Checkpoint_Attempts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Checkpoint_Attempts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Checkpoint_Attempts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Checkpoint_Attempts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Checkpoint_Attempts_Var_Pop_Fields = {
  __typename?: 'checkpoint_attempts_var_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Var_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Checkpoint_Attempts_Var_Samp_Fields = {
  __typename?: 'checkpoint_attempts_var_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Var_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Checkpoint_Attempts_Variance_Fields = {
  __typename?: 'checkpoint_attempts_variance_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "checkpoint_attempts" */
export type Checkpoint_Attempts_Variance_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Checkpoint_Avg_Fields = {
  __typename?: 'checkpoint_avg_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "checkpoint" */
export type Checkpoint_Avg_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "checkpoint". All fields are combined with a logical 'AND'. */
export type Checkpoint_Bool_Exp = {
  _and?: InputMaybe<Array<Checkpoint_Bool_Exp>>;
  _not?: InputMaybe<Checkpoint_Bool_Exp>;
  _or?: InputMaybe<Array<Checkpoint_Bool_Exp>>;
  activities?: InputMaybe<Activity_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activity_Aggregate_Bool_Exp>;
  checkpoint_attempts?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  checkpoint_attempts_aggregate?: InputMaybe<Checkpoint_Attempts_Aggregate_Bool_Exp>;
  coefficient?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lesson?: InputMaybe<Lesson_Bool_Exp>;
  lessonId?: InputMaybe<Int_Comparison_Exp>;
  max_attempts?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_checkpoints?: InputMaybe<User_Checkpoint_Bool_Exp>;
  user_checkpoints_aggregate?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "checkpoint" */
export const enum Checkpoint_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFea86db187949398f8b614f730a = 'PK_fea86db187949398f8b614f730a',
  /** unique or primary key constraint on columns "lessonId" */
  Rel_5eadac50bf6ce3a361596f6b3e = 'REL_5eadac50bf6ce3a361596f6b3e',
  /** unique or primary key constraint on columns "uid" */
  Uq_1427b5d6de53d6ab53c50a54095 = 'UQ_1427b5d6de53d6ab53c50a54095'
};

/** input type for incrementing numeric columns in table "checkpoint" */
export type Checkpoint_Inc_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  max_attempts?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "checkpoint" */
export type Checkpoint_Insert_Input = {
  activities?: InputMaybe<Activity_Arr_Rel_Insert_Input>;
  checkpoint_attempts?: InputMaybe<Checkpoint_Attempts_Arr_Rel_Insert_Input>;
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lesson?: InputMaybe<Lesson_Obj_Rel_Insert_Input>;
  lessonId?: InputMaybe<Scalars['Int']>;
  max_attempts?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_checkpoints?: InputMaybe<User_Checkpoint_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Checkpoint_Max_Fields = {
  __typename?: 'checkpoint_max_fields';
  coefficient?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  max_attempts?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "checkpoint" */
export type Checkpoint_Max_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Checkpoint_Min_Fields = {
  __typename?: 'checkpoint_min_fields';
  coefficient?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  max_attempts?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "checkpoint" */
export type Checkpoint_Min_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkpoint" */
export type Checkpoint_Mutation_Response = {
  __typename?: 'checkpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Checkpoint>;
};

/** input type for inserting object relation for remote table "checkpoint" */
export type Checkpoint_Obj_Rel_Insert_Input = {
  data: Checkpoint_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Checkpoint_On_Conflict>;
};

/** on_conflict condition type for table "checkpoint" */
export type Checkpoint_On_Conflict = {
  constraint: Checkpoint_Constraint;
  update_columns?: Array<Checkpoint_Update_Column>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};

/** Ordering options when selecting data from "checkpoint". */
export type Checkpoint_Order_By = {
  activities_aggregate?: InputMaybe<Activity_Aggregate_Order_By>;
  checkpoint_attempts_aggregate?: InputMaybe<Checkpoint_Attempts_Aggregate_Order_By>;
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson?: InputMaybe<Lesson_Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_checkpoints_aggregate?: InputMaybe<User_Checkpoint_Aggregate_Order_By>;
};

/** primary key columns input for table: checkpoint */
export type Checkpoint_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "checkpoint" */
export const enum Checkpoint_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  MaxAttempts = 'max_attempts',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "checkpoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "checkpoint" */
export const enum Checkpoint_Select_Column_Checkpoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "checkpoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "checkpoint" */
export const enum Checkpoint_Select_Column_Checkpoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "checkpoint" */
export type Checkpoint_Set_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  max_attempts?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Checkpoint_Stddev_Fields = {
  __typename?: 'checkpoint_stddev_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "checkpoint" */
export type Checkpoint_Stddev_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Checkpoint_Stddev_Pop_Fields = {
  __typename?: 'checkpoint_stddev_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "checkpoint" */
export type Checkpoint_Stddev_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Checkpoint_Stddev_Samp_Fields = {
  __typename?: 'checkpoint_stddev_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "checkpoint" */
export type Checkpoint_Stddev_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "checkpoint" */
export type Checkpoint_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Checkpoint_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Checkpoint_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  max_attempts?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Checkpoint_Sum_Fields = {
  __typename?: 'checkpoint_sum_fields';
  coefficient?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  max_attempts?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "checkpoint" */
export type Checkpoint_Sum_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "checkpoint" */
export const enum Checkpoint_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  MaxAttempts = 'max_attempts',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Checkpoint_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Checkpoint_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Checkpoint_Set_Input>;
  /** filter the rows which have to be updated */
  where: Checkpoint_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Checkpoint_Var_Pop_Fields = {
  __typename?: 'checkpoint_var_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "checkpoint" */
export type Checkpoint_Var_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Checkpoint_Var_Samp_Fields = {
  __typename?: 'checkpoint_var_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "checkpoint" */
export type Checkpoint_Var_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Checkpoint_Variance_Fields = {
  __typename?: 'checkpoint_variance_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  max_attempts?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "checkpoint" */
export type Checkpoint_Variance_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  max_attempts?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "class" */
export type Class = {
  __typename?: 'class';
  /** An array relationship */
  class_courses: Array<Class_Course>;
  /** An aggregate relationship */
  class_courses_aggregate: Class_Course_Aggregate;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  end_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  schoolPeriodId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  school_period?: Maybe<School_Period>;
  start_date: Scalars['timestamptz'];
  title: Scalars['String'];
  type: Scalars['class_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_classes: Array<User_Class>;
  /** An aggregate relationship */
  user_classes_aggregate: User_Class_Aggregate;
  /** An array relationship */
  user_courses: Array<User_Course>;
  /** An aggregate relationship */
  user_courses_aggregate: User_Course_Aggregate;
};


/** columns and relationships of "class" */
export type ClassClass_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "class" */
export type ClassClass_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "class" */
export type ClassUser_ClassesArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


/** columns and relationships of "class" */
export type ClassUser_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


/** columns and relationships of "class" */
export type ClassUser_CoursesArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


/** columns and relationships of "class" */
export type ClassUser_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};

/** aggregated selection of "class" */
export type Class_Aggregate = {
  __typename?: 'class_aggregate';
  aggregate?: Maybe<Class_Aggregate_Fields>;
  nodes: Array<Class>;
};

export type Class_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Class_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Class_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Class_Aggregate_Bool_Exp_Count>;
};

export type Class_Aggregate_Bool_Exp_Bool_And = {
  arguments: Class_Select_Column_Class_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Class_Select_Column_Class_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "class" */
export type Class_Aggregate_Fields = {
  __typename?: 'class_aggregate_fields';
  avg?: Maybe<Class_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Class_Max_Fields>;
  min?: Maybe<Class_Min_Fields>;
  stddev?: Maybe<Class_Stddev_Fields>;
  stddev_pop?: Maybe<Class_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Class_Stddev_Samp_Fields>;
  sum?: Maybe<Class_Sum_Fields>;
  var_pop?: Maybe<Class_Var_Pop_Fields>;
  var_samp?: Maybe<Class_Var_Samp_Fields>;
  variance?: Maybe<Class_Variance_Fields>;
};


/** aggregate fields of "class" */
export type Class_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class" */
export type Class_Aggregate_Order_By = {
  avg?: InputMaybe<Class_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Class_Max_Order_By>;
  min?: InputMaybe<Class_Min_Order_By>;
  stddev?: InputMaybe<Class_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Class_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Class_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Class_Sum_Order_By>;
  var_pop?: InputMaybe<Class_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Class_Var_Samp_Order_By>;
  variance?: InputMaybe<Class_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "class" */
export type Class_Arr_Rel_Insert_Input = {
  data: Array<Class_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_On_Conflict>;
};

/** aggregate avg on columns */
export type Class_Avg_Fields = {
  __typename?: 'class_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class" */
export type Class_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "class". All fields are combined with a logical 'AND'. */
export type Class_Bool_Exp = {
  _and?: InputMaybe<Array<Class_Bool_Exp>>;
  _not?: InputMaybe<Class_Bool_Exp>;
  _or?: InputMaybe<Array<Class_Bool_Exp>>;
  class_courses?: InputMaybe<Class_Course_Bool_Exp>;
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  schoolPeriodId?: InputMaybe<Int_Comparison_Exp>;
  school_period?: InputMaybe<School_Period_Bool_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Class_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_classes?: InputMaybe<User_Class_Bool_Exp>;
  user_classes_aggregate?: InputMaybe<User_Class_Aggregate_Bool_Exp>;
  user_courses?: InputMaybe<User_Course_Bool_Exp>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "class" */
export const enum Class_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_0b9024d21bdfba8b1bd1c300eae = 'PK_0b9024d21bdfba8b1bd1c300eae',
  /** unique or primary key constraint on columns "uid" */
  UqEbec5148c0348e13a9aba0dea4e = 'UQ_ebec5148c0348e13a9aba0dea4e'
};

/** columns and relationships of "class_course" */
export type Class_Course = {
  __typename?: 'class_course';
  /** An array relationship */
  assignments: Array<Assignment>;
  /** An aggregate relationship */
  assignments_aggregate: Assignment_Aggregate;
  /** An object relationship */
  class: Class;
  classId: Scalars['Int'];
  /** An array relationship */
  class_course_notes: Array<Class_Course_Note>;
  /** An aggregate relationship */
  class_course_notes_aggregate: Class_Course_Note_Aggregate;
  /** An array relationship */
  class_course_resources: Array<Class_Course_Resource>;
  /** An aggregate relationship */
  class_course_resources_aggregate: Class_Course_Resource_Aggregate;
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  gradebook?: Maybe<Gradebook>;
  id: Scalars['Int'];
  /** An array relationship */
  lectures: Array<Lecture>;
  /** An aggregate relationship */
  lectures_aggregate: Lecture_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_courses: Array<User_Course>;
  /** An aggregate relationship */
  user_courses_aggregate: User_Course_Aggregate;
};


/** columns and relationships of "class_course" */
export type Class_CourseAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseClass_Course_NotesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseClass_Course_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseClass_Course_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseClass_Course_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseLecturesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseLectures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseUser_CoursesArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


/** columns and relationships of "class_course" */
export type Class_CourseUser_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};

/** aggregated selection of "class_course" */
export type Class_Course_Aggregate = {
  __typename?: 'class_course_aggregate';
  aggregate?: Maybe<Class_Course_Aggregate_Fields>;
  nodes: Array<Class_Course>;
};

export type Class_Course_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Class_Course_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Class_Course_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Class_Course_Aggregate_Bool_Exp_Count>;
};

export type Class_Course_Aggregate_Bool_Exp_Bool_And = {
  arguments: Class_Course_Select_Column_Class_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Class_Course_Select_Column_Class_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Class_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "class_course" */
export type Class_Course_Aggregate_Fields = {
  __typename?: 'class_course_aggregate_fields';
  avg?: Maybe<Class_Course_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Class_Course_Max_Fields>;
  min?: Maybe<Class_Course_Min_Fields>;
  stddev?: Maybe<Class_Course_Stddev_Fields>;
  stddev_pop?: Maybe<Class_Course_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Class_Course_Stddev_Samp_Fields>;
  sum?: Maybe<Class_Course_Sum_Fields>;
  var_pop?: Maybe<Class_Course_Var_Pop_Fields>;
  var_samp?: Maybe<Class_Course_Var_Samp_Fields>;
  variance?: Maybe<Class_Course_Variance_Fields>;
};


/** aggregate fields of "class_course" */
export type Class_Course_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Class_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_course" */
export type Class_Course_Aggregate_Order_By = {
  avg?: InputMaybe<Class_Course_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Class_Course_Max_Order_By>;
  min?: InputMaybe<Class_Course_Min_Order_By>;
  stddev?: InputMaybe<Class_Course_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Class_Course_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Class_Course_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Class_Course_Sum_Order_By>;
  var_pop?: InputMaybe<Class_Course_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Class_Course_Var_Samp_Order_By>;
  variance?: InputMaybe<Class_Course_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "class_course" */
export type Class_Course_Arr_Rel_Insert_Input = {
  data: Array<Class_Course_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_On_Conflict>;
};

/** aggregate avg on columns */
export type Class_Course_Avg_Fields = {
  __typename?: 'class_course_avg_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class_course" */
export type Class_Course_Avg_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "class_course". All fields are combined with a logical 'AND'. */
export type Class_Course_Bool_Exp = {
  _and?: InputMaybe<Array<Class_Course_Bool_Exp>>;
  _not?: InputMaybe<Class_Course_Bool_Exp>;
  _or?: InputMaybe<Array<Class_Course_Bool_Exp>>;
  assignments?: InputMaybe<Assignment_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Bool_Exp>;
  class?: InputMaybe<Class_Bool_Exp>;
  classId?: InputMaybe<Int_Comparison_Exp>;
  class_course_notes?: InputMaybe<Class_Course_Note_Bool_Exp>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  gradebook?: InputMaybe<Gradebook_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lectures?: InputMaybe<Lecture_Bool_Exp>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_courses?: InputMaybe<User_Course_Bool_Exp>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "class_course" */
export const enum Class_Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_57476b73061271c061ae6dd16ea = 'PK_57476b73061271c061ae6dd16ea',
  /** unique or primary key constraint on columns "uid" */
  Uq_830b080850136bb8ed0dd13c15c = 'UQ_830b080850136bb8ed0dd13c15c',
  /** unique or primary key constraint on columns "classId", "courseId" */
  IndexClassCourse = 'index_class_course'
};

/** input type for incrementing numeric columns in table "class_course" */
export type Class_Course_Inc_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "class_course" */
export type Class_Course_Insert_Input = {
  assignments?: InputMaybe<Assignment_Arr_Rel_Insert_Input>;
  class?: InputMaybe<Class_Obj_Rel_Insert_Input>;
  classId?: InputMaybe<Scalars['Int']>;
  class_course_notes?: InputMaybe<Class_Course_Note_Arr_Rel_Insert_Input>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Arr_Rel_Insert_Input>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradebook?: InputMaybe<Gradebook_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  lectures?: InputMaybe<Lecture_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_courses?: InputMaybe<User_Course_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Class_Course_Max_Fields = {
  __typename?: 'class_course_max_fields';
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "class_course" */
export type Class_Course_Max_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Class_Course_Min_Fields = {
  __typename?: 'class_course_min_fields';
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "class_course" */
export type Class_Course_Min_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "class_course" */
export type Class_Course_Mutation_Response = {
  __typename?: 'class_course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Course>;
};

/** columns and relationships of "class_course_note" */
export type Class_Course_Note = {
  __typename?: 'class_course_note';
  body: Scalars['String'];
  classCourseId: Scalars['Int'];
  /** An object relationship */
  class_course: Class_Course;
  createdById: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An array relationship */
  lecture_notes: Array<Lecture_Note>;
  /** An aggregate relationship */
  lecture_notes_aggregate: Lecture_Note_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  visibleToStudents: Scalars['Boolean'];
  visibleToTeachers: Scalars['Boolean'];
};


/** columns and relationships of "class_course_note" */
export type Class_Course_NoteLecture_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


/** columns and relationships of "class_course_note" */
export type Class_Course_NoteLecture_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};

/** aggregated selection of "class_course_note" */
export type Class_Course_Note_Aggregate = {
  __typename?: 'class_course_note_aggregate';
  aggregate?: Maybe<Class_Course_Note_Aggregate_Fields>;
  nodes: Array<Class_Course_Note>;
};

export type Class_Course_Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp_Count>;
};

export type Class_Course_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Class_Course_Note_Select_Column_Class_Course_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Class_Course_Note_Select_Column_Class_Course_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "class_course_note" */
export type Class_Course_Note_Aggregate_Fields = {
  __typename?: 'class_course_note_aggregate_fields';
  avg?: Maybe<Class_Course_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Class_Course_Note_Max_Fields>;
  min?: Maybe<Class_Course_Note_Min_Fields>;
  stddev?: Maybe<Class_Course_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Class_Course_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Class_Course_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Class_Course_Note_Sum_Fields>;
  var_pop?: Maybe<Class_Course_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Class_Course_Note_Var_Samp_Fields>;
  variance?: Maybe<Class_Course_Note_Variance_Fields>;
};


/** aggregate fields of "class_course_note" */
export type Class_Course_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_course_note" */
export type Class_Course_Note_Aggregate_Order_By = {
  avg?: InputMaybe<Class_Course_Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Class_Course_Note_Max_Order_By>;
  min?: InputMaybe<Class_Course_Note_Min_Order_By>;
  stddev?: InputMaybe<Class_Course_Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Class_Course_Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Class_Course_Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Class_Course_Note_Sum_Order_By>;
  var_pop?: InputMaybe<Class_Course_Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Class_Course_Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Class_Course_Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "class_course_note" */
export type Class_Course_Note_Arr_Rel_Insert_Input = {
  data: Array<Class_Course_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Class_Course_Note_Avg_Fields = {
  __typename?: 'class_course_note_avg_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class_course_note" */
export type Class_Course_Note_Avg_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "class_course_note". All fields are combined with a logical 'AND'. */
export type Class_Course_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Class_Course_Note_Bool_Exp>>;
  _not?: InputMaybe<Class_Course_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Class_Course_Note_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lecture_notes?: InputMaybe<Lecture_Note_Bool_Exp>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  visibleToStudents?: InputMaybe<Boolean_Comparison_Exp>;
  visibleToTeachers?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "class_course_note" */
export const enum Class_Course_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkE1c62b9a7229f4beb1655ab0159 = 'PK_e1c62b9a7229f4beb1655ab0159',
  /** unique or primary key constraint on columns "uid" */
  UqB8faabd5ff2fd04c1446e04866f = 'UQ_b8faabd5ff2fd04c1446e04866f'
};

/** input type for incrementing numeric columns in table "class_course_note" */
export type Class_Course_Note_Inc_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "class_course_note" */
export type Class_Course_Note_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lecture_notes?: InputMaybe<Lecture_Note_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  visibleToTeachers?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Class_Course_Note_Max_Fields = {
  __typename?: 'class_course_note_max_fields';
  body?: Maybe<Scalars['String']>;
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "class_course_note" */
export type Class_Course_Note_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Class_Course_Note_Min_Fields = {
  __typename?: 'class_course_note_min_fields';
  body?: Maybe<Scalars['String']>;
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "class_course_note" */
export type Class_Course_Note_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "class_course_note" */
export type Class_Course_Note_Mutation_Response = {
  __typename?: 'class_course_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Course_Note>;
};

/** input type for inserting object relation for remote table "class_course_note" */
export type Class_Course_Note_Obj_Rel_Insert_Input = {
  data: Class_Course_Note_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_Note_On_Conflict>;
};

/** on_conflict condition type for table "class_course_note" */
export type Class_Course_Note_On_Conflict = {
  constraint: Class_Course_Note_Constraint;
  update_columns?: Array<Class_Course_Note_Update_Column>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "class_course_note". */
export type Class_Course_Note_Order_By = {
  body?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  visibleToStudents?: InputMaybe<Order_By>;
  visibleToTeachers?: InputMaybe<Order_By>;
};

/** primary key columns input for table: class_course_note */
export type Class_Course_Note_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "class_course_note" */
export const enum Class_Course_Note_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  VisibleToTeachers = 'visibleToTeachers'
};

/** select "class_course_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_course_note" */
export const enum Class_Course_Note_Select_Column_Class_Course_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  VisibleToTeachers = 'visibleToTeachers'
};

/** select "class_course_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_course_note" */
export const enum Class_Course_Note_Select_Column_Class_Course_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  VisibleToTeachers = 'visibleToTeachers'
};

/** input type for updating data in table "class_course_note" */
export type Class_Course_Note_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  visibleToTeachers?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Class_Course_Note_Stddev_Fields = {
  __typename?: 'class_course_note_stddev_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class_course_note" */
export type Class_Course_Note_Stddev_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Class_Course_Note_Stddev_Pop_Fields = {
  __typename?: 'class_course_note_stddev_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class_course_note" */
export type Class_Course_Note_Stddev_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Class_Course_Note_Stddev_Samp_Fields = {
  __typename?: 'class_course_note_stddev_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class_course_note" */
export type Class_Course_Note_Stddev_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "class_course_note" */
export type Class_Course_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Class_Course_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Course_Note_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  visibleToTeachers?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Class_Course_Note_Sum_Fields = {
  __typename?: 'class_course_note_sum_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "class_course_note" */
export type Class_Course_Note_Sum_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "class_course_note" */
export const enum Class_Course_Note_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  VisibleToTeachers = 'visibleToTeachers'
};

export type Class_Course_Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Course_Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Course_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Class_Course_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Class_Course_Note_Var_Pop_Fields = {
  __typename?: 'class_course_note_var_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class_course_note" */
export type Class_Course_Note_Var_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Class_Course_Note_Var_Samp_Fields = {
  __typename?: 'class_course_note_var_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class_course_note" */
export type Class_Course_Note_Var_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Class_Course_Note_Variance_Fields = {
  __typename?: 'class_course_note_variance_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class_course_note" */
export type Class_Course_Note_Variance_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "class_course" */
export type Class_Course_Obj_Rel_Insert_Input = {
  data: Class_Course_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_On_Conflict>;
};

/** on_conflict condition type for table "class_course" */
export type Class_Course_On_Conflict = {
  constraint: Class_Course_Constraint;
  update_columns?: Array<Class_Course_Update_Column>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};

/** Ordering options when selecting data from "class_course". */
export type Class_Course_Order_By = {
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Order_By>;
  class?: InputMaybe<Class_Order_By>;
  classId?: InputMaybe<Order_By>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Order_By>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  gradebook?: InputMaybe<Gradebook_Order_By>;
  id?: InputMaybe<Order_By>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Order_By>;
};

/** primary key columns input for table: class_course */
export type Class_Course_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "class_course_resource" */
export type Class_Course_Resource = {
  __typename?: 'class_course_resource';
  classCourseId: Scalars['Int'];
  /** An object relationship */
  class_course: Class_Course;
  createdById: Scalars['Int'];
  /** An object relationship */
  createdByUser: User;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  file: File;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  /** An array relationship */
  lecture_resources: Array<Lecture_Resource>;
  /** An aggregate relationship */
  lecture_resources_aggregate: Lecture_Resource_Aggregate;
  order: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "class_course_resource" */
export type Class_Course_ResourceLecture_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


/** columns and relationships of "class_course_resource" */
export type Class_Course_ResourceLecture_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};

/** aggregated selection of "class_course_resource" */
export type Class_Course_Resource_Aggregate = {
  __typename?: 'class_course_resource_aggregate';
  aggregate?: Maybe<Class_Course_Resource_Aggregate_Fields>;
  nodes: Array<Class_Course_Resource>;
};

export type Class_Course_Resource_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp_Count>;
};

export type Class_Course_Resource_Aggregate_Bool_Exp_Bool_And = {
  arguments: Class_Course_Resource_Select_Column_Class_Course_Resource_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Resource_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Class_Course_Resource_Select_Column_Class_Course_Resource_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Class_Course_Resource_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "class_course_resource" */
export type Class_Course_Resource_Aggregate_Fields = {
  __typename?: 'class_course_resource_aggregate_fields';
  avg?: Maybe<Class_Course_Resource_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Class_Course_Resource_Max_Fields>;
  min?: Maybe<Class_Course_Resource_Min_Fields>;
  stddev?: Maybe<Class_Course_Resource_Stddev_Fields>;
  stddev_pop?: Maybe<Class_Course_Resource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Class_Course_Resource_Stddev_Samp_Fields>;
  sum?: Maybe<Class_Course_Resource_Sum_Fields>;
  var_pop?: Maybe<Class_Course_Resource_Var_Pop_Fields>;
  var_samp?: Maybe<Class_Course_Resource_Var_Samp_Fields>;
  variance?: Maybe<Class_Course_Resource_Variance_Fields>;
};


/** aggregate fields of "class_course_resource" */
export type Class_Course_Resource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_course_resource" */
export type Class_Course_Resource_Aggregate_Order_By = {
  avg?: InputMaybe<Class_Course_Resource_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Class_Course_Resource_Max_Order_By>;
  min?: InputMaybe<Class_Course_Resource_Min_Order_By>;
  stddev?: InputMaybe<Class_Course_Resource_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Class_Course_Resource_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Class_Course_Resource_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Class_Course_Resource_Sum_Order_By>;
  var_pop?: InputMaybe<Class_Course_Resource_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Class_Course_Resource_Var_Samp_Order_By>;
  variance?: InputMaybe<Class_Course_Resource_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "class_course_resource" */
export type Class_Course_Resource_Arr_Rel_Insert_Input = {
  data: Array<Class_Course_Resource_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_Resource_On_Conflict>;
};

/** aggregate avg on columns */
export type Class_Course_Resource_Avg_Fields = {
  __typename?: 'class_course_resource_avg_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class_course_resource" */
export type Class_Course_Resource_Avg_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "class_course_resource". All fields are combined with a logical 'AND'. */
export type Class_Course_Resource_Bool_Exp = {
  _and?: InputMaybe<Array<Class_Course_Resource_Bool_Exp>>;
  _not?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  _or?: InputMaybe<Array<Class_Course_Resource_Bool_Exp>>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  fileId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  lecture_resources?: InputMaybe<Lecture_Resource_Bool_Exp>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "class_course_resource" */
export const enum Class_Course_Resource_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_0159cb5c77e7ead0425aed837af = 'PK_0159cb5c77e7ead0425aed837af',
  /** unique or primary key constraint on columns "uid" */
  UqDb55ae096ba6b5f65294207a1cf = 'UQ_db55ae096ba6b5f65294207a1cf'
};

/** input type for incrementing numeric columns in table "class_course_resource" */
export type Class_Course_Resource_Inc_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "class_course_resource" */
export type Class_Course_Resource_Insert_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  lecture_resources?: InputMaybe<Lecture_Resource_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Class_Course_Resource_Max_Fields = {
  __typename?: 'class_course_resource_max_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "class_course_resource" */
export type Class_Course_Resource_Max_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Class_Course_Resource_Min_Fields = {
  __typename?: 'class_course_resource_min_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "class_course_resource" */
export type Class_Course_Resource_Min_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "class_course_resource" */
export type Class_Course_Resource_Mutation_Response = {
  __typename?: 'class_course_resource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Course_Resource>;
};

/** input type for inserting object relation for remote table "class_course_resource" */
export type Class_Course_Resource_Obj_Rel_Insert_Input = {
  data: Class_Course_Resource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Course_Resource_On_Conflict>;
};

/** on_conflict condition type for table "class_course_resource" */
export type Class_Course_Resource_On_Conflict = {
  constraint: Class_Course_Resource_Constraint;
  update_columns?: Array<Class_Course_Resource_Update_Column>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};

/** Ordering options when selecting data from "class_course_resource". */
export type Class_Course_Resource_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: class_course_resource */
export type Class_Course_Resource_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "class_course_resource" */
export const enum Class_Course_Resource_Select_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "class_course_resource_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_course_resource" */
export const enum Class_Course_Resource_Select_Column_Class_Course_Resource_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "class_course_resource_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_course_resource" */
export const enum Class_Course_Resource_Select_Column_Class_Course_Resource_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "class_course_resource" */
export type Class_Course_Resource_Set_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Class_Course_Resource_Stddev_Fields = {
  __typename?: 'class_course_resource_stddev_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class_course_resource" */
export type Class_Course_Resource_Stddev_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Class_Course_Resource_Stddev_Pop_Fields = {
  __typename?: 'class_course_resource_stddev_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class_course_resource" */
export type Class_Course_Resource_Stddev_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Class_Course_Resource_Stddev_Samp_Fields = {
  __typename?: 'class_course_resource_stddev_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class_course_resource" */
export type Class_Course_Resource_Stddev_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "class_course_resource" */
export type Class_Course_Resource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Class_Course_Resource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Course_Resource_Stream_Cursor_Value_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Class_Course_Resource_Sum_Fields = {
  __typename?: 'class_course_resource_sum_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "class_course_resource" */
export type Class_Course_Resource_Sum_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "class_course_resource" */
export const enum Class_Course_Resource_Update_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Class_Course_Resource_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Course_Resource_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Course_Resource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Class_Course_Resource_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Class_Course_Resource_Var_Pop_Fields = {
  __typename?: 'class_course_resource_var_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class_course_resource" */
export type Class_Course_Resource_Var_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Class_Course_Resource_Var_Samp_Fields = {
  __typename?: 'class_course_resource_var_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class_course_resource" */
export type Class_Course_Resource_Var_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Class_Course_Resource_Variance_Fields = {
  __typename?: 'class_course_resource_variance_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class_course_resource" */
export type Class_Course_Resource_Variance_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** select columns of table "class_course" */
export const enum Class_Course_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "class_course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_course" */
export const enum Class_Course_Select_Column_Class_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "class_course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_course" */
export const enum Class_Course_Select_Column_Class_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "class_course" */
export type Class_Course_Set_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Class_Course_Stddev_Fields = {
  __typename?: 'class_course_stddev_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class_course" */
export type Class_Course_Stddev_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Class_Course_Stddev_Pop_Fields = {
  __typename?: 'class_course_stddev_pop_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class_course" */
export type Class_Course_Stddev_Pop_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Class_Course_Stddev_Samp_Fields = {
  __typename?: 'class_course_stddev_samp_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class_course" */
export type Class_Course_Stddev_Samp_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "class_course" */
export type Class_Course_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Class_Course_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Course_Stream_Cursor_Value_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Class_Course_Sum_Fields = {
  __typename?: 'class_course_sum_fields';
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "class_course" */
export type Class_Course_Sum_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "class_course" */
export const enum Class_Course_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Class_Course_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Course_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Course_Set_Input>;
  /** filter the rows which have to be updated */
  where: Class_Course_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Class_Course_Var_Pop_Fields = {
  __typename?: 'class_course_var_pop_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class_course" */
export type Class_Course_Var_Pop_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Class_Course_Var_Samp_Fields = {
  __typename?: 'class_course_var_samp_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class_course" */
export type Class_Course_Var_Samp_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Class_Course_Variance_Fields = {
  __typename?: 'class_course_variance_fields';
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class_course" */
export type Class_Course_Variance_Order_By = {
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "class" */
export type Class_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "class" */
export type Class_Insert_Input = {
  class_courses?: InputMaybe<Class_Course_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  school_period?: InputMaybe<School_Period_Obj_Rel_Insert_Input>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['class_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_classes?: InputMaybe<User_Class_Arr_Rel_Insert_Input>;
  user_courses?: InputMaybe<User_Course_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Class_Max_Fields = {
  __typename?: 'class_max_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['class_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "class" */
export type Class_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Class_Min_Fields = {
  __typename?: 'class_min_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['class_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "class" */
export type Class_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "class" */
export type Class_Mutation_Response = {
  __typename?: 'class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class>;
};

/** input type for inserting object relation for remote table "class" */
export type Class_Obj_Rel_Insert_Input = {
  data: Class_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_On_Conflict>;
};

/** on_conflict condition type for table "class" */
export type Class_On_Conflict = {
  constraint: Class_Constraint;
  update_columns?: Array<Class_Update_Column>;
  where?: InputMaybe<Class_Bool_Exp>;
};

/** Ordering options when selecting data from "class". */
export type Class_Order_By = {
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  school_period?: InputMaybe<School_Period_Order_By>;
  start_date?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_classes_aggregate?: InputMaybe<User_Class_Aggregate_Order_By>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Order_By>;
};

/** primary key columns input for table: class */
export type Class_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "class" */
export const enum Class_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "class_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class" */
export const enum Class_Select_Column_Class_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** select "class_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class" */
export const enum Class_Select_Column_Class_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** input type for updating data in table "class" */
export type Class_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['class_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Class_Stddev_Fields = {
  __typename?: 'class_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class" */
export type Class_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Class_Stddev_Pop_Fields = {
  __typename?: 'class_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class" */
export type Class_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Class_Stddev_Samp_Fields = {
  __typename?: 'class_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class" */
export type Class_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "class" */
export type Class_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Class_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['class_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Class_Sum_Fields = {
  __typename?: 'class_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "class" */
export type Class_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export type Class_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['class_type_enum']>;
  _gt?: InputMaybe<Scalars['class_type_enum']>;
  _gte?: InputMaybe<Scalars['class_type_enum']>;
  _in?: InputMaybe<Array<Scalars['class_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['class_type_enum']>;
  _lte?: InputMaybe<Scalars['class_type_enum']>;
  _neq?: InputMaybe<Scalars['class_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['class_type_enum']>>;
};

/** update columns of table "class" */
export const enum Class_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Class_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Set_Input>;
  /** filter the rows which have to be updated */
  where: Class_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Class_Var_Pop_Fields = {
  __typename?: 'class_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class" */
export type Class_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Class_Var_Samp_Fields = {
  __typename?: 'class_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class" */
export type Class_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Class_Variance_Fields = {
  __typename?: 'class_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class" */
export type Class_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** columns and relationships of "classroom" */
export type Classroom = {
  __typename?: 'classroom';
  capacity: Scalars['Int'];
  classroomGroupId: Scalars['Int'];
  /** An object relationship */
  classroom_group: Classroom_Group;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_classrooms: Array<Event_Classroom>;
  /** An aggregate relationship */
  event_classrooms_aggregate: Event_Classroom_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "classroom" */
export type ClassroomEvent_ClassroomsArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


/** columns and relationships of "classroom" */
export type ClassroomEvent_Classrooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};

/** aggregated selection of "classroom" */
export type Classroom_Aggregate = {
  __typename?: 'classroom_aggregate';
  aggregate?: Maybe<Classroom_Aggregate_Fields>;
  nodes: Array<Classroom>;
};

export type Classroom_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Classroom_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Classroom_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Classroom_Aggregate_Bool_Exp_Count>;
};

export type Classroom_Aggregate_Bool_Exp_Bool_And = {
  arguments: Classroom_Select_Column_Classroom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Classroom_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Classroom_Select_Column_Classroom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Classroom_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Classroom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classroom" */
export type Classroom_Aggregate_Fields = {
  __typename?: 'classroom_aggregate_fields';
  avg?: Maybe<Classroom_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Classroom_Max_Fields>;
  min?: Maybe<Classroom_Min_Fields>;
  stddev?: Maybe<Classroom_Stddev_Fields>;
  stddev_pop?: Maybe<Classroom_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Classroom_Stddev_Samp_Fields>;
  sum?: Maybe<Classroom_Sum_Fields>;
  var_pop?: Maybe<Classroom_Var_Pop_Fields>;
  var_samp?: Maybe<Classroom_Var_Samp_Fields>;
  variance?: Maybe<Classroom_Variance_Fields>;
};


/** aggregate fields of "classroom" */
export type Classroom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Classroom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classroom" */
export type Classroom_Aggregate_Order_By = {
  avg?: InputMaybe<Classroom_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Classroom_Max_Order_By>;
  min?: InputMaybe<Classroom_Min_Order_By>;
  stddev?: InputMaybe<Classroom_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Classroom_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Classroom_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Classroom_Sum_Order_By>;
  var_pop?: InputMaybe<Classroom_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Classroom_Var_Samp_Order_By>;
  variance?: InputMaybe<Classroom_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classroom" */
export type Classroom_Arr_Rel_Insert_Input = {
  data: Array<Classroom_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Classroom_On_Conflict>;
};

/** aggregate avg on columns */
export type Classroom_Avg_Fields = {
  __typename?: 'classroom_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classroom" */
export type Classroom_Avg_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classroom". All fields are combined with a logical 'AND'. */
export type Classroom_Bool_Exp = {
  _and?: InputMaybe<Array<Classroom_Bool_Exp>>;
  _not?: InputMaybe<Classroom_Bool_Exp>;
  _or?: InputMaybe<Array<Classroom_Bool_Exp>>;
  capacity?: InputMaybe<Int_Comparison_Exp>;
  classroomGroupId?: InputMaybe<Int_Comparison_Exp>;
  classroom_group?: InputMaybe<Classroom_Group_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  event_classrooms?: InputMaybe<Event_Classroom_Bool_Exp>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classroom" */
export const enum Classroom_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_729f896c8b7b96ddf10c341e6ff = 'PK_729f896c8b7b96ddf10c341e6ff',
  /** unique or primary key constraint on columns "uid" */
  Uq_708f8af8a326116510ef577bb99 = 'UQ_708f8af8a326116510ef577bb99'
};

/** columns and relationships of "classroom_group" */
export type Classroom_Group = {
  __typename?: 'classroom_group';
  /** An array relationship */
  classrooms: Array<Classroom>;
  /** An aggregate relationship */
  classrooms_aggregate: Classroom_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "classroom_group" */
export type Classroom_GroupClassroomsArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


/** columns and relationships of "classroom_group" */
export type Classroom_GroupClassrooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};

/** aggregated selection of "classroom_group" */
export type Classroom_Group_Aggregate = {
  __typename?: 'classroom_group_aggregate';
  aggregate?: Maybe<Classroom_Group_Aggregate_Fields>;
  nodes: Array<Classroom_Group>;
};

export type Classroom_Group_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Classroom_Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Classroom_Group_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Classroom_Group_Aggregate_Bool_Exp_Count>;
};

export type Classroom_Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: Classroom_Group_Select_Column_Classroom_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Classroom_Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Classroom_Group_Select_Column_Classroom_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Classroom_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classroom_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classroom_group" */
export type Classroom_Group_Aggregate_Fields = {
  __typename?: 'classroom_group_aggregate_fields';
  avg?: Maybe<Classroom_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Classroom_Group_Max_Fields>;
  min?: Maybe<Classroom_Group_Min_Fields>;
  stddev?: Maybe<Classroom_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Classroom_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Classroom_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Classroom_Group_Sum_Fields>;
  var_pop?: Maybe<Classroom_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Classroom_Group_Var_Samp_Fields>;
  variance?: Maybe<Classroom_Group_Variance_Fields>;
};


/** aggregate fields of "classroom_group" */
export type Classroom_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classroom_group" */
export type Classroom_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Classroom_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Classroom_Group_Max_Order_By>;
  min?: InputMaybe<Classroom_Group_Min_Order_By>;
  stddev?: InputMaybe<Classroom_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Classroom_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Classroom_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Classroom_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Classroom_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Classroom_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Classroom_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classroom_group" */
export type Classroom_Group_Arr_Rel_Insert_Input = {
  data: Array<Classroom_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Classroom_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Classroom_Group_Avg_Fields = {
  __typename?: 'classroom_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classroom_group" */
export type Classroom_Group_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classroom_group". All fields are combined with a logical 'AND'. */
export type Classroom_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Classroom_Group_Bool_Exp>>;
  _not?: InputMaybe<Classroom_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Classroom_Group_Bool_Exp>>;
  classrooms?: InputMaybe<Classroom_Bool_Exp>;
  classrooms_aggregate?: InputMaybe<Classroom_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classroom_group" */
export const enum Classroom_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBcb192693b4951ab0b923516644 = 'PK_bcb192693b4951ab0b923516644',
  /** unique or primary key constraint on columns "uid" */
  Uq_71ec7aaf9e80b03f625f50c68d4 = 'UQ_71ec7aaf9e80b03f625f50c68d4',
  /** unique or primary key constraint on columns "name" */
  Uq_3558cf7288e5527273539d7e199 = 'UQ_3558cf7288e5527273539d7e199'
};

/** input type for incrementing numeric columns in table "classroom_group" */
export type Classroom_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "classroom_group" */
export type Classroom_Group_Insert_Input = {
  classrooms?: InputMaybe<Classroom_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Classroom_Group_Max_Fields = {
  __typename?: 'classroom_group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "classroom_group" */
export type Classroom_Group_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Classroom_Group_Min_Fields = {
  __typename?: 'classroom_group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "classroom_group" */
export type Classroom_Group_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classroom_group" */
export type Classroom_Group_Mutation_Response = {
  __typename?: 'classroom_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Classroom_Group>;
};

/** input type for inserting object relation for remote table "classroom_group" */
export type Classroom_Group_Obj_Rel_Insert_Input = {
  data: Classroom_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Classroom_Group_On_Conflict>;
};

/** on_conflict condition type for table "classroom_group" */
export type Classroom_Group_On_Conflict = {
  constraint: Classroom_Group_Constraint;
  update_columns?: Array<Classroom_Group_Update_Column>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "classroom_group". */
export type Classroom_Group_Order_By = {
  classrooms_aggregate?: InputMaybe<Classroom_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classroom_group */
export type Classroom_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "classroom_group" */
export const enum Classroom_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "classroom_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classroom_group" */
export const enum Classroom_Group_Select_Column_Classroom_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "classroom_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classroom_group" */
export const enum Classroom_Group_Select_Column_Classroom_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "classroom_group" */
export type Classroom_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Classroom_Group_Stddev_Fields = {
  __typename?: 'classroom_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classroom_group" */
export type Classroom_Group_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Classroom_Group_Stddev_Pop_Fields = {
  __typename?: 'classroom_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classroom_group" */
export type Classroom_Group_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Classroom_Group_Stddev_Samp_Fields = {
  __typename?: 'classroom_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classroom_group" */
export type Classroom_Group_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classroom_group" */
export type Classroom_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Classroom_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Classroom_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Classroom_Group_Sum_Fields = {
  __typename?: 'classroom_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classroom_group" */
export type Classroom_Group_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "classroom_group" */
export const enum Classroom_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Classroom_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Classroom_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Classroom_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Classroom_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Classroom_Group_Var_Pop_Fields = {
  __typename?: 'classroom_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classroom_group" */
export type Classroom_Group_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Classroom_Group_Var_Samp_Fields = {
  __typename?: 'classroom_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classroom_group" */
export type Classroom_Group_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Classroom_Group_Variance_Fields = {
  __typename?: 'classroom_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classroom_group" */
export type Classroom_Group_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "classroom" */
export type Classroom_Inc_Input = {
  capacity?: InputMaybe<Scalars['Int']>;
  classroomGroupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "classroom" */
export type Classroom_Insert_Input = {
  capacity?: InputMaybe<Scalars['Int']>;
  classroomGroupId?: InputMaybe<Scalars['Int']>;
  classroom_group?: InputMaybe<Classroom_Group_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  event_classrooms?: InputMaybe<Event_Classroom_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Classroom_Max_Fields = {
  __typename?: 'classroom_max_fields';
  capacity?: Maybe<Scalars['Int']>;
  classroomGroupId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "classroom" */
export type Classroom_Max_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Classroom_Min_Fields = {
  __typename?: 'classroom_min_fields';
  capacity?: Maybe<Scalars['Int']>;
  classroomGroupId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "classroom" */
export type Classroom_Min_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classroom" */
export type Classroom_Mutation_Response = {
  __typename?: 'classroom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Classroom>;
};

/** input type for inserting object relation for remote table "classroom" */
export type Classroom_Obj_Rel_Insert_Input = {
  data: Classroom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Classroom_On_Conflict>;
};

/** on_conflict condition type for table "classroom" */
export type Classroom_On_Conflict = {
  constraint: Classroom_Constraint;
  update_columns?: Array<Classroom_Update_Column>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};

/** Ordering options when selecting data from "classroom". */
export type Classroom_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  classroom_group?: InputMaybe<Classroom_Group_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classroom */
export type Classroom_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "classroom" */
export const enum Classroom_Select_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  ClassroomGroupId = 'classroomGroupId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "classroom_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classroom" */
export const enum Classroom_Select_Column_Classroom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "classroom_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classroom" */
export const enum Classroom_Select_Column_Classroom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "classroom" */
export type Classroom_Set_Input = {
  capacity?: InputMaybe<Scalars['Int']>;
  classroomGroupId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Classroom_Stddev_Fields = {
  __typename?: 'classroom_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classroom" */
export type Classroom_Stddev_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Classroom_Stddev_Pop_Fields = {
  __typename?: 'classroom_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classroom" */
export type Classroom_Stddev_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Classroom_Stddev_Samp_Fields = {
  __typename?: 'classroom_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classroom" */
export type Classroom_Stddev_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classroom" */
export type Classroom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Classroom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Classroom_Stream_Cursor_Value_Input = {
  capacity?: InputMaybe<Scalars['Int']>;
  classroomGroupId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Classroom_Sum_Fields = {
  __typename?: 'classroom_sum_fields';
  capacity?: Maybe<Scalars['Int']>;
  classroomGroupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classroom" */
export type Classroom_Sum_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "classroom" */
export const enum Classroom_Update_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  ClassroomGroupId = 'classroomGroupId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Classroom_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Classroom_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Classroom_Set_Input>;
  /** filter the rows which have to be updated */
  where: Classroom_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Classroom_Var_Pop_Fields = {
  __typename?: 'classroom_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classroom" */
export type Classroom_Var_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Classroom_Var_Samp_Fields = {
  __typename?: 'classroom_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classroom" */
export type Classroom_Var_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Classroom_Variance_Fields = {
  __typename?: 'classroom_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  classroomGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classroom" */
export type Classroom_Variance_Order_By = {
  capacity?: InputMaybe<Order_By>;
  classroomGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course" */
export type Course = {
  __typename?: 'course';
  /** An array relationship */
  class_courses: Array<Class_Course>;
  /** An aggregate relationship */
  class_courses_aggregate: Class_Course_Aggregate;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  config: Scalars['String'];
  /** An array relationship */
  course_categories: Array<Course_Category>;
  /** An aggregate relationship */
  course_categories_aggregate: Course_Category_Aggregate;
  /** An array relationship */
  course_grade_levels: Array<Course_Grade_Level>;
  /** An aggregate relationship */
  course_grade_levels_aggregate: Course_Grade_Level_Aggregate;
  /** An array relationship */
  course_instructors: Array<Course_Instructor>;
  /** An aggregate relationship */
  course_instructors_aggregate: Course_Instructor_Aggregate;
  /** An array relationship */
  course_tags: Array<Course_Tag>;
  /** An aggregate relationship */
  course_tags_aggregate: Course_Tag_Aggregate;
  /** An array relationship */
  course_workspaces: Array<Course_Workspace>;
  /** An aggregate relationship */
  course_workspaces_aggregate: Course_Workspace_Aggregate;
  cover?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  group_courses: Array<Group_Course>;
  /** An aggregate relationship */
  group_courses_aggregate: Group_Course_Aggregate;
  id: Scalars['Int'];
  isOnline: Scalars['Boolean'];
  /** An array relationship */
  lessons: Array<Lesson>;
  /** An aggregate relationship */
  lessons_aggregate: Lesson_Aggregate;
  /** An array relationship */
  levels: Array<Level>;
  /** An aggregate relationship */
  levels_aggregate: Level_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  overview?: Maybe<Scalars['String']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  published: Scalars['Boolean'];
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_courses: Array<User_Course>;
  /** An aggregate relationship */
  user_courses_aggregate: User_Course_Aggregate;
};


/** columns and relationships of "course" */
export type CourseClass_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseClass_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Grade_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Grade_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_InstructorsArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Instructors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_TagsArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseGroup_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseGroup_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseLessonsArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseLessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseLevelsArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseLevels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseUser_CoursesArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseUser_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};

/** aggregated selection of "course" */
export type Course_Aggregate = {
  __typename?: 'course_aggregate';
  aggregate?: Maybe<Course_Aggregate_Fields>;
  nodes: Array<Course>;
};

export type Course_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Aggregate_Bool_Exp_Count>;
};

export type Course_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course" */
export type Course_Aggregate_Fields = {
  __typename?: 'course_aggregate_fields';
  avg?: Maybe<Course_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Max_Fields>;
  min?: Maybe<Course_Min_Fields>;
  stddev?: Maybe<Course_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Sum_Fields>;
  var_pop?: Maybe<Course_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Var_Samp_Fields>;
  variance?: Maybe<Course_Variance_Fields>;
};


/** aggregate fields of "course" */
export type Course_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course" */
export type Course_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Max_Order_By>;
  min?: InputMaybe<Course_Min_Order_By>;
  stddev?: InputMaybe<Course_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course" */
export type Course_Arr_Rel_Insert_Input = {
  data: Array<Course_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Avg_Fields = {
  __typename?: 'course_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course" */
export type Course_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course". All fields are combined with a logical 'AND'. */
export type Course_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Bool_Exp>>;
  _not?: InputMaybe<Course_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Bool_Exp>>;
  class_courses?: InputMaybe<Class_Course_Bool_Exp>;
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  config?: InputMaybe<String_Comparison_Exp>;
  course_categories?: InputMaybe<Course_Category_Bool_Exp>;
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Bool_Exp>;
  course_grade_levels?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  course_grade_levels_aggregate?: InputMaybe<Course_Grade_Level_Aggregate_Bool_Exp>;
  course_instructors?: InputMaybe<Course_Instructor_Bool_Exp>;
  course_instructors_aggregate?: InputMaybe<Course_Instructor_Aggregate_Bool_Exp>;
  course_tags?: InputMaybe<Course_Tag_Bool_Exp>;
  course_tags_aggregate?: InputMaybe<Course_Tag_Aggregate_Bool_Exp>;
  course_workspaces?: InputMaybe<Course_Workspace_Bool_Exp>;
  course_workspaces_aggregate?: InputMaybe<Course_Workspace_Aggregate_Bool_Exp>;
  cover?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  group_courses?: InputMaybe<Group_Course_Bool_Exp>;
  group_courses_aggregate?: InputMaybe<Group_Course_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isOnline?: InputMaybe<Boolean_Comparison_Exp>;
  lessons?: InputMaybe<Lesson_Bool_Exp>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Bool_Exp>;
  levels?: InputMaybe<Level_Bool_Exp>;
  levels_aggregate?: InputMaybe<Level_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  overview?: InputMaybe<String_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_courses?: InputMaybe<User_Course_Bool_Exp>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Bool_Exp>;
};

/** columns and relationships of "course_category" */
export type Course_Category = {
  __typename?: 'course_category';
  /** An object relationship */
  category: Category;
  categoryId: Scalars['Int'];
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_category" */
export type Course_Category_Aggregate = {
  __typename?: 'course_category_aggregate';
  aggregate?: Maybe<Course_Category_Aggregate_Fields>;
  nodes: Array<Course_Category>;
};

export type Course_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Category_Aggregate_Bool_Exp_Count>;
};

export type Course_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Category_Select_Column_Course_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Category_Select_Column_Course_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_category" */
export type Course_Category_Aggregate_Fields = {
  __typename?: 'course_category_aggregate_fields';
  avg?: Maybe<Course_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Category_Max_Fields>;
  min?: Maybe<Course_Category_Min_Fields>;
  stddev?: Maybe<Course_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Category_Sum_Fields>;
  var_pop?: Maybe<Course_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Category_Var_Samp_Fields>;
  variance?: Maybe<Course_Category_Variance_Fields>;
};


/** aggregate fields of "course_category" */
export type Course_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_category" */
export type Course_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Category_Max_Order_By>;
  min?: InputMaybe<Course_Category_Min_Order_By>;
  stddev?: InputMaybe<Course_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_category" */
export type Course_Category_Arr_Rel_Insert_Input = {
  data: Array<Course_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Category_Avg_Fields = {
  __typename?: 'course_category_avg_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_category" */
export type Course_Category_Avg_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_category". All fields are combined with a logical 'AND'. */
export type Course_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Category_Bool_Exp>>;
  _not?: InputMaybe<Course_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Category_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Int_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_category" */
export const enum Course_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_2f133fd8aa7a4d85ff7cd6f7c98 = 'PK_2f133fd8aa7a4d85ff7cd6f7c98',
  /** unique or primary key constraint on columns "uid" */
  UqF1d695eabb832ba74db2e7fb908 = 'UQ_f1d695eabb832ba74db2e7fb908'
};

/** input type for incrementing numeric columns in table "course_category" */
export type Course_Category_Inc_Input = {
  categoryId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_category" */
export type Course_Category_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['Int']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Category_Max_Fields = {
  __typename?: 'course_category_max_fields';
  categoryId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_category" */
export type Course_Category_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Category_Min_Fields = {
  __typename?: 'course_category_min_fields';
  categoryId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_category" */
export type Course_Category_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_category" */
export type Course_Category_Mutation_Response = {
  __typename?: 'course_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Category>;
};

/** on_conflict condition type for table "course_category" */
export type Course_Category_On_Conflict = {
  constraint: Course_Category_Constraint;
  update_columns?: Array<Course_Category_Update_Column>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "course_category". */
export type Course_Category_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_category */
export type Course_Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course_category" */
export const enum Course_Category_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "course_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_category" */
export const enum Course_Category_Select_Column_Course_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "course_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_category" */
export const enum Course_Category_Select_Column_Course_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "course_category" */
export type Course_Category_Set_Input = {
  categoryId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Category_Stddev_Fields = {
  __typename?: 'course_category_stddev_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_category" */
export type Course_Category_Stddev_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Category_Stddev_Pop_Fields = {
  __typename?: 'course_category_stddev_pop_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_category" */
export type Course_Category_Stddev_Pop_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Category_Stddev_Samp_Fields = {
  __typename?: 'course_category_stddev_samp_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_category" */
export type Course_Category_Stddev_Samp_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_category" */
export type Course_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Category_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Category_Sum_Fields = {
  __typename?: 'course_category_sum_fields';
  categoryId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_category" */
export type Course_Category_Sum_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "course_category" */
export const enum Course_Category_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Course_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Category_Var_Pop_Fields = {
  __typename?: 'course_category_var_pop_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_category" */
export type Course_Category_Var_Pop_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Category_Var_Samp_Fields = {
  __typename?: 'course_category_var_samp_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_category" */
export type Course_Category_Var_Samp_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Category_Variance_Fields = {
  __typename?: 'course_category_variance_fields';
  categoryId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_category" */
export type Course_Category_Variance_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "course" */
export const enum Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBf95180dd756fd204fb01ce4916 = 'PK_bf95180dd756fd204fb01ce4916',
  /** unique or primary key constraint on columns "uid" */
  Uq_5d79e91a25aefc6912fcaa002ee = 'UQ_5d79e91a25aefc6912fcaa002ee'
};

/** columns and relationships of "course_grade_level" */
export type Course_Grade_Level = {
  __typename?: 'course_grade_level';
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  gradeLevelId: Scalars['Int'];
  /** An object relationship */
  grade_level: Grade_Level;
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_grade_level" */
export type Course_Grade_Level_Aggregate = {
  __typename?: 'course_grade_level_aggregate';
  aggregate?: Maybe<Course_Grade_Level_Aggregate_Fields>;
  nodes: Array<Course_Grade_Level>;
};

export type Course_Grade_Level_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Grade_Level_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Grade_Level_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Grade_Level_Aggregate_Bool_Exp_Count>;
};

export type Course_Grade_Level_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Grade_Level_Select_Column_Course_Grade_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Grade_Level_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Grade_Level_Select_Column_Course_Grade_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Grade_Level_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_grade_level" */
export type Course_Grade_Level_Aggregate_Fields = {
  __typename?: 'course_grade_level_aggregate_fields';
  avg?: Maybe<Course_Grade_Level_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Grade_Level_Max_Fields>;
  min?: Maybe<Course_Grade_Level_Min_Fields>;
  stddev?: Maybe<Course_Grade_Level_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Grade_Level_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Grade_Level_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Grade_Level_Sum_Fields>;
  var_pop?: Maybe<Course_Grade_Level_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Grade_Level_Var_Samp_Fields>;
  variance?: Maybe<Course_Grade_Level_Variance_Fields>;
};


/** aggregate fields of "course_grade_level" */
export type Course_Grade_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_grade_level" */
export type Course_Grade_Level_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Grade_Level_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Grade_Level_Max_Order_By>;
  min?: InputMaybe<Course_Grade_Level_Min_Order_By>;
  stddev?: InputMaybe<Course_Grade_Level_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Grade_Level_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Grade_Level_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Grade_Level_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Grade_Level_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Grade_Level_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Grade_Level_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_grade_level" */
export type Course_Grade_Level_Arr_Rel_Insert_Input = {
  data: Array<Course_Grade_Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Grade_Level_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Grade_Level_Avg_Fields = {
  __typename?: 'course_grade_level_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_grade_level" */
export type Course_Grade_Level_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_grade_level". All fields are combined with a logical 'AND'. */
export type Course_Grade_Level_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Grade_Level_Bool_Exp>>;
  _not?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Grade_Level_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  gradeLevelId?: InputMaybe<Int_Comparison_Exp>;
  grade_level?: InputMaybe<Grade_Level_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_grade_level" */
export const enum Course_Grade_Level_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_7bc5fb2e27404e4edcb749bee29 = 'PK_7bc5fb2e27404e4edcb749bee29',
  /** unique or primary key constraint on columns "uid" */
  Uq_2c68e5f40d6b3f191c45ed2a003 = 'UQ_2c68e5f40d6b3f191c45ed2a003'
};

/** input type for incrementing numeric columns in table "course_grade_level" */
export type Course_Grade_Level_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  gradeLevelId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_grade_level" */
export type Course_Grade_Level_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelId?: InputMaybe<Scalars['Int']>;
  grade_level?: InputMaybe<Grade_Level_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Grade_Level_Max_Fields = {
  __typename?: 'course_grade_level_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeLevelId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_grade_level" */
export type Course_Grade_Level_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Grade_Level_Min_Fields = {
  __typename?: 'course_grade_level_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeLevelId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_grade_level" */
export type Course_Grade_Level_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_grade_level" */
export type Course_Grade_Level_Mutation_Response = {
  __typename?: 'course_grade_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Grade_Level>;
};

/** on_conflict condition type for table "course_grade_level" */
export type Course_Grade_Level_On_Conflict = {
  constraint: Course_Grade_Level_Constraint;
  update_columns?: Array<Course_Grade_Level_Update_Column>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "course_grade_level". */
export type Course_Grade_Level_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  grade_level?: InputMaybe<Grade_Level_Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_grade_level */
export type Course_Grade_Level_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course_grade_level" */
export const enum Course_Grade_Level_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeLevelId = 'gradeLevelId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "course_grade_level_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_grade_level" */
export const enum Course_Grade_Level_Select_Column_Course_Grade_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "course_grade_level_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_grade_level" */
export const enum Course_Grade_Level_Select_Column_Course_Grade_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "course_grade_level" */
export type Course_Grade_Level_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Grade_Level_Stddev_Fields = {
  __typename?: 'course_grade_level_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_grade_level" */
export type Course_Grade_Level_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Grade_Level_Stddev_Pop_Fields = {
  __typename?: 'course_grade_level_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_grade_level" */
export type Course_Grade_Level_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Grade_Level_Stddev_Samp_Fields = {
  __typename?: 'course_grade_level_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_grade_level" */
export type Course_Grade_Level_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_grade_level" */
export type Course_Grade_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Grade_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Grade_Level_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Grade_Level_Sum_Fields = {
  __typename?: 'course_grade_level_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  gradeLevelId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_grade_level" */
export type Course_Grade_Level_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "course_grade_level" */
export const enum Course_Grade_Level_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeLevelId = 'gradeLevelId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Course_Grade_Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Grade_Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Grade_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Grade_Level_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Grade_Level_Var_Pop_Fields = {
  __typename?: 'course_grade_level_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_grade_level" */
export type Course_Grade_Level_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Grade_Level_Var_Samp_Fields = {
  __typename?: 'course_grade_level_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_grade_level" */
export type Course_Grade_Level_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Grade_Level_Variance_Fields = {
  __typename?: 'course_grade_level_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  gradeLevelId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_grade_level" */
export type Course_Grade_Level_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
  gradeLevelId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "course" */
export type Course_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course" */
export type Course_Insert_Input = {
  class_courses?: InputMaybe<Class_Course_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  course_categories?: InputMaybe<Course_Category_Arr_Rel_Insert_Input>;
  course_grade_levels?: InputMaybe<Course_Grade_Level_Arr_Rel_Insert_Input>;
  course_instructors?: InputMaybe<Course_Instructor_Arr_Rel_Insert_Input>;
  course_tags?: InputMaybe<Course_Tag_Arr_Rel_Insert_Input>;
  course_workspaces?: InputMaybe<Course_Workspace_Arr_Rel_Insert_Input>;
  cover?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  group_courses?: InputMaybe<Group_Course_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  lessons?: InputMaybe<Lesson_Arr_Rel_Insert_Input>;
  levels?: InputMaybe<Level_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_courses?: InputMaybe<User_Course_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "course_instructor" */
export type Course_Instructor = {
  __typename?: 'course_instructor';
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  instructor?: Maybe<Instructor>;
  instructorId?: Maybe<Scalars['Int']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_instructor" */
export type Course_Instructor_Aggregate = {
  __typename?: 'course_instructor_aggregate';
  aggregate?: Maybe<Course_Instructor_Aggregate_Fields>;
  nodes: Array<Course_Instructor>;
};

export type Course_Instructor_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Instructor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Instructor_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Instructor_Aggregate_Bool_Exp_Count>;
};

export type Course_Instructor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Instructor_Select_Column_Course_Instructor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Instructor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Instructor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Instructor_Select_Column_Course_Instructor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Instructor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Instructor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Instructor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_instructor" */
export type Course_Instructor_Aggregate_Fields = {
  __typename?: 'course_instructor_aggregate_fields';
  avg?: Maybe<Course_Instructor_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Instructor_Max_Fields>;
  min?: Maybe<Course_Instructor_Min_Fields>;
  stddev?: Maybe<Course_Instructor_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Instructor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Instructor_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Instructor_Sum_Fields>;
  var_pop?: Maybe<Course_Instructor_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Instructor_Var_Samp_Fields>;
  variance?: Maybe<Course_Instructor_Variance_Fields>;
};


/** aggregate fields of "course_instructor" */
export type Course_Instructor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_instructor" */
export type Course_Instructor_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Instructor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Instructor_Max_Order_By>;
  min?: InputMaybe<Course_Instructor_Min_Order_By>;
  stddev?: InputMaybe<Course_Instructor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Instructor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Instructor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Instructor_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Instructor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Instructor_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Instructor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_instructor" */
export type Course_Instructor_Arr_Rel_Insert_Input = {
  data: Array<Course_Instructor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Instructor_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Instructor_Avg_Fields = {
  __typename?: 'course_instructor_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_instructor" */
export type Course_Instructor_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_instructor". All fields are combined with a logical 'AND'. */
export type Course_Instructor_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Instructor_Bool_Exp>>;
  _not?: InputMaybe<Course_Instructor_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Instructor_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instructor?: InputMaybe<Instructor_Bool_Exp>;
  instructorId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_instructor" */
export const enum Course_Instructor_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDeca5c9911b3b2100b361060826 = 'PK_deca5c9911b3b2100b361060826',
  /** unique or primary key constraint on columns "uid" */
  UqB3badd8dcfe2d6a05b5c8495b58 = 'UQ_b3badd8dcfe2d6a05b5c8495b58'
};

/** input type for incrementing numeric columns in table "course_instructor" */
export type Course_Instructor_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  instructorId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_instructor" */
export type Course_Instructor_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instructor?: InputMaybe<Instructor_Obj_Rel_Insert_Input>;
  instructorId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Instructor_Max_Fields = {
  __typename?: 'course_instructor_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  instructorId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_instructor" */
export type Course_Instructor_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Instructor_Min_Fields = {
  __typename?: 'course_instructor_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  instructorId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_instructor" */
export type Course_Instructor_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_instructor" */
export type Course_Instructor_Mutation_Response = {
  __typename?: 'course_instructor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Instructor>;
};

/** on_conflict condition type for table "course_instructor" */
export type Course_Instructor_On_Conflict = {
  constraint: Course_Instructor_Constraint;
  update_columns?: Array<Course_Instructor_Update_Column>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};

/** Ordering options when selecting data from "course_instructor". */
export type Course_Instructor_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructor?: InputMaybe<Instructor_Order_By>;
  instructorId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_instructor */
export type Course_Instructor_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course_instructor" */
export const enum Course_Instructor_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InstructorId = 'instructorId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "course_instructor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_instructor" */
export const enum Course_Instructor_Select_Column_Course_Instructor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "course_instructor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_instructor" */
export const enum Course_Instructor_Select_Column_Course_Instructor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "course_instructor" */
export type Course_Instructor_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instructorId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Instructor_Stddev_Fields = {
  __typename?: 'course_instructor_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_instructor" */
export type Course_Instructor_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Instructor_Stddev_Pop_Fields = {
  __typename?: 'course_instructor_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_instructor" */
export type Course_Instructor_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Instructor_Stddev_Samp_Fields = {
  __typename?: 'course_instructor_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_instructor" */
export type Course_Instructor_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_instructor" */
export type Course_Instructor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Instructor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Instructor_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instructorId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Instructor_Sum_Fields = {
  __typename?: 'course_instructor_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  instructorId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_instructor" */
export type Course_Instructor_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** update columns of table "course_instructor" */
export const enum Course_Instructor_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InstructorId = 'instructorId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Course_Instructor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Instructor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Instructor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Instructor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Instructor_Var_Pop_Fields = {
  __typename?: 'course_instructor_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_instructor" */
export type Course_Instructor_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Instructor_Var_Samp_Fields = {
  __typename?: 'course_instructor_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_instructor" */
export type Course_Instructor_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Instructor_Variance_Fields = {
  __typename?: 'course_instructor_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instructorId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_instructor" */
export type Course_Instructor_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructorId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Course_Max_Fields = {
  __typename?: 'course_max_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course" */
export type Course_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Min_Fields = {
  __typename?: 'course_min_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course" */
export type Course_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course" */
export type Course_Mutation_Response = {
  __typename?: 'course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course>;
};

/** input type for inserting object relation for remote table "course" */
export type Course_Obj_Rel_Insert_Input = {
  data: Course_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_On_Conflict>;
};

/** on_conflict condition type for table "course" */
export type Course_On_Conflict = {
  constraint: Course_Constraint;
  update_columns?: Array<Course_Update_Column>;
  where?: InputMaybe<Course_Bool_Exp>;
};

/** Ordering options when selecting data from "course". */
export type Course_Order_By = {
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Order_By>;
  course_grade_levels_aggregate?: InputMaybe<Course_Grade_Level_Aggregate_Order_By>;
  course_instructors_aggregate?: InputMaybe<Course_Instructor_Aggregate_Order_By>;
  course_tags_aggregate?: InputMaybe<Course_Tag_Aggregate_Order_By>;
  course_workspaces_aggregate?: InputMaybe<Course_Workspace_Aggregate_Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  group_courses_aggregate?: InputMaybe<Group_Course_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isOnline?: InputMaybe<Order_By>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Order_By>;
  levels_aggregate?: InputMaybe<Level_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  published?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Order_By>;
};

/** primary key columns input for table: course */
export type Course_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course" */
export const enum Course_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Color = 'color',
  /** column name */
  Config = 'config',
  /** column name */
  Cover = 'cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Published = 'published',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course" */
export const enum Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  Published = 'published'
};

/** select "course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course" */
export const enum Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  Published = 'published'
};

/** input type for updating data in table "course" */
export type Course_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Stddev_Fields = {
  __typename?: 'course_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course" */
export type Course_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Stddev_Pop_Fields = {
  __typename?: 'course_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course" */
export type Course_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Stddev_Samp_Fields = {
  __typename?: 'course_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course" */
export type Course_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course" */
export type Course_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Sum_Fields = {
  __typename?: 'course_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course" */
export type Course_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_tag" */
export type Course_Tag = {
  __typename?: 'course_tag';
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['Int']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_tag" */
export type Course_Tag_Aggregate = {
  __typename?: 'course_tag_aggregate';
  aggregate?: Maybe<Course_Tag_Aggregate_Fields>;
  nodes: Array<Course_Tag>;
};

export type Course_Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Tag_Aggregate_Bool_Exp_Count>;
};

export type Course_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Tag_Select_Column_Course_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Tag_Select_Column_Course_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_tag" */
export type Course_Tag_Aggregate_Fields = {
  __typename?: 'course_tag_aggregate_fields';
  avg?: Maybe<Course_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Tag_Max_Fields>;
  min?: Maybe<Course_Tag_Min_Fields>;
  stddev?: Maybe<Course_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Tag_Sum_Fields>;
  var_pop?: Maybe<Course_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Tag_Var_Samp_Fields>;
  variance?: Maybe<Course_Tag_Variance_Fields>;
};


/** aggregate fields of "course_tag" */
export type Course_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_tag" */
export type Course_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Tag_Max_Order_By>;
  min?: InputMaybe<Course_Tag_Min_Order_By>;
  stddev?: InputMaybe<Course_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_tag" */
export type Course_Tag_Arr_Rel_Insert_Input = {
  data: Array<Course_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Tag_Avg_Fields = {
  __typename?: 'course_tag_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_tag" */
export type Course_Tag_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_tag". All fields are combined with a logical 'AND'. */
export type Course_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Tag_Bool_Exp>>;
  _not?: InputMaybe<Course_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Tag_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tagId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_tag" */
export const enum Course_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_6c6a0ad4b5f67db91353e5b2ae1 = 'PK_6c6a0ad4b5f67db91353e5b2ae1',
  /** unique or primary key constraint on columns "uid" */
  Uq_0526aa755250794b03c84cbbb8b = 'UQ_0526aa755250794b03c84cbbb8b'
};

/** input type for incrementing numeric columns in table "course_tag" */
export type Course_Tag_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_tag" */
export type Course_Tag_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Tag_Max_Fields = {
  __typename?: 'course_tag_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_tag" */
export type Course_Tag_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Tag_Min_Fields = {
  __typename?: 'course_tag_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_tag" */
export type Course_Tag_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_tag" */
export type Course_Tag_Mutation_Response = {
  __typename?: 'course_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Tag>;
};

/** on_conflict condition type for table "course_tag" */
export type Course_Tag_On_Conflict = {
  constraint: Course_Tag_Constraint;
  update_columns?: Array<Course_Tag_Update_Column>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "course_tag". */
export type Course_Tag_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_tag */
export type Course_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course_tag" */
export const enum Course_Tag_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "course_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_tag" */
export const enum Course_Tag_Select_Column_Course_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "course_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_tag" */
export const enum Course_Tag_Select_Column_Course_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "course_tag" */
export type Course_Tag_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Tag_Stddev_Fields = {
  __typename?: 'course_tag_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_tag" */
export type Course_Tag_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Tag_Stddev_Pop_Fields = {
  __typename?: 'course_tag_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_tag" */
export type Course_Tag_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Tag_Stddev_Samp_Fields = {
  __typename?: 'course_tag_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_tag" */
export type Course_Tag_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_tag" */
export type Course_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Tag_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Tag_Sum_Fields = {
  __typename?: 'course_tag_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_tag" */
export type Course_Tag_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** update columns of table "course_tag" */
export const enum Course_Tag_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Course_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Tag_Var_Pop_Fields = {
  __typename?: 'course_tag_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_tag" */
export type Course_Tag_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Tag_Var_Samp_Fields = {
  __typename?: 'course_tag_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_tag" */
export type Course_Tag_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Tag_Variance_Fields = {
  __typename?: 'course_tag_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_tag" */
export type Course_Tag_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** update columns of table "course" */
export const enum Course_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Color = 'color',
  /** column name */
  Config = 'config',
  /** column name */
  Cover = 'cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Published = 'published',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Course_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Var_Pop_Fields = {
  __typename?: 'course_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course" */
export type Course_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Var_Samp_Fields = {
  __typename?: 'course_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course" */
export type Course_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Variance_Fields = {
  __typename?: 'course_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course" */
export type Course_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_workspace" */
export type Course_Workspace = {
  __typename?: 'course_workspace';
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspace;
  workspaceId: Scalars['Int'];
};

/** aggregated selection of "course_workspace" */
export type Course_Workspace_Aggregate = {
  __typename?: 'course_workspace_aggregate';
  aggregate?: Maybe<Course_Workspace_Aggregate_Fields>;
  nodes: Array<Course_Workspace>;
};

export type Course_Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Workspace_Aggregate_Bool_Exp_Count>;
};

export type Course_Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Workspace_Select_Column_Course_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Workspace_Select_Column_Course_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_workspace" */
export type Course_Workspace_Aggregate_Fields = {
  __typename?: 'course_workspace_aggregate_fields';
  avg?: Maybe<Course_Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Workspace_Max_Fields>;
  min?: Maybe<Course_Workspace_Min_Fields>;
  stddev?: Maybe<Course_Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Workspace_Sum_Fields>;
  var_pop?: Maybe<Course_Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Workspace_Var_Samp_Fields>;
  variance?: Maybe<Course_Workspace_Variance_Fields>;
};


/** aggregate fields of "course_workspace" */
export type Course_Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_workspace" */
export type Course_Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Workspace_Max_Order_By>;
  min?: InputMaybe<Course_Workspace_Min_Order_By>;
  stddev?: InputMaybe<Course_Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_workspace" */
export type Course_Workspace_Arr_Rel_Insert_Input = {
  data: Array<Course_Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Workspace_Avg_Fields = {
  __typename?: 'course_workspace_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_workspace" */
export type Course_Workspace_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_workspace". All fields are combined with a logical 'AND'. */
export type Course_Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Workspace_Bool_Exp>>;
  _not?: InputMaybe<Course_Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Workspace_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workspace?: InputMaybe<Workspace_Bool_Exp>;
  workspaceId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_workspace" */
export const enum Course_Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_0af4f43b07fba4699c5849d440c = 'PK_0af4f43b07fba4699c5849d440c',
  /** unique or primary key constraint on columns "uid" */
  Uq_1aa74474e909f229f3d5fd703ef = 'UQ_1aa74474e909f229f3d5fd703ef',
  /** unique or primary key constraint on columns "workspaceId", "courseId" */
  IndexCourseWorkspace = 'index_course_workspace'
};

/** input type for incrementing numeric columns in table "course_workspace" */
export type Course_Workspace_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_workspace" */
export type Course_Workspace_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace?: InputMaybe<Workspace_Obj_Rel_Insert_Input>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Course_Workspace_Max_Fields = {
  __typename?: 'course_workspace_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "course_workspace" */
export type Course_Workspace_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Workspace_Min_Fields = {
  __typename?: 'course_workspace_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "course_workspace" */
export type Course_Workspace_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_workspace" */
export type Course_Workspace_Mutation_Response = {
  __typename?: 'course_workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Workspace>;
};

/** on_conflict condition type for table "course_workspace" */
export type Course_Workspace_On_Conflict = {
  constraint: Course_Workspace_Constraint;
  update_columns?: Array<Course_Workspace_Update_Column>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "course_workspace". */
export type Course_Workspace_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspace?: InputMaybe<Workspace_Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_workspace */
export type Course_Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "course_workspace" */
export const enum Course_Workspace_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

/** select "course_workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_workspace" */
export const enum Course_Workspace_Select_Column_Course_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "course_workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_workspace" */
export const enum Course_Workspace_Select_Column_Course_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "course_workspace" */
export type Course_Workspace_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Course_Workspace_Stddev_Fields = {
  __typename?: 'course_workspace_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_workspace" */
export type Course_Workspace_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Workspace_Stddev_Pop_Fields = {
  __typename?: 'course_workspace_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_workspace" */
export type Course_Workspace_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Workspace_Stddev_Samp_Fields = {
  __typename?: 'course_workspace_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_workspace" */
export type Course_Workspace_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_workspace" */
export type Course_Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Workspace_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Course_Workspace_Sum_Fields = {
  __typename?: 'course_workspace_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_workspace" */
export type Course_Workspace_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** update columns of table "course_workspace" */
export const enum Course_Workspace_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

export type Course_Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Workspace_Var_Pop_Fields = {
  __typename?: 'course_workspace_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_workspace" */
export type Course_Workspace_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Workspace_Var_Samp_Fields = {
  __typename?: 'course_workspace_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_workspace" */
export type Course_Workspace_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Workspace_Variance_Fields = {
  __typename?: 'course_workspace_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_workspace" */
export type Course_Workspace_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export const enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
};

/** columns and relationships of "dnd" */
export type Dnd = {
  __typename?: 'dnd';
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  question_options: Array<Question_Option>;
  /** An aggregate relationship */
  question_options_aggregate: Question_Option_Aggregate;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "dnd" */
export type DndBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndQuestion_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndQuestion_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "dnd" */
export type DndQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** aggregated selection of "dnd" */
export type Dnd_Aggregate = {
  __typename?: 'dnd_aggregate';
  aggregate?: Maybe<Dnd_Aggregate_Fields>;
  nodes: Array<Dnd>;
};

export type Dnd_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Dnd_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Dnd_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Dnd_Aggregate_Bool_Exp_Count>;
};

export type Dnd_Aggregate_Bool_Exp_Bool_And = {
  arguments: Dnd_Select_Column_Dnd_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dnd_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dnd_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Dnd_Select_Column_Dnd_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dnd_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dnd_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dnd_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dnd_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dnd" */
export type Dnd_Aggregate_Fields = {
  __typename?: 'dnd_aggregate_fields';
  avg?: Maybe<Dnd_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Dnd_Max_Fields>;
  min?: Maybe<Dnd_Min_Fields>;
  stddev?: Maybe<Dnd_Stddev_Fields>;
  stddev_pop?: Maybe<Dnd_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dnd_Stddev_Samp_Fields>;
  sum?: Maybe<Dnd_Sum_Fields>;
  var_pop?: Maybe<Dnd_Var_Pop_Fields>;
  var_samp?: Maybe<Dnd_Var_Samp_Fields>;
  variance?: Maybe<Dnd_Variance_Fields>;
};


/** aggregate fields of "dnd" */
export type Dnd_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dnd_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dnd" */
export type Dnd_Aggregate_Order_By = {
  avg?: InputMaybe<Dnd_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dnd_Max_Order_By>;
  min?: InputMaybe<Dnd_Min_Order_By>;
  stddev?: InputMaybe<Dnd_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dnd_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dnd_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dnd_Sum_Order_By>;
  var_pop?: InputMaybe<Dnd_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dnd_Var_Samp_Order_By>;
  variance?: InputMaybe<Dnd_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dnd" */
export type Dnd_Arr_Rel_Insert_Input = {
  data: Array<Dnd_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dnd_On_Conflict>;
};

/** aggregate avg on columns */
export type Dnd_Avg_Fields = {
  __typename?: 'dnd_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "dnd" */
export type Dnd_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dnd". All fields are combined with a logical 'AND'. */
export type Dnd_Bool_Exp = {
  _and?: InputMaybe<Array<Dnd_Bool_Exp>>;
  _not?: InputMaybe<Dnd_Bool_Exp>;
  _or?: InputMaybe<Array<Dnd_Bool_Exp>>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_options?: InputMaybe<Question_Option_Bool_Exp>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dnd" */
export const enum Dnd_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_2e3196bbce9a161b90302f8af86 = 'PK_2e3196bbce9a161b90302f8af86',
  /** unique or primary key constraint on columns "uid" */
  UqA67317f40b9ab42dea60b434016 = 'UQ_a67317f40b9ab42dea60b434016'
};

/** input type for incrementing numeric columns in table "dnd" */
export type Dnd_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "dnd" */
export type Dnd_Insert_Input = {
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_options?: InputMaybe<Question_Option_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Dnd_Max_Fields = {
  __typename?: 'dnd_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "dnd" */
export type Dnd_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dnd_Min_Fields = {
  __typename?: 'dnd_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "dnd" */
export type Dnd_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dnd" */
export type Dnd_Mutation_Response = {
  __typename?: 'dnd_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dnd>;
};

/** input type for inserting object relation for remote table "dnd" */
export type Dnd_Obj_Rel_Insert_Input = {
  data: Dnd_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dnd_On_Conflict>;
};

/** on_conflict condition type for table "dnd" */
export type Dnd_On_Conflict = {
  constraint: Dnd_Constraint;
  update_columns?: Array<Dnd_Update_Column>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};

/** Ordering options when selecting data from "dnd". */
export type Dnd_Order_By = {
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dnd */
export type Dnd_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "dnd" */
export const enum Dnd_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "dnd_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dnd" */
export const enum Dnd_Select_Column_Dnd_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "dnd_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dnd" */
export const enum Dnd_Select_Column_Dnd_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "dnd" */
export type Dnd_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Dnd_Stddev_Fields = {
  __typename?: 'dnd_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "dnd" */
export type Dnd_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dnd_Stddev_Pop_Fields = {
  __typename?: 'dnd_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "dnd" */
export type Dnd_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dnd_Stddev_Samp_Fields = {
  __typename?: 'dnd_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "dnd" */
export type Dnd_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dnd" */
export type Dnd_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dnd_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dnd_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Dnd_Sum_Fields = {
  __typename?: 'dnd_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "dnd" */
export type Dnd_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "dnd" */
export const enum Dnd_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Dnd_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dnd_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dnd_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dnd_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dnd_Var_Pop_Fields = {
  __typename?: 'dnd_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "dnd" */
export type Dnd_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dnd_Var_Samp_Fields = {
  __typename?: 'dnd_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "dnd" */
export type Dnd_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dnd_Variance_Fields = {
  __typename?: 'dnd_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "dnd" */
export type Dnd_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "event_classroom" */
export type Event_Classroom = {
  __typename?: 'event_classroom';
  calendarEventId: Scalars['Int'];
  /** An object relationship */
  calendar_event: Calendar_Event;
  /** An object relationship */
  classroom: Classroom;
  classroomId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "event_classroom" */
export type Event_Classroom_Aggregate = {
  __typename?: 'event_classroom_aggregate';
  aggregate?: Maybe<Event_Classroom_Aggregate_Fields>;
  nodes: Array<Event_Classroom>;
};

export type Event_Classroom_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp_Count>;
};

export type Event_Classroom_Aggregate_Bool_Exp_Bool_And = {
  arguments: Event_Classroom_Select_Column_Event_Classroom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Classroom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Event_Classroom_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Event_Classroom_Select_Column_Event_Classroom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Classroom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Event_Classroom_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Classroom_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "event_classroom" */
export type Event_Classroom_Aggregate_Fields = {
  __typename?: 'event_classroom_aggregate_fields';
  avg?: Maybe<Event_Classroom_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Event_Classroom_Max_Fields>;
  min?: Maybe<Event_Classroom_Min_Fields>;
  stddev?: Maybe<Event_Classroom_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Classroom_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Classroom_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Classroom_Sum_Fields>;
  var_pop?: Maybe<Event_Classroom_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Classroom_Var_Samp_Fields>;
  variance?: Maybe<Event_Classroom_Variance_Fields>;
};


/** aggregate fields of "event_classroom" */
export type Event_Classroom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_classroom" */
export type Event_Classroom_Aggregate_Order_By = {
  avg?: InputMaybe<Event_Classroom_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Classroom_Max_Order_By>;
  min?: InputMaybe<Event_Classroom_Min_Order_By>;
  stddev?: InputMaybe<Event_Classroom_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Event_Classroom_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Event_Classroom_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Event_Classroom_Sum_Order_By>;
  var_pop?: InputMaybe<Event_Classroom_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Event_Classroom_Var_Samp_Order_By>;
  variance?: InputMaybe<Event_Classroom_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "event_classroom" */
export type Event_Classroom_Arr_Rel_Insert_Input = {
  data: Array<Event_Classroom_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Classroom_On_Conflict>;
};

/** aggregate avg on columns */
export type Event_Classroom_Avg_Fields = {
  __typename?: 'event_classroom_avg_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_classroom" */
export type Event_Classroom_Avg_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "event_classroom". All fields are combined with a logical 'AND'. */
export type Event_Classroom_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Classroom_Bool_Exp>>;
  _not?: InputMaybe<Event_Classroom_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Classroom_Bool_Exp>>;
  calendarEventId?: InputMaybe<Int_Comparison_Exp>;
  calendar_event?: InputMaybe<Calendar_Event_Bool_Exp>;
  classroom?: InputMaybe<Classroom_Bool_Exp>;
  classroomId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_classroom" */
export const enum Event_Classroom_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_3d0a0c33a1d5099f83e4343eca7 = 'PK_3d0a0c33a1d5099f83e4343eca7',
  /** unique or primary key constraint on columns "calendarEventId" */
  Uq_6f8f0185146347611f9043e7736 = 'UQ_6f8f0185146347611f9043e7736',
  /** unique or primary key constraint on columns "uid" */
  Uq_962a4ffdc66e21ee0d8465709c8 = 'UQ_962a4ffdc66e21ee0d8465709c8'
};

/** input type for incrementing numeric columns in table "event_classroom" */
export type Event_Classroom_Inc_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_classroom" */
export type Event_Classroom_Insert_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  calendar_event?: InputMaybe<Calendar_Event_Obj_Rel_Insert_Input>;
  classroom?: InputMaybe<Classroom_Obj_Rel_Insert_Input>;
  classroomId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Event_Classroom_Max_Fields = {
  __typename?: 'event_classroom_max_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_classroom" */
export type Event_Classroom_Max_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Classroom_Min_Fields = {
  __typename?: 'event_classroom_min_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_classroom" */
export type Event_Classroom_Min_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "event_classroom" */
export type Event_Classroom_Mutation_Response = {
  __typename?: 'event_classroom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Classroom>;
};

/** input type for inserting object relation for remote table "event_classroom" */
export type Event_Classroom_Obj_Rel_Insert_Input = {
  data: Event_Classroom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Classroom_On_Conflict>;
};

/** on_conflict condition type for table "event_classroom" */
export type Event_Classroom_On_Conflict = {
  constraint: Event_Classroom_Constraint;
  update_columns?: Array<Event_Classroom_Update_Column>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};

/** Ordering options when selecting data from "event_classroom". */
export type Event_Classroom_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  calendar_event?: InputMaybe<Calendar_Event_Order_By>;
  classroom?: InputMaybe<Classroom_Order_By>;
  classroomId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_classroom */
export type Event_Classroom_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "event_classroom" */
export const enum Event_Classroom_Select_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  ClassroomId = 'classroomId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "event_classroom_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event_classroom" */
export const enum Event_Classroom_Select_Column_Event_Classroom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "event_classroom_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event_classroom" */
export const enum Event_Classroom_Select_Column_Event_Classroom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "event_classroom" */
export type Event_Classroom_Set_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Event_Classroom_Stddev_Fields = {
  __typename?: 'event_classroom_stddev_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_classroom" */
export type Event_Classroom_Stddev_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Event_Classroom_Stddev_Pop_Fields = {
  __typename?: 'event_classroom_stddev_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_classroom" */
export type Event_Classroom_Stddev_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Event_Classroom_Stddev_Samp_Fields = {
  __typename?: 'event_classroom_stddev_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_classroom" */
export type Event_Classroom_Stddev_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "event_classroom" */
export type Event_Classroom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Classroom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Classroom_Stream_Cursor_Value_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Event_Classroom_Sum_Fields = {
  __typename?: 'event_classroom_sum_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_classroom" */
export type Event_Classroom_Sum_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "event_classroom" */
export const enum Event_Classroom_Update_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  ClassroomId = 'classroomId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Event_Classroom_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Event_Classroom_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Classroom_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_Classroom_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Event_Classroom_Var_Pop_Fields = {
  __typename?: 'event_classroom_var_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_classroom" */
export type Event_Classroom_Var_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Event_Classroom_Var_Samp_Fields = {
  __typename?: 'event_classroom_var_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_classroom" */
export type Event_Classroom_Var_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Event_Classroom_Variance_Fields = {
  __typename?: 'event_classroom_variance_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classroomId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_classroom" */
export type Event_Classroom_Variance_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classroomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "feedback" */
export type Feedback = {
  __typename?: 'feedback';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  payload: Scalars['jsonb'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "feedback" */
export type FeedbackPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "feedback" */
export type Feedback_Aggregate = {
  __typename?: 'feedback_aggregate';
  aggregate?: Maybe<Feedback_Aggregate_Fields>;
  nodes: Array<Feedback>;
};

/** aggregate fields of "feedback" */
export type Feedback_Aggregate_Fields = {
  __typename?: 'feedback_aggregate_fields';
  avg?: Maybe<Feedback_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Max_Fields>;
  min?: Maybe<Feedback_Min_Fields>;
  stddev?: Maybe<Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Sum_Fields>;
  var_pop?: Maybe<Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Variance_Fields>;
};


/** aggregate fields of "feedback" */
export type Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Feedback_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Feedback_Avg_Fields = {
  __typename?: 'feedback_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback". All fields are combined with a logical 'AND'. */
export type Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback" */
export const enum Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_8389f9e087a57689cd5be8b2b13 = 'PK_8389f9e087a57689cd5be8b2b13',
  /** unique or primary key constraint on columns "uid" */
  Uq_87615c827c0389fe8569c784783 = 'UQ_87615c827c0389fe8569c784783'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Feedback_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Feedback_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Feedback_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "feedback" */
export type Feedback_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback" */
export type Feedback_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Max_Fields = {
  __typename?: 'feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feedback_Min_Fields = {
  __typename?: 'feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "feedback" */
export type Feedback_Mutation_Response = {
  __typename?: 'feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback>;
};

/** on_conflict condition type for table "feedback" */
export type Feedback_On_Conflict = {
  constraint: Feedback_Constraint;
  update_columns?: Array<Feedback_Update_Column>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback". */
export type Feedback_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback */
export type Feedback_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Feedback_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "feedback" */
export const enum Feedback_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** input type for updating data in table "feedback" */
export type Feedback_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feedback_Stddev_Fields = {
  __typename?: 'feedback_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Stddev_Pop_Fields = {
  __typename?: 'feedback_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Stddev_Samp_Fields = {
  __typename?: 'feedback_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback" */
export type Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feedback_Sum_Fields = {
  __typename?: 'feedback_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "feedback" */
export const enum Feedback_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Feedback_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Feedback_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Feedback_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Feedback_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Feedback_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Feedback_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Var_Pop_Fields = {
  __typename?: 'feedback_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Var_Samp_Fields = {
  __typename?: 'feedback_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Variance_Fields = {
  __typename?: 'feedback_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "file" */
export type File = {
  __typename?: 'file';
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  /** An array relationship */
  class_course_resources: Array<Class_Course_Resource>;
  /** An aggregate relationship */
  class_course_resources_aggregate: Class_Course_Resource_Aggregate;
  config: Scalars['jsonb'];
  createdById: Scalars['Int'];
  /** An object relationship */
  createdByUser: User;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  size: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "file" */
export type FileBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileClass_Course_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileClass_Course_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "file" */
export type File_Aggregate = {
  __typename?: 'file_aggregate';
  aggregate?: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

export type File_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<File_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<File_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<File_Aggregate_Bool_Exp_Count>;
};

export type File_Aggregate_Bool_Exp_Bool_And = {
  arguments: File_Select_Column_File_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<File_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type File_Aggregate_Bool_Exp_Bool_Or = {
  arguments: File_Select_Column_File_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<File_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "file" */
export type File_Aggregate_Fields = {
  __typename?: 'file_aggregate_fields';
  avg?: Maybe<File_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<File_Max_Fields>;
  min?: Maybe<File_Min_Fields>;
  stddev?: Maybe<File_Stddev_Fields>;
  stddev_pop?: Maybe<File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Stddev_Samp_Fields>;
  sum?: Maybe<File_Sum_Fields>;
  var_pop?: Maybe<File_Var_Pop_Fields>;
  var_samp?: Maybe<File_Var_Samp_Fields>;
  variance?: Maybe<File_Variance_Fields>;
};


/** aggregate fields of "file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file" */
export type File_Aggregate_Order_By = {
  avg?: InputMaybe<File_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Max_Order_By>;
  min?: InputMaybe<File_Min_Order_By>;
  stddev?: InputMaybe<File_Stddev_Order_By>;
  stddev_pop?: InputMaybe<File_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<File_Stddev_Samp_Order_By>;
  sum?: InputMaybe<File_Sum_Order_By>;
  var_pop?: InputMaybe<File_Var_Pop_Order_By>;
  var_samp?: InputMaybe<File_Var_Samp_Order_By>;
  variance?: InputMaybe<File_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type File_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "file" */
export type File_Arr_Rel_Insert_Input = {
  data: Array<File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** aggregate avg on columns */
export type File_Avg_Fields = {
  __typename?: 'file_avg_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "file" */
export type File_Avg_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "file" */
export const enum File_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_36b46d232307066b3a2c9ea3a1d = 'PK_36b46d232307066b3a2c9ea3a1d',
  /** unique or primary key constraint on columns "uid" */
  UqF46ea043f91e2bd922dfa58bcf2 = 'UQ_f46ea043f91e2bd922dfa58bcf2'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type File_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type File_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type File_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "file" */
export type File_Inc_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Arr_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['jsonb']>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  __typename?: 'file_max_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "file" */
export type File_Max_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  __typename?: 'file_min_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "file" */
export type File_Min_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  __typename?: 'file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** on_conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** Ordering options when selecting data from "file". */
export type File_Order_By = {
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Order_By>;
  config?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file */
export type File_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type File_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "file" */
export const enum File_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Path = 'path',
  /** column name */
  Size = 'size',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "file_aggregate_bool_exp_bool_and_arguments_columns" columns of table "file" */
export const enum File_Select_Column_File_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "file_aggregate_bool_exp_bool_or_arguments_columns" columns of table "file" */
export const enum File_Select_Column_File_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "file" */
export type File_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type File_Stddev_Fields = {
  __typename?: 'file_stddev_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "file" */
export type File_Stddev_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type File_Stddev_Pop_Fields = {
  __typename?: 'file_stddev_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "file" */
export type File_Stddev_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type File_Stddev_Samp_Fields = {
  __typename?: 'file_stddev_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "file" */
export type File_Stddev_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type File_Sum_Fields = {
  __typename?: 'file_sum_fields';
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "file" */
export type File_Sum_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** update columns of table "file" */
export const enum File_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Path = 'path',
  /** column name */
  Size = 'size',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type File_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<File_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<File_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<File_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Bool_Exp;
};

/** aggregate var_pop on columns */
export type File_Var_Pop_Fields = {
  __typename?: 'file_var_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "file" */
export type File_Var_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type File_Var_Samp_Fields = {
  __typename?: 'file_var_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "file" */
export type File_Var_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type File_Variance_Fields = {
  __typename?: 'file_variance_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "file" */
export type File_Variance_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "fill_blank" */
export type Fill_Blank = {
  __typename?: 'fill_blank';
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  question_options: Array<Question_Option>;
  /** An aggregate relationship */
  question_options_aggregate: Question_Option_Aggregate;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankQuestion_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankQuestion_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "fill_blank" */
export type Fill_BlankQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** aggregated selection of "fill_blank" */
export type Fill_Blank_Aggregate = {
  __typename?: 'fill_blank_aggregate';
  aggregate?: Maybe<Fill_Blank_Aggregate_Fields>;
  nodes: Array<Fill_Blank>;
};

export type Fill_Blank_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Fill_Blank_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Fill_Blank_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Fill_Blank_Aggregate_Bool_Exp_Count>;
};

export type Fill_Blank_Aggregate_Bool_Exp_Bool_And = {
  arguments: Fill_Blank_Select_Column_Fill_Blank_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fill_Blank_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fill_Blank_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Fill_Blank_Select_Column_Fill_Blank_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fill_Blank_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fill_Blank_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fill_Blank_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fill_blank" */
export type Fill_Blank_Aggregate_Fields = {
  __typename?: 'fill_blank_aggregate_fields';
  avg?: Maybe<Fill_Blank_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fill_Blank_Max_Fields>;
  min?: Maybe<Fill_Blank_Min_Fields>;
  stddev?: Maybe<Fill_Blank_Stddev_Fields>;
  stddev_pop?: Maybe<Fill_Blank_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fill_Blank_Stddev_Samp_Fields>;
  sum?: Maybe<Fill_Blank_Sum_Fields>;
  var_pop?: Maybe<Fill_Blank_Var_Pop_Fields>;
  var_samp?: Maybe<Fill_Blank_Var_Samp_Fields>;
  variance?: Maybe<Fill_Blank_Variance_Fields>;
};


/** aggregate fields of "fill_blank" */
export type Fill_Blank_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fill_blank" */
export type Fill_Blank_Aggregate_Order_By = {
  avg?: InputMaybe<Fill_Blank_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fill_Blank_Max_Order_By>;
  min?: InputMaybe<Fill_Blank_Min_Order_By>;
  stddev?: InputMaybe<Fill_Blank_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fill_Blank_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fill_Blank_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fill_Blank_Sum_Order_By>;
  var_pop?: InputMaybe<Fill_Blank_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fill_Blank_Var_Samp_Order_By>;
  variance?: InputMaybe<Fill_Blank_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fill_blank" */
export type Fill_Blank_Arr_Rel_Insert_Input = {
  data: Array<Fill_Blank_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fill_Blank_On_Conflict>;
};

/** aggregate avg on columns */
export type Fill_Blank_Avg_Fields = {
  __typename?: 'fill_blank_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fill_blank" */
export type Fill_Blank_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fill_blank". All fields are combined with a logical 'AND'. */
export type Fill_Blank_Bool_Exp = {
  _and?: InputMaybe<Array<Fill_Blank_Bool_Exp>>;
  _not?: InputMaybe<Fill_Blank_Bool_Exp>;
  _or?: InputMaybe<Array<Fill_Blank_Bool_Exp>>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_options?: InputMaybe<Question_Option_Bool_Exp>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "fill_blank" */
export const enum Fill_Blank_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_5542c65c6c5a1a5762bcbcf7f00 = 'PK_5542c65c6c5a1a5762bcbcf7f00',
  /** unique or primary key constraint on columns "uid" */
  Uq_4199732dbf9cd61a3a73f1090f4 = 'UQ_4199732dbf9cd61a3a73f1090f4'
};

/** input type for incrementing numeric columns in table "fill_blank" */
export type Fill_Blank_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "fill_blank" */
export type Fill_Blank_Insert_Input = {
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_options?: InputMaybe<Question_Option_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Fill_Blank_Max_Fields = {
  __typename?: 'fill_blank_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "fill_blank" */
export type Fill_Blank_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fill_Blank_Min_Fields = {
  __typename?: 'fill_blank_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "fill_blank" */
export type Fill_Blank_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fill_blank" */
export type Fill_Blank_Mutation_Response = {
  __typename?: 'fill_blank_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fill_Blank>;
};

/** input type for inserting object relation for remote table "fill_blank" */
export type Fill_Blank_Obj_Rel_Insert_Input = {
  data: Fill_Blank_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fill_Blank_On_Conflict>;
};

/** on_conflict condition type for table "fill_blank" */
export type Fill_Blank_On_Conflict = {
  constraint: Fill_Blank_Constraint;
  update_columns?: Array<Fill_Blank_Update_Column>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};

/** Ordering options when selecting data from "fill_blank". */
export type Fill_Blank_Order_By = {
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fill_blank */
export type Fill_Blank_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "fill_blank" */
export const enum Fill_Blank_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "fill_blank_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fill_blank" */
export const enum Fill_Blank_Select_Column_Fill_Blank_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "fill_blank_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fill_blank" */
export const enum Fill_Blank_Select_Column_Fill_Blank_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "fill_blank" */
export type Fill_Blank_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Fill_Blank_Stddev_Fields = {
  __typename?: 'fill_blank_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fill_blank" */
export type Fill_Blank_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fill_Blank_Stddev_Pop_Fields = {
  __typename?: 'fill_blank_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fill_blank" */
export type Fill_Blank_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fill_Blank_Stddev_Samp_Fields = {
  __typename?: 'fill_blank_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fill_blank" */
export type Fill_Blank_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fill_blank" */
export type Fill_Blank_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fill_Blank_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fill_Blank_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Fill_Blank_Sum_Fields = {
  __typename?: 'fill_blank_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "fill_blank" */
export type Fill_Blank_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "fill_blank" */
export const enum Fill_Blank_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Fill_Blank_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fill_Blank_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fill_Blank_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fill_Blank_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fill_Blank_Var_Pop_Fields = {
  __typename?: 'fill_blank_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fill_blank" */
export type Fill_Blank_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fill_Blank_Var_Samp_Fields = {
  __typename?: 'fill_blank_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fill_blank" */
export type Fill_Blank_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fill_Blank_Variance_Fields = {
  __typename?: 'fill_blank_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fill_blank" */
export type Fill_Blank_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "grade" */
export type Grade = {
  __typename?: 'grade';
  assignmentId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  grade_values: Array<Grade_Value>;
  /** An aggregate relationship */
  grade_values_aggregate: Grade_Value_Aggregate;
  /** An object relationship */
  gradebook?: Maybe<Gradebook>;
  gradebookId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  visibleToStudents: Scalars['Boolean'];
  weight: Scalars['float8'];
};


/** columns and relationships of "grade" */
export type GradeGrade_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "grade" */
export type GradeGrade_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};

/** aggregated selection of "grade" */
export type Grade_Aggregate = {
  __typename?: 'grade_aggregate';
  aggregate?: Maybe<Grade_Aggregate_Fields>;
  nodes: Array<Grade>;
};

export type Grade_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Grade_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Grade_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Grade_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Grade_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Grade_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Grade_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Grade_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Grade_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Grade_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Grade_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Grade_Aggregate_Bool_Exp_Var_Samp>;
};

export type Grade_Aggregate_Bool_Exp_Avg = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Bool_And = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Corr = {
  arguments: Grade_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Grade_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Grade_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Grade_Aggregate_Bool_Exp_Max = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Min = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Sum = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Grade_Select_Column_Grade_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "grade" */
export type Grade_Aggregate_Fields = {
  __typename?: 'grade_aggregate_fields';
  avg?: Maybe<Grade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Max_Fields>;
  min?: Maybe<Grade_Min_Fields>;
  stddev?: Maybe<Grade_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Sum_Fields>;
  var_pop?: Maybe<Grade_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Var_Samp_Fields>;
  variance?: Maybe<Grade_Variance_Fields>;
};


/** aggregate fields of "grade" */
export type Grade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grade" */
export type Grade_Aggregate_Order_By = {
  avg?: InputMaybe<Grade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grade_Max_Order_By>;
  min?: InputMaybe<Grade_Min_Order_By>;
  stddev?: InputMaybe<Grade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Grade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Grade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Grade_Sum_Order_By>;
  var_pop?: InputMaybe<Grade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Grade_Var_Samp_Order_By>;
  variance?: InputMaybe<Grade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "grade" */
export type Grade_Arr_Rel_Insert_Input = {
  data: Array<Grade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};

/** aggregate avg on columns */
export type Grade_Avg_Fields = {
  __typename?: 'grade_avg_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grade" */
export type Grade_Avg_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "grade". All fields are combined with a logical 'AND'. */
export type Grade_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Bool_Exp>>;
  _not?: InputMaybe<Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Bool_Exp>>;
  assignmentId?: InputMaybe<Int_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  grade_values?: InputMaybe<Grade_Value_Bool_Exp>;
  grade_values_aggregate?: InputMaybe<Grade_Value_Aggregate_Bool_Exp>;
  gradebook?: InputMaybe<Gradebook_Bool_Exp>;
  gradebookId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibleToStudents?: InputMaybe<Boolean_Comparison_Exp>;
  weight?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade" */
export const enum Grade_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_58c2176c3ae96bf57daebdbcb5e = 'PK_58c2176c3ae96bf57daebdbcb5e',
  /** unique or primary key constraint on columns "assignmentId" */
  Uq_88a81bf856632af9c5e762d0985 = 'UQ_88a81bf856632af9c5e762d0985',
  /** unique or primary key constraint on columns "uid" */
  UqD3895e5641d5389e3ef8d324062 = 'UQ_d3895e5641d5389e3ef8d324062'
};

/** input type for incrementing numeric columns in table "grade" */
export type Grade_Inc_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  gradebookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "grade" */
export type Grade_Insert_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  grade_values?: InputMaybe<Grade_Value_Arr_Rel_Insert_Input>;
  gradebook?: InputMaybe<Gradebook_Obj_Rel_Insert_Input>;
  gradebookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "grade_level" */
export type Grade_Level = {
  __typename?: 'grade_level';
  /** An array relationship */
  course_grade_levels: Array<Course_Grade_Level>;
  /** An aggregate relationship */
  course_grade_levels_aggregate: Course_Grade_Level_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  gradeLevelGroupId: Scalars['Int'];
  /** An object relationship */
  grade_level_group: Grade_Level_Group;
  id: Scalars['Int'];
  /** An object relationship */
  tag: Tag;
  tagId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "grade_level" */
export type Grade_LevelCourse_Grade_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


/** columns and relationships of "grade_level" */
export type Grade_LevelCourse_Grade_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};

/** aggregated selection of "grade_level" */
export type Grade_Level_Aggregate = {
  __typename?: 'grade_level_aggregate';
  aggregate?: Maybe<Grade_Level_Aggregate_Fields>;
  nodes: Array<Grade_Level>;
};

export type Grade_Level_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Grade_Level_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Grade_Level_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Grade_Level_Aggregate_Bool_Exp_Count>;
};

export type Grade_Level_Aggregate_Bool_Exp_Bool_And = {
  arguments: Grade_Level_Select_Column_Grade_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Level_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Grade_Level_Select_Column_Grade_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Level_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Grade_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "grade_level" */
export type Grade_Level_Aggregate_Fields = {
  __typename?: 'grade_level_aggregate_fields';
  avg?: Maybe<Grade_Level_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Level_Max_Fields>;
  min?: Maybe<Grade_Level_Min_Fields>;
  stddev?: Maybe<Grade_Level_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Level_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Level_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Level_Sum_Fields>;
  var_pop?: Maybe<Grade_Level_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Level_Var_Samp_Fields>;
  variance?: Maybe<Grade_Level_Variance_Fields>;
};


/** aggregate fields of "grade_level" */
export type Grade_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grade_level" */
export type Grade_Level_Aggregate_Order_By = {
  avg?: InputMaybe<Grade_Level_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grade_Level_Max_Order_By>;
  min?: InputMaybe<Grade_Level_Min_Order_By>;
  stddev?: InputMaybe<Grade_Level_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Grade_Level_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Grade_Level_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Grade_Level_Sum_Order_By>;
  var_pop?: InputMaybe<Grade_Level_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Grade_Level_Var_Samp_Order_By>;
  variance?: InputMaybe<Grade_Level_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "grade_level" */
export type Grade_Level_Arr_Rel_Insert_Input = {
  data: Array<Grade_Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Level_On_Conflict>;
};

/** aggregate avg on columns */
export type Grade_Level_Avg_Fields = {
  __typename?: 'grade_level_avg_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grade_level" */
export type Grade_Level_Avg_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "grade_level". All fields are combined with a logical 'AND'. */
export type Grade_Level_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Level_Bool_Exp>>;
  _not?: InputMaybe<Grade_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Level_Bool_Exp>>;
  course_grade_levels?: InputMaybe<Course_Grade_Level_Bool_Exp>;
  course_grade_levels_aggregate?: InputMaybe<Course_Grade_Level_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  gradeLevelGroupId?: InputMaybe<Int_Comparison_Exp>;
  grade_level_group?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tagId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_level" */
export const enum Grade_Level_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_671ed744b09956194024b8b7645 = 'PK_671ed744b09956194024b8b7645',
  /** unique or primary key constraint on columns "uid" */
  Uq_766251e303aa38b8b77a86600ea = 'UQ_766251e303aa38b8b77a86600ea',
  /** unique or primary key constraint on columns "tagId", "gradeLevelGroupId" */
  IndexGradeLevel = 'index_grade_level'
};

/** columns and relationships of "grade_level_group" */
export type Grade_Level_Group = {
  __typename?: 'grade_level_group';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  grade_levels: Array<Grade_Level>;
  /** An aggregate relationship */
  grade_levels_aggregate: Grade_Level_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "grade_level_group" */
export type Grade_Level_GroupGrade_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


/** columns and relationships of "grade_level_group" */
export type Grade_Level_GroupGrade_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};

/** aggregated selection of "grade_level_group" */
export type Grade_Level_Group_Aggregate = {
  __typename?: 'grade_level_group_aggregate';
  aggregate?: Maybe<Grade_Level_Group_Aggregate_Fields>;
  nodes: Array<Grade_Level_Group>;
};

export type Grade_Level_Group_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Grade_Level_Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Grade_Level_Group_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Grade_Level_Group_Aggregate_Bool_Exp_Count>;
};

export type Grade_Level_Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: Grade_Level_Group_Select_Column_Grade_Level_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Level_Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Grade_Level_Group_Select_Column_Grade_Level_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Level_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "grade_level_group" */
export type Grade_Level_Group_Aggregate_Fields = {
  __typename?: 'grade_level_group_aggregate_fields';
  avg?: Maybe<Grade_Level_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Level_Group_Max_Fields>;
  min?: Maybe<Grade_Level_Group_Min_Fields>;
  stddev?: Maybe<Grade_Level_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Level_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Level_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Level_Group_Sum_Fields>;
  var_pop?: Maybe<Grade_Level_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Level_Group_Var_Samp_Fields>;
  variance?: Maybe<Grade_Level_Group_Variance_Fields>;
};


/** aggregate fields of "grade_level_group" */
export type Grade_Level_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grade_level_group" */
export type Grade_Level_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Grade_Level_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grade_Level_Group_Max_Order_By>;
  min?: InputMaybe<Grade_Level_Group_Min_Order_By>;
  stddev?: InputMaybe<Grade_Level_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Grade_Level_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Grade_Level_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Grade_Level_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Grade_Level_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Grade_Level_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Grade_Level_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "grade_level_group" */
export type Grade_Level_Group_Arr_Rel_Insert_Input = {
  data: Array<Grade_Level_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Level_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Grade_Level_Group_Avg_Fields = {
  __typename?: 'grade_level_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grade_level_group" */
export type Grade_Level_Group_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "grade_level_group". All fields are combined with a logical 'AND'. */
export type Grade_Level_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Level_Group_Bool_Exp>>;
  _not?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Level_Group_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  grade_levels?: InputMaybe<Grade_Level_Bool_Exp>;
  grade_levels_aggregate?: InputMaybe<Grade_Level_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_level_group" */
export const enum Grade_Level_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_6f453f0e56377d4f75551ae7317 = 'PK_6f453f0e56377d4f75551ae7317',
  /** unique or primary key constraint on columns "uid" */
  UqC6bf374a4a03208e92a50b836b2 = 'UQ_c6bf374a4a03208e92a50b836b2'
};

/** input type for incrementing numeric columns in table "grade_level_group" */
export type Grade_Level_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "grade_level_group" */
export type Grade_Level_Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  grade_levels?: InputMaybe<Grade_Level_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Grade_Level_Group_Max_Fields = {
  __typename?: 'grade_level_group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "grade_level_group" */
export type Grade_Level_Group_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grade_Level_Group_Min_Fields = {
  __typename?: 'grade_level_group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "grade_level_group" */
export type Grade_Level_Group_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "grade_level_group" */
export type Grade_Level_Group_Mutation_Response = {
  __typename?: 'grade_level_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Level_Group>;
};

/** input type for inserting object relation for remote table "grade_level_group" */
export type Grade_Level_Group_Obj_Rel_Insert_Input = {
  data: Grade_Level_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Level_Group_On_Conflict>;
};

/** on_conflict condition type for table "grade_level_group" */
export type Grade_Level_Group_On_Conflict = {
  constraint: Grade_Level_Group_Constraint;
  update_columns?: Array<Grade_Level_Group_Update_Column>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_level_group". */
export type Grade_Level_Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  grade_levels_aggregate?: InputMaybe<Grade_Level_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_level_group */
export type Grade_Level_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade_level_group" */
export const enum Grade_Level_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "grade_level_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "grade_level_group" */
export const enum Grade_Level_Group_Select_Column_Grade_Level_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "grade_level_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "grade_level_group" */
export const enum Grade_Level_Group_Select_Column_Grade_Level_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "grade_level_group" */
export type Grade_Level_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Grade_Level_Group_Stddev_Fields = {
  __typename?: 'grade_level_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grade_level_group" */
export type Grade_Level_Group_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Grade_Level_Group_Stddev_Pop_Fields = {
  __typename?: 'grade_level_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grade_level_group" */
export type Grade_Level_Group_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Grade_Level_Group_Stddev_Samp_Fields = {
  __typename?: 'grade_level_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grade_level_group" */
export type Grade_Level_Group_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "grade_level_group" */
export type Grade_Level_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Level_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Level_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Grade_Level_Group_Sum_Fields = {
  __typename?: 'grade_level_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "grade_level_group" */
export type Grade_Level_Group_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "grade_level_group" */
export const enum Grade_Level_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Grade_Level_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Level_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Level_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grade_Level_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Level_Group_Var_Pop_Fields = {
  __typename?: 'grade_level_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grade_level_group" */
export type Grade_Level_Group_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Grade_Level_Group_Var_Samp_Fields = {
  __typename?: 'grade_level_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grade_level_group" */
export type Grade_Level_Group_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Grade_Level_Group_Variance_Fields = {
  __typename?: 'grade_level_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grade_level_group" */
export type Grade_Level_Group_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "grade_level" */
export type Grade_Level_Inc_Input = {
  gradeLevelGroupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "grade_level" */
export type Grade_Level_Insert_Input = {
  course_grade_levels?: InputMaybe<Course_Grade_Level_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelGroupId?: InputMaybe<Scalars['Int']>;
  grade_level_group?: InputMaybe<Grade_Level_Group_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Grade_Level_Max_Fields = {
  __typename?: 'grade_level_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeLevelGroupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "grade_level" */
export type Grade_Level_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grade_Level_Min_Fields = {
  __typename?: 'grade_level_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeLevelGroupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "grade_level" */
export type Grade_Level_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "grade_level" */
export type Grade_Level_Mutation_Response = {
  __typename?: 'grade_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Level>;
};

/** input type for inserting object relation for remote table "grade_level" */
export type Grade_Level_Obj_Rel_Insert_Input = {
  data: Grade_Level_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Level_On_Conflict>;
};

/** on_conflict condition type for table "grade_level" */
export type Grade_Level_On_Conflict = {
  constraint: Grade_Level_Constraint;
  update_columns?: Array<Grade_Level_Update_Column>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_level". */
export type Grade_Level_Order_By = {
  course_grade_levels_aggregate?: InputMaybe<Course_Grade_Level_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  gradeLevelGroupId?: InputMaybe<Order_By>;
  grade_level_group?: InputMaybe<Grade_Level_Group_Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_level */
export type Grade_Level_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade_level" */
export const enum Grade_Level_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeLevelGroupId = 'gradeLevelGroupId',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "grade_level_aggregate_bool_exp_bool_and_arguments_columns" columns of table "grade_level" */
export const enum Grade_Level_Select_Column_Grade_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "grade_level_aggregate_bool_exp_bool_or_arguments_columns" columns of table "grade_level" */
export const enum Grade_Level_Select_Column_Grade_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "grade_level" */
export type Grade_Level_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelGroupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Grade_Level_Stddev_Fields = {
  __typename?: 'grade_level_stddev_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grade_level" */
export type Grade_Level_Stddev_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Grade_Level_Stddev_Pop_Fields = {
  __typename?: 'grade_level_stddev_pop_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grade_level" */
export type Grade_Level_Stddev_Pop_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Grade_Level_Stddev_Samp_Fields = {
  __typename?: 'grade_level_stddev_samp_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grade_level" */
export type Grade_Level_Stddev_Samp_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "grade_level" */
export type Grade_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Level_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeLevelGroupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Grade_Level_Sum_Fields = {
  __typename?: 'grade_level_sum_fields';
  gradeLevelGroupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "grade_level" */
export type Grade_Level_Sum_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** update columns of table "grade_level" */
export const enum Grade_Level_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeLevelGroupId = 'gradeLevelGroupId',
  /** column name */
  Id = 'id',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Grade_Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grade_Level_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Level_Var_Pop_Fields = {
  __typename?: 'grade_level_var_pop_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grade_level" */
export type Grade_Level_Var_Pop_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Grade_Level_Var_Samp_Fields = {
  __typename?: 'grade_level_var_samp_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grade_level" */
export type Grade_Level_Var_Samp_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Grade_Level_Variance_Fields = {
  __typename?: 'grade_level_variance_fields';
  gradeLevelGroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grade_level" */
export type Grade_Level_Variance_Order_By = {
  gradeLevelGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Grade_Max_Fields = {
  __typename?: 'grade_max_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  gradebookId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "grade" */
export type Grade_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grade_Min_Fields = {
  __typename?: 'grade_min_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  gradebookId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "grade" */
export type Grade_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "grade" */
export type Grade_Mutation_Response = {
  __typename?: 'grade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade>;
};

/** input type for inserting object relation for remote table "grade" */
export type Grade_Obj_Rel_Insert_Input = {
  data: Grade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};

/** on_conflict condition type for table "grade" */
export type Grade_On_Conflict = {
  constraint: Grade_Constraint;
  update_columns?: Array<Grade_Update_Column>;
  where?: InputMaybe<Grade_Bool_Exp>;
};

/** Ordering options when selecting data from "grade". */
export type Grade_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  grade_values_aggregate?: InputMaybe<Grade_Value_Aggregate_Order_By>;
  gradebook?: InputMaybe<Gradebook_Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibleToStudents?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade */
export type Grade_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade" */
export const enum Grade_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  GradebookId = 'gradebookId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_avg_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_bool_and_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  VisibleToStudents = 'visibleToStudents'
};

/** select "grade_aggregate_bool_exp_bool_or_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  VisibleToStudents = 'visibleToStudents'
};

/** select "grade_aggregate_bool_exp_corr_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_max_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_min_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_sum_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** select "grade_aggregate_bool_exp_var_samp_arguments_columns" columns of table "grade" */
export const enum Grade_Select_Column_Grade_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Weight = 'weight'
};

/** input type for updating data in table "grade" */
export type Grade_Set_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  gradebookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Grade_Stddev_Fields = {
  __typename?: 'grade_stddev_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grade" */
export type Grade_Stddev_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Grade_Stddev_Pop_Fields = {
  __typename?: 'grade_stddev_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grade" */
export type Grade_Stddev_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Grade_Stddev_Samp_Fields = {
  __typename?: 'grade_stddev_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grade" */
export type Grade_Stddev_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "grade" */
export type Grade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  gradebookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Grade_Sum_Fields = {
  __typename?: 'grade_sum_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  gradebookId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "grade" */
export type Grade_Sum_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "grade" */
export const enum Grade_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  GradebookId = 'gradebookId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibleToStudents = 'visibleToStudents',
  /** column name */
  Weight = 'weight'
};

export type Grade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grade_Bool_Exp;
};

/** columns and relationships of "grade_value" */
export type Grade_Value = {
  __typename?: 'grade_value';
  comment?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['Int']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  grade: Grade;
  gradeId: Scalars['Int'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updatedById?: Maybe<Scalars['Int']>;
  /** An object relationship */
  updatedByUser?: Maybe<User>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
  value: Scalars['float8'];
};

/** aggregated selection of "grade_value" */
export type Grade_Value_Aggregate = {
  __typename?: 'grade_value_aggregate';
  aggregate?: Maybe<Grade_Value_Aggregate_Fields>;
  nodes: Array<Grade_Value>;
};

export type Grade_Value_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Grade_Value_Aggregate_Bool_Exp_Var_Samp>;
};

export type Grade_Value_Aggregate_Bool_Exp_Avg = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Bool_And = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Corr = {
  arguments: Grade_Value_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Grade_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Grade_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Grade_Value_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Grade_Value_Aggregate_Bool_Exp_Max = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Min = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Sum = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Grade_Value_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Grade_Value_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "grade_value" */
export type Grade_Value_Aggregate_Fields = {
  __typename?: 'grade_value_aggregate_fields';
  avg?: Maybe<Grade_Value_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Value_Max_Fields>;
  min?: Maybe<Grade_Value_Min_Fields>;
  stddev?: Maybe<Grade_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Value_Sum_Fields>;
  var_pop?: Maybe<Grade_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Value_Var_Samp_Fields>;
  variance?: Maybe<Grade_Value_Variance_Fields>;
};


/** aggregate fields of "grade_value" */
export type Grade_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grade_value" */
export type Grade_Value_Aggregate_Order_By = {
  avg?: InputMaybe<Grade_Value_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grade_Value_Max_Order_By>;
  min?: InputMaybe<Grade_Value_Min_Order_By>;
  stddev?: InputMaybe<Grade_Value_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Grade_Value_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Grade_Value_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Grade_Value_Sum_Order_By>;
  var_pop?: InputMaybe<Grade_Value_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Grade_Value_Var_Samp_Order_By>;
  variance?: InputMaybe<Grade_Value_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "grade_value" */
export type Grade_Value_Arr_Rel_Insert_Input = {
  data: Array<Grade_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Value_On_Conflict>;
};

/** aggregate avg on columns */
export type Grade_Value_Avg_Fields = {
  __typename?: 'grade_value_avg_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grade_value" */
export type Grade_Value_Avg_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "grade_value". All fields are combined with a logical 'AND'. */
export type Grade_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Value_Bool_Exp>>;
  _not?: InputMaybe<Grade_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Value_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  grade?: InputMaybe<Grade_Bool_Exp>;
  gradeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updatedById?: InputMaybe<Int_Comparison_Exp>;
  updatedByUser?: InputMaybe<User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_value" */
export const enum Grade_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_071ca7c868e7cbd000e7ae17064 = 'PK_071ca7c868e7cbd000e7ae17064',
  /** unique or primary key constraint on columns "uid" */
  Uq_2bd01f0c034f5c93bed51ae4d33 = 'UQ_2bd01f0c034f5c93bed51ae4d33',
  /** unique or primary key constraint on columns "userId", "gradeId" */
  IndexGradeValue = 'index_grade_value'
};

/** input type for incrementing numeric columns in table "grade_value" */
export type Grade_Value_Inc_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  gradeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedById?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "grade_value" */
export type Grade_Value_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  grade?: InputMaybe<Grade_Obj_Rel_Insert_Input>;
  gradeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updatedById?: InputMaybe<Scalars['Int']>;
  updatedByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Grade_Value_Max_Fields = {
  __typename?: 'grade_value_max_fields';
  comment?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updatedById?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "grade_value" */
export type Grade_Value_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grade_Value_Min_Fields = {
  __typename?: 'grade_value_min_fields';
  comment?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gradeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updatedById?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "grade_value" */
export type Grade_Value_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "grade_value" */
export type Grade_Value_Mutation_Response = {
  __typename?: 'grade_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Value>;
};

/** on_conflict condition type for table "grade_value" */
export type Grade_Value_On_Conflict = {
  constraint: Grade_Value_Constraint;
  update_columns?: Array<Grade_Value_Update_Column>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_value". */
export type Grade_Value_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  grade?: InputMaybe<Grade_Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  updatedByUser?: InputMaybe<User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_value */
export type Grade_Value_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade_value" */
export const enum Grade_Value_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeId = 'gradeId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedById = 'updatedById',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_avg_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_bool_and_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "grade_value_aggregate_bool_exp_bool_or_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "grade_value_aggregate_bool_exp_corr_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_max_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_min_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_sum_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** select "grade_value_aggregate_bool_exp_var_samp_arguments_columns" columns of table "grade_value" */
export const enum Grade_Value_Select_Column_Grade_Value_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
};

/** input type for updating data in table "grade_value" */
export type Grade_Value_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updatedById?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Grade_Value_Stddev_Fields = {
  __typename?: 'grade_value_stddev_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grade_value" */
export type Grade_Value_Stddev_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Grade_Value_Stddev_Pop_Fields = {
  __typename?: 'grade_value_stddev_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grade_value" */
export type Grade_Value_Stddev_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Grade_Value_Stddev_Samp_Fields = {
  __typename?: 'grade_value_stddev_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grade_value" */
export type Grade_Value_Stddev_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "grade_value" */
export type Grade_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Value_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gradeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updatedById?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Grade_Value_Sum_Fields = {
  __typename?: 'grade_value_sum_fields';
  createdById?: Maybe<Scalars['Int']>;
  gradeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updatedById?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "grade_value" */
export type Grade_Value_Sum_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "grade_value" */
export const enum Grade_Value_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GradeId = 'gradeId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedById = 'updatedById',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
};

export type Grade_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grade_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Value_Var_Pop_Fields = {
  __typename?: 'grade_value_var_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grade_value" */
export type Grade_Value_Var_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Grade_Value_Var_Samp_Fields = {
  __typename?: 'grade_value_var_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grade_value" */
export type Grade_Value_Var_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Grade_Value_Variance_Fields = {
  __typename?: 'grade_value_variance_fields';
  createdById?: Maybe<Scalars['Float']>;
  gradeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updatedById?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grade_value" */
export type Grade_Value_Variance_Order_By = {
  createdById?: InputMaybe<Order_By>;
  gradeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedById?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Grade_Var_Pop_Fields = {
  __typename?: 'grade_var_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grade" */
export type Grade_Var_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Grade_Var_Samp_Fields = {
  __typename?: 'grade_var_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grade" */
export type Grade_Var_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Grade_Variance_Fields = {
  __typename?: 'grade_variance_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  gradebookId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grade" */
export type Grade_Variance_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  gradebookId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "gradebook" */
export type Gradebook = {
  __typename?: 'gradebook';
  classCourseId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  class_course?: Maybe<Class_Course>;
  createdById?: Maybe<Scalars['Int']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  grades: Array<Grade>;
  /** An aggregate relationship */
  grades_aggregate: Grade_Aggregate;
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "gradebook" */
export type GradebookGradesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


/** columns and relationships of "gradebook" */
export type GradebookGrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};

/** aggregated selection of "gradebook" */
export type Gradebook_Aggregate = {
  __typename?: 'gradebook_aggregate';
  aggregate?: Maybe<Gradebook_Aggregate_Fields>;
  nodes: Array<Gradebook>;
};

export type Gradebook_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Gradebook_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Gradebook_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Gradebook_Aggregate_Bool_Exp_Count>;
};

export type Gradebook_Aggregate_Bool_Exp_Bool_And = {
  arguments: Gradebook_Select_Column_Gradebook_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gradebook_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Gradebook_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Gradebook_Select_Column_Gradebook_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gradebook_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Gradebook_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gradebook_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gradebook_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gradebook" */
export type Gradebook_Aggregate_Fields = {
  __typename?: 'gradebook_aggregate_fields';
  avg?: Maybe<Gradebook_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gradebook_Max_Fields>;
  min?: Maybe<Gradebook_Min_Fields>;
  stddev?: Maybe<Gradebook_Stddev_Fields>;
  stddev_pop?: Maybe<Gradebook_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gradebook_Stddev_Samp_Fields>;
  sum?: Maybe<Gradebook_Sum_Fields>;
  var_pop?: Maybe<Gradebook_Var_Pop_Fields>;
  var_samp?: Maybe<Gradebook_Var_Samp_Fields>;
  variance?: Maybe<Gradebook_Variance_Fields>;
};


/** aggregate fields of "gradebook" */
export type Gradebook_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gradebook_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gradebook" */
export type Gradebook_Aggregate_Order_By = {
  avg?: InputMaybe<Gradebook_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gradebook_Max_Order_By>;
  min?: InputMaybe<Gradebook_Min_Order_By>;
  stddev?: InputMaybe<Gradebook_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gradebook_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gradebook_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gradebook_Sum_Order_By>;
  var_pop?: InputMaybe<Gradebook_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gradebook_Var_Samp_Order_By>;
  variance?: InputMaybe<Gradebook_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gradebook" */
export type Gradebook_Arr_Rel_Insert_Input = {
  data: Array<Gradebook_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gradebook_On_Conflict>;
};

/** aggregate avg on columns */
export type Gradebook_Avg_Fields = {
  __typename?: 'gradebook_avg_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gradebook" */
export type Gradebook_Avg_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gradebook". All fields are combined with a logical 'AND'. */
export type Gradebook_Bool_Exp = {
  _and?: InputMaybe<Array<Gradebook_Bool_Exp>>;
  _not?: InputMaybe<Gradebook_Bool_Exp>;
  _or?: InputMaybe<Array<Gradebook_Bool_Exp>>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  grades?: InputMaybe<Grade_Bool_Exp>;
  grades_aggregate?: InputMaybe<Grade_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gradebook" */
export const enum Gradebook_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkA6ceae4a733c0275878f34df660 = 'PK_a6ceae4a733c0275878f34df660',
  /** unique or primary key constraint on columns "classCourseId" */
  Rel_4f902e977cd619fae6dd43c68c = 'REL_4f902e977cd619fae6dd43c68c',
  /** unique or primary key constraint on columns "uid" */
  UqFfdea49876ce97372bdd5e5c22d = 'UQ_ffdea49876ce97372bdd5e5c22d'
};

/** input type for incrementing numeric columns in table "gradebook" */
export type Gradebook_Inc_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gradebook" */
export type Gradebook_Insert_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  grades?: InputMaybe<Grade_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Gradebook_Max_Fields = {
  __typename?: 'gradebook_max_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "gradebook" */
export type Gradebook_Max_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gradebook_Min_Fields = {
  __typename?: 'gradebook_min_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "gradebook" */
export type Gradebook_Min_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gradebook" */
export type Gradebook_Mutation_Response = {
  __typename?: 'gradebook_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gradebook>;
};

/** input type for inserting object relation for remote table "gradebook" */
export type Gradebook_Obj_Rel_Insert_Input = {
  data: Gradebook_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gradebook_On_Conflict>;
};

/** on_conflict condition type for table "gradebook" */
export type Gradebook_On_Conflict = {
  constraint: Gradebook_Constraint;
  update_columns?: Array<Gradebook_Update_Column>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};

/** Ordering options when selecting data from "gradebook". */
export type Gradebook_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  grades_aggregate?: InputMaybe<Grade_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gradebook */
export type Gradebook_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "gradebook" */
export const enum Gradebook_Select_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "gradebook_aggregate_bool_exp_bool_and_arguments_columns" columns of table "gradebook" */
export const enum Gradebook_Select_Column_Gradebook_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "gradebook_aggregate_bool_exp_bool_or_arguments_columns" columns of table "gradebook" */
export const enum Gradebook_Select_Column_Gradebook_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "gradebook" */
export type Gradebook_Set_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Gradebook_Stddev_Fields = {
  __typename?: 'gradebook_stddev_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gradebook" */
export type Gradebook_Stddev_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gradebook_Stddev_Pop_Fields = {
  __typename?: 'gradebook_stddev_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gradebook" */
export type Gradebook_Stddev_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gradebook_Stddev_Samp_Fields = {
  __typename?: 'gradebook_stddev_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gradebook" */
export type Gradebook_Stddev_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gradebook" */
export type Gradebook_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gradebook_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gradebook_Stream_Cursor_Value_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Gradebook_Sum_Fields = {
  __typename?: 'gradebook_sum_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "gradebook" */
export type Gradebook_Sum_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "gradebook" */
export const enum Gradebook_Update_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Gradebook_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gradebook_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gradebook_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gradebook_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gradebook_Var_Pop_Fields = {
  __typename?: 'gradebook_var_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gradebook" */
export type Gradebook_Var_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gradebook_Var_Samp_Fields = {
  __typename?: 'gradebook_var_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gradebook" */
export type Gradebook_Var_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gradebook_Variance_Fields = {
  __typename?: 'gradebook_variance_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gradebook" */
export type Gradebook_Variance_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "group" */
export type Group = {
  __typename?: 'group';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  group_courses: Array<Group_Course>;
  /** An aggregate relationship */
  group_courses_aggregate: Group_Course_Aggregate;
  /** An array relationship */
  group_workspaces: Array<Group_Workspace>;
  /** An aggregate relationship */
  group_workspaces_aggregate: Group_Workspace_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_groups: Array<User_Group>;
  /** An aggregate relationship */
  user_groups_aggregate: User_Group_Aggregate;
};


/** columns and relationships of "group" */
export type GroupGroup_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


/** columns and relationships of "group" */
export type GroupGroup_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


/** columns and relationships of "group" */
export type GroupGroup_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


/** columns and relationships of "group" */
export type GroupGroup_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


/** columns and relationships of "group" */
export type GroupUser_GroupsArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


/** columns and relationships of "group" */
export type GroupUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};

/** aggregated selection of "group" */
export type Group_Aggregate = {
  __typename?: 'group_aggregate';
  aggregate?: Maybe<Group_Aggregate_Fields>;
  nodes: Array<Group>;
};

export type Group_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Group_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Group_Aggregate_Bool_Exp_Count>;
};

export type Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: Group_Select_Column_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Group_Select_Column_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "group" */
export type Group_Aggregate_Fields = {
  __typename?: 'group_aggregate_fields';
  avg?: Maybe<Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Group_Max_Fields>;
  min?: Maybe<Group_Min_Fields>;
  stddev?: Maybe<Group_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Sum_Fields>;
  var_pop?: Maybe<Group_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Var_Samp_Fields>;
  variance?: Maybe<Group_Variance_Fields>;
};


/** aggregate fields of "group" */
export type Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group" */
export type Group_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Max_Order_By>;
  min?: InputMaybe<Group_Min_Order_By>;
  stddev?: InputMaybe<Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "group" */
export type Group_Arr_Rel_Insert_Input = {
  data: Array<Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Group_Avg_Fields = {
  __typename?: 'group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "group" */
export type Group_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "group". All fields are combined with a logical 'AND'. */
export type Group_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Bool_Exp>>;
  _not?: InputMaybe<Group_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  group_courses?: InputMaybe<Group_Course_Bool_Exp>;
  group_courses_aggregate?: InputMaybe<Group_Course_Aggregate_Bool_Exp>;
  group_workspaces?: InputMaybe<Group_Workspace_Bool_Exp>;
  group_workspaces_aggregate?: InputMaybe<Group_Workspace_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_groups?: InputMaybe<User_Group_Bool_Exp>;
  user_groups_aggregate?: InputMaybe<User_Group_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "group" */
export const enum Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_256aa0fda9b1de1a73ee0b7106b = 'PK_256aa0fda9b1de1a73ee0b7106b',
  /** unique or primary key constraint on columns "uid" */
  UqAe54293bc5c1277fbc5bc0f94b0 = 'UQ_ae54293bc5c1277fbc5bc0f94b0'
};

/** columns and relationships of "group_course" */
export type Group_Course = {
  __typename?: 'group_course';
  begin: Scalars['timestamptz'];
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  end: Scalars['timestamptz'];
  /** An object relationship */
  group: Group;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "group_course" */
export type Group_Course_Aggregate = {
  __typename?: 'group_course_aggregate';
  aggregate?: Maybe<Group_Course_Aggregate_Fields>;
  nodes: Array<Group_Course>;
};

export type Group_Course_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Group_Course_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Group_Course_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Group_Course_Aggregate_Bool_Exp_Count>;
};

export type Group_Course_Aggregate_Bool_Exp_Bool_And = {
  arguments: Group_Course_Select_Column_Group_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Course_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Group_Course_Select_Column_Group_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Course_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Group_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Course_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "group_course" */
export type Group_Course_Aggregate_Fields = {
  __typename?: 'group_course_aggregate_fields';
  avg?: Maybe<Group_Course_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Group_Course_Max_Fields>;
  min?: Maybe<Group_Course_Min_Fields>;
  stddev?: Maybe<Group_Course_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Course_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Course_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Course_Sum_Fields>;
  var_pop?: Maybe<Group_Course_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Course_Var_Samp_Fields>;
  variance?: Maybe<Group_Course_Variance_Fields>;
};


/** aggregate fields of "group_course" */
export type Group_Course_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_course" */
export type Group_Course_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Course_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Course_Max_Order_By>;
  min?: InputMaybe<Group_Course_Min_Order_By>;
  stddev?: InputMaybe<Group_Course_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Course_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Course_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Course_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Course_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Course_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Course_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "group_course" */
export type Group_Course_Arr_Rel_Insert_Input = {
  data: Array<Group_Course_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_Course_On_Conflict>;
};

/** aggregate avg on columns */
export type Group_Course_Avg_Fields = {
  __typename?: 'group_course_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "group_course" */
export type Group_Course_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "group_course". All fields are combined with a logical 'AND'. */
export type Group_Course_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Course_Bool_Exp>>;
  _not?: InputMaybe<Group_Course_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Course_Bool_Exp>>;
  begin?: InputMaybe<Timestamptz_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  group?: InputMaybe<Group_Bool_Exp>;
  groupId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "group_course" */
export const enum Group_Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkF644c24b387124a3fa6ff89f0f1 = 'PK_f644c24b387124a3fa6ff89f0f1',
  /** unique or primary key constraint on columns "uid" */
  UqEad77d33b1b2fbd4cbec4ec5331 = 'UQ_ead77d33b1b2fbd4cbec4ec5331',
  /** unique or primary key constraint on columns "groupId", "courseId" */
  IndexGroupCourse = 'index_group_course'
};

/** input type for incrementing numeric columns in table "group_course" */
export type Group_Course_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "group_course" */
export type Group_Course_Insert_Input = {
  begin?: InputMaybe<Scalars['timestamptz']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Group_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Group_Course_Max_Fields = {
  __typename?: 'group_course_max_fields';
  begin?: Maybe<Scalars['timestamptz']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "group_course" */
export type Group_Course_Max_Order_By = {
  begin?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Group_Course_Min_Fields = {
  __typename?: 'group_course_min_fields';
  begin?: Maybe<Scalars['timestamptz']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "group_course" */
export type Group_Course_Min_Order_By = {
  begin?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "group_course" */
export type Group_Course_Mutation_Response = {
  __typename?: 'group_course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Course>;
};

/** on_conflict condition type for table "group_course" */
export type Group_Course_On_Conflict = {
  constraint: Group_Course_Constraint;
  update_columns?: Array<Group_Course_Update_Column>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};

/** Ordering options when selecting data from "group_course". */
export type Group_Course_Order_By = {
  begin?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  group?: InputMaybe<Group_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: group_course */
export type Group_Course_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "group_course" */
export const enum Group_Course_Select_Column {
  /** column name */
  Begin = 'begin',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  End = 'end',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "group_course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "group_course" */
export const enum Group_Course_Select_Column_Group_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** select "group_course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "group_course" */
export const enum Group_Course_Select_Column_Group_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** input type for updating data in table "group_course" */
export type Group_Course_Set_Input = {
  begin?: InputMaybe<Scalars['timestamptz']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Group_Course_Stddev_Fields = {
  __typename?: 'group_course_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "group_course" */
export type Group_Course_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Group_Course_Stddev_Pop_Fields = {
  __typename?: 'group_course_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "group_course" */
export type Group_Course_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Group_Course_Stddev_Samp_Fields = {
  __typename?: 'group_course_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "group_course" */
export type Group_Course_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "group_course" */
export type Group_Course_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Course_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Course_Stream_Cursor_Value_Input = {
  begin?: InputMaybe<Scalars['timestamptz']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Group_Course_Sum_Fields = {
  __typename?: 'group_course_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "group_course" */
export type Group_Course_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "group_course" */
export const enum Group_Course_Update_Column {
  /** column name */
  Begin = 'begin',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  End = 'end',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Group_Course_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Course_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Course_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Course_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Course_Var_Pop_Fields = {
  __typename?: 'group_course_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "group_course" */
export type Group_Course_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Group_Course_Var_Samp_Fields = {
  __typename?: 'group_course_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "group_course" */
export type Group_Course_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Group_Course_Variance_Fields = {
  __typename?: 'group_course_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "group_course" */
export type Group_Course_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "group" */
export type Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "group" */
export type Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  group_courses?: InputMaybe<Group_Course_Arr_Rel_Insert_Input>;
  group_workspaces?: InputMaybe<Group_Workspace_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_groups?: InputMaybe<User_Group_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Group_Max_Fields = {
  __typename?: 'group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "group" */
export type Group_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Group_Min_Fields = {
  __typename?: 'group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "group" */
export type Group_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "group" */
export type Group_Mutation_Response = {
  __typename?: 'group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Group>;
};

/** input type for inserting object relation for remote table "group" */
export type Group_Obj_Rel_Insert_Input = {
  data: Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_On_Conflict>;
};

/** on_conflict condition type for table "group" */
export type Group_On_Conflict = {
  constraint: Group_Constraint;
  update_columns?: Array<Group_Update_Column>;
  where?: InputMaybe<Group_Bool_Exp>;
};

/** Ordering options when selecting data from "group". */
export type Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  group_courses_aggregate?: InputMaybe<Group_Course_Aggregate_Order_By>;
  group_workspaces_aggregate?: InputMaybe<Group_Workspace_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_groups_aggregate?: InputMaybe<User_Group_Aggregate_Order_By>;
};

/** primary key columns input for table: group */
export type Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "group" */
export const enum Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "group" */
export const enum Group_Select_Column_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "group" */
export const enum Group_Select_Column_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "group" */
export type Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Group_Stddev_Fields = {
  __typename?: 'group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "group" */
export type Group_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Group_Stddev_Pop_Fields = {
  __typename?: 'group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "group" */
export type Group_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Group_Stddev_Samp_Fields = {
  __typename?: 'group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "group" */
export type Group_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "group" */
export type Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Group_Sum_Fields = {
  __typename?: 'group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "group" */
export type Group_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "group" */
export const enum Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Var_Pop_Fields = {
  __typename?: 'group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "group" */
export type Group_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Group_Var_Samp_Fields = {
  __typename?: 'group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "group" */
export type Group_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Group_Variance_Fields = {
  __typename?: 'group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "group" */
export type Group_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "group_workspace" */
export type Group_Workspace = {
  __typename?: 'group_workspace';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  group: Group;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspace;
  workspaceId: Scalars['Int'];
};

/** aggregated selection of "group_workspace" */
export type Group_Workspace_Aggregate = {
  __typename?: 'group_workspace_aggregate';
  aggregate?: Maybe<Group_Workspace_Aggregate_Fields>;
  nodes: Array<Group_Workspace>;
};

export type Group_Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Group_Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Group_Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Group_Workspace_Aggregate_Bool_Exp_Count>;
};

export type Group_Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: Group_Workspace_Select_Column_Group_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Group_Workspace_Select_Column_Group_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Group_Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Group_Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "group_workspace" */
export type Group_Workspace_Aggregate_Fields = {
  __typename?: 'group_workspace_aggregate_fields';
  avg?: Maybe<Group_Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Group_Workspace_Max_Fields>;
  min?: Maybe<Group_Workspace_Min_Fields>;
  stddev?: Maybe<Group_Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Workspace_Sum_Fields>;
  var_pop?: Maybe<Group_Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Workspace_Var_Samp_Fields>;
  variance?: Maybe<Group_Workspace_Variance_Fields>;
};


/** aggregate fields of "group_workspace" */
export type Group_Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_workspace" */
export type Group_Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Workspace_Max_Order_By>;
  min?: InputMaybe<Group_Workspace_Min_Order_By>;
  stddev?: InputMaybe<Group_Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "group_workspace" */
export type Group_Workspace_Arr_Rel_Insert_Input = {
  data: Array<Group_Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type Group_Workspace_Avg_Fields = {
  __typename?: 'group_workspace_avg_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "group_workspace" */
export type Group_Workspace_Avg_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "group_workspace". All fields are combined with a logical 'AND'. */
export type Group_Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Workspace_Bool_Exp>>;
  _not?: InputMaybe<Group_Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Workspace_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  group?: InputMaybe<Group_Bool_Exp>;
  groupId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workspace?: InputMaybe<Workspace_Bool_Exp>;
  workspaceId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "group_workspace" */
export const enum Group_Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_330ca53a5db8c610f0aab54c5ab = 'PK_330ca53a5db8c610f0aab54c5ab',
  /** unique or primary key constraint on columns "uid" */
  Uq_12abe543514658288e39d7902b1 = 'UQ_12abe543514658288e39d7902b1',
  /** unique or primary key constraint on columns "groupId", "workspaceId" */
  IndexGroupWorkspace = 'index_group_workspace'
};

/** input type for incrementing numeric columns in table "group_workspace" */
export type Group_Workspace_Inc_Input = {
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "group_workspace" */
export type Group_Workspace_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Group_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace?: InputMaybe<Workspace_Obj_Rel_Insert_Input>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Group_Workspace_Max_Fields = {
  __typename?: 'group_workspace_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "group_workspace" */
export type Group_Workspace_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Group_Workspace_Min_Fields = {
  __typename?: 'group_workspace_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "group_workspace" */
export type Group_Workspace_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "group_workspace" */
export type Group_Workspace_Mutation_Response = {
  __typename?: 'group_workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Workspace>;
};

/** on_conflict condition type for table "group_workspace" */
export type Group_Workspace_On_Conflict = {
  constraint: Group_Workspace_Constraint;
  update_columns?: Array<Group_Workspace_Update_Column>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "group_workspace". */
export type Group_Workspace_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  group?: InputMaybe<Group_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspace?: InputMaybe<Workspace_Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: group_workspace */
export type Group_Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "group_workspace" */
export const enum Group_Workspace_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

/** select "group_workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "group_workspace" */
export const enum Group_Workspace_Select_Column_Group_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "group_workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "group_workspace" */
export const enum Group_Workspace_Select_Column_Group_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "group_workspace" */
export type Group_Workspace_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Group_Workspace_Stddev_Fields = {
  __typename?: 'group_workspace_stddev_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "group_workspace" */
export type Group_Workspace_Stddev_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Group_Workspace_Stddev_Pop_Fields = {
  __typename?: 'group_workspace_stddev_pop_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "group_workspace" */
export type Group_Workspace_Stddev_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Group_Workspace_Stddev_Samp_Fields = {
  __typename?: 'group_workspace_stddev_samp_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "group_workspace" */
export type Group_Workspace_Stddev_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "group_workspace" */
export type Group_Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Workspace_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Group_Workspace_Sum_Fields = {
  __typename?: 'group_workspace_sum_fields';
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "group_workspace" */
export type Group_Workspace_Sum_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** update columns of table "group_workspace" */
export const enum Group_Workspace_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

export type Group_Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Workspace_Var_Pop_Fields = {
  __typename?: 'group_workspace_var_pop_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "group_workspace" */
export type Group_Workspace_Var_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Group_Workspace_Var_Samp_Fields = {
  __typename?: 'group_workspace_var_samp_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "group_workspace" */
export type Group_Workspace_Var_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Group_Workspace_Variance_Fields = {
  __typename?: 'group_workspace_variance_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "group_workspace" */
export type Group_Workspace_Variance_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "installment" */
export type Installment = {
  __typename?: 'installment';
  createdById?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  discount: Scalars['float8'];
  discountType?: Maybe<Scalars['installment_discounttype_enum']>;
  end_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An array relationship */
  invoice_installments: Array<Invoice_Installment>;
  /** An aggregate relationship */
  invoice_installments_aggregate: Invoice_Installment_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  paid_amount: Scalars['float8'];
  schoolFeeId: Scalars['Int'];
  /** An object relationship */
  school_fee: School_Fee;
  start_date: Scalars['timestamptz'];
  status: Scalars['installment_status_enum'];
  studentId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByCreatedbyid?: Maybe<User>;
};


/** columns and relationships of "installment" */
export type InstallmentInvoice_InstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "installment" */
export type InstallmentInvoice_Installments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};

/** aggregated selection of "installment" */
export type Installment_Aggregate = {
  __typename?: 'installment_aggregate';
  aggregate?: Maybe<Installment_Aggregate_Fields>;
  nodes: Array<Installment>;
};

export type Installment_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Installment_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Installment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Installment_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Installment_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Installment_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Installment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Installment_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Installment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Installment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Installment_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Installment_Aggregate_Bool_Exp_Var_Samp>;
};

export type Installment_Aggregate_Bool_Exp_Avg = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Corr = {
  arguments: Installment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Installment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Installment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Installment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Installment_Aggregate_Bool_Exp_Max = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Min = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Sum = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Installment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Installment_Select_Column_Installment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Installment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "installment" */
export type Installment_Aggregate_Fields = {
  __typename?: 'installment_aggregate_fields';
  avg?: Maybe<Installment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Installment_Max_Fields>;
  min?: Maybe<Installment_Min_Fields>;
  stddev?: Maybe<Installment_Stddev_Fields>;
  stddev_pop?: Maybe<Installment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Installment_Stddev_Samp_Fields>;
  sum?: Maybe<Installment_Sum_Fields>;
  var_pop?: Maybe<Installment_Var_Pop_Fields>;
  var_samp?: Maybe<Installment_Var_Samp_Fields>;
  variance?: Maybe<Installment_Variance_Fields>;
};


/** aggregate fields of "installment" */
export type Installment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "installment" */
export type Installment_Aggregate_Order_By = {
  avg?: InputMaybe<Installment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Installment_Max_Order_By>;
  min?: InputMaybe<Installment_Min_Order_By>;
  stddev?: InputMaybe<Installment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Installment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Installment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Installment_Sum_Order_By>;
  var_pop?: InputMaybe<Installment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Installment_Var_Samp_Order_By>;
  variance?: InputMaybe<Installment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "installment" */
export type Installment_Arr_Rel_Insert_Input = {
  data: Array<Installment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Installment_On_Conflict>;
};

/** aggregate avg on columns */
export type Installment_Avg_Fields = {
  __typename?: 'installment_avg_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "installment" */
export type Installment_Avg_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "installment". All fields are combined with a logical 'AND'. */
export type Installment_Bool_Exp = {
  _and?: InputMaybe<Array<Installment_Bool_Exp>>;
  _not?: InputMaybe<Installment_Bool_Exp>;
  _or?: InputMaybe<Array<Installment_Bool_Exp>>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  discount?: InputMaybe<Float8_Comparison_Exp>;
  discountType?: InputMaybe<Installment_Discounttype_Enum_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice_installments?: InputMaybe<Invoice_Installment_Bool_Exp>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  paid_amount?: InputMaybe<Float8_Comparison_Exp>;
  schoolFeeId?: InputMaybe<Int_Comparison_Exp>;
  school_fee?: InputMaybe<School_Fee_Bool_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Installment_Status_Enum_Comparison_Exp>;
  studentId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByCreatedbyid?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "installment" */
export const enum Installment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkC79b5b68e8b6293a0210ce7dbda = 'PK_c79b5b68e8b6293a0210ce7dbda',
  /** unique or primary key constraint on columns "uid" */
  Uq_9a35f3f7290103c87b98a6d84ef = 'UQ_9a35f3f7290103c87b98a6d84ef'
};

/** Boolean expression to compare columns of type "installment_discounttype_enum". All fields are combined with logical 'AND'. */
export type Installment_Discounttype_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _gt?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _gte?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _in?: InputMaybe<Array<Scalars['installment_discounttype_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _lte?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _neq?: InputMaybe<Scalars['installment_discounttype_enum']>;
  _nin?: InputMaybe<Array<Scalars['installment_discounttype_enum']>>;
};

/** input type for incrementing numeric columns in table "installment" */
export type Installment_Inc_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paid_amount?: InputMaybe<Scalars['float8']>;
  schoolFeeId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "installment" */
export type Installment_Insert_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['float8']>;
  discountType?: InputMaybe<Scalars['installment_discounttype_enum']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_installments?: InputMaybe<Invoice_Installment_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paid_amount?: InputMaybe<Scalars['float8']>;
  schoolFeeId?: InputMaybe<Scalars['Int']>;
  school_fee?: InputMaybe<School_Fee_Obj_Rel_Insert_Input>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['installment_status_enum']>;
  studentId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByCreatedbyid?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Installment_Max_Fields = {
  __typename?: 'installment_max_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount?: Maybe<Scalars['float8']>;
  discountType?: Maybe<Scalars['installment_discounttype_enum']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  paid_amount?: Maybe<Scalars['float8']>;
  schoolFeeId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['installment_status_enum']>;
  studentId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "installment" */
export type Installment_Max_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discountType?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Installment_Min_Fields = {
  __typename?: 'installment_min_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount?: Maybe<Scalars['float8']>;
  discountType?: Maybe<Scalars['installment_discounttype_enum']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  paid_amount?: Maybe<Scalars['float8']>;
  schoolFeeId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['installment_status_enum']>;
  studentId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "installment" */
export type Installment_Min_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discountType?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "installment" */
export type Installment_Mutation_Response = {
  __typename?: 'installment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Installment>;
};

/** input type for inserting object relation for remote table "installment" */
export type Installment_Obj_Rel_Insert_Input = {
  data: Installment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Installment_On_Conflict>;
};

/** on_conflict condition type for table "installment" */
export type Installment_On_Conflict = {
  constraint: Installment_Constraint;
  update_columns?: Array<Installment_Update_Column>;
  where?: InputMaybe<Installment_Bool_Exp>;
};

/** Ordering options when selecting data from "installment". */
export type Installment_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discountType?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  school_fee?: InputMaybe<School_Fee_Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByCreatedbyid?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: installment */
export type Installment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "installment" */
export const enum Installment_Select_Column {
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Discount = 'discount',
  /** column name */
  DiscountType = 'discountType',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaidAmount = 'paid_amount',
  /** column name */
  SchoolFeeId = 'schoolFeeId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "installment_aggregate_bool_exp_avg_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "installment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "installment_aggregate_bool_exp_corr_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_max_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_min_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_sum_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** select "installment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "installment" */
export const enum Installment_Select_Column_Installment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Discount = 'discount',
  /** column name */
  PaidAmount = 'paid_amount'
};

/** input type for updating data in table "installment" */
export type Installment_Set_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['float8']>;
  discountType?: InputMaybe<Scalars['installment_discounttype_enum']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paid_amount?: InputMaybe<Scalars['float8']>;
  schoolFeeId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['installment_status_enum']>;
  studentId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "installment_status_enum". All fields are combined with logical 'AND'. */
export type Installment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['installment_status_enum']>;
  _gt?: InputMaybe<Scalars['installment_status_enum']>;
  _gte?: InputMaybe<Scalars['installment_status_enum']>;
  _in?: InputMaybe<Array<Scalars['installment_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['installment_status_enum']>;
  _lte?: InputMaybe<Scalars['installment_status_enum']>;
  _neq?: InputMaybe<Scalars['installment_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['installment_status_enum']>>;
};

/** aggregate stddev on columns */
export type Installment_Stddev_Fields = {
  __typename?: 'installment_stddev_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "installment" */
export type Installment_Stddev_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Installment_Stddev_Pop_Fields = {
  __typename?: 'installment_stddev_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "installment" */
export type Installment_Stddev_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Installment_Stddev_Samp_Fields = {
  __typename?: 'installment_stddev_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "installment" */
export type Installment_Stddev_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "installment" */
export type Installment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installment_Stream_Cursor_Value_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['float8']>;
  discountType?: InputMaybe<Scalars['installment_discounttype_enum']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paid_amount?: InputMaybe<Scalars['float8']>;
  schoolFeeId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['installment_status_enum']>;
  studentId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Installment_Sum_Fields = {
  __typename?: 'installment_sum_fields';
  createdById?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  paid_amount?: Maybe<Scalars['float8']>;
  schoolFeeId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "installment" */
export type Installment_Sum_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** update columns of table "installment" */
export const enum Installment_Update_Column {
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Discount = 'discount',
  /** column name */
  DiscountType = 'discountType',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaidAmount = 'paid_amount',
  /** column name */
  SchoolFeeId = 'schoolFeeId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Installment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Installment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Installment_Var_Pop_Fields = {
  __typename?: 'installment_var_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "installment" */
export type Installment_Var_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Installment_Var_Samp_Fields = {
  __typename?: 'installment_var_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "installment" */
export type Installment_Var_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Installment_Variance_Fields = {
  __typename?: 'installment_variance_fields';
  createdById?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  paid_amount?: Maybe<Scalars['Float']>;
  schoolFeeId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "installment" */
export type Installment_Variance_Order_By = {
  createdById?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paid_amount?: InputMaybe<Order_By>;
  schoolFeeId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "instructor" */
export type Instructor = {
  __typename?: 'instructor';
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  course_instructors: Array<Course_Instructor>;
  /** An aggregate relationship */
  course_instructors_aggregate: Course_Instructor_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  last_name: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  picture?: Maybe<Scalars['String']>;
  position: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "instructor" */
export type InstructorCourse_InstructorsArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


/** columns and relationships of "instructor" */
export type InstructorCourse_Instructors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};

/** aggregated selection of "instructor" */
export type Instructor_Aggregate = {
  __typename?: 'instructor_aggregate';
  aggregate?: Maybe<Instructor_Aggregate_Fields>;
  nodes: Array<Instructor>;
};

export type Instructor_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Instructor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Instructor_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Instructor_Aggregate_Bool_Exp_Count>;
};

export type Instructor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Instructor_Select_Column_Instructor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instructor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Instructor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Instructor_Select_Column_Instructor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instructor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Instructor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Instructor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instructor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "instructor" */
export type Instructor_Aggregate_Fields = {
  __typename?: 'instructor_aggregate_fields';
  avg?: Maybe<Instructor_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Instructor_Max_Fields>;
  min?: Maybe<Instructor_Min_Fields>;
  stddev?: Maybe<Instructor_Stddev_Fields>;
  stddev_pop?: Maybe<Instructor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Instructor_Stddev_Samp_Fields>;
  sum?: Maybe<Instructor_Sum_Fields>;
  var_pop?: Maybe<Instructor_Var_Pop_Fields>;
  var_samp?: Maybe<Instructor_Var_Samp_Fields>;
  variance?: Maybe<Instructor_Variance_Fields>;
};


/** aggregate fields of "instructor" */
export type Instructor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Instructor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "instructor" */
export type Instructor_Aggregate_Order_By = {
  avg?: InputMaybe<Instructor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Instructor_Max_Order_By>;
  min?: InputMaybe<Instructor_Min_Order_By>;
  stddev?: InputMaybe<Instructor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Instructor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Instructor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Instructor_Sum_Order_By>;
  var_pop?: InputMaybe<Instructor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Instructor_Var_Samp_Order_By>;
  variance?: InputMaybe<Instructor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "instructor" */
export type Instructor_Arr_Rel_Insert_Input = {
  data: Array<Instructor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Instructor_On_Conflict>;
};

/** aggregate avg on columns */
export type Instructor_Avg_Fields = {
  __typename?: 'instructor_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "instructor" */
export type Instructor_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "instructor". All fields are combined with a logical 'AND'. */
export type Instructor_Bool_Exp = {
  _and?: InputMaybe<Array<Instructor_Bool_Exp>>;
  _not?: InputMaybe<Instructor_Bool_Exp>;
  _or?: InputMaybe<Array<Instructor_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  course_instructors?: InputMaybe<Course_Instructor_Bool_Exp>;
  course_instructors_aggregate?: InputMaybe<Course_Instructor_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  position?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "instructor" */
export const enum Instructor_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCcc0348eefb581ca002c05ef2f3 = 'PK_ccc0348eefb581ca002c05ef2f3',
  /** unique or primary key constraint on columns "uid" */
  Uq_66cb1f9e831ddffa085114ebb74 = 'UQ_66cb1f9e831ddffa085114ebb74'
};

/** input type for incrementing numeric columns in table "instructor" */
export type Instructor_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "instructor" */
export type Instructor_Insert_Input = {
  bio?: InputMaybe<Scalars['String']>;
  course_instructors?: InputMaybe<Course_Instructor_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Instructor_Max_Fields = {
  __typename?: 'instructor_max_fields';
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  picture?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "instructor" */
export type Instructor_Max_Order_By = {
  bio?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Instructor_Min_Fields = {
  __typename?: 'instructor_min_fields';
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  picture?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "instructor" */
export type Instructor_Min_Order_By = {
  bio?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "instructor" */
export type Instructor_Mutation_Response = {
  __typename?: 'instructor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Instructor>;
};

/** input type for inserting object relation for remote table "instructor" */
export type Instructor_Obj_Rel_Insert_Input = {
  data: Instructor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Instructor_On_Conflict>;
};

/** on_conflict condition type for table "instructor" */
export type Instructor_On_Conflict = {
  constraint: Instructor_Constraint;
  update_columns?: Array<Instructor_Update_Column>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};

/** Ordering options when selecting data from "instructor". */
export type Instructor_Order_By = {
  bio?: InputMaybe<Order_By>;
  course_instructors_aggregate?: InputMaybe<Course_Instructor_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: instructor */
export type Instructor_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "instructor" */
export const enum Instructor_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Position = 'position',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "instructor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "instructor" */
export const enum Instructor_Select_Column_Instructor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "instructor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "instructor" */
export const enum Instructor_Select_Column_Instructor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "instructor" */
export type Instructor_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Instructor_Stddev_Fields = {
  __typename?: 'instructor_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "instructor" */
export type Instructor_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Instructor_Stddev_Pop_Fields = {
  __typename?: 'instructor_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "instructor" */
export type Instructor_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Instructor_Stddev_Samp_Fields = {
  __typename?: 'instructor_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "instructor" */
export type Instructor_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "instructor" */
export type Instructor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Instructor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Instructor_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Instructor_Sum_Fields = {
  __typename?: 'instructor_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "instructor" */
export type Instructor_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "instructor" */
export const enum Instructor_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Position = 'position',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Instructor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Instructor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Instructor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Instructor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Instructor_Var_Pop_Fields = {
  __typename?: 'instructor_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "instructor" */
export type Instructor_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Instructor_Var_Samp_Fields = {
  __typename?: 'instructor_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "instructor" */
export type Instructor_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Instructor_Variance_Fields = {
  __typename?: 'instructor_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "instructor" */
export type Instructor_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  amount: Scalars['float8'];
  createdById: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  due_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An array relationship */
  invoice_installments: Array<Invoice_Installment>;
  /** An aggregate relationship */
  invoice_installments_aggregate: Invoice_Installment_Aggregate;
  invoice_number: Scalars['String'];
  invoicedToId: Scalars['Int'];
  issue_date: Scalars['timestamptz'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  school_period?: Maybe<School_Period>;
  status: Scalars['invoice_status_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByCreatedbyid: User;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoice_InstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoice_Installments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoicePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoicePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

export type Invoice_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Invoice_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Invoice_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Invoice_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Invoice_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Invoice_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Invoice_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Invoice_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Invoice_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Invoice_Aggregate_Bool_Exp_Var_Samp>;
};

export type Invoice_Aggregate_Bool_Exp_Avg = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Corr = {
  arguments: Invoice_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Invoice_Aggregate_Bool_Exp_Max = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Min = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Sum = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice" */
export type Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Max_Order_By>;
  min?: InputMaybe<Invoice_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice" */
export type Invoice_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice" */
export type Invoice_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice_installments?: InputMaybe<Invoice_Installment_Bool_Exp>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  invoicedToId?: InputMaybe<Int_Comparison_Exp>;
  issue_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  schoolPeriodId?: InputMaybe<Int_Comparison_Exp>;
  school_period?: InputMaybe<School_Period_Bool_Exp>;
  status?: InputMaybe<Invoice_Status_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByCreatedbyid?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "invoice" */
export const enum Invoice_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_15d25c200d9bcd8a33f698daf18 = 'PK_15d25c200d9bcd8a33f698daf18',
  /** unique or primary key constraint on columns "uid" */
  UqB8507385cd8f35564457ba88ca4 = 'UQ_b8507385cd8f35564457ba88ca4'
};

/** input type for incrementing numeric columns in table "invoice" */
export type Invoice_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoicedToId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_installments?: InputMaybe<Invoice_Installment_Arr_Rel_Insert_Input>;
  invoice_number?: InputMaybe<Scalars['String']>;
  invoicedToId?: InputMaybe<Scalars['Int']>;
  issue_date?: InputMaybe<Scalars['timestamptz']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  school_period?: InputMaybe<School_Period_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['invoice_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByCreatedbyid?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "invoice_installment" */
export type Invoice_Installment = {
  __typename?: 'invoice_installment';
  createdById: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  installment: Installment;
  installmentId: Scalars['Int'];
  /** An object relationship */
  invoice: Invoice;
  invoiceId: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
};

/** aggregated selection of "invoice_installment" */
export type Invoice_Installment_Aggregate = {
  __typename?: 'invoice_installment_aggregate';
  aggregate?: Maybe<Invoice_Installment_Aggregate_Fields>;
  nodes: Array<Invoice_Installment>;
};

export type Invoice_Installment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Installment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Installment_Select_Column_Invoice_Installment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Installment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Installment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Installment_Select_Column_Invoice_Installment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Installment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Installment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Installment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice_installment" */
export type Invoice_Installment_Aggregate_Fields = {
  __typename?: 'invoice_installment_aggregate_fields';
  avg?: Maybe<Invoice_Installment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Installment_Max_Fields>;
  min?: Maybe<Invoice_Installment_Min_Fields>;
  stddev?: Maybe<Invoice_Installment_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Installment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Installment_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Installment_Sum_Fields>;
  var_pop?: Maybe<Invoice_Installment_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Installment_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Installment_Variance_Fields>;
};


/** aggregate fields of "invoice_installment" */
export type Invoice_Installment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_installment" */
export type Invoice_Installment_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Installment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Installment_Max_Order_By>;
  min?: InputMaybe<Invoice_Installment_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Installment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Installment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Installment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Installment_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Installment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Installment_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Installment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice_installment" */
export type Invoice_Installment_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Installment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_Installment_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Installment_Avg_Fields = {
  __typename?: 'invoice_installment_avg_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_installment" */
export type Invoice_Installment_Avg_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice_installment". All fields are combined with a logical 'AND'. */
export type Invoice_Installment_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Installment_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Installment_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Installment_Bool_Exp>>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  installment?: InputMaybe<Installment_Bool_Exp>;
  installmentId?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoiceId?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "invoice_installment" */
export const enum Invoice_Installment_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_7853842c46697fe03c5fa21d2d5 = 'PK_7853842c46697fe03c5fa21d2d5',
  /** unique or primary key constraint on columns "uid" */
  UqE49b1a46192b3ec147817165994 = 'UQ_e49b1a46192b3ec147817165994'
};

/** input type for incrementing numeric columns in table "invoice_installment" */
export type Invoice_Installment_Inc_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  installmentId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_installment" */
export type Invoice_Installment_Insert_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  installment?: InputMaybe<Installment_Obj_Rel_Insert_Input>;
  installmentId?: InputMaybe<Scalars['Int']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoice_Installment_Max_Fields = {
  __typename?: 'invoice_installment_max_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  installmentId?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice_installment" */
export type Invoice_Installment_Max_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Installment_Min_Fields = {
  __typename?: 'invoice_installment_min_fields';
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  installmentId?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice_installment" */
export type Invoice_Installment_Min_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice_installment" */
export type Invoice_Installment_Mutation_Response = {
  __typename?: 'invoice_installment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Installment>;
};

/** on_conflict condition type for table "invoice_installment" */
export type Invoice_Installment_On_Conflict = {
  constraint: Invoice_Installment_Constraint;
  update_columns?: Array<Invoice_Installment_Update_Column>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice_installment". */
export type Invoice_Installment_Order_By = {
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installment?: InputMaybe<Installment_Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: invoice_installment */
export type Invoice_Installment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "invoice_installment" */
export const enum Invoice_Installment_Select_Column {
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InstallmentId = 'installmentId',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "invoice_installment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice_installment" */
export const enum Invoice_Installment_Select_Column_Invoice_Installment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "invoice_installment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice_installment" */
export const enum Invoice_Installment_Select_Column_Invoice_Installment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "invoice_installment" */
export type Invoice_Installment_Set_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  installmentId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Invoice_Installment_Stddev_Fields = {
  __typename?: 'invoice_installment_stddev_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_installment" */
export type Invoice_Installment_Stddev_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Installment_Stddev_Pop_Fields = {
  __typename?: 'invoice_installment_stddev_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice_installment" */
export type Invoice_Installment_Stddev_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Installment_Stddev_Samp_Fields = {
  __typename?: 'invoice_installment_stddev_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice_installment" */
export type Invoice_Installment_Stddev_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice_installment" */
export type Invoice_Installment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Installment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Installment_Stream_Cursor_Value_Input = {
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  installmentId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Installment_Sum_Fields = {
  __typename?: 'invoice_installment_sum_fields';
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  installmentId?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_installment" */
export type Invoice_Installment_Sum_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "invoice_installment" */
export const enum Invoice_Installment_Update_Column {
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InstallmentId = 'installmentId',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Invoice_Installment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Installment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Installment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Installment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Installment_Var_Pop_Fields = {
  __typename?: 'invoice_installment_var_pop_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice_installment" */
export type Invoice_Installment_Var_Pop_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Installment_Var_Samp_Fields = {
  __typename?: 'invoice_installment_var_samp_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice_installment" */
export type Invoice_Installment_Var_Samp_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Installment_Variance_Fields = {
  __typename?: 'invoice_installment_variance_fields';
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  installmentId?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_installment" */
export type Invoice_Installment_Variance_Order_By = {
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installmentId?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  invoicedToId?: Maybe<Scalars['Int']>;
  issue_date?: Maybe<Scalars['timestamptz']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['invoice_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice" */
export type Invoice_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  invoicedToId?: Maybe<Scalars['Int']>;
  issue_date?: Maybe<Scalars['timestamptz']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['invoice_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice" */
export type Invoice_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** input type for inserting object relation for remote table "invoice" */
export type Invoice_Obj_Rel_Insert_Input = {
  data: Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  school_period?: InputMaybe<School_Period_Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByCreatedbyid?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "invoice" */
export const enum Invoice_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  InvoicedToId = 'invoicedToId',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "invoice_aggregate_bool_exp_avg_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "invoice_aggregate_bool_exp_corr_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_max_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_min_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_sum_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "invoice_aggregate_bool_exp_var_samp_arguments_columns" columns of table "invoice" */
export const enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  invoicedToId?: InputMaybe<Scalars['Int']>;
  issue_date?: InputMaybe<Scalars['timestamptz']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['invoice_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "invoice_status_enum". All fields are combined with logical 'AND'. */
export type Invoice_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['invoice_status_enum']>;
  _gt?: InputMaybe<Scalars['invoice_status_enum']>;
  _gte?: InputMaybe<Scalars['invoice_status_enum']>;
  _in?: InputMaybe<Array<Scalars['invoice_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['invoice_status_enum']>;
  _lte?: InputMaybe<Scalars['invoice_status_enum']>;
  _neq?: InputMaybe<Scalars['invoice_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['invoice_status_enum']>>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice" */
export type Invoice_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type Invoice_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type Invoice_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  invoicedToId?: InputMaybe<Scalars['Int']>;
  issue_date?: InputMaybe<Scalars['timestamptz']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['invoice_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoicedToId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice" */
export type Invoice_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** update columns of table "invoice" */
export const enum Invoice_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  InvoicedToId = 'invoicedToId',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice" */
export type Invoice_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice" */
export type Invoice_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoicedToId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice" */
export type Invoice_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedToId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lecture" */
export type Lecture = {
  __typename?: 'lecture';
  /** An array relationship */
  assignments: Array<Assignment>;
  /** An aggregate relationship */
  assignments_aggregate: Assignment_Aggregate;
  calendarEventId: Scalars['Int'];
  /** An object relationship */
  calendar_event: Calendar_Event;
  classCourseId: Scalars['Int'];
  /** An object relationship */
  class_course: Class_Course;
  createdById?: Maybe<Scalars['Int']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  isVirtual: Scalars['Boolean'];
  /** An array relationship */
  lecture_notes: Array<Lecture_Note>;
  /** An aggregate relationship */
  lecture_notes_aggregate: Lecture_Note_Aggregate;
  /** An array relationship */
  lecture_resources: Array<Lecture_Resource>;
  /** An aggregate relationship */
  lecture_resources_aggregate: Lecture_Resource_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  status: Scalars['lecture_status_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_lectures: Array<User_Lecture>;
  /** An aggregate relationship */
  user_lectures_aggregate: User_Lecture_Aggregate;
};


/** columns and relationships of "lecture" */
export type LectureAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureLecture_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureLecture_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureLecture_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureLecture_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureUser_LecturesArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


/** columns and relationships of "lecture" */
export type LectureUser_Lectures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};

/** aggregated selection of "lecture" */
export type Lecture_Aggregate = {
  __typename?: 'lecture_aggregate';
  aggregate?: Maybe<Lecture_Aggregate_Fields>;
  nodes: Array<Lecture>;
};

export type Lecture_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lecture_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lecture_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lecture_Aggregate_Bool_Exp_Count>;
};

export type Lecture_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lecture_Select_Column_Lecture_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lecture_Select_Column_Lecture_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lecture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lecture" */
export type Lecture_Aggregate_Fields = {
  __typename?: 'lecture_aggregate_fields';
  avg?: Maybe<Lecture_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Lecture_Max_Fields>;
  min?: Maybe<Lecture_Min_Fields>;
  stddev?: Maybe<Lecture_Stddev_Fields>;
  stddev_pop?: Maybe<Lecture_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lecture_Stddev_Samp_Fields>;
  sum?: Maybe<Lecture_Sum_Fields>;
  var_pop?: Maybe<Lecture_Var_Pop_Fields>;
  var_samp?: Maybe<Lecture_Var_Samp_Fields>;
  variance?: Maybe<Lecture_Variance_Fields>;
};


/** aggregate fields of "lecture" */
export type Lecture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lecture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lecture" */
export type Lecture_Aggregate_Order_By = {
  avg?: InputMaybe<Lecture_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lecture_Max_Order_By>;
  min?: InputMaybe<Lecture_Min_Order_By>;
  stddev?: InputMaybe<Lecture_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lecture_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lecture_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lecture_Sum_Order_By>;
  var_pop?: InputMaybe<Lecture_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lecture_Var_Samp_Order_By>;
  variance?: InputMaybe<Lecture_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lecture" */
export type Lecture_Arr_Rel_Insert_Input = {
  data: Array<Lecture_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lecture_On_Conflict>;
};

/** aggregate avg on columns */
export type Lecture_Avg_Fields = {
  __typename?: 'lecture_avg_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lecture" */
export type Lecture_Avg_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lecture". All fields are combined with a logical 'AND'. */
export type Lecture_Bool_Exp = {
  _and?: InputMaybe<Array<Lecture_Bool_Exp>>;
  _not?: InputMaybe<Lecture_Bool_Exp>;
  _or?: InputMaybe<Array<Lecture_Bool_Exp>>;
  assignments?: InputMaybe<Assignment_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Bool_Exp>;
  calendarEventId?: InputMaybe<Int_Comparison_Exp>;
  calendar_event?: InputMaybe<Calendar_Event_Bool_Exp>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isVirtual?: InputMaybe<Boolean_Comparison_Exp>;
  lecture_notes?: InputMaybe<Lecture_Note_Bool_Exp>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp>;
  lecture_resources?: InputMaybe<Lecture_Resource_Bool_Exp>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Lecture_Status_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_lectures?: InputMaybe<User_Lecture_Bool_Exp>;
  user_lectures_aggregate?: InputMaybe<User_Lecture_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "lecture" */
export const enum Lecture_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_2abef7c1e52b7b58a9f905c9643 = 'PK_2abef7c1e52b7b58a9f905c9643',
  /** unique or primary key constraint on columns "uid" */
  Uq_9f90430c8a690dd5beb84604acb = 'UQ_9f90430c8a690dd5beb84604acb',
  /** unique or primary key constraint on columns "calendarEventId" */
  Uq_1395e5ccd20906f97417bc27b14 = 'UQ_1395e5ccd20906f97417bc27b14'
};

/** input type for incrementing numeric columns in table "lecture" */
export type Lecture_Inc_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lecture" */
export type Lecture_Insert_Input = {
  assignments?: InputMaybe<Assignment_Arr_Rel_Insert_Input>;
  calendarEventId?: InputMaybe<Scalars['Int']>;
  calendar_event?: InputMaybe<Calendar_Event_Obj_Rel_Insert_Input>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  createdById?: InputMaybe<Scalars['Int']>;
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  lecture_notes?: InputMaybe<Lecture_Note_Arr_Rel_Insert_Input>;
  lecture_resources?: InputMaybe<Lecture_Resource_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_lectures?: InputMaybe<User_Lecture_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Lecture_Max_Fields = {
  __typename?: 'lecture_max_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['lecture_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lecture" */
export type Lecture_Max_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lecture_Min_Fields = {
  __typename?: 'lecture_min_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['lecture_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lecture" */
export type Lecture_Min_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lecture" */
export type Lecture_Mutation_Response = {
  __typename?: 'lecture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lecture>;
};

/** columns and relationships of "lecture_note" */
export type Lecture_Note = {
  __typename?: 'lecture_note';
  classCourseNoteId: Scalars['Int'];
  /** An object relationship */
  class_course_note: Class_Course_Note;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lecture: Lecture;
  lectureId: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "lecture_note" */
export type Lecture_Note_Aggregate = {
  __typename?: 'lecture_note_aggregate';
  aggregate?: Maybe<Lecture_Note_Aggregate_Fields>;
  nodes: Array<Lecture_Note>;
};

export type Lecture_Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp_Count>;
};

export type Lecture_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lecture_Note_Select_Column_Lecture_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lecture_Note_Select_Column_Lecture_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lecture_note" */
export type Lecture_Note_Aggregate_Fields = {
  __typename?: 'lecture_note_aggregate_fields';
  avg?: Maybe<Lecture_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Lecture_Note_Max_Fields>;
  min?: Maybe<Lecture_Note_Min_Fields>;
  stddev?: Maybe<Lecture_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Lecture_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lecture_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Lecture_Note_Sum_Fields>;
  var_pop?: Maybe<Lecture_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Lecture_Note_Var_Samp_Fields>;
  variance?: Maybe<Lecture_Note_Variance_Fields>;
};


/** aggregate fields of "lecture_note" */
export type Lecture_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lecture_note" */
export type Lecture_Note_Aggregate_Order_By = {
  avg?: InputMaybe<Lecture_Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lecture_Note_Max_Order_By>;
  min?: InputMaybe<Lecture_Note_Min_Order_By>;
  stddev?: InputMaybe<Lecture_Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lecture_Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lecture_Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lecture_Note_Sum_Order_By>;
  var_pop?: InputMaybe<Lecture_Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lecture_Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Lecture_Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lecture_note" */
export type Lecture_Note_Arr_Rel_Insert_Input = {
  data: Array<Lecture_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lecture_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Lecture_Note_Avg_Fields = {
  __typename?: 'lecture_note_avg_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lecture_note" */
export type Lecture_Note_Avg_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lecture_note". All fields are combined with a logical 'AND'. */
export type Lecture_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Lecture_Note_Bool_Exp>>;
  _not?: InputMaybe<Lecture_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Lecture_Note_Bool_Exp>>;
  classCourseNoteId?: InputMaybe<Int_Comparison_Exp>;
  class_course_note?: InputMaybe<Class_Course_Note_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lecture?: InputMaybe<Lecture_Bool_Exp>;
  lectureId?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lecture_note" */
export const enum Lecture_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_5114435a376f8cd22f45350b040 = 'PK_5114435a376f8cd22f45350b040',
  /** unique or primary key constraint on columns "uid" */
  UqEf9f91a496468981c10c9429737 = 'UQ_ef9f91a496468981c10c9429737'
};

/** input type for incrementing numeric columns in table "lecture_note" */
export type Lecture_Note_Inc_Input = {
  classCourseNoteId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lecture_note" */
export type Lecture_Note_Insert_Input = {
  classCourseNoteId?: InputMaybe<Scalars['Int']>;
  class_course_note?: InputMaybe<Class_Course_Note_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lecture?: InputMaybe<Lecture_Obj_Rel_Insert_Input>;
  lectureId?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Lecture_Note_Max_Fields = {
  __typename?: 'lecture_note_max_fields';
  classCourseNoteId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lecture_note" */
export type Lecture_Note_Max_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lecture_Note_Min_Fields = {
  __typename?: 'lecture_note_min_fields';
  classCourseNoteId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lecture_note" */
export type Lecture_Note_Min_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lecture_note" */
export type Lecture_Note_Mutation_Response = {
  __typename?: 'lecture_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lecture_Note>;
};

/** on_conflict condition type for table "lecture_note" */
export type Lecture_Note_On_Conflict = {
  constraint: Lecture_Note_Constraint;
  update_columns?: Array<Lecture_Note_Update_Column>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "lecture_note". */
export type Lecture_Note_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  class_course_note?: InputMaybe<Class_Course_Note_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lecture?: InputMaybe<Lecture_Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lecture_note */
export type Lecture_Note_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "lecture_note" */
export const enum Lecture_Note_Select_Column {
  /** column name */
  ClassCourseNoteId = 'classCourseNoteId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "lecture_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lecture_note" */
export const enum Lecture_Note_Select_Column_Lecture_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "lecture_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lecture_note" */
export const enum Lecture_Note_Select_Column_Lecture_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "lecture_note" */
export type Lecture_Note_Set_Input = {
  classCourseNoteId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Lecture_Note_Stddev_Fields = {
  __typename?: 'lecture_note_stddev_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lecture_note" */
export type Lecture_Note_Stddev_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lecture_Note_Stddev_Pop_Fields = {
  __typename?: 'lecture_note_stddev_pop_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lecture_note" */
export type Lecture_Note_Stddev_Pop_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lecture_Note_Stddev_Samp_Fields = {
  __typename?: 'lecture_note_stddev_samp_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lecture_note" */
export type Lecture_Note_Stddev_Samp_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lecture_note" */
export type Lecture_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lecture_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lecture_Note_Stream_Cursor_Value_Input = {
  classCourseNoteId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Lecture_Note_Sum_Fields = {
  __typename?: 'lecture_note_sum_fields';
  classCourseNoteId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lecture_note" */
export type Lecture_Note_Sum_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "lecture_note" */
export const enum Lecture_Note_Update_Column {
  /** column name */
  ClassCourseNoteId = 'classCourseNoteId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Lecture_Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lecture_Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lecture_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lecture_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lecture_Note_Var_Pop_Fields = {
  __typename?: 'lecture_note_var_pop_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lecture_note" */
export type Lecture_Note_Var_Pop_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lecture_Note_Var_Samp_Fields = {
  __typename?: 'lecture_note_var_samp_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lecture_note" */
export type Lecture_Note_Var_Samp_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lecture_Note_Variance_Fields = {
  __typename?: 'lecture_note_variance_fields';
  classCourseNoteId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lecture_note" */
export type Lecture_Note_Variance_Order_By = {
  classCourseNoteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "lecture" */
export type Lecture_Obj_Rel_Insert_Input = {
  data: Lecture_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lecture_On_Conflict>;
};

/** on_conflict condition type for table "lecture" */
export type Lecture_On_Conflict = {
  constraint: Lecture_Constraint;
  update_columns?: Array<Lecture_Update_Column>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};

/** Ordering options when selecting data from "lecture". */
export type Lecture_Order_By = {
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Order_By>;
  calendarEventId?: InputMaybe<Order_By>;
  calendar_event?: InputMaybe<Calendar_Event_Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  createdById?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isVirtual?: InputMaybe<Order_By>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Order_By>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_lectures_aggregate?: InputMaybe<User_Lecture_Aggregate_Order_By>;
};

/** primary key columns input for table: lecture */
export type Lecture_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "lecture_resource" */
export type Lecture_Resource = {
  __typename?: 'lecture_resource';
  classCourseResourceId: Scalars['Int'];
  /** An object relationship */
  class_course_resource: Class_Course_Resource;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lecture: Lecture;
  lectureId: Scalars['Int'];
  order: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "lecture_resource" */
export type Lecture_Resource_Aggregate = {
  __typename?: 'lecture_resource_aggregate';
  aggregate?: Maybe<Lecture_Resource_Aggregate_Fields>;
  nodes: Array<Lecture_Resource>;
};

export type Lecture_Resource_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp_Count>;
};

export type Lecture_Resource_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lecture_Resource_Select_Column_Lecture_Resource_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Resource_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Resource_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lecture_Resource_Select_Column_Lecture_Resource_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Resource_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lecture_Resource_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lecture_Resource_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lecture_resource" */
export type Lecture_Resource_Aggregate_Fields = {
  __typename?: 'lecture_resource_aggregate_fields';
  avg?: Maybe<Lecture_Resource_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Lecture_Resource_Max_Fields>;
  min?: Maybe<Lecture_Resource_Min_Fields>;
  stddev?: Maybe<Lecture_Resource_Stddev_Fields>;
  stddev_pop?: Maybe<Lecture_Resource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lecture_Resource_Stddev_Samp_Fields>;
  sum?: Maybe<Lecture_Resource_Sum_Fields>;
  var_pop?: Maybe<Lecture_Resource_Var_Pop_Fields>;
  var_samp?: Maybe<Lecture_Resource_Var_Samp_Fields>;
  variance?: Maybe<Lecture_Resource_Variance_Fields>;
};


/** aggregate fields of "lecture_resource" */
export type Lecture_Resource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lecture_resource" */
export type Lecture_Resource_Aggregate_Order_By = {
  avg?: InputMaybe<Lecture_Resource_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lecture_Resource_Max_Order_By>;
  min?: InputMaybe<Lecture_Resource_Min_Order_By>;
  stddev?: InputMaybe<Lecture_Resource_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lecture_Resource_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lecture_Resource_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lecture_Resource_Sum_Order_By>;
  var_pop?: InputMaybe<Lecture_Resource_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lecture_Resource_Var_Samp_Order_By>;
  variance?: InputMaybe<Lecture_Resource_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lecture_resource" */
export type Lecture_Resource_Arr_Rel_Insert_Input = {
  data: Array<Lecture_Resource_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lecture_Resource_On_Conflict>;
};

/** aggregate avg on columns */
export type Lecture_Resource_Avg_Fields = {
  __typename?: 'lecture_resource_avg_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lecture_resource" */
export type Lecture_Resource_Avg_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lecture_resource". All fields are combined with a logical 'AND'. */
export type Lecture_Resource_Bool_Exp = {
  _and?: InputMaybe<Array<Lecture_Resource_Bool_Exp>>;
  _not?: InputMaybe<Lecture_Resource_Bool_Exp>;
  _or?: InputMaybe<Array<Lecture_Resource_Bool_Exp>>;
  classCourseResourceId?: InputMaybe<Int_Comparison_Exp>;
  class_course_resource?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lecture?: InputMaybe<Lecture_Bool_Exp>;
  lectureId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lecture_resource" */
export const enum Lecture_Resource_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_72f31adaf0bc84d29918d5ec6c6 = 'PK_72f31adaf0bc84d29918d5ec6c6',
  /** unique or primary key constraint on columns "uid" */
  Uq_5d2d524e654cc2caa25777d3ec5 = 'UQ_5d2d524e654cc2caa25777d3ec5'
};

/** input type for incrementing numeric columns in table "lecture_resource" */
export type Lecture_Resource_Inc_Input = {
  classCourseResourceId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lecture_resource" */
export type Lecture_Resource_Insert_Input = {
  classCourseResourceId?: InputMaybe<Scalars['Int']>;
  class_course_resource?: InputMaybe<Class_Course_Resource_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lecture?: InputMaybe<Lecture_Obj_Rel_Insert_Input>;
  lectureId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Lecture_Resource_Max_Fields = {
  __typename?: 'lecture_resource_max_fields';
  classCourseResourceId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lecture_resource" */
export type Lecture_Resource_Max_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lecture_Resource_Min_Fields = {
  __typename?: 'lecture_resource_min_fields';
  classCourseResourceId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lecture_resource" */
export type Lecture_Resource_Min_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lecture_resource" */
export type Lecture_Resource_Mutation_Response = {
  __typename?: 'lecture_resource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lecture_Resource>;
};

/** on_conflict condition type for table "lecture_resource" */
export type Lecture_Resource_On_Conflict = {
  constraint: Lecture_Resource_Constraint;
  update_columns?: Array<Lecture_Resource_Update_Column>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};

/** Ordering options when selecting data from "lecture_resource". */
export type Lecture_Resource_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  class_course_resource?: InputMaybe<Class_Course_Resource_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lecture?: InputMaybe<Lecture_Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lecture_resource */
export type Lecture_Resource_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "lecture_resource" */
export const enum Lecture_Resource_Select_Column {
  /** column name */
  ClassCourseResourceId = 'classCourseResourceId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "lecture_resource_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lecture_resource" */
export const enum Lecture_Resource_Select_Column_Lecture_Resource_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "lecture_resource_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lecture_resource" */
export const enum Lecture_Resource_Select_Column_Lecture_Resource_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "lecture_resource" */
export type Lecture_Resource_Set_Input = {
  classCourseResourceId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Lecture_Resource_Stddev_Fields = {
  __typename?: 'lecture_resource_stddev_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lecture_resource" */
export type Lecture_Resource_Stddev_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lecture_Resource_Stddev_Pop_Fields = {
  __typename?: 'lecture_resource_stddev_pop_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lecture_resource" */
export type Lecture_Resource_Stddev_Pop_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lecture_Resource_Stddev_Samp_Fields = {
  __typename?: 'lecture_resource_stddev_samp_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lecture_resource" */
export type Lecture_Resource_Stddev_Samp_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lecture_resource" */
export type Lecture_Resource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lecture_Resource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lecture_Resource_Stream_Cursor_Value_Input = {
  classCourseResourceId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Lecture_Resource_Sum_Fields = {
  __typename?: 'lecture_resource_sum_fields';
  classCourseResourceId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lecture_resource" */
export type Lecture_Resource_Sum_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "lecture_resource" */
export const enum Lecture_Resource_Update_Column {
  /** column name */
  ClassCourseResourceId = 'classCourseResourceId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Lecture_Resource_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lecture_Resource_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lecture_Resource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lecture_Resource_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lecture_Resource_Var_Pop_Fields = {
  __typename?: 'lecture_resource_var_pop_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lecture_resource" */
export type Lecture_Resource_Var_Pop_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lecture_Resource_Var_Samp_Fields = {
  __typename?: 'lecture_resource_var_samp_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lecture_resource" */
export type Lecture_Resource_Var_Samp_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lecture_Resource_Variance_Fields = {
  __typename?: 'lecture_resource_variance_fields';
  classCourseResourceId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lecture_resource" */
export type Lecture_Resource_Variance_Order_By = {
  classCourseResourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** select columns of table "lecture" */
export const enum Lecture_Select_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsVirtual = 'isVirtual',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "lecture_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lecture" */
export const enum Lecture_Select_Column_Lecture_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsVirtual = 'isVirtual'
};

/** select "lecture_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lecture" */
export const enum Lecture_Select_Column_Lecture_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsVirtual = 'isVirtual'
};

/** input type for updating data in table "lecture" */
export type Lecture_Set_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "lecture_status_enum". All fields are combined with logical 'AND'. */
export type Lecture_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lecture_status_enum']>;
  _gt?: InputMaybe<Scalars['lecture_status_enum']>;
  _gte?: InputMaybe<Scalars['lecture_status_enum']>;
  _in?: InputMaybe<Array<Scalars['lecture_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['lecture_status_enum']>;
  _lte?: InputMaybe<Scalars['lecture_status_enum']>;
  _neq?: InputMaybe<Scalars['lecture_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['lecture_status_enum']>>;
};

/** aggregate stddev on columns */
export type Lecture_Stddev_Fields = {
  __typename?: 'lecture_stddev_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lecture" */
export type Lecture_Stddev_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lecture_Stddev_Pop_Fields = {
  __typename?: 'lecture_stddev_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lecture" */
export type Lecture_Stddev_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lecture_Stddev_Samp_Fields = {
  __typename?: 'lecture_stddev_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lecture" */
export type Lecture_Stddev_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lecture" */
export type Lecture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lecture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lecture_Stream_Cursor_Value_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Lecture_Sum_Fields = {
  __typename?: 'lecture_sum_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  classCourseId?: Maybe<Scalars['Int']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lecture" */
export type Lecture_Sum_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "lecture" */
export const enum Lecture_Update_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsVirtual = 'isVirtual',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Lecture_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lecture_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lecture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lecture_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lecture_Var_Pop_Fields = {
  __typename?: 'lecture_var_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lecture" */
export type Lecture_Var_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lecture_Var_Samp_Fields = {
  __typename?: 'lecture_var_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lecture" */
export type Lecture_Var_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lecture_Variance_Fields = {
  __typename?: 'lecture_variance_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  classCourseId?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lecture" */
export type Lecture_Variance_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "lesson" */
export type Lesson = {
  __typename?: 'lesson';
  /** An array relationship */
  activities: Array<Activity>;
  /** An aggregate relationship */
  activities_aggregate: Activity_Aggregate;
  /** An object relationship */
  checkpoint?: Maybe<Checkpoint>;
  coefficient: Scalars['Int'];
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  level?: Maybe<Level>;
  levelId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  passingScore?: Maybe<Scalars['Int']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  /** An object relationship */
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "lesson" */
export type LessonActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "lesson" */
export type LessonActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "lesson" */
export type LessonProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "lesson" */
export type LessonProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};

/** aggregated selection of "lesson" */
export type Lesson_Aggregate = {
  __typename?: 'lesson_aggregate';
  aggregate?: Maybe<Lesson_Aggregate_Fields>;
  nodes: Array<Lesson>;
};

export type Lesson_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lesson_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lesson_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lesson_Aggregate_Bool_Exp_Count>;
};

export type Lesson_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lesson_Select_Column_Lesson_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lesson_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lesson_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lesson_Select_Column_Lesson_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lesson_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lesson_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lesson_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Lesson_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lesson" */
export type Lesson_Aggregate_Fields = {
  __typename?: 'lesson_aggregate_fields';
  avg?: Maybe<Lesson_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Lesson_Max_Fields>;
  min?: Maybe<Lesson_Min_Fields>;
  stddev?: Maybe<Lesson_Stddev_Fields>;
  stddev_pop?: Maybe<Lesson_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lesson_Stddev_Samp_Fields>;
  sum?: Maybe<Lesson_Sum_Fields>;
  var_pop?: Maybe<Lesson_Var_Pop_Fields>;
  var_samp?: Maybe<Lesson_Var_Samp_Fields>;
  variance?: Maybe<Lesson_Variance_Fields>;
};


/** aggregate fields of "lesson" */
export type Lesson_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lesson_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson" */
export type Lesson_Aggregate_Order_By = {
  avg?: InputMaybe<Lesson_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lesson_Max_Order_By>;
  min?: InputMaybe<Lesson_Min_Order_By>;
  stddev?: InputMaybe<Lesson_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lesson_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lesson_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lesson_Sum_Order_By>;
  var_pop?: InputMaybe<Lesson_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lesson_Var_Samp_Order_By>;
  variance?: InputMaybe<Lesson_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lesson" */
export type Lesson_Arr_Rel_Insert_Input = {
  data: Array<Lesson_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lesson_On_Conflict>;
};

/** aggregate avg on columns */
export type Lesson_Avg_Fields = {
  __typename?: 'lesson_avg_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson" */
export type Lesson_Avg_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lesson". All fields are combined with a logical 'AND'. */
export type Lesson_Bool_Exp = {
  _and?: InputMaybe<Array<Lesson_Bool_Exp>>;
  _not?: InputMaybe<Lesson_Bool_Exp>;
  _or?: InputMaybe<Array<Lesson_Bool_Exp>>;
  activities?: InputMaybe<Activity_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activity_Aggregate_Bool_Exp>;
  checkpoint?: InputMaybe<Checkpoint_Bool_Exp>;
  coefficient?: InputMaybe<Int_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  level?: InputMaybe<Level_Bool_Exp>;
  levelId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  overview?: InputMaybe<String_Comparison_Exp>;
  passingScore?: InputMaybe<Int_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lesson" */
export const enum Lesson_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_0ef25918f0237e68696dee455bd = 'PK_0ef25918f0237e68696dee455bd',
  /** unique or primary key constraint on columns "uid" */
  Uq_3e67ebd440cce1c1260d8313782 = 'UQ_3e67ebd440cce1c1260d8313782'
};

/** input type for incrementing numeric columns in table "lesson" */
export type Lesson_Inc_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  passingScore?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson" */
export type Lesson_Insert_Input = {
  activities?: InputMaybe<Activity_Arr_Rel_Insert_Input>;
  checkpoint?: InputMaybe<Checkpoint_Obj_Rel_Insert_Input>;
  coefficient?: InputMaybe<Scalars['Int']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Level_Obj_Rel_Insert_Input>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  passingScore?: InputMaybe<Scalars['Int']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Lesson_Max_Fields = {
  __typename?: 'lesson_max_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  passingScore?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson" */
export type Lesson_Max_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lesson_Min_Fields = {
  __typename?: 'lesson_min_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  passingScore?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson" */
export type Lesson_Min_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lesson" */
export type Lesson_Mutation_Response = {
  __typename?: 'lesson_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lesson>;
};

/** input type for inserting object relation for remote table "lesson" */
export type Lesson_Obj_Rel_Insert_Input = {
  data: Lesson_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lesson_On_Conflict>;
};

/** on_conflict condition type for table "lesson" */
export type Lesson_On_Conflict = {
  constraint: Lesson_Constraint;
  update_columns?: Array<Lesson_Update_Column>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};

/** Ordering options when selecting data from "lesson". */
export type Lesson_Order_By = {
  activities_aggregate?: InputMaybe<Activity_Aggregate_Order_By>;
  checkpoint?: InputMaybe<Checkpoint_Order_By>;
  coefficient?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Level_Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lesson */
export type Lesson_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "lesson" */
export const enum Lesson_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  PassingScore = 'passingScore',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unitId',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "lesson_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lesson" */
export const enum Lesson_Select_Column_Lesson_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "lesson_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lesson" */
export const enum Lesson_Select_Column_Lesson_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "lesson" */
export type Lesson_Set_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  passingScore?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Lesson_Stddev_Fields = {
  __typename?: 'lesson_stddev_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson" */
export type Lesson_Stddev_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lesson_Stddev_Pop_Fields = {
  __typename?: 'lesson_stddev_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lesson" */
export type Lesson_Stddev_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lesson_Stddev_Samp_Fields = {
  __typename?: 'lesson_stddev_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lesson" */
export type Lesson_Stddev_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lesson" */
export type Lesson_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lesson_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lesson_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  passingScore?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Lesson_Sum_Fields = {
  __typename?: 'lesson_sum_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  passingScore?: Maybe<Scalars['Int']>;
  unitId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson" */
export type Lesson_Sum_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** update columns of table "lesson" */
export const enum Lesson_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  PassingScore = 'passingScore',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unitId',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Lesson_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lesson_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lesson_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lesson_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lesson_Var_Pop_Fields = {
  __typename?: 'lesson_var_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lesson" */
export type Lesson_Var_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lesson_Var_Samp_Fields = {
  __typename?: 'lesson_var_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lesson" */
export type Lesson_Var_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lesson_Variance_Fields = {
  __typename?: 'lesson_variance_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  passingScore?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson" */
export type Lesson_Variance_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  passingScore?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** columns and relationships of "level" */
export type Level = {
  __typename?: 'level';
  coefficient: Scalars['Int'];
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An array relationship */
  lessons: Array<Lesson>;
  /** An aggregate relationship */
  lessons_aggregate: Lesson_Aggregate;
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "level" */
export type LevelLessonsArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "level" */
export type LevelLessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "level" */
export type LevelProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "level" */
export type LevelProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "level" */
export type LevelUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "level" */
export type LevelUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** aggregated selection of "level" */
export type Level_Aggregate = {
  __typename?: 'level_aggregate';
  aggregate?: Maybe<Level_Aggregate_Fields>;
  nodes: Array<Level>;
};

export type Level_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Level_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Level_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Level_Aggregate_Bool_Exp_Count>;
};

export type Level_Aggregate_Bool_Exp_Bool_And = {
  arguments: Level_Select_Column_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Level_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Level_Select_Column_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Level_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Level_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Level_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "level" */
export type Level_Aggregate_Fields = {
  __typename?: 'level_aggregate_fields';
  avg?: Maybe<Level_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Level_Max_Fields>;
  min?: Maybe<Level_Min_Fields>;
  stddev?: Maybe<Level_Stddev_Fields>;
  stddev_pop?: Maybe<Level_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Level_Stddev_Samp_Fields>;
  sum?: Maybe<Level_Sum_Fields>;
  var_pop?: Maybe<Level_Var_Pop_Fields>;
  var_samp?: Maybe<Level_Var_Samp_Fields>;
  variance?: Maybe<Level_Variance_Fields>;
};


/** aggregate fields of "level" */
export type Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "level" */
export type Level_Aggregate_Order_By = {
  avg?: InputMaybe<Level_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Level_Max_Order_By>;
  min?: InputMaybe<Level_Min_Order_By>;
  stddev?: InputMaybe<Level_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Level_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Level_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Level_Sum_Order_By>;
  var_pop?: InputMaybe<Level_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Level_Var_Samp_Order_By>;
  variance?: InputMaybe<Level_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "level" */
export type Level_Arr_Rel_Insert_Input = {
  data: Array<Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Level_On_Conflict>;
};

/** aggregate avg on columns */
export type Level_Avg_Fields = {
  __typename?: 'level_avg_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "level" */
export type Level_Avg_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "level". All fields are combined with a logical 'AND'. */
export type Level_Bool_Exp = {
  _and?: InputMaybe<Array<Level_Bool_Exp>>;
  _not?: InputMaybe<Level_Bool_Exp>;
  _or?: InputMaybe<Array<Level_Bool_Exp>>;
  coefficient?: InputMaybe<Int_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lessons?: InputMaybe<Lesson_Bool_Exp>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  overview?: InputMaybe<String_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  units?: InputMaybe<Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "level" */
export const enum Level_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkD3f1a7a6f09f1c3144bacdc6bcc = 'PK_d3f1a7a6f09f1c3144bacdc6bcc',
  /** unique or primary key constraint on columns "uid" */
  UqDc80aaaa087c6b6c1515f8d4400 = 'UQ_dc80aaaa087c6b6c1515f8d4400'
};

/** input type for incrementing numeric columns in table "level" */
export type Level_Inc_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "level" */
export type Level_Insert_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessons?: InputMaybe<Lesson_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  units?: InputMaybe<Unit_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Level_Max_Fields = {
  __typename?: 'level_max_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "level" */
export type Level_Max_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Level_Min_Fields = {
  __typename?: 'level_min_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "level" */
export type Level_Min_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "level" */
export type Level_Mutation_Response = {
  __typename?: 'level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Level>;
};

/** input type for inserting object relation for remote table "level" */
export type Level_Obj_Rel_Insert_Input = {
  data: Level_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Level_On_Conflict>;
};

/** on_conflict condition type for table "level" */
export type Level_On_Conflict = {
  constraint: Level_Constraint;
  update_columns?: Array<Level_Update_Column>;
  where?: InputMaybe<Level_Bool_Exp>;
};

/** Ordering options when selecting data from "level". */
export type Level_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: level */
export type Level_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "level" */
export const enum Level_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "level_aggregate_bool_exp_bool_and_arguments_columns" columns of table "level" */
export const enum Level_Select_Column_Level_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "level_aggregate_bool_exp_bool_or_arguments_columns" columns of table "level" */
export const enum Level_Select_Column_Level_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "level" */
export type Level_Set_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Level_Stddev_Fields = {
  __typename?: 'level_stddev_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "level" */
export type Level_Stddev_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Level_Stddev_Pop_Fields = {
  __typename?: 'level_stddev_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "level" */
export type Level_Stddev_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Level_Stddev_Samp_Fields = {
  __typename?: 'level_stddev_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "level" */
export type Level_Stddev_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "level" */
export type Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Level_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Level_Sum_Fields = {
  __typename?: 'level_sum_fields';
  coefficient?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "level" */
export type Level_Sum_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "level" */
export const enum Level_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Level_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Level_Var_Pop_Fields = {
  __typename?: 'level_var_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "level" */
export type Level_Var_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Level_Var_Samp_Fields = {
  __typename?: 'level_var_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "level" */
export type Level_Var_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Level_Variance_Fields = {
  __typename?: 'level_variance_fields';
  coefficient?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "level" */
export type Level_Variance_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "media" */
export type Media = {
  __typename?: 'media';
  /** An array relationship */
  assignment_blocks: Array<Assignment_Block>;
  /** An aggregate relationship */
  assignment_blocks_aggregate: Assignment_Block_Aggregate;
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  /** An array relationship */
  question_options: Array<Question_Option>;
  /** An aggregate relationship */
  question_options_aggregate: Question_Option_Aggregate;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  type: Scalars['media_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "media" */
export type MediaAssignment_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaAssignment_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaQuestion_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaQuestion_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "media" */
export type MediaQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** aggregated selection of "media" */
export type Media_Aggregate = {
  __typename?: 'media_aggregate';
  aggregate?: Maybe<Media_Aggregate_Fields>;
  nodes: Array<Media>;
};

export type Media_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Media_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Media_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Media_Aggregate_Bool_Exp_Count>;
};

export type Media_Aggregate_Bool_Exp_Bool_And = {
  arguments: Media_Select_Column_Media_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Media_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Media_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Media_Select_Column_Media_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Media_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "media" */
export type Media_Aggregate_Fields = {
  __typename?: 'media_aggregate_fields';
  avg?: Maybe<Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Media_Max_Fields>;
  min?: Maybe<Media_Min_Fields>;
  stddev?: Maybe<Media_Stddev_Fields>;
  stddev_pop?: Maybe<Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Media_Stddev_Samp_Fields>;
  sum?: Maybe<Media_Sum_Fields>;
  var_pop?: Maybe<Media_Var_Pop_Fields>;
  var_samp?: Maybe<Media_Var_Samp_Fields>;
  variance?: Maybe<Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media" */
export type Media_Aggregate_Order_By = {
  avg?: InputMaybe<Media_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Media_Max_Order_By>;
  min?: InputMaybe<Media_Min_Order_By>;
  stddev?: InputMaybe<Media_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Media_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Media_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Media_Sum_Order_By>;
  var_pop?: InputMaybe<Media_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Media_Var_Samp_Order_By>;
  variance?: InputMaybe<Media_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "media" */
export type Media_Arr_Rel_Insert_Input = {
  data: Array<Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Media_On_Conflict>;
};

/** aggregate avg on columns */
export type Media_Avg_Fields = {
  __typename?: 'media_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "media" */
export type Media_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Media_Bool_Exp = {
  _and?: InputMaybe<Array<Media_Bool_Exp>>;
  _not?: InputMaybe<Media_Bool_Exp>;
  _or?: InputMaybe<Array<Media_Bool_Exp>>;
  assignment_blocks?: InputMaybe<Assignment_Block_Bool_Exp>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  question_options?: InputMaybe<Question_Option_Bool_Exp>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  type?: InputMaybe<Media_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export const enum Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkF4e0fcac36e050de337b670d8bd = 'PK_f4e0fcac36e050de337b670d8bd',
  /** unique or primary key constraint on columns "uid" */
  UqC57a12eba8224abc765caf6808e = 'UQ_c57a12eba8224abc765caf6808e'
};

/** input type for incrementing numeric columns in table "media" */
export type Media_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "media" */
export type Media_Insert_Input = {
  assignment_blocks?: InputMaybe<Assignment_Block_Arr_Rel_Insert_Input>;
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  question_options?: InputMaybe<Question_Option_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['media_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Media_Max_Fields = {
  __typename?: 'media_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['media_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "media" */
export type Media_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Media_Min_Fields = {
  __typename?: 'media_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['media_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "media" */
export type Media_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "media" */
export type Media_Mutation_Response = {
  __typename?: 'media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Media_Obj_Rel_Insert_Input = {
  data: Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Media_On_Conflict = {
  constraint: Media_Constraint;
  update_columns?: Array<Media_Update_Column>;
  where?: InputMaybe<Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Media_Order_By = {
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Order_By>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Media_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "media" */
export const enum Media_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Path = 'path',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "media_aggregate_bool_exp_bool_and_arguments_columns" columns of table "media" */
export const enum Media_Select_Column_Media_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "media_aggregate_bool_exp_bool_or_arguments_columns" columns of table "media" */
export const enum Media_Select_Column_Media_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "media" */
export type Media_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['media_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Media_Stddev_Fields = {
  __typename?: 'media_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "media" */
export type Media_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Media_Stddev_Pop_Fields = {
  __typename?: 'media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "media" */
export type Media_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Media_Stddev_Samp_Fields = {
  __typename?: 'media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "media" */
export type Media_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "media" */
export type Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Media_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['media_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Media_Sum_Fields = {
  __typename?: 'media_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "media" */
export type Media_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "media_type_enum". All fields are combined with logical 'AND'. */
export type Media_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['media_type_enum']>;
  _gt?: InputMaybe<Scalars['media_type_enum']>;
  _gte?: InputMaybe<Scalars['media_type_enum']>;
  _in?: InputMaybe<Array<Scalars['media_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['media_type_enum']>;
  _lte?: InputMaybe<Scalars['media_type_enum']>;
  _neq?: InputMaybe<Scalars['media_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['media_type_enum']>>;
};

/** update columns of table "media" */
export const enum Media_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Path = 'path',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Media_Var_Pop_Fields = {
  __typename?: 'media_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "media" */
export type Media_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Media_Var_Samp_Fields = {
  __typename?: 'media_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "media" */
export type Media_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Media_Variance_Fields = {
  __typename?: 'media_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "media" */
export type Media_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  create_bbb_meeting: Scalars['String'];
  /** delete data from the table: "activity" */
  delete_activity?: Maybe<Activity_Mutation_Response>;
  /** delete single row from the table: "activity" */
  delete_activity_by_pk?: Maybe<Activity>;
  /** delete data from the table: "activity_layout" */
  delete_activity_layout?: Maybe<Activity_Layout_Mutation_Response>;
  /** delete single row from the table: "activity_layout" */
  delete_activity_layout_by_pk?: Maybe<Activity_Layout>;
  /** delete data from the table: "assignment" */
  delete_assignment?: Maybe<Assignment_Mutation_Response>;
  /** delete data from the table: "assignment_activity" */
  delete_assignment_activity?: Maybe<Assignment_Activity_Mutation_Response>;
  /** delete single row from the table: "assignment_activity" */
  delete_assignment_activity_by_pk?: Maybe<Assignment_Activity>;
  /** delete data from the table: "assignment_block" */
  delete_assignment_block?: Maybe<Assignment_Block_Mutation_Response>;
  /** delete single row from the table: "assignment_block" */
  delete_assignment_block_by_pk?: Maybe<Assignment_Block>;
  /** delete single row from the table: "assignment" */
  delete_assignment_by_pk?: Maybe<Assignment>;
  /** delete data from the table: "block" */
  delete_block?: Maybe<Block_Mutation_Response>;
  /** delete single row from the table: "block" */
  delete_block_by_pk?: Maybe<Block>;
  /** delete data from the table: "block_list_item" */
  delete_block_list_item?: Maybe<Block_List_Item_Mutation_Response>;
  /** delete single row from the table: "block_list_item" */
  delete_block_list_item_by_pk?: Maybe<Block_List_Item>;
  /** delete data from the table: "block_list_item_workspace" */
  delete_block_list_item_workspace?: Maybe<Block_List_Item_Workspace_Mutation_Response>;
  /** delete single row from the table: "block_list_item_workspace" */
  delete_block_list_item_workspace_by_pk?: Maybe<Block_List_Item_Workspace>;
  /** delete data from the table: "block_tag" */
  delete_block_tag?: Maybe<Block_Tag_Mutation_Response>;
  /** delete single row from the table: "block_tag" */
  delete_block_tag_by_pk?: Maybe<Block_Tag>;
  /** delete data from the table: "calendar_event" */
  delete_calendar_event?: Maybe<Calendar_Event_Mutation_Response>;
  /** delete single row from the table: "calendar_event" */
  delete_calendar_event_by_pk?: Maybe<Calendar_Event>;
  /** delete data from the table: "category" */
  delete_category?: Maybe<Category_Mutation_Response>;
  /** delete single row from the table: "category" */
  delete_category_by_pk?: Maybe<Category>;
  /** delete data from the table: "checkpoint" */
  delete_checkpoint?: Maybe<Checkpoint_Mutation_Response>;
  /** delete data from the table: "checkpoint_attempts" */
  delete_checkpoint_attempts?: Maybe<Checkpoint_Attempts_Mutation_Response>;
  /** delete single row from the table: "checkpoint_attempts" */
  delete_checkpoint_attempts_by_pk?: Maybe<Checkpoint_Attempts>;
  /** delete single row from the table: "checkpoint" */
  delete_checkpoint_by_pk?: Maybe<Checkpoint>;
  /** delete data from the table: "class" */
  delete_class?: Maybe<Class_Mutation_Response>;
  /** delete single row from the table: "class" */
  delete_class_by_pk?: Maybe<Class>;
  /** delete data from the table: "class_course" */
  delete_class_course?: Maybe<Class_Course_Mutation_Response>;
  /** delete single row from the table: "class_course" */
  delete_class_course_by_pk?: Maybe<Class_Course>;
  /** delete data from the table: "class_course_note" */
  delete_class_course_note?: Maybe<Class_Course_Note_Mutation_Response>;
  /** delete single row from the table: "class_course_note" */
  delete_class_course_note_by_pk?: Maybe<Class_Course_Note>;
  /** delete data from the table: "class_course_resource" */
  delete_class_course_resource?: Maybe<Class_Course_Resource_Mutation_Response>;
  /** delete single row from the table: "class_course_resource" */
  delete_class_course_resource_by_pk?: Maybe<Class_Course_Resource>;
  /** delete data from the table: "classroom" */
  delete_classroom?: Maybe<Classroom_Mutation_Response>;
  /** delete single row from the table: "classroom" */
  delete_classroom_by_pk?: Maybe<Classroom>;
  /** delete data from the table: "classroom_group" */
  delete_classroom_group?: Maybe<Classroom_Group_Mutation_Response>;
  /** delete single row from the table: "classroom_group" */
  delete_classroom_group_by_pk?: Maybe<Classroom_Group>;
  /** delete data from the table: "course" */
  delete_course?: Maybe<Course_Mutation_Response>;
  /** delete single row from the table: "course" */
  delete_course_by_pk?: Maybe<Course>;
  /** delete data from the table: "course_category" */
  delete_course_category?: Maybe<Course_Category_Mutation_Response>;
  /** delete single row from the table: "course_category" */
  delete_course_category_by_pk?: Maybe<Course_Category>;
  /** delete data from the table: "course_grade_level" */
  delete_course_grade_level?: Maybe<Course_Grade_Level_Mutation_Response>;
  /** delete single row from the table: "course_grade_level" */
  delete_course_grade_level_by_pk?: Maybe<Course_Grade_Level>;
  /** delete data from the table: "course_instructor" */
  delete_course_instructor?: Maybe<Course_Instructor_Mutation_Response>;
  /** delete single row from the table: "course_instructor" */
  delete_course_instructor_by_pk?: Maybe<Course_Instructor>;
  /** delete data from the table: "course_tag" */
  delete_course_tag?: Maybe<Course_Tag_Mutation_Response>;
  /** delete single row from the table: "course_tag" */
  delete_course_tag_by_pk?: Maybe<Course_Tag>;
  /** delete data from the table: "course_workspace" */
  delete_course_workspace?: Maybe<Course_Workspace_Mutation_Response>;
  /** delete single row from the table: "course_workspace" */
  delete_course_workspace_by_pk?: Maybe<Course_Workspace>;
  /** delete data from the table: "dnd" */
  delete_dnd?: Maybe<Dnd_Mutation_Response>;
  /** delete single row from the table: "dnd" */
  delete_dnd_by_pk?: Maybe<Dnd>;
  /** delete data from the table: "event_classroom" */
  delete_event_classroom?: Maybe<Event_Classroom_Mutation_Response>;
  /** delete single row from the table: "event_classroom" */
  delete_event_classroom_by_pk?: Maybe<Event_Classroom>;
  /** delete data from the table: "feedback" */
  delete_feedback?: Maybe<Feedback_Mutation_Response>;
  /** delete single row from the table: "feedback" */
  delete_feedback_by_pk?: Maybe<Feedback>;
  /** delete data from the table: "file" */
  delete_file?: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk?: Maybe<File>;
  /** delete data from the table: "fill_blank" */
  delete_fill_blank?: Maybe<Fill_Blank_Mutation_Response>;
  /** delete single row from the table: "fill_blank" */
  delete_fill_blank_by_pk?: Maybe<Fill_Blank>;
  /** delete data from the table: "grade" */
  delete_grade?: Maybe<Grade_Mutation_Response>;
  /** delete single row from the table: "grade" */
  delete_grade_by_pk?: Maybe<Grade>;
  /** delete data from the table: "grade_level" */
  delete_grade_level?: Maybe<Grade_Level_Mutation_Response>;
  /** delete single row from the table: "grade_level" */
  delete_grade_level_by_pk?: Maybe<Grade_Level>;
  /** delete data from the table: "grade_level_group" */
  delete_grade_level_group?: Maybe<Grade_Level_Group_Mutation_Response>;
  /** delete single row from the table: "grade_level_group" */
  delete_grade_level_group_by_pk?: Maybe<Grade_Level_Group>;
  /** delete data from the table: "grade_value" */
  delete_grade_value?: Maybe<Grade_Value_Mutation_Response>;
  /** delete single row from the table: "grade_value" */
  delete_grade_value_by_pk?: Maybe<Grade_Value>;
  /** delete data from the table: "gradebook" */
  delete_gradebook?: Maybe<Gradebook_Mutation_Response>;
  /** delete single row from the table: "gradebook" */
  delete_gradebook_by_pk?: Maybe<Gradebook>;
  /** delete data from the table: "group" */
  delete_group?: Maybe<Group_Mutation_Response>;
  /** delete single row from the table: "group" */
  delete_group_by_pk?: Maybe<Group>;
  /** delete data from the table: "group_course" */
  delete_group_course?: Maybe<Group_Course_Mutation_Response>;
  /** delete single row from the table: "group_course" */
  delete_group_course_by_pk?: Maybe<Group_Course>;
  /** delete data from the table: "group_workspace" */
  delete_group_workspace?: Maybe<Group_Workspace_Mutation_Response>;
  /** delete single row from the table: "group_workspace" */
  delete_group_workspace_by_pk?: Maybe<Group_Workspace>;
  /** delete data from the table: "installment" */
  delete_installment?: Maybe<Installment_Mutation_Response>;
  /** delete single row from the table: "installment" */
  delete_installment_by_pk?: Maybe<Installment>;
  /** delete data from the table: "instructor" */
  delete_instructor?: Maybe<Instructor_Mutation_Response>;
  /** delete single row from the table: "instructor" */
  delete_instructor_by_pk?: Maybe<Instructor>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<Invoice_Mutation_Response>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "invoice_installment" */
  delete_invoice_installment?: Maybe<Invoice_Installment_Mutation_Response>;
  /** delete single row from the table: "invoice_installment" */
  delete_invoice_installment_by_pk?: Maybe<Invoice_Installment>;
  /** delete data from the table: "lecture" */
  delete_lecture?: Maybe<Lecture_Mutation_Response>;
  /** delete single row from the table: "lecture" */
  delete_lecture_by_pk?: Maybe<Lecture>;
  /** delete data from the table: "lecture_note" */
  delete_lecture_note?: Maybe<Lecture_Note_Mutation_Response>;
  /** delete single row from the table: "lecture_note" */
  delete_lecture_note_by_pk?: Maybe<Lecture_Note>;
  /** delete data from the table: "lecture_resource" */
  delete_lecture_resource?: Maybe<Lecture_Resource_Mutation_Response>;
  /** delete single row from the table: "lecture_resource" */
  delete_lecture_resource_by_pk?: Maybe<Lecture_Resource>;
  /** delete data from the table: "lesson" */
  delete_lesson?: Maybe<Lesson_Mutation_Response>;
  /** delete single row from the table: "lesson" */
  delete_lesson_by_pk?: Maybe<Lesson>;
  /** delete data from the table: "level" */
  delete_level?: Maybe<Level_Mutation_Response>;
  /** delete single row from the table: "level" */
  delete_level_by_pk?: Maybe<Level>;
  /** delete data from the table: "media" */
  delete_media?: Maybe<Media_Mutation_Response>;
  /** delete single row from the table: "media" */
  delete_media_by_pk?: Maybe<Media>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "payment" */
  delete_payment?: Maybe<Payment_Mutation_Response>;
  /** delete single row from the table: "payment" */
  delete_payment_by_pk?: Maybe<Payment>;
  /** delete data from the table: "progression" */
  delete_progression?: Maybe<Progression_Mutation_Response>;
  /** delete single row from the table: "progression" */
  delete_progression_by_pk?: Maybe<Progression>;
  /** delete data from the table: "question" */
  delete_question?: Maybe<Question_Mutation_Response>;
  /** delete single row from the table: "question" */
  delete_question_by_pk?: Maybe<Question>;
  /** delete data from the table: "question_option" */
  delete_question_option?: Maybe<Question_Option_Mutation_Response>;
  /** delete single row from the table: "question_option" */
  delete_question_option_by_pk?: Maybe<Question_Option>;
  /** delete data from the table: "question_quiz" */
  delete_question_quiz?: Maybe<Question_Quiz_Mutation_Response>;
  /** delete single row from the table: "question_quiz" */
  delete_question_quiz_by_pk?: Maybe<Question_Quiz>;
  /** delete data from the table: "question_tag" */
  delete_question_tag?: Maybe<Question_Tag_Mutation_Response>;
  /** delete single row from the table: "question_tag" */
  delete_question_tag_by_pk?: Maybe<Question_Tag>;
  /** delete data from the table: "question_workspace" */
  delete_question_workspace?: Maybe<Question_Workspace_Mutation_Response>;
  /** delete single row from the table: "question_workspace" */
  delete_question_workspace_by_pk?: Maybe<Question_Workspace>;
  /** delete data from the table: "quiz" */
  delete_quiz?: Maybe<Quiz_Mutation_Response>;
  /** delete single row from the table: "quiz" */
  delete_quiz_by_pk?: Maybe<Quiz>;
  /** delete data from the table: "recurring_event" */
  delete_recurring_event?: Maybe<Recurring_Event_Mutation_Response>;
  /** delete single row from the table: "recurring_event" */
  delete_recurring_event_by_pk?: Maybe<Recurring_Event>;
  /** delete data from the table: "school_fee" */
  delete_school_fee?: Maybe<School_Fee_Mutation_Response>;
  /** delete single row from the table: "school_fee" */
  delete_school_fee_by_pk?: Maybe<School_Fee>;
  /** delete data from the table: "school_period" */
  delete_school_period?: Maybe<School_Period_Mutation_Response>;
  /** delete single row from the table: "school_period" */
  delete_school_period_by_pk?: Maybe<School_Period>;
  /** delete data from the table: "tag" */
  delete_tag?: Maybe<Tag_Mutation_Response>;
  /** delete single row from the table: "tag" */
  delete_tag_by_pk?: Maybe<Tag>;
  /** delete data from the table: "text" */
  delete_text?: Maybe<Text_Mutation_Response>;
  /** delete single row from the table: "text" */
  delete_text_by_pk?: Maybe<Text>;
  /** delete data from the table: "typeorm_metadata" */
  delete_typeorm_metadata?: Maybe<Typeorm_Metadata_Mutation_Response>;
  /** delete data from the table: "unit" */
  delete_unit?: Maybe<Unit_Mutation_Response>;
  /** delete single row from the table: "unit" */
  delete_unit_by_pk?: Maybe<Unit>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_activity" */
  delete_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** delete single row from the table: "user_activity" */
  delete_user_activity_by_pk?: Maybe<User_Activity>;
  /** delete data from the table: "user_assignment" */
  delete_user_assignment?: Maybe<User_Assignment_Mutation_Response>;
  /** delete data from the table: "user_assignment_activity" */
  delete_user_assignment_activity?: Maybe<User_Assignment_Activity_Mutation_Response>;
  /** delete single row from the table: "user_assignment_activity" */
  delete_user_assignment_activity_by_pk?: Maybe<User_Assignment_Activity>;
  /** delete single row from the table: "user_assignment" */
  delete_user_assignment_by_pk?: Maybe<User_Assignment>;
  /** delete data from the table: "user_block" */
  delete_user_block?: Maybe<User_Block_Mutation_Response>;
  /** delete single row from the table: "user_block" */
  delete_user_block_by_pk?: Maybe<User_Block>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_checkpoint" */
  delete_user_checkpoint?: Maybe<User_Checkpoint_Mutation_Response>;
  /** delete single row from the table: "user_checkpoint" */
  delete_user_checkpoint_by_pk?: Maybe<User_Checkpoint>;
  /** delete data from the table: "user_class" */
  delete_user_class?: Maybe<User_Class_Mutation_Response>;
  /** delete single row from the table: "user_class" */
  delete_user_class_by_pk?: Maybe<User_Class>;
  /** delete data from the table: "user_course" */
  delete_user_course?: Maybe<User_Course_Mutation_Response>;
  /** delete single row from the table: "user_course" */
  delete_user_course_by_pk?: Maybe<User_Course>;
  /** delete data from the table: "user_event" */
  delete_user_event?: Maybe<User_Event_Mutation_Response>;
  /** delete single row from the table: "user_event" */
  delete_user_event_by_pk?: Maybe<User_Event>;
  /** delete data from the table: "user_group" */
  delete_user_group?: Maybe<User_Group_Mutation_Response>;
  /** delete single row from the table: "user_group" */
  delete_user_group_by_pk?: Maybe<User_Group>;
  /** delete data from the table: "user_lecture" */
  delete_user_lecture?: Maybe<User_Lecture_Mutation_Response>;
  /** delete single row from the table: "user_lecture" */
  delete_user_lecture_by_pk?: Maybe<User_Lecture>;
  /** delete data from the table: "user_workspace" */
  delete_user_workspace?: Maybe<User_Workspace_Mutation_Response>;
  /** delete single row from the table: "user_workspace" */
  delete_user_workspace_by_pk?: Maybe<User_Workspace>;
  /** delete data from the table: "workspace" */
  delete_workspace?: Maybe<Workspace_Mutation_Response>;
  /** delete single row from the table: "workspace" */
  delete_workspace_by_pk?: Maybe<Workspace>;
  end_bbb_meeting: Scalars['String'];
  grade_checkpoint: Scalars['String'];
  gradebook_export_csv?: Maybe<FileOutput>;
  image_upload?: Maybe<ImageUpload>;
  /** insert data into the table: "activity" */
  insert_activity?: Maybe<Activity_Mutation_Response>;
  /** insert data into the table: "activity_layout" */
  insert_activity_layout?: Maybe<Activity_Layout_Mutation_Response>;
  /** insert a single row into the table: "activity_layout" */
  insert_activity_layout_one?: Maybe<Activity_Layout>;
  /** insert a single row into the table: "activity" */
  insert_activity_one?: Maybe<Activity>;
  /** insert data into the table: "assignment" */
  insert_assignment?: Maybe<Assignment_Mutation_Response>;
  /** insert data into the table: "assignment_activity" */
  insert_assignment_activity?: Maybe<Assignment_Activity_Mutation_Response>;
  /** insert a single row into the table: "assignment_activity" */
  insert_assignment_activity_one?: Maybe<Assignment_Activity>;
  /** insert data into the table: "assignment_block" */
  insert_assignment_block?: Maybe<Assignment_Block_Mutation_Response>;
  /** insert a single row into the table: "assignment_block" */
  insert_assignment_block_one?: Maybe<Assignment_Block>;
  /** insert a single row into the table: "assignment" */
  insert_assignment_one?: Maybe<Assignment>;
  /** insert data into the table: "block" */
  insert_block?: Maybe<Block_Mutation_Response>;
  /** insert data into the table: "block_list_item" */
  insert_block_list_item?: Maybe<Block_List_Item_Mutation_Response>;
  /** insert a single row into the table: "block_list_item" */
  insert_block_list_item_one?: Maybe<Block_List_Item>;
  /** insert data into the table: "block_list_item_workspace" */
  insert_block_list_item_workspace?: Maybe<Block_List_Item_Workspace_Mutation_Response>;
  /** insert a single row into the table: "block_list_item_workspace" */
  insert_block_list_item_workspace_one?: Maybe<Block_List_Item_Workspace>;
  /** insert a single row into the table: "block" */
  insert_block_one?: Maybe<Block>;
  /** insert data into the table: "block_tag" */
  insert_block_tag?: Maybe<Block_Tag_Mutation_Response>;
  /** insert a single row into the table: "block_tag" */
  insert_block_tag_one?: Maybe<Block_Tag>;
  /** insert data into the table: "calendar_event" */
  insert_calendar_event?: Maybe<Calendar_Event_Mutation_Response>;
  /** insert a single row into the table: "calendar_event" */
  insert_calendar_event_one?: Maybe<Calendar_Event>;
  /** insert data into the table: "category" */
  insert_category?: Maybe<Category_Mutation_Response>;
  /** insert a single row into the table: "category" */
  insert_category_one?: Maybe<Category>;
  /** insert data into the table: "checkpoint" */
  insert_checkpoint?: Maybe<Checkpoint_Mutation_Response>;
  /** insert data into the table: "checkpoint_attempts" */
  insert_checkpoint_attempts?: Maybe<Checkpoint_Attempts_Mutation_Response>;
  /** insert a single row into the table: "checkpoint_attempts" */
  insert_checkpoint_attempts_one?: Maybe<Checkpoint_Attempts>;
  /** insert a single row into the table: "checkpoint" */
  insert_checkpoint_one?: Maybe<Checkpoint>;
  /** insert data into the table: "class" */
  insert_class?: Maybe<Class_Mutation_Response>;
  /** insert data into the table: "class_course" */
  insert_class_course?: Maybe<Class_Course_Mutation_Response>;
  /** insert data into the table: "class_course_note" */
  insert_class_course_note?: Maybe<Class_Course_Note_Mutation_Response>;
  /** insert a single row into the table: "class_course_note" */
  insert_class_course_note_one?: Maybe<Class_Course_Note>;
  /** insert a single row into the table: "class_course" */
  insert_class_course_one?: Maybe<Class_Course>;
  /** insert data into the table: "class_course_resource" */
  insert_class_course_resource?: Maybe<Class_Course_Resource_Mutation_Response>;
  /** insert a single row into the table: "class_course_resource" */
  insert_class_course_resource_one?: Maybe<Class_Course_Resource>;
  /** insert a single row into the table: "class" */
  insert_class_one?: Maybe<Class>;
  /** insert data into the table: "classroom" */
  insert_classroom?: Maybe<Classroom_Mutation_Response>;
  /** insert data into the table: "classroom_group" */
  insert_classroom_group?: Maybe<Classroom_Group_Mutation_Response>;
  /** insert a single row into the table: "classroom_group" */
  insert_classroom_group_one?: Maybe<Classroom_Group>;
  /** insert a single row into the table: "classroom" */
  insert_classroom_one?: Maybe<Classroom>;
  /** insert data into the table: "course" */
  insert_course?: Maybe<Course_Mutation_Response>;
  /** insert data into the table: "course_category" */
  insert_course_category?: Maybe<Course_Category_Mutation_Response>;
  /** insert a single row into the table: "course_category" */
  insert_course_category_one?: Maybe<Course_Category>;
  /** insert data into the table: "course_grade_level" */
  insert_course_grade_level?: Maybe<Course_Grade_Level_Mutation_Response>;
  /** insert a single row into the table: "course_grade_level" */
  insert_course_grade_level_one?: Maybe<Course_Grade_Level>;
  /** insert data into the table: "course_instructor" */
  insert_course_instructor?: Maybe<Course_Instructor_Mutation_Response>;
  /** insert a single row into the table: "course_instructor" */
  insert_course_instructor_one?: Maybe<Course_Instructor>;
  /** insert a single row into the table: "course" */
  insert_course_one?: Maybe<Course>;
  /** insert data into the table: "course_tag" */
  insert_course_tag?: Maybe<Course_Tag_Mutation_Response>;
  /** insert a single row into the table: "course_tag" */
  insert_course_tag_one?: Maybe<Course_Tag>;
  /** insert data into the table: "course_workspace" */
  insert_course_workspace?: Maybe<Course_Workspace_Mutation_Response>;
  /** insert a single row into the table: "course_workspace" */
  insert_course_workspace_one?: Maybe<Course_Workspace>;
  /** insert data into the table: "dnd" */
  insert_dnd?: Maybe<Dnd_Mutation_Response>;
  /** insert a single row into the table: "dnd" */
  insert_dnd_one?: Maybe<Dnd>;
  /** insert data into the table: "event_classroom" */
  insert_event_classroom?: Maybe<Event_Classroom_Mutation_Response>;
  /** insert a single row into the table: "event_classroom" */
  insert_event_classroom_one?: Maybe<Event_Classroom>;
  /** insert data into the table: "feedback" */
  insert_feedback?: Maybe<Feedback_Mutation_Response>;
  /** insert a single row into the table: "feedback" */
  insert_feedback_one?: Maybe<Feedback>;
  /** insert data into the table: "file" */
  insert_file?: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one?: Maybe<File>;
  /** insert data into the table: "fill_blank" */
  insert_fill_blank?: Maybe<Fill_Blank_Mutation_Response>;
  /** insert a single row into the table: "fill_blank" */
  insert_fill_blank_one?: Maybe<Fill_Blank>;
  /** insert data into the table: "grade" */
  insert_grade?: Maybe<Grade_Mutation_Response>;
  /** insert data into the table: "grade_level" */
  insert_grade_level?: Maybe<Grade_Level_Mutation_Response>;
  /** insert data into the table: "grade_level_group" */
  insert_grade_level_group?: Maybe<Grade_Level_Group_Mutation_Response>;
  /** insert a single row into the table: "grade_level_group" */
  insert_grade_level_group_one?: Maybe<Grade_Level_Group>;
  /** insert a single row into the table: "grade_level" */
  insert_grade_level_one?: Maybe<Grade_Level>;
  /** insert a single row into the table: "grade" */
  insert_grade_one?: Maybe<Grade>;
  /** insert data into the table: "grade_value" */
  insert_grade_value?: Maybe<Grade_Value_Mutation_Response>;
  /** insert a single row into the table: "grade_value" */
  insert_grade_value_one?: Maybe<Grade_Value>;
  /** insert data into the table: "gradebook" */
  insert_gradebook?: Maybe<Gradebook_Mutation_Response>;
  /** insert a single row into the table: "gradebook" */
  insert_gradebook_one?: Maybe<Gradebook>;
  /** insert data into the table: "group" */
  insert_group?: Maybe<Group_Mutation_Response>;
  /** insert data into the table: "group_course" */
  insert_group_course?: Maybe<Group_Course_Mutation_Response>;
  /** insert a single row into the table: "group_course" */
  insert_group_course_one?: Maybe<Group_Course>;
  /** insert a single row into the table: "group" */
  insert_group_one?: Maybe<Group>;
  /** insert data into the table: "group_workspace" */
  insert_group_workspace?: Maybe<Group_Workspace_Mutation_Response>;
  /** insert a single row into the table: "group_workspace" */
  insert_group_workspace_one?: Maybe<Group_Workspace>;
  /** insert data into the table: "installment" */
  insert_installment?: Maybe<Installment_Mutation_Response>;
  /** insert a single row into the table: "installment" */
  insert_installment_one?: Maybe<Installment>;
  /** insert data into the table: "instructor" */
  insert_instructor?: Maybe<Instructor_Mutation_Response>;
  /** insert a single row into the table: "instructor" */
  insert_instructor_one?: Maybe<Instructor>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<Invoice_Mutation_Response>;
  /** insert data into the table: "invoice_installment" */
  insert_invoice_installment?: Maybe<Invoice_Installment_Mutation_Response>;
  /** insert a single row into the table: "invoice_installment" */
  insert_invoice_installment_one?: Maybe<Invoice_Installment>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "lecture" */
  insert_lecture?: Maybe<Lecture_Mutation_Response>;
  /** insert data into the table: "lecture_note" */
  insert_lecture_note?: Maybe<Lecture_Note_Mutation_Response>;
  /** insert a single row into the table: "lecture_note" */
  insert_lecture_note_one?: Maybe<Lecture_Note>;
  /** insert a single row into the table: "lecture" */
  insert_lecture_one?: Maybe<Lecture>;
  /** insert data into the table: "lecture_resource" */
  insert_lecture_resource?: Maybe<Lecture_Resource_Mutation_Response>;
  /** insert a single row into the table: "lecture_resource" */
  insert_lecture_resource_one?: Maybe<Lecture_Resource>;
  /** insert data into the table: "lesson" */
  insert_lesson?: Maybe<Lesson_Mutation_Response>;
  /** insert a single row into the table: "lesson" */
  insert_lesson_one?: Maybe<Lesson>;
  /** insert data into the table: "level" */
  insert_level?: Maybe<Level_Mutation_Response>;
  /** insert a single row into the table: "level" */
  insert_level_one?: Maybe<Level>;
  /** insert data into the table: "media" */
  insert_media?: Maybe<Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_media_one?: Maybe<Media>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "payment" */
  insert_payment?: Maybe<Payment_Mutation_Response>;
  /** insert a single row into the table: "payment" */
  insert_payment_one?: Maybe<Payment>;
  /** insert data into the table: "progression" */
  insert_progression?: Maybe<Progression_Mutation_Response>;
  /** insert a single row into the table: "progression" */
  insert_progression_one?: Maybe<Progression>;
  /** insert data into the table: "question" */
  insert_question?: Maybe<Question_Mutation_Response>;
  /** insert a single row into the table: "question" */
  insert_question_one?: Maybe<Question>;
  /** insert data into the table: "question_option" */
  insert_question_option?: Maybe<Question_Option_Mutation_Response>;
  /** insert a single row into the table: "question_option" */
  insert_question_option_one?: Maybe<Question_Option>;
  /** insert data into the table: "question_quiz" */
  insert_question_quiz?: Maybe<Question_Quiz_Mutation_Response>;
  /** insert a single row into the table: "question_quiz" */
  insert_question_quiz_one?: Maybe<Question_Quiz>;
  /** insert data into the table: "question_tag" */
  insert_question_tag?: Maybe<Question_Tag_Mutation_Response>;
  /** insert a single row into the table: "question_tag" */
  insert_question_tag_one?: Maybe<Question_Tag>;
  /** insert data into the table: "question_workspace" */
  insert_question_workspace?: Maybe<Question_Workspace_Mutation_Response>;
  /** insert a single row into the table: "question_workspace" */
  insert_question_workspace_one?: Maybe<Question_Workspace>;
  /** insert data into the table: "quiz" */
  insert_quiz?: Maybe<Quiz_Mutation_Response>;
  /** insert a single row into the table: "quiz" */
  insert_quiz_one?: Maybe<Quiz>;
  /** insert data into the table: "recurring_event" */
  insert_recurring_event?: Maybe<Recurring_Event_Mutation_Response>;
  /** insert a single row into the table: "recurring_event" */
  insert_recurring_event_one?: Maybe<Recurring_Event>;
  /** insert data into the table: "school_fee" */
  insert_school_fee?: Maybe<School_Fee_Mutation_Response>;
  /** insert a single row into the table: "school_fee" */
  insert_school_fee_one?: Maybe<School_Fee>;
  /** insert data into the table: "school_period" */
  insert_school_period?: Maybe<School_Period_Mutation_Response>;
  /** insert a single row into the table: "school_period" */
  insert_school_period_one?: Maybe<School_Period>;
  /** insert data into the table: "tag" */
  insert_tag?: Maybe<Tag_Mutation_Response>;
  /** insert a single row into the table: "tag" */
  insert_tag_one?: Maybe<Tag>;
  /** insert data into the table: "text" */
  insert_text?: Maybe<Text_Mutation_Response>;
  /** insert a single row into the table: "text" */
  insert_text_one?: Maybe<Text>;
  /** insert data into the table: "typeorm_metadata" */
  insert_typeorm_metadata?: Maybe<Typeorm_Metadata_Mutation_Response>;
  /** insert a single row into the table: "typeorm_metadata" */
  insert_typeorm_metadata_one?: Maybe<Typeorm_Metadata>;
  /** insert data into the table: "unit" */
  insert_unit?: Maybe<Unit_Mutation_Response>;
  /** insert a single row into the table: "unit" */
  insert_unit_one?: Maybe<Unit>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_activity" */
  insert_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** insert a single row into the table: "user_activity" */
  insert_user_activity_one?: Maybe<User_Activity>;
  /** insert data into the table: "user_assignment" */
  insert_user_assignment?: Maybe<User_Assignment_Mutation_Response>;
  /** insert data into the table: "user_assignment_activity" */
  insert_user_assignment_activity?: Maybe<User_Assignment_Activity_Mutation_Response>;
  /** insert a single row into the table: "user_assignment_activity" */
  insert_user_assignment_activity_one?: Maybe<User_Assignment_Activity>;
  /** insert a single row into the table: "user_assignment" */
  insert_user_assignment_one?: Maybe<User_Assignment>;
  /** insert data into the table: "user_block" */
  insert_user_block?: Maybe<User_Block_Mutation_Response>;
  /** insert a single row into the table: "user_block" */
  insert_user_block_one?: Maybe<User_Block>;
  /** insert data into the table: "user_checkpoint" */
  insert_user_checkpoint?: Maybe<User_Checkpoint_Mutation_Response>;
  /** insert a single row into the table: "user_checkpoint" */
  insert_user_checkpoint_one?: Maybe<User_Checkpoint>;
  /** insert data into the table: "user_class" */
  insert_user_class?: Maybe<User_Class_Mutation_Response>;
  /** insert a single row into the table: "user_class" */
  insert_user_class_one?: Maybe<User_Class>;
  /** insert data into the table: "user_course" */
  insert_user_course?: Maybe<User_Course_Mutation_Response>;
  /** insert a single row into the table: "user_course" */
  insert_user_course_one?: Maybe<User_Course>;
  /** insert data into the table: "user_event" */
  insert_user_event?: Maybe<User_Event_Mutation_Response>;
  /** insert a single row into the table: "user_event" */
  insert_user_event_one?: Maybe<User_Event>;
  /** insert data into the table: "user_group" */
  insert_user_group?: Maybe<User_Group_Mutation_Response>;
  /** insert a single row into the table: "user_group" */
  insert_user_group_one?: Maybe<User_Group>;
  /** insert data into the table: "user_lecture" */
  insert_user_lecture?: Maybe<User_Lecture_Mutation_Response>;
  /** insert a single row into the table: "user_lecture" */
  insert_user_lecture_one?: Maybe<User_Lecture>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_workspace" */
  insert_user_workspace?: Maybe<User_Workspace_Mutation_Response>;
  /** insert a single row into the table: "user_workspace" */
  insert_user_workspace_one?: Maybe<User_Workspace>;
  /** insert data into the table: "workspace" */
  insert_workspace?: Maybe<Workspace_Mutation_Response>;
  /** insert a single row into the table: "workspace" */
  insert_workspace_one?: Maybe<Workspace>;
  join_bbb_meeting: Scalars['String'];
  navigate_lesson?: Maybe<NavigateLessonOutput>;
  reset_checkpoint?: Maybe<Array<Maybe<ResetCheckpointOutput>>>;
  reset_temporary_password: Scalars['Int'];
  /** update data of the table: "activity" */
  update_activity?: Maybe<Activity_Mutation_Response>;
  /** update single row of the table: "activity" */
  update_activity_by_pk?: Maybe<Activity>;
  /** update data of the table: "activity_layout" */
  update_activity_layout?: Maybe<Activity_Layout_Mutation_Response>;
  /** update single row of the table: "activity_layout" */
  update_activity_layout_by_pk?: Maybe<Activity_Layout>;
  /** update multiples rows of table: "activity_layout" */
  update_activity_layout_many?: Maybe<Array<Maybe<Activity_Layout_Mutation_Response>>>;
  /** update multiples rows of table: "activity" */
  update_activity_many?: Maybe<Array<Maybe<Activity_Mutation_Response>>>;
  /** update data of the table: "assignment" */
  update_assignment?: Maybe<Assignment_Mutation_Response>;
  /** update data of the table: "assignment_activity" */
  update_assignment_activity?: Maybe<Assignment_Activity_Mutation_Response>;
  /** update single row of the table: "assignment_activity" */
  update_assignment_activity_by_pk?: Maybe<Assignment_Activity>;
  /** update multiples rows of table: "assignment_activity" */
  update_assignment_activity_many?: Maybe<Array<Maybe<Assignment_Activity_Mutation_Response>>>;
  /** update data of the table: "assignment_block" */
  update_assignment_block?: Maybe<Assignment_Block_Mutation_Response>;
  /** update single row of the table: "assignment_block" */
  update_assignment_block_by_pk?: Maybe<Assignment_Block>;
  /** update multiples rows of table: "assignment_block" */
  update_assignment_block_many?: Maybe<Array<Maybe<Assignment_Block_Mutation_Response>>>;
  /** update single row of the table: "assignment" */
  update_assignment_by_pk?: Maybe<Assignment>;
  /** update multiples rows of table: "assignment" */
  update_assignment_many?: Maybe<Array<Maybe<Assignment_Mutation_Response>>>;
  /** update data of the table: "block" */
  update_block?: Maybe<Block_Mutation_Response>;
  /** update single row of the table: "block" */
  update_block_by_pk?: Maybe<Block>;
  /** update data of the table: "block_list_item" */
  update_block_list_item?: Maybe<Block_List_Item_Mutation_Response>;
  /** update single row of the table: "block_list_item" */
  update_block_list_item_by_pk?: Maybe<Block_List_Item>;
  /** update multiples rows of table: "block_list_item" */
  update_block_list_item_many?: Maybe<Array<Maybe<Block_List_Item_Mutation_Response>>>;
  /** update data of the table: "block_list_item_workspace" */
  update_block_list_item_workspace?: Maybe<Block_List_Item_Workspace_Mutation_Response>;
  /** update single row of the table: "block_list_item_workspace" */
  update_block_list_item_workspace_by_pk?: Maybe<Block_List_Item_Workspace>;
  /** update multiples rows of table: "block_list_item_workspace" */
  update_block_list_item_workspace_many?: Maybe<Array<Maybe<Block_List_Item_Workspace_Mutation_Response>>>;
  /** update multiples rows of table: "block" */
  update_block_many?: Maybe<Array<Maybe<Block_Mutation_Response>>>;
  /** update data of the table: "block_tag" */
  update_block_tag?: Maybe<Block_Tag_Mutation_Response>;
  /** update single row of the table: "block_tag" */
  update_block_tag_by_pk?: Maybe<Block_Tag>;
  /** update multiples rows of table: "block_tag" */
  update_block_tag_many?: Maybe<Array<Maybe<Block_Tag_Mutation_Response>>>;
  /** update data of the table: "calendar_event" */
  update_calendar_event?: Maybe<Calendar_Event_Mutation_Response>;
  /** update single row of the table: "calendar_event" */
  update_calendar_event_by_pk?: Maybe<Calendar_Event>;
  /** update multiples rows of table: "calendar_event" */
  update_calendar_event_many?: Maybe<Array<Maybe<Calendar_Event_Mutation_Response>>>;
  /** update data of the table: "category" */
  update_category?: Maybe<Category_Mutation_Response>;
  /** update single row of the table: "category" */
  update_category_by_pk?: Maybe<Category>;
  /** update multiples rows of table: "category" */
  update_category_many?: Maybe<Array<Maybe<Category_Mutation_Response>>>;
  /** update data of the table: "checkpoint" */
  update_checkpoint?: Maybe<Checkpoint_Mutation_Response>;
  /** update data of the table: "checkpoint_attempts" */
  update_checkpoint_attempts?: Maybe<Checkpoint_Attempts_Mutation_Response>;
  /** update single row of the table: "checkpoint_attempts" */
  update_checkpoint_attempts_by_pk?: Maybe<Checkpoint_Attempts>;
  /** update multiples rows of table: "checkpoint_attempts" */
  update_checkpoint_attempts_many?: Maybe<Array<Maybe<Checkpoint_Attempts_Mutation_Response>>>;
  /** update single row of the table: "checkpoint" */
  update_checkpoint_by_pk?: Maybe<Checkpoint>;
  /** update multiples rows of table: "checkpoint" */
  update_checkpoint_many?: Maybe<Array<Maybe<Checkpoint_Mutation_Response>>>;
  /** update data of the table: "class" */
  update_class?: Maybe<Class_Mutation_Response>;
  /** update single row of the table: "class" */
  update_class_by_pk?: Maybe<Class>;
  /** update data of the table: "class_course" */
  update_class_course?: Maybe<Class_Course_Mutation_Response>;
  /** update single row of the table: "class_course" */
  update_class_course_by_pk?: Maybe<Class_Course>;
  /** update multiples rows of table: "class_course" */
  update_class_course_many?: Maybe<Array<Maybe<Class_Course_Mutation_Response>>>;
  /** update data of the table: "class_course_note" */
  update_class_course_note?: Maybe<Class_Course_Note_Mutation_Response>;
  /** update single row of the table: "class_course_note" */
  update_class_course_note_by_pk?: Maybe<Class_Course_Note>;
  /** update multiples rows of table: "class_course_note" */
  update_class_course_note_many?: Maybe<Array<Maybe<Class_Course_Note_Mutation_Response>>>;
  /** update data of the table: "class_course_resource" */
  update_class_course_resource?: Maybe<Class_Course_Resource_Mutation_Response>;
  /** update single row of the table: "class_course_resource" */
  update_class_course_resource_by_pk?: Maybe<Class_Course_Resource>;
  /** update multiples rows of table: "class_course_resource" */
  update_class_course_resource_many?: Maybe<Array<Maybe<Class_Course_Resource_Mutation_Response>>>;
  /** update multiples rows of table: "class" */
  update_class_many?: Maybe<Array<Maybe<Class_Mutation_Response>>>;
  /** update data of the table: "classroom" */
  update_classroom?: Maybe<Classroom_Mutation_Response>;
  /** update single row of the table: "classroom" */
  update_classroom_by_pk?: Maybe<Classroom>;
  /** update data of the table: "classroom_group" */
  update_classroom_group?: Maybe<Classroom_Group_Mutation_Response>;
  /** update single row of the table: "classroom_group" */
  update_classroom_group_by_pk?: Maybe<Classroom_Group>;
  /** update multiples rows of table: "classroom_group" */
  update_classroom_group_many?: Maybe<Array<Maybe<Classroom_Group_Mutation_Response>>>;
  /** update multiples rows of table: "classroom" */
  update_classroom_many?: Maybe<Array<Maybe<Classroom_Mutation_Response>>>;
  /** update data of the table: "course" */
  update_course?: Maybe<Course_Mutation_Response>;
  /** update single row of the table: "course" */
  update_course_by_pk?: Maybe<Course>;
  /** update data of the table: "course_category" */
  update_course_category?: Maybe<Course_Category_Mutation_Response>;
  /** update single row of the table: "course_category" */
  update_course_category_by_pk?: Maybe<Course_Category>;
  /** update multiples rows of table: "course_category" */
  update_course_category_many?: Maybe<Array<Maybe<Course_Category_Mutation_Response>>>;
  /** update data of the table: "course_grade_level" */
  update_course_grade_level?: Maybe<Course_Grade_Level_Mutation_Response>;
  /** update single row of the table: "course_grade_level" */
  update_course_grade_level_by_pk?: Maybe<Course_Grade_Level>;
  /** update multiples rows of table: "course_grade_level" */
  update_course_grade_level_many?: Maybe<Array<Maybe<Course_Grade_Level_Mutation_Response>>>;
  /** update data of the table: "course_instructor" */
  update_course_instructor?: Maybe<Course_Instructor_Mutation_Response>;
  /** update single row of the table: "course_instructor" */
  update_course_instructor_by_pk?: Maybe<Course_Instructor>;
  /** update multiples rows of table: "course_instructor" */
  update_course_instructor_many?: Maybe<Array<Maybe<Course_Instructor_Mutation_Response>>>;
  /** update multiples rows of table: "course" */
  update_course_many?: Maybe<Array<Maybe<Course_Mutation_Response>>>;
  /** update data of the table: "course_tag" */
  update_course_tag?: Maybe<Course_Tag_Mutation_Response>;
  /** update single row of the table: "course_tag" */
  update_course_tag_by_pk?: Maybe<Course_Tag>;
  /** update multiples rows of table: "course_tag" */
  update_course_tag_many?: Maybe<Array<Maybe<Course_Tag_Mutation_Response>>>;
  /** update data of the table: "course_workspace" */
  update_course_workspace?: Maybe<Course_Workspace_Mutation_Response>;
  /** update single row of the table: "course_workspace" */
  update_course_workspace_by_pk?: Maybe<Course_Workspace>;
  /** update multiples rows of table: "course_workspace" */
  update_course_workspace_many?: Maybe<Array<Maybe<Course_Workspace_Mutation_Response>>>;
  /** update data of the table: "dnd" */
  update_dnd?: Maybe<Dnd_Mutation_Response>;
  /** update single row of the table: "dnd" */
  update_dnd_by_pk?: Maybe<Dnd>;
  /** update multiples rows of table: "dnd" */
  update_dnd_many?: Maybe<Array<Maybe<Dnd_Mutation_Response>>>;
  /** update data of the table: "event_classroom" */
  update_event_classroom?: Maybe<Event_Classroom_Mutation_Response>;
  /** update single row of the table: "event_classroom" */
  update_event_classroom_by_pk?: Maybe<Event_Classroom>;
  /** update multiples rows of table: "event_classroom" */
  update_event_classroom_many?: Maybe<Array<Maybe<Event_Classroom_Mutation_Response>>>;
  /** update data of the table: "feedback" */
  update_feedback?: Maybe<Feedback_Mutation_Response>;
  /** update single row of the table: "feedback" */
  update_feedback_by_pk?: Maybe<Feedback>;
  /** update multiples rows of table: "feedback" */
  update_feedback_many?: Maybe<Array<Maybe<Feedback_Mutation_Response>>>;
  /** update data of the table: "file" */
  update_file?: Maybe<File_Mutation_Response>;
  /** update single row of the table: "file" */
  update_file_by_pk?: Maybe<File>;
  /** update multiples rows of table: "file" */
  update_file_many?: Maybe<Array<Maybe<File_Mutation_Response>>>;
  /** update data of the table: "fill_blank" */
  update_fill_blank?: Maybe<Fill_Blank_Mutation_Response>;
  /** update single row of the table: "fill_blank" */
  update_fill_blank_by_pk?: Maybe<Fill_Blank>;
  /** update multiples rows of table: "fill_blank" */
  update_fill_blank_many?: Maybe<Array<Maybe<Fill_Blank_Mutation_Response>>>;
  /** update data of the table: "grade" */
  update_grade?: Maybe<Grade_Mutation_Response>;
  /** update single row of the table: "grade" */
  update_grade_by_pk?: Maybe<Grade>;
  /** update data of the table: "grade_level" */
  update_grade_level?: Maybe<Grade_Level_Mutation_Response>;
  /** update single row of the table: "grade_level" */
  update_grade_level_by_pk?: Maybe<Grade_Level>;
  /** update data of the table: "grade_level_group" */
  update_grade_level_group?: Maybe<Grade_Level_Group_Mutation_Response>;
  /** update single row of the table: "grade_level_group" */
  update_grade_level_group_by_pk?: Maybe<Grade_Level_Group>;
  /** update multiples rows of table: "grade_level_group" */
  update_grade_level_group_many?: Maybe<Array<Maybe<Grade_Level_Group_Mutation_Response>>>;
  /** update multiples rows of table: "grade_level" */
  update_grade_level_many?: Maybe<Array<Maybe<Grade_Level_Mutation_Response>>>;
  /** update multiples rows of table: "grade" */
  update_grade_many?: Maybe<Array<Maybe<Grade_Mutation_Response>>>;
  /** update data of the table: "grade_value" */
  update_grade_value?: Maybe<Grade_Value_Mutation_Response>;
  /** update single row of the table: "grade_value" */
  update_grade_value_by_pk?: Maybe<Grade_Value>;
  /** update multiples rows of table: "grade_value" */
  update_grade_value_many?: Maybe<Array<Maybe<Grade_Value_Mutation_Response>>>;
  /** update data of the table: "gradebook" */
  update_gradebook?: Maybe<Gradebook_Mutation_Response>;
  /** update single row of the table: "gradebook" */
  update_gradebook_by_pk?: Maybe<Gradebook>;
  /** update multiples rows of table: "gradebook" */
  update_gradebook_many?: Maybe<Array<Maybe<Gradebook_Mutation_Response>>>;
  /** update data of the table: "group" */
  update_group?: Maybe<Group_Mutation_Response>;
  /** update single row of the table: "group" */
  update_group_by_pk?: Maybe<Group>;
  /** update data of the table: "group_course" */
  update_group_course?: Maybe<Group_Course_Mutation_Response>;
  /** update single row of the table: "group_course" */
  update_group_course_by_pk?: Maybe<Group_Course>;
  /** update multiples rows of table: "group_course" */
  update_group_course_many?: Maybe<Array<Maybe<Group_Course_Mutation_Response>>>;
  /** update multiples rows of table: "group" */
  update_group_many?: Maybe<Array<Maybe<Group_Mutation_Response>>>;
  /** update data of the table: "group_workspace" */
  update_group_workspace?: Maybe<Group_Workspace_Mutation_Response>;
  /** update single row of the table: "group_workspace" */
  update_group_workspace_by_pk?: Maybe<Group_Workspace>;
  /** update multiples rows of table: "group_workspace" */
  update_group_workspace_many?: Maybe<Array<Maybe<Group_Workspace_Mutation_Response>>>;
  /** update data of the table: "installment" */
  update_installment?: Maybe<Installment_Mutation_Response>;
  /** update single row of the table: "installment" */
  update_installment_by_pk?: Maybe<Installment>;
  /** update multiples rows of table: "installment" */
  update_installment_many?: Maybe<Array<Maybe<Installment_Mutation_Response>>>;
  /** update data of the table: "instructor" */
  update_instructor?: Maybe<Instructor_Mutation_Response>;
  /** update single row of the table: "instructor" */
  update_instructor_by_pk?: Maybe<Instructor>;
  /** update multiples rows of table: "instructor" */
  update_instructor_many?: Maybe<Array<Maybe<Instructor_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update data of the table: "invoice_installment" */
  update_invoice_installment?: Maybe<Invoice_Installment_Mutation_Response>;
  /** update single row of the table: "invoice_installment" */
  update_invoice_installment_by_pk?: Maybe<Invoice_Installment>;
  /** update multiples rows of table: "invoice_installment" */
  update_invoice_installment_many?: Maybe<Array<Maybe<Invoice_Installment_Mutation_Response>>>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "lecture" */
  update_lecture?: Maybe<Lecture_Mutation_Response>;
  /** update single row of the table: "lecture" */
  update_lecture_by_pk?: Maybe<Lecture>;
  /** update multiples rows of table: "lecture" */
  update_lecture_many?: Maybe<Array<Maybe<Lecture_Mutation_Response>>>;
  /** update data of the table: "lecture_note" */
  update_lecture_note?: Maybe<Lecture_Note_Mutation_Response>;
  /** update single row of the table: "lecture_note" */
  update_lecture_note_by_pk?: Maybe<Lecture_Note>;
  /** update multiples rows of table: "lecture_note" */
  update_lecture_note_many?: Maybe<Array<Maybe<Lecture_Note_Mutation_Response>>>;
  /** update data of the table: "lecture_resource" */
  update_lecture_resource?: Maybe<Lecture_Resource_Mutation_Response>;
  /** update single row of the table: "lecture_resource" */
  update_lecture_resource_by_pk?: Maybe<Lecture_Resource>;
  /** update multiples rows of table: "lecture_resource" */
  update_lecture_resource_many?: Maybe<Array<Maybe<Lecture_Resource_Mutation_Response>>>;
  /** update data of the table: "lesson" */
  update_lesson?: Maybe<Lesson_Mutation_Response>;
  /** update single row of the table: "lesson" */
  update_lesson_by_pk?: Maybe<Lesson>;
  /** update multiples rows of table: "lesson" */
  update_lesson_many?: Maybe<Array<Maybe<Lesson_Mutation_Response>>>;
  /** update data of the table: "level" */
  update_level?: Maybe<Level_Mutation_Response>;
  /** update single row of the table: "level" */
  update_level_by_pk?: Maybe<Level>;
  /** update multiples rows of table: "level" */
  update_level_many?: Maybe<Array<Maybe<Level_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_media?: Maybe<Media_Mutation_Response>;
  /** update single row of the table: "media" */
  update_media_by_pk?: Maybe<Media>;
  /** update multiples rows of table: "media" */
  update_media_many?: Maybe<Array<Maybe<Media_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "payment" */
  update_payment?: Maybe<Payment_Mutation_Response>;
  /** update single row of the table: "payment" */
  update_payment_by_pk?: Maybe<Payment>;
  /** update multiples rows of table: "payment" */
  update_payment_many?: Maybe<Array<Maybe<Payment_Mutation_Response>>>;
  /** update data of the table: "progression" */
  update_progression?: Maybe<Progression_Mutation_Response>;
  /** update single row of the table: "progression" */
  update_progression_by_pk?: Maybe<Progression>;
  /** update multiples rows of table: "progression" */
  update_progression_many?: Maybe<Array<Maybe<Progression_Mutation_Response>>>;
  /** update data of the table: "question" */
  update_question?: Maybe<Question_Mutation_Response>;
  /** update single row of the table: "question" */
  update_question_by_pk?: Maybe<Question>;
  /** update multiples rows of table: "question" */
  update_question_many?: Maybe<Array<Maybe<Question_Mutation_Response>>>;
  /** update data of the table: "question_option" */
  update_question_option?: Maybe<Question_Option_Mutation_Response>;
  /** update single row of the table: "question_option" */
  update_question_option_by_pk?: Maybe<Question_Option>;
  /** update multiples rows of table: "question_option" */
  update_question_option_many?: Maybe<Array<Maybe<Question_Option_Mutation_Response>>>;
  /** update data of the table: "question_quiz" */
  update_question_quiz?: Maybe<Question_Quiz_Mutation_Response>;
  /** update single row of the table: "question_quiz" */
  update_question_quiz_by_pk?: Maybe<Question_Quiz>;
  /** update multiples rows of table: "question_quiz" */
  update_question_quiz_many?: Maybe<Array<Maybe<Question_Quiz_Mutation_Response>>>;
  /** update data of the table: "question_tag" */
  update_question_tag?: Maybe<Question_Tag_Mutation_Response>;
  /** update single row of the table: "question_tag" */
  update_question_tag_by_pk?: Maybe<Question_Tag>;
  /** update multiples rows of table: "question_tag" */
  update_question_tag_many?: Maybe<Array<Maybe<Question_Tag_Mutation_Response>>>;
  /** update data of the table: "question_workspace" */
  update_question_workspace?: Maybe<Question_Workspace_Mutation_Response>;
  /** update single row of the table: "question_workspace" */
  update_question_workspace_by_pk?: Maybe<Question_Workspace>;
  /** update multiples rows of table: "question_workspace" */
  update_question_workspace_many?: Maybe<Array<Maybe<Question_Workspace_Mutation_Response>>>;
  /** update data of the table: "quiz" */
  update_quiz?: Maybe<Quiz_Mutation_Response>;
  /** update single row of the table: "quiz" */
  update_quiz_by_pk?: Maybe<Quiz>;
  /** update multiples rows of table: "quiz" */
  update_quiz_many?: Maybe<Array<Maybe<Quiz_Mutation_Response>>>;
  /** update data of the table: "recurring_event" */
  update_recurring_event?: Maybe<Recurring_Event_Mutation_Response>;
  /** update single row of the table: "recurring_event" */
  update_recurring_event_by_pk?: Maybe<Recurring_Event>;
  /** update multiples rows of table: "recurring_event" */
  update_recurring_event_many?: Maybe<Array<Maybe<Recurring_Event_Mutation_Response>>>;
  /** update data of the table: "school_fee" */
  update_school_fee?: Maybe<School_Fee_Mutation_Response>;
  /** update single row of the table: "school_fee" */
  update_school_fee_by_pk?: Maybe<School_Fee>;
  /** update multiples rows of table: "school_fee" */
  update_school_fee_many?: Maybe<Array<Maybe<School_Fee_Mutation_Response>>>;
  /** update data of the table: "school_period" */
  update_school_period?: Maybe<School_Period_Mutation_Response>;
  /** update single row of the table: "school_period" */
  update_school_period_by_pk?: Maybe<School_Period>;
  /** update multiples rows of table: "school_period" */
  update_school_period_many?: Maybe<Array<Maybe<School_Period_Mutation_Response>>>;
  /** update data of the table: "tag" */
  update_tag?: Maybe<Tag_Mutation_Response>;
  /** update single row of the table: "tag" */
  update_tag_by_pk?: Maybe<Tag>;
  /** update multiples rows of table: "tag" */
  update_tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response>>>;
  /** update data of the table: "text" */
  update_text?: Maybe<Text_Mutation_Response>;
  /** update single row of the table: "text" */
  update_text_by_pk?: Maybe<Text>;
  /** update multiples rows of table: "text" */
  update_text_many?: Maybe<Array<Maybe<Text_Mutation_Response>>>;
  /** update data of the table: "typeorm_metadata" */
  update_typeorm_metadata?: Maybe<Typeorm_Metadata_Mutation_Response>;
  /** update multiples rows of table: "typeorm_metadata" */
  update_typeorm_metadata_many?: Maybe<Array<Maybe<Typeorm_Metadata_Mutation_Response>>>;
  /** update data of the table: "unit" */
  update_unit?: Maybe<Unit_Mutation_Response>;
  /** update single row of the table: "unit" */
  update_unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "unit" */
  update_unit_many?: Maybe<Array<Maybe<Unit_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_activity" */
  update_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** update single row of the table: "user_activity" */
  update_user_activity_by_pk?: Maybe<User_Activity>;
  /** update multiples rows of table: "user_activity" */
  update_user_activity_many?: Maybe<Array<Maybe<User_Activity_Mutation_Response>>>;
  /** update data of the table: "user_assignment" */
  update_user_assignment?: Maybe<User_Assignment_Mutation_Response>;
  /** update data of the table: "user_assignment_activity" */
  update_user_assignment_activity?: Maybe<User_Assignment_Activity_Mutation_Response>;
  /** update single row of the table: "user_assignment_activity" */
  update_user_assignment_activity_by_pk?: Maybe<User_Assignment_Activity>;
  /** update multiples rows of table: "user_assignment_activity" */
  update_user_assignment_activity_many?: Maybe<Array<Maybe<User_Assignment_Activity_Mutation_Response>>>;
  /** update single row of the table: "user_assignment" */
  update_user_assignment_by_pk?: Maybe<User_Assignment>;
  /** update multiples rows of table: "user_assignment" */
  update_user_assignment_many?: Maybe<Array<Maybe<User_Assignment_Mutation_Response>>>;
  /** update data of the table: "user_block" */
  update_user_block?: Maybe<User_Block_Mutation_Response>;
  /** update single row of the table: "user_block" */
  update_user_block_by_pk?: Maybe<User_Block>;
  /** update multiples rows of table: "user_block" */
  update_user_block_many?: Maybe<Array<Maybe<User_Block_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_checkpoint" */
  update_user_checkpoint?: Maybe<User_Checkpoint_Mutation_Response>;
  /** update single row of the table: "user_checkpoint" */
  update_user_checkpoint_by_pk?: Maybe<User_Checkpoint>;
  /** update multiples rows of table: "user_checkpoint" */
  update_user_checkpoint_many?: Maybe<Array<Maybe<User_Checkpoint_Mutation_Response>>>;
  /** update data of the table: "user_class" */
  update_user_class?: Maybe<User_Class_Mutation_Response>;
  /** update single row of the table: "user_class" */
  update_user_class_by_pk?: Maybe<User_Class>;
  /** update multiples rows of table: "user_class" */
  update_user_class_many?: Maybe<Array<Maybe<User_Class_Mutation_Response>>>;
  /** update data of the table: "user_course" */
  update_user_course?: Maybe<User_Course_Mutation_Response>;
  /** update single row of the table: "user_course" */
  update_user_course_by_pk?: Maybe<User_Course>;
  /** update multiples rows of table: "user_course" */
  update_user_course_many?: Maybe<Array<Maybe<User_Course_Mutation_Response>>>;
  /** update data of the table: "user_event" */
  update_user_event?: Maybe<User_Event_Mutation_Response>;
  /** update single row of the table: "user_event" */
  update_user_event_by_pk?: Maybe<User_Event>;
  /** update multiples rows of table: "user_event" */
  update_user_event_many?: Maybe<Array<Maybe<User_Event_Mutation_Response>>>;
  /** update data of the table: "user_group" */
  update_user_group?: Maybe<User_Group_Mutation_Response>;
  /** update single row of the table: "user_group" */
  update_user_group_by_pk?: Maybe<User_Group>;
  /** update multiples rows of table: "user_group" */
  update_user_group_many?: Maybe<Array<Maybe<User_Group_Mutation_Response>>>;
  /** update data of the table: "user_lecture" */
  update_user_lecture?: Maybe<User_Lecture_Mutation_Response>;
  /** update single row of the table: "user_lecture" */
  update_user_lecture_by_pk?: Maybe<User_Lecture>;
  /** update multiples rows of table: "user_lecture" */
  update_user_lecture_many?: Maybe<Array<Maybe<User_Lecture_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  update_user_profile?: Maybe<UserProfileOutput>;
  /** update data of the table: "user_workspace" */
  update_user_workspace?: Maybe<User_Workspace_Mutation_Response>;
  /** update single row of the table: "user_workspace" */
  update_user_workspace_by_pk?: Maybe<User_Workspace>;
  /** update multiples rows of table: "user_workspace" */
  update_user_workspace_many?: Maybe<Array<Maybe<User_Workspace_Mutation_Response>>>;
  /** update data of the table: "workspace" */
  update_workspace?: Maybe<Workspace_Mutation_Response>;
  /** update single row of the table: "workspace" */
  update_workspace_by_pk?: Maybe<Workspace>;
  /** update multiples rows of table: "workspace" */
  update_workspace_many?: Maybe<Array<Maybe<Workspace_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootCreate_Bbb_MeetingArgs = {
  lectureId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootDelete_ActivityArgs = {
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_LayoutArgs = {
  where: Activity_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AssignmentArgs = {
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_ActivityArgs = {
  where: Assignment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_BlockArgs = {
  where: Assignment_Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Block_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BlockArgs = {
  where: Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Block_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Block_List_ItemArgs = {
  where: Block_List_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Block_List_Item_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Block_List_Item_WorkspaceArgs = {
  where: Block_List_Item_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Block_List_Item_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Block_TagArgs = {
  where: Block_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Block_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Calendar_EventArgs = {
  where: Calendar_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Calendar_Event_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CategoryArgs = {
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CheckpointArgs = {
  where: Checkpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Checkpoint_AttemptsArgs = {
  where: Checkpoint_Attempts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Checkpoint_Attempts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Checkpoint_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ClassArgs = {
  where: Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Class_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Class_CourseArgs = {
  where: Class_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Class_Course_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Course_NoteArgs = {
  where: Class_Course_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Class_Course_Note_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Course_ResourceArgs = {
  where: Class_Course_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Class_Course_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ClassroomArgs = {
  where: Classroom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Classroom_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Classroom_GroupArgs = {
  where: Classroom_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Classroom_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CourseArgs = {
  where: Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_CategoryArgs = {
  where: Course_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Grade_LevelArgs = {
  where: Course_Grade_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Grade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_InstructorArgs = {
  where: Course_Instructor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Instructor_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_TagArgs = {
  where: Course_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_WorkspaceArgs = {
  where: Course_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DndArgs = {
  where: Dnd_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dnd_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Event_ClassroomArgs = {
  where: Event_Classroom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Classroom_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FeedbackArgs = {
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Fill_BlankArgs = {
  where: Fill_Blank_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fill_Blank_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GradeArgs = {
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_LevelArgs = {
  where: Grade_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_Level_GroupArgs = {
  where: Grade_Level_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Level_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_ValueArgs = {
  where: Grade_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Value_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GradebookArgs = {
  where: Gradebook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gradebook_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GroupArgs = {
  where: Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Group_CourseArgs = {
  where: Group_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Group_Course_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Group_WorkspaceArgs = {
  where: Group_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Group_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InstallmentArgs = {
  where: Installment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InstructorArgs = {
  where: Instructor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Instructor_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InvoiceArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Invoice_InstallmentArgs = {
  where: Invoice_Installment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Installment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LectureArgs = {
  where: Lecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lecture_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Lecture_NoteArgs = {
  where: Lecture_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lecture_Note_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Lecture_ResourceArgs = {
  where: Lecture_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lecture_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LessonArgs = {
  where: Lesson_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lesson_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LevelArgs = {
  where: Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Level_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MediaArgs = {
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Media_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentArgs = {
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ProgressionArgs = {
  where: Progression_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Progression_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionArgs = {
  where: Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_OptionArgs = {
  where: Question_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Option_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_QuizArgs = {
  where: Question_Quiz_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Quiz_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_TagArgs = {
  where: Question_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_WorkspaceArgs = {
  where: Question_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_QuizArgs = {
  where: Quiz_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quiz_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Recurring_EventArgs = {
  where: Recurring_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recurring_Event_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_School_FeeArgs = {
  where: School_Fee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_Fee_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_School_PeriodArgs = {
  where: School_Period_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_Period_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TagArgs = {
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TextArgs = {
  where: Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Text_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Typeorm_MetadataArgs = {
  where: Typeorm_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UnitArgs = {
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_ActivityArgs = {
  where: User_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_AssignmentArgs = {
  where: User_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Assignment_ActivityArgs = {
  where: User_Assignment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Assignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Assignment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_BlockArgs = {
  where: User_Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Block_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_CheckpointArgs = {
  where: User_Checkpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Checkpoint_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_ClassArgs = {
  where: User_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Class_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_CourseArgs = {
  where: User_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Course_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_EventArgs = {
  where: User_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Event_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_GroupArgs = {
  where: User_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_LectureArgs = {
  where: User_Lecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Lecture_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_WorkspaceArgs = {
  where: User_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WorkspaceArgs = {
  where: Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootEnd_Bbb_MeetingArgs = {
  meetingId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootGrade_CheckpointArgs = {
  checkpointId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootGradebook_Export_CsvArgs = {
  gradebookId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_ActivityArgs = {
  objects: Array<Activity_Insert_Input>;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_LayoutArgs = {
  objects: Array<Activity_Layout_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Layout_OneArgs = {
  object: Activity_Layout_Insert_Input;
  on_conflict?: InputMaybe<Activity_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_OneArgs = {
  object: Activity_Insert_Input;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssignmentArgs = {
  objects: Array<Assignment_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_ActivityArgs = {
  objects: Array<Assignment_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Activity_OneArgs = {
  object: Assignment_Activity_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_BlockArgs = {
  objects: Array<Assignment_Block_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Block_OneArgs = {
  object: Assignment_Block_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_OneArgs = {
  object: Assignment_Insert_Input;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BlockArgs = {
  objects: Array<Block_Insert_Input>;
  on_conflict?: InputMaybe<Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_List_ItemArgs = {
  objects: Array<Block_List_Item_Insert_Input>;
  on_conflict?: InputMaybe<Block_List_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_List_Item_OneArgs = {
  object: Block_List_Item_Insert_Input;
  on_conflict?: InputMaybe<Block_List_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_List_Item_WorkspaceArgs = {
  objects: Array<Block_List_Item_Workspace_Insert_Input>;
  on_conflict?: InputMaybe<Block_List_Item_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_List_Item_Workspace_OneArgs = {
  object: Block_List_Item_Workspace_Insert_Input;
  on_conflict?: InputMaybe<Block_List_Item_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_OneArgs = {
  object: Block_Insert_Input;
  on_conflict?: InputMaybe<Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_TagArgs = {
  objects: Array<Block_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Block_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Block_Tag_OneArgs = {
  object: Block_Tag_Insert_Input;
  on_conflict?: InputMaybe<Block_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calendar_EventArgs = {
  objects: Array<Calendar_Event_Insert_Input>;
  on_conflict?: InputMaybe<Calendar_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calendar_Event_OneArgs = {
  object: Calendar_Event_Insert_Input;
  on_conflict?: InputMaybe<Calendar_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoryArgs = {
  objects: Array<Category_Insert_Input>;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_OneArgs = {
  object: Category_Insert_Input;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CheckpointArgs = {
  objects: Array<Checkpoint_Insert_Input>;
  on_conflict?: InputMaybe<Checkpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkpoint_AttemptsArgs = {
  objects: Array<Checkpoint_Attempts_Insert_Input>;
  on_conflict?: InputMaybe<Checkpoint_Attempts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkpoint_Attempts_OneArgs = {
  object: Checkpoint_Attempts_Insert_Input;
  on_conflict?: InputMaybe<Checkpoint_Attempts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkpoint_OneArgs = {
  object: Checkpoint_Insert_Input;
  on_conflict?: InputMaybe<Checkpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassArgs = {
  objects: Array<Class_Insert_Input>;
  on_conflict?: InputMaybe<Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_CourseArgs = {
  objects: Array<Class_Course_Insert_Input>;
  on_conflict?: InputMaybe<Class_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Course_NoteArgs = {
  objects: Array<Class_Course_Note_Insert_Input>;
  on_conflict?: InputMaybe<Class_Course_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Course_Note_OneArgs = {
  object: Class_Course_Note_Insert_Input;
  on_conflict?: InputMaybe<Class_Course_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Course_OneArgs = {
  object: Class_Course_Insert_Input;
  on_conflict?: InputMaybe<Class_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Course_ResourceArgs = {
  objects: Array<Class_Course_Resource_Insert_Input>;
  on_conflict?: InputMaybe<Class_Course_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Course_Resource_OneArgs = {
  object: Class_Course_Resource_Insert_Input;
  on_conflict?: InputMaybe<Class_Course_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_OneArgs = {
  object: Class_Insert_Input;
  on_conflict?: InputMaybe<Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassroomArgs = {
  objects: Array<Classroom_Insert_Input>;
  on_conflict?: InputMaybe<Classroom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Classroom_GroupArgs = {
  objects: Array<Classroom_Group_Insert_Input>;
  on_conflict?: InputMaybe<Classroom_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Classroom_Group_OneArgs = {
  object: Classroom_Group_Insert_Input;
  on_conflict?: InputMaybe<Classroom_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Classroom_OneArgs = {
  object: Classroom_Insert_Input;
  on_conflict?: InputMaybe<Classroom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CourseArgs = {
  objects: Array<Course_Insert_Input>;
  on_conflict?: InputMaybe<Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_CategoryArgs = {
  objects: Array<Course_Category_Insert_Input>;
  on_conflict?: InputMaybe<Course_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Category_OneArgs = {
  object: Course_Category_Insert_Input;
  on_conflict?: InputMaybe<Course_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Grade_LevelArgs = {
  objects: Array<Course_Grade_Level_Insert_Input>;
  on_conflict?: InputMaybe<Course_Grade_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Grade_Level_OneArgs = {
  object: Course_Grade_Level_Insert_Input;
  on_conflict?: InputMaybe<Course_Grade_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_InstructorArgs = {
  objects: Array<Course_Instructor_Insert_Input>;
  on_conflict?: InputMaybe<Course_Instructor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Instructor_OneArgs = {
  object: Course_Instructor_Insert_Input;
  on_conflict?: InputMaybe<Course_Instructor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_OneArgs = {
  object: Course_Insert_Input;
  on_conflict?: InputMaybe<Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_TagArgs = {
  objects: Array<Course_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Course_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Tag_OneArgs = {
  object: Course_Tag_Insert_Input;
  on_conflict?: InputMaybe<Course_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_WorkspaceArgs = {
  objects: Array<Course_Workspace_Insert_Input>;
  on_conflict?: InputMaybe<Course_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Workspace_OneArgs = {
  object: Course_Workspace_Insert_Input;
  on_conflict?: InputMaybe<Course_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DndArgs = {
  objects: Array<Dnd_Insert_Input>;
  on_conflict?: InputMaybe<Dnd_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dnd_OneArgs = {
  object: Dnd_Insert_Input;
  on_conflict?: InputMaybe<Dnd_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_ClassroomArgs = {
  objects: Array<Event_Classroom_Insert_Input>;
  on_conflict?: InputMaybe<Event_Classroom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Classroom_OneArgs = {
  object: Event_Classroom_Insert_Input;
  on_conflict?: InputMaybe<Event_Classroom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeedbackArgs = {
  objects: Array<Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_OneArgs = {
  object: Feedback_Insert_Input;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fill_BlankArgs = {
  objects: Array<Fill_Blank_Insert_Input>;
  on_conflict?: InputMaybe<Fill_Blank_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fill_Blank_OneArgs = {
  object: Fill_Blank_Insert_Input;
  on_conflict?: InputMaybe<Fill_Blank_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GradeArgs = {
  objects: Array<Grade_Insert_Input>;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_LevelArgs = {
  objects: Array<Grade_Level_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Level_GroupArgs = {
  objects: Array<Grade_Level_Group_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Level_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Level_Group_OneArgs = {
  object: Grade_Level_Group_Insert_Input;
  on_conflict?: InputMaybe<Grade_Level_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Level_OneArgs = {
  object: Grade_Level_Insert_Input;
  on_conflict?: InputMaybe<Grade_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_OneArgs = {
  object: Grade_Insert_Input;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_ValueArgs = {
  objects: Array<Grade_Value_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Value_OneArgs = {
  object: Grade_Value_Insert_Input;
  on_conflict?: InputMaybe<Grade_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GradebookArgs = {
  objects: Array<Gradebook_Insert_Input>;
  on_conflict?: InputMaybe<Gradebook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gradebook_OneArgs = {
  object: Gradebook_Insert_Input;
  on_conflict?: InputMaybe<Gradebook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupArgs = {
  objects: Array<Group_Insert_Input>;
  on_conflict?: InputMaybe<Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_CourseArgs = {
  objects: Array<Group_Course_Insert_Input>;
  on_conflict?: InputMaybe<Group_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_Course_OneArgs = {
  object: Group_Course_Insert_Input;
  on_conflict?: InputMaybe<Group_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_OneArgs = {
  object: Group_Insert_Input;
  on_conflict?: InputMaybe<Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_WorkspaceArgs = {
  objects: Array<Group_Workspace_Insert_Input>;
  on_conflict?: InputMaybe<Group_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_Workspace_OneArgs = {
  object: Group_Workspace_Insert_Input;
  on_conflict?: InputMaybe<Group_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstallmentArgs = {
  objects: Array<Installment_Insert_Input>;
  on_conflict?: InputMaybe<Installment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installment_OneArgs = {
  object: Installment_Insert_Input;
  on_conflict?: InputMaybe<Installment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstructorArgs = {
  objects: Array<Instructor_Insert_Input>;
  on_conflict?: InputMaybe<Instructor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instructor_OneArgs = {
  object: Instructor_Insert_Input;
  on_conflict?: InputMaybe<Instructor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoiceArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_InstallmentArgs = {
  objects: Array<Invoice_Installment_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_Installment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Installment_OneArgs = {
  object: Invoice_Installment_Insert_Input;
  on_conflict?: InputMaybe<Invoice_Installment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_OneArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LectureArgs = {
  objects: Array<Lecture_Insert_Input>;
  on_conflict?: InputMaybe<Lecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lecture_NoteArgs = {
  objects: Array<Lecture_Note_Insert_Input>;
  on_conflict?: InputMaybe<Lecture_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lecture_Note_OneArgs = {
  object: Lecture_Note_Insert_Input;
  on_conflict?: InputMaybe<Lecture_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lecture_OneArgs = {
  object: Lecture_Insert_Input;
  on_conflict?: InputMaybe<Lecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lecture_ResourceArgs = {
  objects: Array<Lecture_Resource_Insert_Input>;
  on_conflict?: InputMaybe<Lecture_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lecture_Resource_OneArgs = {
  object: Lecture_Resource_Insert_Input;
  on_conflict?: InputMaybe<Lecture_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LessonArgs = {
  objects: Array<Lesson_Insert_Input>;
  on_conflict?: InputMaybe<Lesson_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lesson_OneArgs = {
  object: Lesson_Insert_Input;
  on_conflict?: InputMaybe<Lesson_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LevelArgs = {
  objects: Array<Level_Insert_Input>;
  on_conflict?: InputMaybe<Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Level_OneArgs = {
  object: Level_Insert_Input;
  on_conflict?: InputMaybe<Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MediaArgs = {
  objects: Array<Media_Insert_Input>;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Media_OneArgs = {
  object: Media_Insert_Input;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentArgs = {
  objects: Array<Payment_Insert_Input>;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_OneArgs = {
  object: Payment_Insert_Input;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProgressionArgs = {
  objects: Array<Progression_Insert_Input>;
  on_conflict?: InputMaybe<Progression_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Progression_OneArgs = {
  object: Progression_Insert_Input;
  on_conflict?: InputMaybe<Progression_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionArgs = {
  objects: Array<Question_Insert_Input>;
  on_conflict?: InputMaybe<Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_OneArgs = {
  object: Question_Insert_Input;
  on_conflict?: InputMaybe<Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_OptionArgs = {
  objects: Array<Question_Option_Insert_Input>;
  on_conflict?: InputMaybe<Question_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Option_OneArgs = {
  object: Question_Option_Insert_Input;
  on_conflict?: InputMaybe<Question_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_QuizArgs = {
  objects: Array<Question_Quiz_Insert_Input>;
  on_conflict?: InputMaybe<Question_Quiz_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Quiz_OneArgs = {
  object: Question_Quiz_Insert_Input;
  on_conflict?: InputMaybe<Question_Quiz_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_TagArgs = {
  objects: Array<Question_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Question_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Tag_OneArgs = {
  object: Question_Tag_Insert_Input;
  on_conflict?: InputMaybe<Question_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_WorkspaceArgs = {
  objects: Array<Question_Workspace_Insert_Input>;
  on_conflict?: InputMaybe<Question_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Workspace_OneArgs = {
  object: Question_Workspace_Insert_Input;
  on_conflict?: InputMaybe<Question_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuizArgs = {
  objects: Array<Quiz_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quiz_OneArgs = {
  object: Quiz_Insert_Input;
  on_conflict?: InputMaybe<Quiz_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_EventArgs = {
  objects: Array<Recurring_Event_Insert_Input>;
  on_conflict?: InputMaybe<Recurring_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_Event_OneArgs = {
  object: Recurring_Event_Insert_Input;
  on_conflict?: InputMaybe<Recurring_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_FeeArgs = {
  objects: Array<School_Fee_Insert_Input>;
  on_conflict?: InputMaybe<School_Fee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_Fee_OneArgs = {
  object: School_Fee_Insert_Input;
  on_conflict?: InputMaybe<School_Fee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_PeriodArgs = {
  objects: Array<School_Period_Insert_Input>;
  on_conflict?: InputMaybe<School_Period_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_Period_OneArgs = {
  object: School_Period_Insert_Input;
  on_conflict?: InputMaybe<School_Period_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagArgs = {
  objects: Array<Tag_Insert_Input>;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_OneArgs = {
  object: Tag_Insert_Input;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TextArgs = {
  objects: Array<Text_Insert_Input>;
  on_conflict?: InputMaybe<Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_OneArgs = {
  object: Text_Insert_Input;
  on_conflict?: InputMaybe<Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Typeorm_MetadataArgs = {
  objects: Array<Typeorm_Metadata_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Typeorm_Metadata_OneArgs = {
  object: Typeorm_Metadata_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_UnitArgs = {
  objects: Array<Unit_Insert_Input>;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_OneArgs = {
  object: Unit_Insert_Input;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ActivityArgs = {
  objects: Array<User_Activity_Insert_Input>;
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Activity_OneArgs = {
  object: User_Activity_Insert_Input;
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_AssignmentArgs = {
  objects: Array<User_Assignment_Insert_Input>;
  on_conflict?: InputMaybe<User_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assignment_ActivityArgs = {
  objects: Array<User_Assignment_Activity_Insert_Input>;
  on_conflict?: InputMaybe<User_Assignment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assignment_Activity_OneArgs = {
  object: User_Assignment_Activity_Insert_Input;
  on_conflict?: InputMaybe<User_Assignment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assignment_OneArgs = {
  object: User_Assignment_Insert_Input;
  on_conflict?: InputMaybe<User_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_BlockArgs = {
  objects: Array<User_Block_Insert_Input>;
  on_conflict?: InputMaybe<User_Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Block_OneArgs = {
  object: User_Block_Insert_Input;
  on_conflict?: InputMaybe<User_Block_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CheckpointArgs = {
  objects: Array<User_Checkpoint_Insert_Input>;
  on_conflict?: InputMaybe<User_Checkpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Checkpoint_OneArgs = {
  object: User_Checkpoint_Insert_Input;
  on_conflict?: InputMaybe<User_Checkpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ClassArgs = {
  objects: Array<User_Class_Insert_Input>;
  on_conflict?: InputMaybe<User_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Class_OneArgs = {
  object: User_Class_Insert_Input;
  on_conflict?: InputMaybe<User_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CourseArgs = {
  objects: Array<User_Course_Insert_Input>;
  on_conflict?: InputMaybe<User_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Course_OneArgs = {
  object: User_Course_Insert_Input;
  on_conflict?: InputMaybe<User_Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_EventArgs = {
  objects: Array<User_Event_Insert_Input>;
  on_conflict?: InputMaybe<User_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Event_OneArgs = {
  object: User_Event_Insert_Input;
  on_conflict?: InputMaybe<User_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_GroupArgs = {
  objects: Array<User_Group_Insert_Input>;
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_OneArgs = {
  object: User_Group_Insert_Input;
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LectureArgs = {
  objects: Array<User_Lecture_Insert_Input>;
  on_conflict?: InputMaybe<User_Lecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Lecture_OneArgs = {
  object: User_Lecture_Insert_Input;
  on_conflict?: InputMaybe<User_Lecture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_WorkspaceArgs = {
  objects: Array<User_Workspace_Insert_Input>;
  on_conflict?: InputMaybe<User_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Workspace_OneArgs = {
  object: User_Workspace_Insert_Input;
  on_conflict?: InputMaybe<User_Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WorkspaceArgs = {
  objects: Array<Workspace_Insert_Input>;
  on_conflict?: InputMaybe<Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workspace_OneArgs = {
  object: Workspace_Insert_Input;
  on_conflict?: InputMaybe<Workspace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootJoin_Bbb_MeetingArgs = {
  meetingId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootNavigate_LessonArgs = {
  direction?: InputMaybe<Scalars['Float']>;
  progressionId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootReset_CheckpointArgs = {
  checkpointId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootReset_Temporary_PasswordArgs = {
  Username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_ActivityArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_By_PkArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  pk_columns: Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_LayoutArgs = {
  _inc?: InputMaybe<Activity_Layout_Inc_Input>;
  _set?: InputMaybe<Activity_Layout_Set_Input>;
  where: Activity_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Layout_By_PkArgs = {
  _inc?: InputMaybe<Activity_Layout_Inc_Input>;
  _set?: InputMaybe<Activity_Layout_Set_Input>;
  pk_columns: Activity_Layout_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Layout_ManyArgs = {
  updates: Array<Activity_Layout_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_ManyArgs = {
  updates: Array<Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentArgs = {
  _inc?: InputMaybe<Assignment_Inc_Input>;
  _set?: InputMaybe<Assignment_Set_Input>;
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_ActivityArgs = {
  _inc?: InputMaybe<Assignment_Activity_Inc_Input>;
  _set?: InputMaybe<Assignment_Activity_Set_Input>;
  where: Assignment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Activity_By_PkArgs = {
  _inc?: InputMaybe<Assignment_Activity_Inc_Input>;
  _set?: InputMaybe<Assignment_Activity_Set_Input>;
  pk_columns: Assignment_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Activity_ManyArgs = {
  updates: Array<Assignment_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_BlockArgs = {
  _append?: InputMaybe<Assignment_Block_Append_Input>;
  _delete_at_path?: InputMaybe<Assignment_Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assignment_Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assignment_Block_Delete_Key_Input>;
  _inc?: InputMaybe<Assignment_Block_Inc_Input>;
  _prepend?: InputMaybe<Assignment_Block_Prepend_Input>;
  _set?: InputMaybe<Assignment_Block_Set_Input>;
  where: Assignment_Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Block_By_PkArgs = {
  _append?: InputMaybe<Assignment_Block_Append_Input>;
  _delete_at_path?: InputMaybe<Assignment_Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assignment_Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assignment_Block_Delete_Key_Input>;
  _inc?: InputMaybe<Assignment_Block_Inc_Input>;
  _prepend?: InputMaybe<Assignment_Block_Prepend_Input>;
  _set?: InputMaybe<Assignment_Block_Set_Input>;
  pk_columns: Assignment_Block_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Block_ManyArgs = {
  updates: Array<Assignment_Block_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_By_PkArgs = {
  _inc?: InputMaybe<Assignment_Inc_Input>;
  _set?: InputMaybe<Assignment_Set_Input>;
  pk_columns: Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_ManyArgs = {
  updates: Array<Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BlockArgs = {
  _append?: InputMaybe<Block_Append_Input>;
  _delete_at_path?: InputMaybe<Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Block_Delete_Key_Input>;
  _inc?: InputMaybe<Block_Inc_Input>;
  _prepend?: InputMaybe<Block_Prepend_Input>;
  _set?: InputMaybe<Block_Set_Input>;
  where: Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Block_By_PkArgs = {
  _append?: InputMaybe<Block_Append_Input>;
  _delete_at_path?: InputMaybe<Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Block_Delete_Key_Input>;
  _inc?: InputMaybe<Block_Inc_Input>;
  _prepend?: InputMaybe<Block_Prepend_Input>;
  _set?: InputMaybe<Block_Set_Input>;
  pk_columns: Block_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_ItemArgs = {
  _inc?: InputMaybe<Block_List_Item_Inc_Input>;
  _set?: InputMaybe<Block_List_Item_Set_Input>;
  where: Block_List_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_Item_By_PkArgs = {
  _inc?: InputMaybe<Block_List_Item_Inc_Input>;
  _set?: InputMaybe<Block_List_Item_Set_Input>;
  pk_columns: Block_List_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_Item_ManyArgs = {
  updates: Array<Block_List_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_Item_WorkspaceArgs = {
  _inc?: InputMaybe<Block_List_Item_Workspace_Inc_Input>;
  _set?: InputMaybe<Block_List_Item_Workspace_Set_Input>;
  where: Block_List_Item_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_Item_Workspace_By_PkArgs = {
  _inc?: InputMaybe<Block_List_Item_Workspace_Inc_Input>;
  _set?: InputMaybe<Block_List_Item_Workspace_Set_Input>;
  pk_columns: Block_List_Item_Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Block_List_Item_Workspace_ManyArgs = {
  updates: Array<Block_List_Item_Workspace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Block_ManyArgs = {
  updates: Array<Block_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Block_TagArgs = {
  _inc?: InputMaybe<Block_Tag_Inc_Input>;
  _set?: InputMaybe<Block_Tag_Set_Input>;
  where: Block_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Block_Tag_By_PkArgs = {
  _inc?: InputMaybe<Block_Tag_Inc_Input>;
  _set?: InputMaybe<Block_Tag_Set_Input>;
  pk_columns: Block_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Block_Tag_ManyArgs = {
  updates: Array<Block_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Calendar_EventArgs = {
  _inc?: InputMaybe<Calendar_Event_Inc_Input>;
  _set?: InputMaybe<Calendar_Event_Set_Input>;
  where: Calendar_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Calendar_Event_By_PkArgs = {
  _inc?: InputMaybe<Calendar_Event_Inc_Input>;
  _set?: InputMaybe<Calendar_Event_Set_Input>;
  pk_columns: Calendar_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Calendar_Event_ManyArgs = {
  updates: Array<Calendar_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoryArgs = {
  _inc?: InputMaybe<Category_Inc_Input>;
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_By_PkArgs = {
  _inc?: InputMaybe<Category_Inc_Input>;
  _set?: InputMaybe<Category_Set_Input>;
  pk_columns: Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_ManyArgs = {
  updates: Array<Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CheckpointArgs = {
  _inc?: InputMaybe<Checkpoint_Inc_Input>;
  _set?: InputMaybe<Checkpoint_Set_Input>;
  where: Checkpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Checkpoint_AttemptsArgs = {
  _inc?: InputMaybe<Checkpoint_Attempts_Inc_Input>;
  _set?: InputMaybe<Checkpoint_Attempts_Set_Input>;
  where: Checkpoint_Attempts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Checkpoint_Attempts_By_PkArgs = {
  _inc?: InputMaybe<Checkpoint_Attempts_Inc_Input>;
  _set?: InputMaybe<Checkpoint_Attempts_Set_Input>;
  pk_columns: Checkpoint_Attempts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Checkpoint_Attempts_ManyArgs = {
  updates: Array<Checkpoint_Attempts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Checkpoint_By_PkArgs = {
  _inc?: InputMaybe<Checkpoint_Inc_Input>;
  _set?: InputMaybe<Checkpoint_Set_Input>;
  pk_columns: Checkpoint_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Checkpoint_ManyArgs = {
  updates: Array<Checkpoint_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassArgs = {
  _inc?: InputMaybe<Class_Inc_Input>;
  _set?: InputMaybe<Class_Set_Input>;
  where: Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Class_By_PkArgs = {
  _inc?: InputMaybe<Class_Inc_Input>;
  _set?: InputMaybe<Class_Set_Input>;
  pk_columns: Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Class_CourseArgs = {
  _inc?: InputMaybe<Class_Course_Inc_Input>;
  _set?: InputMaybe<Class_Course_Set_Input>;
  where: Class_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_By_PkArgs = {
  _inc?: InputMaybe<Class_Course_Inc_Input>;
  _set?: InputMaybe<Class_Course_Set_Input>;
  pk_columns: Class_Course_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_ManyArgs = {
  updates: Array<Class_Course_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_NoteArgs = {
  _inc?: InputMaybe<Class_Course_Note_Inc_Input>;
  _set?: InputMaybe<Class_Course_Note_Set_Input>;
  where: Class_Course_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_Note_By_PkArgs = {
  _inc?: InputMaybe<Class_Course_Note_Inc_Input>;
  _set?: InputMaybe<Class_Course_Note_Set_Input>;
  pk_columns: Class_Course_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_Note_ManyArgs = {
  updates: Array<Class_Course_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_ResourceArgs = {
  _inc?: InputMaybe<Class_Course_Resource_Inc_Input>;
  _set?: InputMaybe<Class_Course_Resource_Set_Input>;
  where: Class_Course_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_Resource_By_PkArgs = {
  _inc?: InputMaybe<Class_Course_Resource_Inc_Input>;
  _set?: InputMaybe<Class_Course_Resource_Set_Input>;
  pk_columns: Class_Course_Resource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Course_Resource_ManyArgs = {
  updates: Array<Class_Course_Resource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_ManyArgs = {
  updates: Array<Class_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassroomArgs = {
  _inc?: InputMaybe<Classroom_Inc_Input>;
  _set?: InputMaybe<Classroom_Set_Input>;
  where: Classroom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Classroom_By_PkArgs = {
  _inc?: InputMaybe<Classroom_Inc_Input>;
  _set?: InputMaybe<Classroom_Set_Input>;
  pk_columns: Classroom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Classroom_GroupArgs = {
  _inc?: InputMaybe<Classroom_Group_Inc_Input>;
  _set?: InputMaybe<Classroom_Group_Set_Input>;
  where: Classroom_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Classroom_Group_By_PkArgs = {
  _inc?: InputMaybe<Classroom_Group_Inc_Input>;
  _set?: InputMaybe<Classroom_Group_Set_Input>;
  pk_columns: Classroom_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Classroom_Group_ManyArgs = {
  updates: Array<Classroom_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Classroom_ManyArgs = {
  updates: Array<Classroom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CourseArgs = {
  _inc?: InputMaybe<Course_Inc_Input>;
  _set?: InputMaybe<Course_Set_Input>;
  where: Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_By_PkArgs = {
  _inc?: InputMaybe<Course_Inc_Input>;
  _set?: InputMaybe<Course_Set_Input>;
  pk_columns: Course_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_CategoryArgs = {
  _inc?: InputMaybe<Course_Category_Inc_Input>;
  _set?: InputMaybe<Course_Category_Set_Input>;
  where: Course_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Category_By_PkArgs = {
  _inc?: InputMaybe<Course_Category_Inc_Input>;
  _set?: InputMaybe<Course_Category_Set_Input>;
  pk_columns: Course_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Category_ManyArgs = {
  updates: Array<Course_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Grade_LevelArgs = {
  _inc?: InputMaybe<Course_Grade_Level_Inc_Input>;
  _set?: InputMaybe<Course_Grade_Level_Set_Input>;
  where: Course_Grade_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Grade_Level_By_PkArgs = {
  _inc?: InputMaybe<Course_Grade_Level_Inc_Input>;
  _set?: InputMaybe<Course_Grade_Level_Set_Input>;
  pk_columns: Course_Grade_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Grade_Level_ManyArgs = {
  updates: Array<Course_Grade_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_InstructorArgs = {
  _inc?: InputMaybe<Course_Instructor_Inc_Input>;
  _set?: InputMaybe<Course_Instructor_Set_Input>;
  where: Course_Instructor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Instructor_By_PkArgs = {
  _inc?: InputMaybe<Course_Instructor_Inc_Input>;
  _set?: InputMaybe<Course_Instructor_Set_Input>;
  pk_columns: Course_Instructor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Instructor_ManyArgs = {
  updates: Array<Course_Instructor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ManyArgs = {
  updates: Array<Course_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_TagArgs = {
  _inc?: InputMaybe<Course_Tag_Inc_Input>;
  _set?: InputMaybe<Course_Tag_Set_Input>;
  where: Course_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Tag_By_PkArgs = {
  _inc?: InputMaybe<Course_Tag_Inc_Input>;
  _set?: InputMaybe<Course_Tag_Set_Input>;
  pk_columns: Course_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Tag_ManyArgs = {
  updates: Array<Course_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_WorkspaceArgs = {
  _inc?: InputMaybe<Course_Workspace_Inc_Input>;
  _set?: InputMaybe<Course_Workspace_Set_Input>;
  where: Course_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Workspace_By_PkArgs = {
  _inc?: InputMaybe<Course_Workspace_Inc_Input>;
  _set?: InputMaybe<Course_Workspace_Set_Input>;
  pk_columns: Course_Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Workspace_ManyArgs = {
  updates: Array<Course_Workspace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DndArgs = {
  _inc?: InputMaybe<Dnd_Inc_Input>;
  _set?: InputMaybe<Dnd_Set_Input>;
  where: Dnd_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dnd_By_PkArgs = {
  _inc?: InputMaybe<Dnd_Inc_Input>;
  _set?: InputMaybe<Dnd_Set_Input>;
  pk_columns: Dnd_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dnd_ManyArgs = {
  updates: Array<Dnd_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_ClassroomArgs = {
  _inc?: InputMaybe<Event_Classroom_Inc_Input>;
  _set?: InputMaybe<Event_Classroom_Set_Input>;
  where: Event_Classroom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Classroom_By_PkArgs = {
  _inc?: InputMaybe<Event_Classroom_Inc_Input>;
  _set?: InputMaybe<Event_Classroom_Set_Input>;
  pk_columns: Event_Classroom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Classroom_ManyArgs = {
  updates: Array<Event_Classroom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FeedbackArgs = {
  _append?: InputMaybe<Feedback_Append_Input>;
  _delete_at_path?: InputMaybe<Feedback_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feedback_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feedback_Delete_Key_Input>;
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _prepend?: InputMaybe<Feedback_Prepend_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_By_PkArgs = {
  _append?: InputMaybe<Feedback_Append_Input>;
  _delete_at_path?: InputMaybe<Feedback_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feedback_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feedback_Delete_Key_Input>;
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _prepend?: InputMaybe<Feedback_Prepend_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  pk_columns: Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_ManyArgs = {
  updates: Array<Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_By_PkArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  pk_columns: File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_ManyArgs = {
  updates: Array<File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fill_BlankArgs = {
  _inc?: InputMaybe<Fill_Blank_Inc_Input>;
  _set?: InputMaybe<Fill_Blank_Set_Input>;
  where: Fill_Blank_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fill_Blank_By_PkArgs = {
  _inc?: InputMaybe<Fill_Blank_Inc_Input>;
  _set?: InputMaybe<Fill_Blank_Set_Input>;
  pk_columns: Fill_Blank_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fill_Blank_ManyArgs = {
  updates: Array<Fill_Blank_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GradeArgs = {
  _inc?: InputMaybe<Grade_Inc_Input>;
  _set?: InputMaybe<Grade_Set_Input>;
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_By_PkArgs = {
  _inc?: InputMaybe<Grade_Inc_Input>;
  _set?: InputMaybe<Grade_Set_Input>;
  pk_columns: Grade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_LevelArgs = {
  _inc?: InputMaybe<Grade_Level_Inc_Input>;
  _set?: InputMaybe<Grade_Level_Set_Input>;
  where: Grade_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Level_By_PkArgs = {
  _inc?: InputMaybe<Grade_Level_Inc_Input>;
  _set?: InputMaybe<Grade_Level_Set_Input>;
  pk_columns: Grade_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Level_GroupArgs = {
  _inc?: InputMaybe<Grade_Level_Group_Inc_Input>;
  _set?: InputMaybe<Grade_Level_Group_Set_Input>;
  where: Grade_Level_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Level_Group_By_PkArgs = {
  _inc?: InputMaybe<Grade_Level_Group_Inc_Input>;
  _set?: InputMaybe<Grade_Level_Group_Set_Input>;
  pk_columns: Grade_Level_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Level_Group_ManyArgs = {
  updates: Array<Grade_Level_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Level_ManyArgs = {
  updates: Array<Grade_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_ManyArgs = {
  updates: Array<Grade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_ValueArgs = {
  _inc?: InputMaybe<Grade_Value_Inc_Input>;
  _set?: InputMaybe<Grade_Value_Set_Input>;
  where: Grade_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Value_By_PkArgs = {
  _inc?: InputMaybe<Grade_Value_Inc_Input>;
  _set?: InputMaybe<Grade_Value_Set_Input>;
  pk_columns: Grade_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Value_ManyArgs = {
  updates: Array<Grade_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GradebookArgs = {
  _inc?: InputMaybe<Gradebook_Inc_Input>;
  _set?: InputMaybe<Gradebook_Set_Input>;
  where: Gradebook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gradebook_By_PkArgs = {
  _inc?: InputMaybe<Gradebook_Inc_Input>;
  _set?: InputMaybe<Gradebook_Set_Input>;
  pk_columns: Gradebook_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gradebook_ManyArgs = {
  updates: Array<Gradebook_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupArgs = {
  _inc?: InputMaybe<Group_Inc_Input>;
  _set?: InputMaybe<Group_Set_Input>;
  where: Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Group_By_PkArgs = {
  _inc?: InputMaybe<Group_Inc_Input>;
  _set?: InputMaybe<Group_Set_Input>;
  pk_columns: Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Group_CourseArgs = {
  _inc?: InputMaybe<Group_Course_Inc_Input>;
  _set?: InputMaybe<Group_Course_Set_Input>;
  where: Group_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Course_By_PkArgs = {
  _inc?: InputMaybe<Group_Course_Inc_Input>;
  _set?: InputMaybe<Group_Course_Set_Input>;
  pk_columns: Group_Course_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Course_ManyArgs = {
  updates: Array<Group_Course_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Group_ManyArgs = {
  updates: Array<Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Group_WorkspaceArgs = {
  _inc?: InputMaybe<Group_Workspace_Inc_Input>;
  _set?: InputMaybe<Group_Workspace_Set_Input>;
  where: Group_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Workspace_By_PkArgs = {
  _inc?: InputMaybe<Group_Workspace_Inc_Input>;
  _set?: InputMaybe<Group_Workspace_Set_Input>;
  pk_columns: Group_Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Workspace_ManyArgs = {
  updates: Array<Group_Workspace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InstallmentArgs = {
  _inc?: InputMaybe<Installment_Inc_Input>;
  _set?: InputMaybe<Installment_Set_Input>;
  where: Installment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installment_By_PkArgs = {
  _inc?: InputMaybe<Installment_Inc_Input>;
  _set?: InputMaybe<Installment_Set_Input>;
  pk_columns: Installment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installment_ManyArgs = {
  updates: Array<Installment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InstructorArgs = {
  _inc?: InputMaybe<Instructor_Inc_Input>;
  _set?: InputMaybe<Instructor_Set_Input>;
  where: Instructor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Instructor_By_PkArgs = {
  _inc?: InputMaybe<Instructor_Inc_Input>;
  _set?: InputMaybe<Instructor_Set_Input>;
  pk_columns: Instructor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Instructor_ManyArgs = {
  updates: Array<Instructor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_InstallmentArgs = {
  _inc?: InputMaybe<Invoice_Installment_Inc_Input>;
  _set?: InputMaybe<Invoice_Installment_Set_Input>;
  where: Invoice_Installment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Installment_By_PkArgs = {
  _inc?: InputMaybe<Invoice_Installment_Inc_Input>;
  _set?: InputMaybe<Invoice_Installment_Set_Input>;
  pk_columns: Invoice_Installment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Installment_ManyArgs = {
  updates: Array<Invoice_Installment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LectureArgs = {
  _inc?: InputMaybe<Lecture_Inc_Input>;
  _set?: InputMaybe<Lecture_Set_Input>;
  where: Lecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_By_PkArgs = {
  _inc?: InputMaybe<Lecture_Inc_Input>;
  _set?: InputMaybe<Lecture_Set_Input>;
  pk_columns: Lecture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_ManyArgs = {
  updates: Array<Lecture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_NoteArgs = {
  _inc?: InputMaybe<Lecture_Note_Inc_Input>;
  _set?: InputMaybe<Lecture_Note_Set_Input>;
  where: Lecture_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_Note_By_PkArgs = {
  _inc?: InputMaybe<Lecture_Note_Inc_Input>;
  _set?: InputMaybe<Lecture_Note_Set_Input>;
  pk_columns: Lecture_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_Note_ManyArgs = {
  updates: Array<Lecture_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_ResourceArgs = {
  _inc?: InputMaybe<Lecture_Resource_Inc_Input>;
  _set?: InputMaybe<Lecture_Resource_Set_Input>;
  where: Lecture_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_Resource_By_PkArgs = {
  _inc?: InputMaybe<Lecture_Resource_Inc_Input>;
  _set?: InputMaybe<Lecture_Resource_Set_Input>;
  pk_columns: Lecture_Resource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lecture_Resource_ManyArgs = {
  updates: Array<Lecture_Resource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LessonArgs = {
  _inc?: InputMaybe<Lesson_Inc_Input>;
  _set?: InputMaybe<Lesson_Set_Input>;
  where: Lesson_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lesson_By_PkArgs = {
  _inc?: InputMaybe<Lesson_Inc_Input>;
  _set?: InputMaybe<Lesson_Set_Input>;
  pk_columns: Lesson_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lesson_ManyArgs = {
  updates: Array<Lesson_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LevelArgs = {
  _inc?: InputMaybe<Level_Inc_Input>;
  _set?: InputMaybe<Level_Set_Input>;
  where: Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Level_By_PkArgs = {
  _inc?: InputMaybe<Level_Inc_Input>;
  _set?: InputMaybe<Level_Set_Input>;
  pk_columns: Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Level_ManyArgs = {
  updates: Array<Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MediaArgs = {
  _inc?: InputMaybe<Media_Inc_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Media_By_PkArgs = {
  _inc?: InputMaybe<Media_Inc_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  pk_columns: Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Media_ManyArgs = {
  updates: Array<Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_By_PkArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  pk_columns: Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_ManyArgs = {
  updates: Array<Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProgressionArgs = {
  _inc?: InputMaybe<Progression_Inc_Input>;
  _set?: InputMaybe<Progression_Set_Input>;
  where: Progression_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Progression_By_PkArgs = {
  _inc?: InputMaybe<Progression_Inc_Input>;
  _set?: InputMaybe<Progression_Set_Input>;
  pk_columns: Progression_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Progression_ManyArgs = {
  updates: Array<Progression_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionArgs = {
  _inc?: InputMaybe<Question_Inc_Input>;
  _set?: InputMaybe<Question_Set_Input>;
  where: Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_By_PkArgs = {
  _inc?: InputMaybe<Question_Inc_Input>;
  _set?: InputMaybe<Question_Set_Input>;
  pk_columns: Question_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_ManyArgs = {
  updates: Array<Question_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_OptionArgs = {
  _inc?: InputMaybe<Question_Option_Inc_Input>;
  _set?: InputMaybe<Question_Option_Set_Input>;
  where: Question_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Option_By_PkArgs = {
  _inc?: InputMaybe<Question_Option_Inc_Input>;
  _set?: InputMaybe<Question_Option_Set_Input>;
  pk_columns: Question_Option_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Option_ManyArgs = {
  updates: Array<Question_Option_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_QuizArgs = {
  _inc?: InputMaybe<Question_Quiz_Inc_Input>;
  _set?: InputMaybe<Question_Quiz_Set_Input>;
  where: Question_Quiz_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Quiz_By_PkArgs = {
  _inc?: InputMaybe<Question_Quiz_Inc_Input>;
  _set?: InputMaybe<Question_Quiz_Set_Input>;
  pk_columns: Question_Quiz_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Quiz_ManyArgs = {
  updates: Array<Question_Quiz_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_TagArgs = {
  _inc?: InputMaybe<Question_Tag_Inc_Input>;
  _set?: InputMaybe<Question_Tag_Set_Input>;
  where: Question_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Tag_By_PkArgs = {
  _inc?: InputMaybe<Question_Tag_Inc_Input>;
  _set?: InputMaybe<Question_Tag_Set_Input>;
  pk_columns: Question_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Tag_ManyArgs = {
  updates: Array<Question_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_WorkspaceArgs = {
  _inc?: InputMaybe<Question_Workspace_Inc_Input>;
  _set?: InputMaybe<Question_Workspace_Set_Input>;
  where: Question_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Workspace_By_PkArgs = {
  _inc?: InputMaybe<Question_Workspace_Inc_Input>;
  _set?: InputMaybe<Question_Workspace_Set_Input>;
  pk_columns: Question_Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Workspace_ManyArgs = {
  updates: Array<Question_Workspace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuizArgs = {
  _inc?: InputMaybe<Quiz_Inc_Input>;
  _set?: InputMaybe<Quiz_Set_Input>;
  where: Quiz_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quiz_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Inc_Input>;
  _set?: InputMaybe<Quiz_Set_Input>;
  pk_columns: Quiz_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quiz_ManyArgs = {
  updates: Array<Quiz_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_EventArgs = {
  _inc?: InputMaybe<Recurring_Event_Inc_Input>;
  _set?: InputMaybe<Recurring_Event_Set_Input>;
  where: Recurring_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_Event_By_PkArgs = {
  _inc?: InputMaybe<Recurring_Event_Inc_Input>;
  _set?: InputMaybe<Recurring_Event_Set_Input>;
  pk_columns: Recurring_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_Event_ManyArgs = {
  updates: Array<Recurring_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_School_FeeArgs = {
  _inc?: InputMaybe<School_Fee_Inc_Input>;
  _set?: InputMaybe<School_Fee_Set_Input>;
  where: School_Fee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_School_Fee_By_PkArgs = {
  _inc?: InputMaybe<School_Fee_Inc_Input>;
  _set?: InputMaybe<School_Fee_Set_Input>;
  pk_columns: School_Fee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_School_Fee_ManyArgs = {
  updates: Array<School_Fee_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_School_PeriodArgs = {
  _inc?: InputMaybe<School_Period_Inc_Input>;
  _set?: InputMaybe<School_Period_Set_Input>;
  where: School_Period_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_School_Period_By_PkArgs = {
  _inc?: InputMaybe<School_Period_Inc_Input>;
  _set?: InputMaybe<School_Period_Set_Input>;
  pk_columns: School_Period_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_School_Period_ManyArgs = {
  updates: Array<School_Period_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagArgs = {
  _inc?: InputMaybe<Tag_Inc_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_By_PkArgs = {
  _inc?: InputMaybe<Tag_Inc_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  pk_columns: Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs = {
  updates: Array<Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TextArgs = {
  _inc?: InputMaybe<Text_Inc_Input>;
  _set?: InputMaybe<Text_Set_Input>;
  where: Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Text_By_PkArgs = {
  _inc?: InputMaybe<Text_Inc_Input>;
  _set?: InputMaybe<Text_Set_Input>;
  pk_columns: Text_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Text_ManyArgs = {
  updates: Array<Text_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Typeorm_MetadataArgs = {
  _set?: InputMaybe<Typeorm_Metadata_Set_Input>;
  where: Typeorm_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Typeorm_Metadata_ManyArgs = {
  updates: Array<Typeorm_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_By_PkArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  pk_columns: Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_ManyArgs = {
  updates: Array<Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_ActivityArgs = {
  _append?: InputMaybe<User_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<User_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Activity_Delete_Key_Input>;
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  _prepend?: InputMaybe<User_Activity_Prepend_Input>;
  _set?: InputMaybe<User_Activity_Set_Input>;
  where: User_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Activity_By_PkArgs = {
  _append?: InputMaybe<User_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<User_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Activity_Delete_Key_Input>;
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  _prepend?: InputMaybe<User_Activity_Prepend_Input>;
  _set?: InputMaybe<User_Activity_Set_Input>;
  pk_columns: User_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Activity_ManyArgs = {
  updates: Array<User_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_AssignmentArgs = {
  _inc?: InputMaybe<User_Assignment_Inc_Input>;
  _set?: InputMaybe<User_Assignment_Set_Input>;
  where: User_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assignment_ActivityArgs = {
  _append?: InputMaybe<User_Assignment_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<User_Assignment_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Assignment_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Assignment_Activity_Delete_Key_Input>;
  _inc?: InputMaybe<User_Assignment_Activity_Inc_Input>;
  _prepend?: InputMaybe<User_Assignment_Activity_Prepend_Input>;
  _set?: InputMaybe<User_Assignment_Activity_Set_Input>;
  where: User_Assignment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assignment_Activity_By_PkArgs = {
  _append?: InputMaybe<User_Assignment_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<User_Assignment_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Assignment_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Assignment_Activity_Delete_Key_Input>;
  _inc?: InputMaybe<User_Assignment_Activity_Inc_Input>;
  _prepend?: InputMaybe<User_Assignment_Activity_Prepend_Input>;
  _set?: InputMaybe<User_Assignment_Activity_Set_Input>;
  pk_columns: User_Assignment_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assignment_Activity_ManyArgs = {
  updates: Array<User_Assignment_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assignment_By_PkArgs = {
  _inc?: InputMaybe<User_Assignment_Inc_Input>;
  _set?: InputMaybe<User_Assignment_Set_Input>;
  pk_columns: User_Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assignment_ManyArgs = {
  updates: Array<User_Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_BlockArgs = {
  _append?: InputMaybe<User_Block_Append_Input>;
  _delete_at_path?: InputMaybe<User_Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Block_Delete_Key_Input>;
  _inc?: InputMaybe<User_Block_Inc_Input>;
  _prepend?: InputMaybe<User_Block_Prepend_Input>;
  _set?: InputMaybe<User_Block_Set_Input>;
  where: User_Block_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Block_By_PkArgs = {
  _append?: InputMaybe<User_Block_Append_Input>;
  _delete_at_path?: InputMaybe<User_Block_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Block_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Block_Delete_Key_Input>;
  _inc?: InputMaybe<User_Block_Inc_Input>;
  _prepend?: InputMaybe<User_Block_Prepend_Input>;
  _set?: InputMaybe<User_Block_Set_Input>;
  pk_columns: User_Block_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Block_ManyArgs = {
  updates: Array<User_Block_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_CheckpointArgs = {
  _inc?: InputMaybe<User_Checkpoint_Inc_Input>;
  _set?: InputMaybe<User_Checkpoint_Set_Input>;
  where: User_Checkpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Checkpoint_By_PkArgs = {
  _inc?: InputMaybe<User_Checkpoint_Inc_Input>;
  _set?: InputMaybe<User_Checkpoint_Set_Input>;
  pk_columns: User_Checkpoint_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Checkpoint_ManyArgs = {
  updates: Array<User_Checkpoint_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ClassArgs = {
  _inc?: InputMaybe<User_Class_Inc_Input>;
  _set?: InputMaybe<User_Class_Set_Input>;
  where: User_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Class_By_PkArgs = {
  _inc?: InputMaybe<User_Class_Inc_Input>;
  _set?: InputMaybe<User_Class_Set_Input>;
  pk_columns: User_Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Class_ManyArgs = {
  updates: Array<User_Class_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CourseArgs = {
  _inc?: InputMaybe<User_Course_Inc_Input>;
  _set?: InputMaybe<User_Course_Set_Input>;
  where: User_Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Course_By_PkArgs = {
  _inc?: InputMaybe<User_Course_Inc_Input>;
  _set?: InputMaybe<User_Course_Set_Input>;
  pk_columns: User_Course_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Course_ManyArgs = {
  updates: Array<User_Course_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_EventArgs = {
  _inc?: InputMaybe<User_Event_Inc_Input>;
  _set?: InputMaybe<User_Event_Set_Input>;
  where: User_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Event_By_PkArgs = {
  _inc?: InputMaybe<User_Event_Inc_Input>;
  _set?: InputMaybe<User_Event_Set_Input>;
  pk_columns: User_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Event_ManyArgs = {
  updates: Array<User_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_GroupArgs = {
  _inc?: InputMaybe<User_Group_Inc_Input>;
  _set?: InputMaybe<User_Group_Set_Input>;
  where: User_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_By_PkArgs = {
  _inc?: InputMaybe<User_Group_Inc_Input>;
  _set?: InputMaybe<User_Group_Set_Input>;
  pk_columns: User_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_ManyArgs = {
  updates: Array<User_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_LectureArgs = {
  _inc?: InputMaybe<User_Lecture_Inc_Input>;
  _set?: InputMaybe<User_Lecture_Set_Input>;
  where: User_Lecture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Lecture_By_PkArgs = {
  _inc?: InputMaybe<User_Lecture_Inc_Input>;
  _set?: InputMaybe<User_Lecture_Set_Input>;
  pk_columns: User_Lecture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Lecture_ManyArgs = {
  updates: Array<User_Lecture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfileArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdate_User_WorkspaceArgs = {
  _inc?: InputMaybe<User_Workspace_Inc_Input>;
  _set?: InputMaybe<User_Workspace_Set_Input>;
  where: User_Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Workspace_By_PkArgs = {
  _inc?: InputMaybe<User_Workspace_Inc_Input>;
  _set?: InputMaybe<User_Workspace_Set_Input>;
  pk_columns: User_Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Workspace_ManyArgs = {
  updates: Array<User_Workspace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WorkspaceArgs = {
  _inc?: InputMaybe<Workspace_Inc_Input>;
  _set?: InputMaybe<Workspace_Set_Input>;
  where: Workspace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workspace_By_PkArgs = {
  _inc?: InputMaybe<Workspace_Inc_Input>;
  _set?: InputMaybe<Workspace_Set_Input>;
  pk_columns: Workspace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workspace_ManyArgs = {
  updates: Array<Workspace_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export const enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  /** An array relationship */
  activities: Array<Activity>;
  /** An aggregate relationship */
  activities_aggregate: Activity_Aggregate;
  /** An array relationship */
  assignment_activities: Array<Assignment_Activity>;
  /** An aggregate relationship */
  assignment_activities_aggregate: Assignment_Activity_Aggregate;
  /** An array relationship */
  assignment_blocks: Array<Assignment_Block>;
  /** An aggregate relationship */
  assignment_blocks_aggregate: Assignment_Block_Aggregate;
  /** An array relationship */
  assignments: Array<Assignment>;
  /** An aggregate relationship */
  assignments_aggregate: Assignment_Aggregate;
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  /** An array relationship */
  calendar_events: Array<Calendar_Event>;
  /** An aggregate relationship */
  calendar_events_aggregate: Calendar_Event_Aggregate;
  /** An array relationship */
  categories: Array<Category>;
  /** An aggregate relationship */
  categories_aggregate: Category_Aggregate;
  /** An array relationship */
  checkpoints: Array<Checkpoint>;
  /** An aggregate relationship */
  checkpoints_aggregate: Checkpoint_Aggregate;
  /** An array relationship */
  class_course_notes: Array<Class_Course_Note>;
  /** An aggregate relationship */
  class_course_notes_aggregate: Class_Course_Note_Aggregate;
  /** An array relationship */
  class_course_resources: Array<Class_Course_Resource>;
  /** An aggregate relationship */
  class_course_resources_aggregate: Class_Course_Resource_Aggregate;
  /** An array relationship */
  class_courses: Array<Class_Course>;
  /** An aggregate relationship */
  class_courses_aggregate: Class_Course_Aggregate;
  /** An array relationship */
  classes: Array<Class>;
  /** An aggregate relationship */
  classes_aggregate: Class_Aggregate;
  /** An array relationship */
  classroom_groups: Array<Classroom_Group>;
  /** An aggregate relationship */
  classroom_groups_aggregate: Classroom_Group_Aggregate;
  config: Scalars['jsonb'];
  /** An array relationship */
  course_categories: Array<Course_Category>;
  /** An aggregate relationship */
  course_categories_aggregate: Course_Category_Aggregate;
  /** An array relationship */
  courses: Array<Course>;
  /** An aggregate relationship */
  courses_aggregate: Course_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  dnds: Array<Dnd>;
  /** An aggregate relationship */
  dnds_aggregate: Dnd_Aggregate;
  /** An array relationship */
  event_classrooms: Array<Event_Classroom>;
  /** An aggregate relationship */
  event_classrooms_aggregate: Event_Classroom_Aggregate;
  /** An array relationship */
  files: Array<File>;
  /** An aggregate relationship */
  files_aggregate: File_Aggregate;
  /** An array relationship */
  fill_blanks: Array<Fill_Blank>;
  /** An aggregate relationship */
  fill_blanks_aggregate: Fill_Blank_Aggregate;
  gid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  grade_level_groups: Array<Grade_Level_Group>;
  /** An aggregate relationship */
  grade_level_groups_aggregate: Grade_Level_Group_Aggregate;
  /** An array relationship */
  gradebooks: Array<Gradebook>;
  /** An aggregate relationship */
  gradebooks_aggregate: Gradebook_Aggregate;
  /** An array relationship */
  groups: Array<Group>;
  /** An aggregate relationship */
  groups_aggregate: Group_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  installments: Array<Installment>;
  /** An aggregate relationship */
  installments_aggregate: Installment_Aggregate;
  /** An array relationship */
  instructors: Array<Instructor>;
  /** An aggregate relationship */
  instructors_aggregate: Instructor_Aggregate;
  /** An array relationship */
  invoice_installments: Array<Invoice_Installment>;
  /** An aggregate relationship */
  invoice_installments_aggregate: Invoice_Installment_Aggregate;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  /** An array relationship */
  lecture_notes: Array<Lecture_Note>;
  /** An aggregate relationship */
  lecture_notes_aggregate: Lecture_Note_Aggregate;
  /** An array relationship */
  lecture_resources: Array<Lecture_Resource>;
  /** An aggregate relationship */
  lecture_resources_aggregate: Lecture_Resource_Aggregate;
  /** An array relationship */
  lectures: Array<Lecture>;
  /** An aggregate relationship */
  lectures_aggregate: Lecture_Aggregate;
  /** An array relationship */
  lessons: Array<Lesson>;
  /** An aggregate relationship */
  lessons_aggregate: Lesson_Aggregate;
  /** An array relationship */
  levels: Array<Level>;
  /** An aggregate relationship */
  levels_aggregate: Level_Aggregate;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  media_aggregate: Media_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  /** An array relationship */
  quizzes: Array<Quiz>;
  /** An aggregate relationship */
  quizzes_aggregate: Quiz_Aggregate;
  /** An array relationship */
  recurring_events: Array<Recurring_Event>;
  /** An aggregate relationship */
  recurring_events_aggregate: Recurring_Event_Aggregate;
  /** An array relationship */
  school_fees: Array<School_Fee>;
  /** An aggregate relationship */
  school_fees_aggregate: School_Fee_Aggregate;
  /** An array relationship */
  school_periods: Array<School_Period>;
  /** An aggregate relationship */
  school_periods_aggregate: School_Period_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
  /** An aggregate relationship */
  tags_aggregate: Tag_Aggregate;
  /** An array relationship */
  texts: Array<Text>;
  /** An aggregate relationship */
  texts_aggregate: Text_Aggregate;
  tier: Scalars['organization_tier_enum'];
  type: Scalars['organization_type_enum'];
  uid: Scalars['uuid'];
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_assignment_activities: Array<User_Assignment_Activity>;
  /** An aggregate relationship */
  user_assignment_activities_aggregate: User_Assignment_Activity_Aggregate;
  /** An array relationship */
  user_assignments: Array<User_Assignment>;
  /** An aggregate relationship */
  user_assignments_aggregate: User_Assignment_Aggregate;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
  /** An array relationship */
  workspaces: Array<Workspace>;
  /** An aggregate relationship */
  workspaces_aggregate: Workspace_Aggregate;
};


/** columns and relationships of "organization" */
export type OrganizationActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignment_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignment_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignment_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignment_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCalendar_EventsArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCalendar_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCheckpointsArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCheckpoints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_Course_NotesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_Course_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_Course_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_Course_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClass_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClassesArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClasses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClassroom_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationClassroom_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationCourse_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCourse_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCoursesArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDndsArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDnds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationEvent_ClassroomsArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationEvent_Classrooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationFilesArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationFill_BlanksArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationFill_Blanks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGrade_Level_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGrade_Level_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGradebooksArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGradebooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGroupsArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInstallments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInstructorsArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInstructors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvoice_InstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvoice_Installments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLecture_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLecture_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLecture_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLecture_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLecturesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLectures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLessonsArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLevelsArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLevels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationQuizzesArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationQuizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationRecurring_EventsArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationRecurring_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSchool_FeesArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSchool_Fees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSchool_PeriodsArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSchool_Periods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationTextsArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationTexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_Assignment_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_Assignment_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWorkspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  avg?: Maybe<Organization_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
  stddev?: Maybe<Organization_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Sum_Fields>;
  var_pop?: Maybe<Organization_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Var_Samp_Fields>;
  variance?: Maybe<Organization_Variance_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Organization_Avg_Fields = {
  __typename?: 'organization_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  activities?: InputMaybe<Activity_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activity_Aggregate_Bool_Exp>;
  assignment_activities?: InputMaybe<Assignment_Activity_Bool_Exp>;
  assignment_activities_aggregate?: InputMaybe<Assignment_Activity_Aggregate_Bool_Exp>;
  assignment_blocks?: InputMaybe<Assignment_Block_Bool_Exp>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp>;
  assignments?: InputMaybe<Assignment_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Bool_Exp>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  calendar_events?: InputMaybe<Calendar_Event_Bool_Exp>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp>;
  categories?: InputMaybe<Category_Bool_Exp>;
  categories_aggregate?: InputMaybe<Category_Aggregate_Bool_Exp>;
  checkpoints?: InputMaybe<Checkpoint_Bool_Exp>;
  checkpoints_aggregate?: InputMaybe<Checkpoint_Aggregate_Bool_Exp>;
  class_course_notes?: InputMaybe<Class_Course_Note_Bool_Exp>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp>;
  class_courses?: InputMaybe<Class_Course_Bool_Exp>;
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Bool_Exp>;
  classes?: InputMaybe<Class_Bool_Exp>;
  classes_aggregate?: InputMaybe<Class_Aggregate_Bool_Exp>;
  classroom_groups?: InputMaybe<Classroom_Group_Bool_Exp>;
  classroom_groups_aggregate?: InputMaybe<Classroom_Group_Aggregate_Bool_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  course_categories?: InputMaybe<Course_Category_Bool_Exp>;
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Bool_Exp>;
  courses?: InputMaybe<Course_Bool_Exp>;
  courses_aggregate?: InputMaybe<Course_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  dnds?: InputMaybe<Dnd_Bool_Exp>;
  dnds_aggregate?: InputMaybe<Dnd_Aggregate_Bool_Exp>;
  event_classrooms?: InputMaybe<Event_Classroom_Bool_Exp>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Bool_Exp>;
  files?: InputMaybe<File_Bool_Exp>;
  files_aggregate?: InputMaybe<File_Aggregate_Bool_Exp>;
  fill_blanks?: InputMaybe<Fill_Blank_Bool_Exp>;
  fill_blanks_aggregate?: InputMaybe<Fill_Blank_Aggregate_Bool_Exp>;
  gid?: InputMaybe<Uuid_Comparison_Exp>;
  grade_level_groups?: InputMaybe<Grade_Level_Group_Bool_Exp>;
  grade_level_groups_aggregate?: InputMaybe<Grade_Level_Group_Aggregate_Bool_Exp>;
  gradebooks?: InputMaybe<Gradebook_Bool_Exp>;
  gradebooks_aggregate?: InputMaybe<Gradebook_Aggregate_Bool_Exp>;
  groups?: InputMaybe<Group_Bool_Exp>;
  groups_aggregate?: InputMaybe<Group_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  installments?: InputMaybe<Installment_Bool_Exp>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Bool_Exp>;
  instructors?: InputMaybe<Instructor_Bool_Exp>;
  instructors_aggregate?: InputMaybe<Instructor_Aggregate_Bool_Exp>;
  invoice_installments?: InputMaybe<Invoice_Installment_Bool_Exp>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  lecture_notes?: InputMaybe<Lecture_Note_Bool_Exp>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Bool_Exp>;
  lecture_resources?: InputMaybe<Lecture_Resource_Bool_Exp>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Bool_Exp>;
  lectures?: InputMaybe<Lecture_Bool_Exp>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Bool_Exp>;
  lessons?: InputMaybe<Lesson_Bool_Exp>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Bool_Exp>;
  levels?: InputMaybe<Level_Bool_Exp>;
  levels_aggregate?: InputMaybe<Level_Aggregate_Bool_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  media_aggregate?: InputMaybe<Media_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  quizzes?: InputMaybe<Quiz_Bool_Exp>;
  quizzes_aggregate?: InputMaybe<Quiz_Aggregate_Bool_Exp>;
  recurring_events?: InputMaybe<Recurring_Event_Bool_Exp>;
  recurring_events_aggregate?: InputMaybe<Recurring_Event_Aggregate_Bool_Exp>;
  school_fees?: InputMaybe<School_Fee_Bool_Exp>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Bool_Exp>;
  school_periods?: InputMaybe<School_Period_Bool_Exp>;
  school_periods_aggregate?: InputMaybe<School_Period_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Bool_Exp>;
  texts?: InputMaybe<Text_Bool_Exp>;
  texts_aggregate?: InputMaybe<Text_Aggregate_Bool_Exp>;
  tier?: InputMaybe<Organization_Tier_Enum_Comparison_Exp>;
  type?: InputMaybe<Organization_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  units?: InputMaybe<Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp>;
  user_assignments?: InputMaybe<User_Assignment_Bool_Exp>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Bool_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
  workspaces?: InputMaybe<Workspace_Bool_Exp>;
  workspaces_aggregate?: InputMaybe<Workspace_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organization" */
export const enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_472c1f99a32def1b0abb219cd67 = 'PK_472c1f99a32def1b0abb219cd67',
  /** unique or primary key constraint on columns "uid" */
  Uq_079e141c457292a8770f1a40541 = 'UQ_079e141c457292a8770f1a40541',
  /** unique or primary key constraint on columns "gid" */
  Uq_1d408b3aa959823b9c76bbf412d = 'UQ_1d408b3aa959823b9c76bbf412d',
  /** unique or primary key constraint on columns "name" */
  UqC21e615583a3ebbb0977452afb0 = 'UQ_c21e615583a3ebbb0977452afb0'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "organization" */
export type Organization_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  activities?: InputMaybe<Activity_Arr_Rel_Insert_Input>;
  assignment_activities?: InputMaybe<Assignment_Activity_Arr_Rel_Insert_Input>;
  assignment_blocks?: InputMaybe<Assignment_Block_Arr_Rel_Insert_Input>;
  assignments?: InputMaybe<Assignment_Arr_Rel_Insert_Input>;
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  calendar_events?: InputMaybe<Calendar_Event_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Category_Arr_Rel_Insert_Input>;
  checkpoints?: InputMaybe<Checkpoint_Arr_Rel_Insert_Input>;
  class_course_notes?: InputMaybe<Class_Course_Note_Arr_Rel_Insert_Input>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Arr_Rel_Insert_Input>;
  class_courses?: InputMaybe<Class_Course_Arr_Rel_Insert_Input>;
  classes?: InputMaybe<Class_Arr_Rel_Insert_Input>;
  classroom_groups?: InputMaybe<Classroom_Group_Arr_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['jsonb']>;
  course_categories?: InputMaybe<Course_Category_Arr_Rel_Insert_Input>;
  courses?: InputMaybe<Course_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dnds?: InputMaybe<Dnd_Arr_Rel_Insert_Input>;
  event_classrooms?: InputMaybe<Event_Classroom_Arr_Rel_Insert_Input>;
  files?: InputMaybe<File_Arr_Rel_Insert_Input>;
  fill_blanks?: InputMaybe<Fill_Blank_Arr_Rel_Insert_Input>;
  gid?: InputMaybe<Scalars['uuid']>;
  grade_level_groups?: InputMaybe<Grade_Level_Group_Arr_Rel_Insert_Input>;
  gradebooks?: InputMaybe<Gradebook_Arr_Rel_Insert_Input>;
  groups?: InputMaybe<Group_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  installments?: InputMaybe<Installment_Arr_Rel_Insert_Input>;
  instructors?: InputMaybe<Instructor_Arr_Rel_Insert_Input>;
  invoice_installments?: InputMaybe<Invoice_Installment_Arr_Rel_Insert_Input>;
  invoices?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  lecture_notes?: InputMaybe<Lecture_Note_Arr_Rel_Insert_Input>;
  lecture_resources?: InputMaybe<Lecture_Resource_Arr_Rel_Insert_Input>;
  lectures?: InputMaybe<Lecture_Arr_Rel_Insert_Input>;
  lessons?: InputMaybe<Lesson_Arr_Rel_Insert_Input>;
  levels?: InputMaybe<Level_Arr_Rel_Insert_Input>;
  media?: InputMaybe<Media_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  quizzes?: InputMaybe<Quiz_Arr_Rel_Insert_Input>;
  recurring_events?: InputMaybe<Recurring_Event_Arr_Rel_Insert_Input>;
  school_fees?: InputMaybe<School_Fee_Arr_Rel_Insert_Input>;
  school_periods?: InputMaybe<School_Period_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
  texts?: InputMaybe<Text_Arr_Rel_Insert_Input>;
  tier?: InputMaybe<Scalars['organization_tier_enum']>;
  type?: InputMaybe<Scalars['organization_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  units?: InputMaybe<Unit_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Arr_Rel_Insert_Input>;
  user_assignments?: InputMaybe<User_Assignment_Arr_Rel_Insert_Input>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
  workspaces?: InputMaybe<Workspace_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gid?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['organization_tier_enum']>;
  type?: Maybe<Scalars['organization_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gid?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['organization_tier_enum']>;
  type?: Maybe<Scalars['organization_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  activities_aggregate?: InputMaybe<Activity_Aggregate_Order_By>;
  assignment_activities_aggregate?: InputMaybe<Assignment_Activity_Aggregate_Order_By>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Order_By>;
  assignments_aggregate?: InputMaybe<Assignment_Aggregate_Order_By>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Category_Aggregate_Order_By>;
  checkpoints_aggregate?: InputMaybe<Checkpoint_Aggregate_Order_By>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Order_By>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Order_By>;
  class_courses_aggregate?: InputMaybe<Class_Course_Aggregate_Order_By>;
  classes_aggregate?: InputMaybe<Class_Aggregate_Order_By>;
  classroom_groups_aggregate?: InputMaybe<Classroom_Group_Aggregate_Order_By>;
  config?: InputMaybe<Order_By>;
  course_categories_aggregate?: InputMaybe<Course_Category_Aggregate_Order_By>;
  courses_aggregate?: InputMaybe<Course_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  dnds_aggregate?: InputMaybe<Dnd_Aggregate_Order_By>;
  event_classrooms_aggregate?: InputMaybe<Event_Classroom_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<File_Aggregate_Order_By>;
  fill_blanks_aggregate?: InputMaybe<Fill_Blank_Aggregate_Order_By>;
  gid?: InputMaybe<Order_By>;
  grade_level_groups_aggregate?: InputMaybe<Grade_Level_Group_Aggregate_Order_By>;
  gradebooks_aggregate?: InputMaybe<Gradebook_Aggregate_Order_By>;
  groups_aggregate?: InputMaybe<Group_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Order_By>;
  instructors_aggregate?: InputMaybe<Instructor_Aggregate_Order_By>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  lecture_notes_aggregate?: InputMaybe<Lecture_Note_Aggregate_Order_By>;
  lecture_resources_aggregate?: InputMaybe<Lecture_Resource_Aggregate_Order_By>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Order_By>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Order_By>;
  levels_aggregate?: InputMaybe<Level_Aggregate_Order_By>;
  media_aggregate?: InputMaybe<Media_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  quizzes_aggregate?: InputMaybe<Quiz_Aggregate_Order_By>;
  recurring_events_aggregate?: InputMaybe<Recurring_Event_Aggregate_Order_By>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Order_By>;
  school_periods_aggregate?: InputMaybe<School_Period_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
  texts_aggregate?: InputMaybe<Text_Aggregate_Order_By>;
  tier?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Order_By>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  workspaces_aggregate?: InputMaybe<Workspace_Aggregate_Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "organization" */
export const enum Organization_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Gid = 'gid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Tier = 'tier',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gid?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['organization_tier_enum']>;
  type?: InputMaybe<Scalars['organization_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Organization_Stddev_Fields = {
  __typename?: 'organization_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Stddev_Pop_Fields = {
  __typename?: 'organization_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Stddev_Samp_Fields = {
  __typename?: 'organization_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  gid?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['organization_tier_enum']>;
  type?: InputMaybe<Scalars['organization_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Organization_Sum_Fields = {
  __typename?: 'organization_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "organization_tier_enum". All fields are combined with logical 'AND'. */
export type Organization_Tier_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['organization_tier_enum']>;
  _gt?: InputMaybe<Scalars['organization_tier_enum']>;
  _gte?: InputMaybe<Scalars['organization_tier_enum']>;
  _in?: InputMaybe<Array<Scalars['organization_tier_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['organization_tier_enum']>;
  _lte?: InputMaybe<Scalars['organization_tier_enum']>;
  _neq?: InputMaybe<Scalars['organization_tier_enum']>;
  _nin?: InputMaybe<Array<Scalars['organization_tier_enum']>>;
};

/** Boolean expression to compare columns of type "organization_type_enum". All fields are combined with logical 'AND'. */
export type Organization_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['organization_type_enum']>;
  _gt?: InputMaybe<Scalars['organization_type_enum']>;
  _gte?: InputMaybe<Scalars['organization_type_enum']>;
  _in?: InputMaybe<Array<Scalars['organization_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['organization_type_enum']>;
  _lte?: InputMaybe<Scalars['organization_type_enum']>;
  _neq?: InputMaybe<Scalars['organization_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['organization_type_enum']>>;
};

/** update columns of table "organization" */
export const enum Organization_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Gid = 'gid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Tier = 'tier',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Organization_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Var_Pop_Fields = {
  __typename?: 'organization_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organization_Var_Samp_Fields = {
  __typename?: 'organization_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organization_Variance_Fields = {
  __typename?: 'organization_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment" */
export type Payment = {
  __typename?: 'payment';
  amount: Scalars['float8'];
  createdById?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  invoice: Invoice;
  invoiceId: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  paymentMethod: Scalars['payment_paymentmethod_enum'];
  payment_date: Scalars['timestamptz'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "payment" */
export type Payment_Aggregate = {
  __typename?: 'payment_aggregate';
  aggregate?: Maybe<Payment_Aggregate_Fields>;
  nodes: Array<Payment>;
};

export type Payment_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Payment_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Payment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Payment_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Payment_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Payment_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Payment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Payment_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Payment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Payment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Payment_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Payment_Aggregate_Bool_Exp_Var_Samp>;
};

export type Payment_Aggregate_Bool_Exp_Avg = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Corr = {
  arguments: Payment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Payment_Aggregate_Bool_Exp_Max = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Min = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Sum = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Payment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Payment_Select_Column_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "payment" */
export type Payment_Aggregate_Fields = {
  __typename?: 'payment_aggregate_fields';
  avg?: Maybe<Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Max_Fields>;
  min?: Maybe<Payment_Min_Fields>;
  stddev?: Maybe<Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Sum_Fields>;
  var_pop?: Maybe<Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Var_Samp_Fields>;
  variance?: Maybe<Payment_Variance_Fields>;
};


/** aggregate fields of "payment" */
export type Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment" */
export type Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Max_Order_By>;
  min?: InputMaybe<Payment_Min_Order_By>;
  stddev?: InputMaybe<Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment" */
export type Payment_Arr_Rel_Insert_Input = {
  data: Array<Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Avg_Fields = {
  __typename?: 'payment_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment" */
export type Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment". All fields are combined with a logical 'AND'. */
export type Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Bool_Exp>>;
  _not?: InputMaybe<Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoiceId?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  paymentMethod?: InputMaybe<Payment_Paymentmethod_Enum_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "payment" */
export const enum Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFcaec7df5adf9cac408c686b2ab = 'PK_fcaec7df5adf9cac408c686b2ab',
  /** unique or primary key constraint on columns "uid" */
  Uq_2d9bd143bbe39364da9ac92bd80 = 'UQ_2d9bd143bbe39364da9ac92bd80'
};

/** input type for incrementing numeric columns in table "payment" */
export type Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment" */
export type Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Payment_Max_Fields = {
  __typename?: 'payment_max_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['payment_paymentmethod_enum']>;
  payment_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "payment" */
export type Payment_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paymentMethod?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Min_Fields = {
  __typename?: 'payment_min_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['payment_paymentmethod_enum']>;
  payment_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "payment" */
export type Payment_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paymentMethod?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment" */
export type Payment_Mutation_Response = {
  __typename?: 'payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment>;
};

/** on_conflict condition type for table "payment" */
export type Payment_On_Conflict = {
  constraint: Payment_Constraint;
  update_columns?: Array<Payment_Update_Column>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "payment". */
export type Payment_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paymentMethod?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** Boolean expression to compare columns of type "payment_paymentmethod_enum". All fields are combined with logical 'AND'. */
export type Payment_Paymentmethod_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _gt?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _gte?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _in?: InputMaybe<Array<Scalars['payment_paymentmethod_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _lte?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _neq?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  _nin?: InputMaybe<Array<Scalars['payment_paymentmethod_enum']>>;
};

/** primary key columns input for table: payment */
export type Payment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment" */
export const enum Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "payment_aggregate_bool_exp_avg_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "payment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "payment_aggregate_bool_exp_corr_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_max_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_min_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_sum_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** select "payment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "payment" */
export const enum Payment_Select_Column_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
};

/** input type for updating data in table "payment" */
export type Payment_Set_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Stddev_Fields = {
  __typename?: 'payment_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment" */
export type Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Stddev_Pop_Fields = {
  __typename?: 'payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment" */
export type Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Stddev_Samp_Fields = {
  __typename?: 'payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment" */
export type Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment" */
export type Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['payment_paymentmethod_enum']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Sum_Fields = {
  __typename?: 'payment_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "payment" */
export type Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "payment" */
export const enum Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Var_Pop_Fields = {
  __typename?: 'payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment" */
export type Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Var_Samp_Fields = {
  __typename?: 'payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment" */
export type Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Variance_Fields = {
  __typename?: 'payment_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment" */
export type Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "progression" */
export type Progression = {
  __typename?: 'progression';
  /** An object relationship */
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  checkpoint?: Maybe<Checkpoint>;
  checkpointId?: Maybe<Scalars['Int']>;
  completed: Scalars['Boolean'];
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lesson?: Maybe<Lesson>;
  lessonId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  level?: Maybe<Level>;
  levelId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  started: Scalars['Boolean'];
  status: Scalars['progression_status_enum'];
  uid: Scalars['uuid'];
  /** An object relationship */
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "progression" */
export type Progression_Aggregate = {
  __typename?: 'progression_aggregate';
  aggregate?: Maybe<Progression_Aggregate_Fields>;
  nodes: Array<Progression>;
};

export type Progression_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Progression_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Progression_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Progression_Aggregate_Bool_Exp_Count>;
};

export type Progression_Aggregate_Bool_Exp_Bool_And = {
  arguments: Progression_Select_Column_Progression_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Progression_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Progression_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Progression_Select_Column_Progression_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Progression_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Progression_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Progression_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Progression_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "progression" */
export type Progression_Aggregate_Fields = {
  __typename?: 'progression_aggregate_fields';
  avg?: Maybe<Progression_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Progression_Max_Fields>;
  min?: Maybe<Progression_Min_Fields>;
  stddev?: Maybe<Progression_Stddev_Fields>;
  stddev_pop?: Maybe<Progression_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Progression_Stddev_Samp_Fields>;
  sum?: Maybe<Progression_Sum_Fields>;
  var_pop?: Maybe<Progression_Var_Pop_Fields>;
  var_samp?: Maybe<Progression_Var_Samp_Fields>;
  variance?: Maybe<Progression_Variance_Fields>;
};


/** aggregate fields of "progression" */
export type Progression_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Progression_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "progression" */
export type Progression_Aggregate_Order_By = {
  avg?: InputMaybe<Progression_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Progression_Max_Order_By>;
  min?: InputMaybe<Progression_Min_Order_By>;
  stddev?: InputMaybe<Progression_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Progression_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Progression_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Progression_Sum_Order_By>;
  var_pop?: InputMaybe<Progression_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Progression_Var_Samp_Order_By>;
  variance?: InputMaybe<Progression_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "progression" */
export type Progression_Arr_Rel_Insert_Input = {
  data: Array<Progression_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Progression_On_Conflict>;
};

/** aggregate avg on columns */
export type Progression_Avg_Fields = {
  __typename?: 'progression_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "progression" */
export type Progression_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "progression". All fields are combined with a logical 'AND'. */
export type Progression_Bool_Exp = {
  _and?: InputMaybe<Array<Progression_Bool_Exp>>;
  _not?: InputMaybe<Progression_Bool_Exp>;
  _or?: InputMaybe<Array<Progression_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  checkpoint?: InputMaybe<Checkpoint_Bool_Exp>;
  checkpointId?: InputMaybe<Int_Comparison_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lesson?: InputMaybe<Lesson_Bool_Exp>;
  lessonId?: InputMaybe<Int_Comparison_Exp>;
  level?: InputMaybe<Level_Bool_Exp>;
  levelId?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  started?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Progression_Status_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "progression" */
export const enum Progression_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_98e9625372ce1600cea879ba52b = 'PK_98e9625372ce1600cea879ba52b',
  /** unique or primary key constraint on columns "uid" */
  UqEcab77084e79993f3daf63dad9d = 'UQ_ecab77084e79993f3daf63dad9d',
  /** unique or primary key constraint on columns "userId", "courseId" */
  IndexProgression = 'index_progression'
};

/** input type for incrementing numeric columns in table "progression" */
export type Progression_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "progression" */
export type Progression_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['Int']>;
  checkpoint?: InputMaybe<Checkpoint_Obj_Rel_Insert_Input>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lesson?: InputMaybe<Lesson_Obj_Rel_Insert_Input>;
  lessonId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Level_Obj_Rel_Insert_Input>;
  levelId?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  started?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['progression_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Progression_Max_Fields = {
  __typename?: 'progression_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  checkpointId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['progression_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "progression" */
export type Progression_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Progression_Min_Fields = {
  __typename?: 'progression_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  checkpointId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['progression_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  unitId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "progression" */
export type Progression_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "progression" */
export type Progression_Mutation_Response = {
  __typename?: 'progression_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Progression>;
};

/** on_conflict condition type for table "progression" */
export type Progression_On_Conflict = {
  constraint: Progression_Constraint;
  update_columns?: Array<Progression_Update_Column>;
  where?: InputMaybe<Progression_Bool_Exp>;
};

/** Ordering options when selecting data from "progression". */
export type Progression_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityId?: InputMaybe<Order_By>;
  checkpoint?: InputMaybe<Checkpoint_Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson?: InputMaybe<Lesson_Order_By>;
  lessonId?: InputMaybe<Order_By>;
  level?: InputMaybe<Level_Order_By>;
  levelId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  started?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: progression */
export type Progression_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "progression" */
export const enum Progression_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Started = 'started',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unitId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "progression_aggregate_bool_exp_bool_and_arguments_columns" columns of table "progression" */
export const enum Progression_Select_Column_Progression_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Started = 'started'
};

/** select "progression_aggregate_bool_exp_bool_or_arguments_columns" columns of table "progression" */
export const enum Progression_Select_Column_Progression_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Started = 'started'
};

/** input type for updating data in table "progression" */
export type Progression_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  started?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['progression_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "progression_status_enum". All fields are combined with logical 'AND'. */
export type Progression_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['progression_status_enum']>;
  _gt?: InputMaybe<Scalars['progression_status_enum']>;
  _gte?: InputMaybe<Scalars['progression_status_enum']>;
  _in?: InputMaybe<Array<Scalars['progression_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['progression_status_enum']>;
  _lte?: InputMaybe<Scalars['progression_status_enum']>;
  _neq?: InputMaybe<Scalars['progression_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['progression_status_enum']>>;
};

/** aggregate stddev on columns */
export type Progression_Stddev_Fields = {
  __typename?: 'progression_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "progression" */
export type Progression_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Progression_Stddev_Pop_Fields = {
  __typename?: 'progression_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "progression" */
export type Progression_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Progression_Stddev_Samp_Fields = {
  __typename?: 'progression_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "progression" */
export type Progression_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "progression" */
export type Progression_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Progression_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Progression_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  started?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['progression_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  unitId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Progression_Sum_Fields = {
  __typename?: 'progression_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  checkpointId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  unitId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "progression" */
export type Progression_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "progression" */
export const enum Progression_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Started = 'started',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unitId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type Progression_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Progression_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Progression_Set_Input>;
  /** filter the rows which have to be updated */
  where: Progression_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Progression_Var_Pop_Fields = {
  __typename?: 'progression_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "progression" */
export type Progression_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Progression_Var_Samp_Fields = {
  __typename?: 'progression_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "progression" */
export type Progression_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Progression_Variance_Fields = {
  __typename?: 'progression_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  checkpointId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lessonId?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "progression" */
export type Progression_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessonId?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** fetch data from the table: "activity_layout" */
  activity_layout: Array<Activity_Layout>;
  /** fetch aggregated fields from the table: "activity_layout" */
  activity_layout_aggregate: Activity_Layout_Aggregate;
  /** fetch data from the table: "activity_layout" using primary key columns */
  activity_layout_by_pk?: Maybe<Activity_Layout>;
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch data from the table: "assignment_activity" */
  assignment_activity: Array<Assignment_Activity>;
  /** fetch aggregated fields from the table: "assignment_activity" */
  assignment_activity_aggregate: Assignment_Activity_Aggregate;
  /** fetch data from the table: "assignment_activity" using primary key columns */
  assignment_activity_by_pk?: Maybe<Assignment_Activity>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment_block" */
  assignment_block: Array<Assignment_Block>;
  /** fetch aggregated fields from the table: "assignment_block" */
  assignment_block_aggregate: Assignment_Block_Aggregate;
  /** fetch data from the table: "assignment_block" using primary key columns */
  assignment_block_by_pk?: Maybe<Assignment_Block>;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table: "block" */
  block: Array<Block>;
  /** fetch aggregated fields from the table: "block" */
  block_aggregate: Block_Aggregate;
  /** fetch data from the table: "block" using primary key columns */
  block_by_pk?: Maybe<Block>;
  /** fetch data from the table: "block_list_item" */
  block_list_item: Array<Block_List_Item>;
  /** fetch aggregated fields from the table: "block_list_item" */
  block_list_item_aggregate: Block_List_Item_Aggregate;
  /** fetch data from the table: "block_list_item" using primary key columns */
  block_list_item_by_pk?: Maybe<Block_List_Item>;
  /** fetch data from the table: "block_list_item_workspace" */
  block_list_item_workspace: Array<Block_List_Item_Workspace>;
  /** fetch aggregated fields from the table: "block_list_item_workspace" */
  block_list_item_workspace_aggregate: Block_List_Item_Workspace_Aggregate;
  /** fetch data from the table: "block_list_item_workspace" using primary key columns */
  block_list_item_workspace_by_pk?: Maybe<Block_List_Item_Workspace>;
  /** fetch data from the table: "block_tag" */
  block_tag: Array<Block_Tag>;
  /** fetch aggregated fields from the table: "block_tag" */
  block_tag_aggregate: Block_Tag_Aggregate;
  /** fetch data from the table: "block_tag" using primary key columns */
  block_tag_by_pk?: Maybe<Block_Tag>;
  /** fetch data from the table: "calendar_event" */
  calendar_event: Array<Calendar_Event>;
  /** fetch aggregated fields from the table: "calendar_event" */
  calendar_event_aggregate: Calendar_Event_Aggregate;
  /** fetch data from the table: "calendar_event" using primary key columns */
  calendar_event_by_pk?: Maybe<Calendar_Event>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  check_last_lesson: Scalars['Boolean'];
  /** fetch data from the table: "checkpoint" */
  checkpoint: Array<Checkpoint>;
  /** fetch aggregated fields from the table: "checkpoint" */
  checkpoint_aggregate: Checkpoint_Aggregate;
  /** An array relationship */
  checkpoint_attempts: Array<Checkpoint_Attempts>;
  /** An aggregate relationship */
  checkpoint_attempts_aggregate: Checkpoint_Attempts_Aggregate;
  /** fetch data from the table: "checkpoint_attempts" using primary key columns */
  checkpoint_attempts_by_pk?: Maybe<Checkpoint_Attempts>;
  /** fetch data from the table: "checkpoint" using primary key columns */
  checkpoint_by_pk?: Maybe<Checkpoint>;
  /** fetch data from the table: "class" */
  class: Array<Class>;
  /** fetch aggregated fields from the table: "class" */
  class_aggregate: Class_Aggregate;
  /** fetch data from the table: "class" using primary key columns */
  class_by_pk?: Maybe<Class>;
  /** fetch data from the table: "class_course" */
  class_course: Array<Class_Course>;
  /** fetch aggregated fields from the table: "class_course" */
  class_course_aggregate: Class_Course_Aggregate;
  /** fetch data from the table: "class_course" using primary key columns */
  class_course_by_pk?: Maybe<Class_Course>;
  /** fetch data from the table: "class_course_note" */
  class_course_note: Array<Class_Course_Note>;
  /** fetch aggregated fields from the table: "class_course_note" */
  class_course_note_aggregate: Class_Course_Note_Aggregate;
  /** fetch data from the table: "class_course_note" using primary key columns */
  class_course_note_by_pk?: Maybe<Class_Course_Note>;
  /** fetch data from the table: "class_course_resource" */
  class_course_resource: Array<Class_Course_Resource>;
  /** fetch aggregated fields from the table: "class_course_resource" */
  class_course_resource_aggregate: Class_Course_Resource_Aggregate;
  /** fetch data from the table: "class_course_resource" using primary key columns */
  class_course_resource_by_pk?: Maybe<Class_Course_Resource>;
  /** fetch data from the table: "classroom" */
  classroom: Array<Classroom>;
  /** fetch aggregated fields from the table: "classroom" */
  classroom_aggregate: Classroom_Aggregate;
  /** fetch data from the table: "classroom" using primary key columns */
  classroom_by_pk?: Maybe<Classroom>;
  /** fetch data from the table: "classroom_group" */
  classroom_group: Array<Classroom_Group>;
  /** fetch aggregated fields from the table: "classroom_group" */
  classroom_group_aggregate: Classroom_Group_Aggregate;
  /** fetch data from the table: "classroom_group" using primary key columns */
  classroom_group_by_pk?: Maybe<Classroom_Group>;
  /** fetch data from the table: "course" */
  course: Array<Course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: Course_Aggregate;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<Course>;
  /** fetch data from the table: "course_category" */
  course_category: Array<Course_Category>;
  /** fetch aggregated fields from the table: "course_category" */
  course_category_aggregate: Course_Category_Aggregate;
  /** fetch data from the table: "course_category" using primary key columns */
  course_category_by_pk?: Maybe<Course_Category>;
  /** fetch data from the table: "course_grade_level" */
  course_grade_level: Array<Course_Grade_Level>;
  /** fetch aggregated fields from the table: "course_grade_level" */
  course_grade_level_aggregate: Course_Grade_Level_Aggregate;
  /** fetch data from the table: "course_grade_level" using primary key columns */
  course_grade_level_by_pk?: Maybe<Course_Grade_Level>;
  /** fetch data from the table: "course_instructor" */
  course_instructor: Array<Course_Instructor>;
  /** fetch aggregated fields from the table: "course_instructor" */
  course_instructor_aggregate: Course_Instructor_Aggregate;
  /** fetch data from the table: "course_instructor" using primary key columns */
  course_instructor_by_pk?: Maybe<Course_Instructor>;
  /** fetch data from the table: "course_tag" */
  course_tag: Array<Course_Tag>;
  /** fetch aggregated fields from the table: "course_tag" */
  course_tag_aggregate: Course_Tag_Aggregate;
  /** fetch data from the table: "course_tag" using primary key columns */
  course_tag_by_pk?: Maybe<Course_Tag>;
  /** fetch data from the table: "course_workspace" */
  course_workspace: Array<Course_Workspace>;
  /** fetch aggregated fields from the table: "course_workspace" */
  course_workspace_aggregate: Course_Workspace_Aggregate;
  /** fetch data from the table: "course_workspace" using primary key columns */
  course_workspace_by_pk?: Maybe<Course_Workspace>;
  /** fetch data from the table: "dnd" */
  dnd: Array<Dnd>;
  /** fetch aggregated fields from the table: "dnd" */
  dnd_aggregate: Dnd_Aggregate;
  /** fetch data from the table: "dnd" using primary key columns */
  dnd_by_pk?: Maybe<Dnd>;
  /** fetch data from the table: "event_classroom" */
  event_classroom: Array<Event_Classroom>;
  /** fetch aggregated fields from the table: "event_classroom" */
  event_classroom_aggregate: Event_Classroom_Aggregate;
  /** fetch data from the table: "event_classroom" using primary key columns */
  event_classroom_by_pk?: Maybe<Event_Classroom>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table: "fill_blank" */
  fill_blank: Array<Fill_Blank>;
  /** fetch aggregated fields from the table: "fill_blank" */
  fill_blank_aggregate: Fill_Blank_Aggregate;
  /** fetch data from the table: "fill_blank" using primary key columns */
  fill_blank_by_pk?: Maybe<Fill_Blank>;
  get_user_profile?: Maybe<UserProfileOutput>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table: "grade_level" */
  grade_level: Array<Grade_Level>;
  /** fetch aggregated fields from the table: "grade_level" */
  grade_level_aggregate: Grade_Level_Aggregate;
  /** fetch data from the table: "grade_level" using primary key columns */
  grade_level_by_pk?: Maybe<Grade_Level>;
  /** fetch data from the table: "grade_level_group" */
  grade_level_group: Array<Grade_Level_Group>;
  /** fetch aggregated fields from the table: "grade_level_group" */
  grade_level_group_aggregate: Grade_Level_Group_Aggregate;
  /** fetch data from the table: "grade_level_group" using primary key columns */
  grade_level_group_by_pk?: Maybe<Grade_Level_Group>;
  /** fetch data from the table: "grade_value" */
  grade_value: Array<Grade_Value>;
  /** fetch aggregated fields from the table: "grade_value" */
  grade_value_aggregate: Grade_Value_Aggregate;
  /** fetch data from the table: "grade_value" using primary key columns */
  grade_value_by_pk?: Maybe<Grade_Value>;
  /** fetch data from the table: "gradebook" */
  gradebook: Array<Gradebook>;
  /** fetch aggregated fields from the table: "gradebook" */
  gradebook_aggregate: Gradebook_Aggregate;
  /** fetch data from the table: "gradebook" using primary key columns */
  gradebook_by_pk?: Maybe<Gradebook>;
  /** fetch data from the table: "group" */
  group: Array<Group>;
  /** fetch aggregated fields from the table: "group" */
  group_aggregate: Group_Aggregate;
  /** fetch data from the table: "group" using primary key columns */
  group_by_pk?: Maybe<Group>;
  /** fetch data from the table: "group_course" */
  group_course: Array<Group_Course>;
  /** fetch aggregated fields from the table: "group_course" */
  group_course_aggregate: Group_Course_Aggregate;
  /** fetch data from the table: "group_course" using primary key columns */
  group_course_by_pk?: Maybe<Group_Course>;
  /** fetch data from the table: "group_workspace" */
  group_workspace: Array<Group_Workspace>;
  /** fetch aggregated fields from the table: "group_workspace" */
  group_workspace_aggregate: Group_Workspace_Aggregate;
  /** fetch data from the table: "group_workspace" using primary key columns */
  group_workspace_by_pk?: Maybe<Group_Workspace>;
  /** fetch data from the table: "installment" */
  installment: Array<Installment>;
  /** fetch aggregated fields from the table: "installment" */
  installment_aggregate: Installment_Aggregate;
  /** fetch data from the table: "installment" using primary key columns */
  installment_by_pk?: Maybe<Installment>;
  /** fetch data from the table: "instructor" */
  instructor: Array<Instructor>;
  /** fetch aggregated fields from the table: "instructor" */
  instructor_aggregate: Instructor_Aggregate;
  /** fetch data from the table: "instructor" using primary key columns */
  instructor_by_pk?: Maybe<Instructor>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "invoice_installment" */
  invoice_installment: Array<Invoice_Installment>;
  /** fetch aggregated fields from the table: "invoice_installment" */
  invoice_installment_aggregate: Invoice_Installment_Aggregate;
  /** fetch data from the table: "invoice_installment" using primary key columns */
  invoice_installment_by_pk?: Maybe<Invoice_Installment>;
  /** fetch data from the table: "lecture" */
  lecture: Array<Lecture>;
  /** fetch aggregated fields from the table: "lecture" */
  lecture_aggregate: Lecture_Aggregate;
  /** fetch data from the table: "lecture" using primary key columns */
  lecture_by_pk?: Maybe<Lecture>;
  /** fetch data from the table: "lecture_note" */
  lecture_note: Array<Lecture_Note>;
  /** fetch aggregated fields from the table: "lecture_note" */
  lecture_note_aggregate: Lecture_Note_Aggregate;
  /** fetch data from the table: "lecture_note" using primary key columns */
  lecture_note_by_pk?: Maybe<Lecture_Note>;
  /** fetch data from the table: "lecture_resource" */
  lecture_resource: Array<Lecture_Resource>;
  /** fetch aggregated fields from the table: "lecture_resource" */
  lecture_resource_aggregate: Lecture_Resource_Aggregate;
  /** fetch data from the table: "lecture_resource" using primary key columns */
  lecture_resource_by_pk?: Maybe<Lecture_Resource>;
  /** fetch data from the table: "lesson" */
  lesson: Array<Lesson>;
  /** fetch aggregated fields from the table: "lesson" */
  lesson_aggregate: Lesson_Aggregate;
  /** fetch data from the table: "lesson" using primary key columns */
  lesson_by_pk?: Maybe<Lesson>;
  /** fetch data from the table: "level" */
  level: Array<Level>;
  /** fetch aggregated fields from the table: "level" */
  level_aggregate: Level_Aggregate;
  /** fetch data from the table: "level" using primary key columns */
  level_by_pk?: Maybe<Level>;
  list_cognito_users?: Maybe<ListCognitoOutput>;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table: "progression" */
  progression: Array<Progression>;
  /** fetch aggregated fields from the table: "progression" */
  progression_aggregate: Progression_Aggregate;
  /** fetch data from the table: "progression" using primary key columns */
  progression_by_pk?: Maybe<Progression>;
  progression_get_one?: Maybe<NavigateLessonOutput>;
  /** fetch data from the table: "question" */
  question: Array<Question>;
  /** fetch aggregated fields from the table: "question" */
  question_aggregate: Question_Aggregate;
  /** fetch data from the table: "question" using primary key columns */
  question_by_pk?: Maybe<Question>;
  /** fetch data from the table: "question_option" */
  question_option: Array<Question_Option>;
  /** fetch aggregated fields from the table: "question_option" */
  question_option_aggregate: Question_Option_Aggregate;
  /** fetch data from the table: "question_option" using primary key columns */
  question_option_by_pk?: Maybe<Question_Option>;
  /** fetch data from the table: "question_quiz" */
  question_quiz: Array<Question_Quiz>;
  /** fetch aggregated fields from the table: "question_quiz" */
  question_quiz_aggregate: Question_Quiz_Aggregate;
  /** fetch data from the table: "question_quiz" using primary key columns */
  question_quiz_by_pk?: Maybe<Question_Quiz>;
  /** fetch data from the table: "question_tag" */
  question_tag: Array<Question_Tag>;
  /** fetch aggregated fields from the table: "question_tag" */
  question_tag_aggregate: Question_Tag_Aggregate;
  /** fetch data from the table: "question_tag" using primary key columns */
  question_tag_by_pk?: Maybe<Question_Tag>;
  /** fetch data from the table: "question_workspace" */
  question_workspace: Array<Question_Workspace>;
  /** fetch aggregated fields from the table: "question_workspace" */
  question_workspace_aggregate: Question_Workspace_Aggregate;
  /** fetch data from the table: "question_workspace" using primary key columns */
  question_workspace_by_pk?: Maybe<Question_Workspace>;
  /** fetch data from the table: "quiz" */
  quiz: Array<Quiz>;
  /** fetch aggregated fields from the table: "quiz" */
  quiz_aggregate: Quiz_Aggregate;
  /** fetch data from the table: "quiz" using primary key columns */
  quiz_by_pk?: Maybe<Quiz>;
  /** fetch data from the table: "recurring_event" */
  recurring_event: Array<Recurring_Event>;
  /** fetch aggregated fields from the table: "recurring_event" */
  recurring_event_aggregate: Recurring_Event_Aggregate;
  /** fetch data from the table: "recurring_event" using primary key columns */
  recurring_event_by_pk?: Maybe<Recurring_Event>;
  /** fetch data from the table: "school_fee" */
  school_fee: Array<School_Fee>;
  /** fetch aggregated fields from the table: "school_fee" */
  school_fee_aggregate: School_Fee_Aggregate;
  /** fetch data from the table: "school_fee" using primary key columns */
  school_fee_by_pk?: Maybe<School_Fee>;
  /** fetch data from the table: "school_period" */
  school_period: Array<School_Period>;
  /** fetch aggregated fields from the table: "school_period" */
  school_period_aggregate: School_Period_Aggregate;
  /** fetch data from the table: "school_period" using primary key columns */
  school_period_by_pk?: Maybe<School_Period>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table: "text" */
  text: Array<Text>;
  /** fetch aggregated fields from the table: "text" */
  text_aggregate: Text_Aggregate;
  /** fetch data from the table: "text" using primary key columns */
  text_by_pk?: Maybe<Text>;
  /** fetch data from the table: "typeorm_metadata" */
  typeorm_metadata: Array<Typeorm_Metadata>;
  /** fetch aggregated fields from the table: "typeorm_metadata" */
  typeorm_metadata_aggregate: Typeorm_Metadata_Aggregate;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_activity" */
  user_activity: Array<User_Activity>;
  /** fetch aggregated fields from the table: "user_activity" */
  user_activity_aggregate: User_Activity_Aggregate;
  /** fetch data from the table: "user_activity" using primary key columns */
  user_activity_by_pk?: Maybe<User_Activity>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_assignment" */
  user_assignment: Array<User_Assignment>;
  /** fetch data from the table: "user_assignment_activity" */
  user_assignment_activity: Array<User_Assignment_Activity>;
  /** fetch aggregated fields from the table: "user_assignment_activity" */
  user_assignment_activity_aggregate: User_Assignment_Activity_Aggregate;
  /** fetch data from the table: "user_assignment_activity" using primary key columns */
  user_assignment_activity_by_pk?: Maybe<User_Assignment_Activity>;
  /** fetch aggregated fields from the table: "user_assignment" */
  user_assignment_aggregate: User_Assignment_Aggregate;
  /** fetch data from the table: "user_assignment" using primary key columns */
  user_assignment_by_pk?: Maybe<User_Assignment>;
  /** fetch data from the table: "user_block" */
  user_block: Array<User_Block>;
  /** fetch aggregated fields from the table: "user_block" */
  user_block_aggregate: User_Block_Aggregate;
  /** fetch data from the table: "user_block" using primary key columns */
  user_block_by_pk?: Maybe<User_Block>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_checkpoint" */
  user_checkpoint: Array<User_Checkpoint>;
  /** fetch aggregated fields from the table: "user_checkpoint" */
  user_checkpoint_aggregate: User_Checkpoint_Aggregate;
  /** fetch data from the table: "user_checkpoint" using primary key columns */
  user_checkpoint_by_pk?: Maybe<User_Checkpoint>;
  /** fetch data from the table: "user_class" */
  user_class: Array<User_Class>;
  /** fetch aggregated fields from the table: "user_class" */
  user_class_aggregate: User_Class_Aggregate;
  /** fetch data from the table: "user_class" using primary key columns */
  user_class_by_pk?: Maybe<User_Class>;
  /** fetch data from the table: "user_course" */
  user_course: Array<User_Course>;
  /** fetch aggregated fields from the table: "user_course" */
  user_course_aggregate: User_Course_Aggregate;
  /** fetch data from the table: "user_course" using primary key columns */
  user_course_by_pk?: Maybe<User_Course>;
  /** fetch data from the table: "user_event" */
  user_event: Array<User_Event>;
  /** fetch aggregated fields from the table: "user_event" */
  user_event_aggregate: User_Event_Aggregate;
  /** fetch data from the table: "user_event" using primary key columns */
  user_event_by_pk?: Maybe<User_Event>;
  /** fetch data from the table: "user_group" */
  user_group: Array<User_Group>;
  /** fetch aggregated fields from the table: "user_group" */
  user_group_aggregate: User_Group_Aggregate;
  /** fetch data from the table: "user_group" using primary key columns */
  user_group_by_pk?: Maybe<User_Group>;
  /** fetch data from the table: "user_lecture" */
  user_lecture: Array<User_Lecture>;
  /** fetch aggregated fields from the table: "user_lecture" */
  user_lecture_aggregate: User_Lecture_Aggregate;
  /** fetch data from the table: "user_lecture" using primary key columns */
  user_lecture_by_pk?: Maybe<User_Lecture>;
  /** fetch data from the table: "user_workspace" */
  user_workspace: Array<User_Workspace>;
  /** fetch aggregated fields from the table: "user_workspace" */
  user_workspace_aggregate: User_Workspace_Aggregate;
  /** fetch data from the table: "user_workspace" using primary key columns */
  user_workspace_by_pk?: Maybe<User_Workspace>;
  /** fetch data from the table: "workspace" */
  workspace: Array<Workspace>;
  /** fetch aggregated fields from the table: "workspace" */
  workspace_aggregate: Workspace_Aggregate;
  /** fetch data from the table: "workspace" using primary key columns */
  workspace_by_pk?: Maybe<Workspace>;
};


export type Query_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActivity_LayoutArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


export type Query_RootActivity_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


export type Query_RootActivity_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


export type Query_RootAssignment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


export type Query_RootAssignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_BlockArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


export type Query_RootAssignment_Block_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


export type Query_RootAssignment_Block_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAssignment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBlockArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


export type Query_RootBlock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


export type Query_RootBlock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBlock_List_ItemArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


export type Query_RootBlock_List_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


export type Query_RootBlock_List_Item_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBlock_List_Item_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


export type Query_RootBlock_List_Item_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


export type Query_RootBlock_List_Item_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBlock_TagArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


export type Query_RootBlock_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


export type Query_RootBlock_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCalendar_EventArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


export type Query_RootCalendar_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


export type Query_RootCalendar_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCheck_Last_LessonArgs = {
  lessonId: Scalars['Int'];
  progressionId: Scalars['Int'];
};


export type Query_RootCheckpointArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


export type Query_RootCheckpoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


export type Query_RootCheckpoint_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


export type Query_RootCheckpoint_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


export type Query_RootCheckpoint_Attempts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCheckpoint_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClassArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


export type Query_RootClass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


export type Query_RootClass_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClass_CourseArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


export type Query_RootClass_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


export type Query_RootClass_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClass_Course_NoteArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


export type Query_RootClass_Course_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


export type Query_RootClass_Course_Note_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClass_Course_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


export type Query_RootClass_Course_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


export type Query_RootClass_Course_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClassroomArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


export type Query_RootClassroom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


export type Query_RootClassroom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClassroom_GroupArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


export type Query_RootClassroom_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


export type Query_RootClassroom_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Query_RootCourse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Query_RootCourse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


export type Query_RootCourse_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


export type Query_RootCourse_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_Grade_LevelArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


export type Query_RootCourse_Grade_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


export type Query_RootCourse_Grade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_InstructorArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


export type Query_RootCourse_Instructor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


export type Query_RootCourse_Instructor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_TagArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


export type Query_RootCourse_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


export type Query_RootCourse_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


export type Query_RootCourse_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


export type Query_RootCourse_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDndArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


export type Query_RootDnd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


export type Query_RootDnd_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEvent_ClassroomArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


export type Query_RootEvent_Classroom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


export type Query_RootEvent_Classroom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFill_BlankArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


export type Query_RootFill_Blank_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


export type Query_RootFill_Blank_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGrade_LevelArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


export type Query_RootGrade_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


export type Query_RootGrade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGrade_Level_GroupArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


export type Query_RootGrade_Level_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


export type Query_RootGrade_Level_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGrade_ValueArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


export type Query_RootGrade_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


export type Query_RootGrade_Value_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGradebookArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


export type Query_RootGradebook_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


export type Query_RootGradebook_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGroupArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


export type Query_RootGroup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


export type Query_RootGroup_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGroup_CourseArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


export type Query_RootGroup_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


export type Query_RootGroup_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGroup_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


export type Query_RootGroup_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


export type Query_RootGroup_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInstallmentArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


export type Query_RootInstallment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


export type Query_RootInstallment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInstructorArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


export type Query_RootInstructor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


export type Query_RootInstructor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvoice_InstallmentArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


export type Query_RootInvoice_Installment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


export type Query_RootInvoice_Installment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLectureArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


export type Query_RootLecture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


export type Query_RootLecture_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLecture_NoteArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


export type Query_RootLecture_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


export type Query_RootLecture_Note_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLecture_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


export type Query_RootLecture_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


export type Query_RootLecture_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLessonArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


export type Query_RootLesson_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


export type Query_RootLesson_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLevelArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


export type Query_RootLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


export type Query_RootLevel_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootList_Cognito_UsersArgs = {
  Limit: Scalars['Int'];
  PaginationToken?: InputMaybe<Scalars['String']>;
  UsernameFilter?: InputMaybe<Scalars['String']>;
};


export type Query_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProgressionArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


export type Query_RootProgression_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


export type Query_RootProgression_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProgression_Get_OneArgs = {
  progressionId: Scalars['Int'];
};


export type Query_RootQuestionArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


export type Query_RootQuestion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


export type Query_RootQuestion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestion_OptionArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


export type Query_RootQuestion_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


export type Query_RootQuestion_Option_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestion_QuizArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


export type Query_RootQuestion_Quiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


export type Query_RootQuestion_Quiz_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestion_TagArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


export type Query_RootQuestion_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


export type Query_RootQuestion_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestion_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


export type Query_RootQuestion_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


export type Query_RootQuestion_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuizArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


export type Query_RootQuiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


export type Query_RootQuiz_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRecurring_EventArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


export type Query_RootRecurring_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


export type Query_RootRecurring_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSchool_FeeArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


export type Query_RootSchool_Fee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


export type Query_RootSchool_Fee_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSchool_PeriodArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


export type Query_RootSchool_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


export type Query_RootSchool_Period_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTextArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


export type Query_RootText_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


export type Query_RootText_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTypeorm_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Typeorm_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Typeorm_Metadata_Order_By>>;
  where?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
};


export type Query_RootTypeorm_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Typeorm_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Typeorm_Metadata_Order_By>>;
  where?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
};


export type Query_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type Query_RootUser_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type Query_RootUser_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


export type Query_RootUser_Assignment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


export type Query_RootUser_Assignment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


export type Query_RootUser_Assignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


export type Query_RootUser_Assignment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_BlockArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


export type Query_RootUser_Block_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


export type Query_RootUser_Block_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_CheckpointArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


export type Query_RootUser_Checkpoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


export type Query_RootUser_Checkpoint_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_ClassArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


export type Query_RootUser_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


export type Query_RootUser_Class_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_CourseArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


export type Query_RootUser_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


export type Query_RootUser_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_EventArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


export type Query_RootUser_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


export type Query_RootUser_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_GroupArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Query_RootUser_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Query_RootUser_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_LectureArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


export type Query_RootUser_Lecture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


export type Query_RootUser_Lecture_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


export type Query_RootUser_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


export type Query_RootUser_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};


export type Query_RootWorkspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};


export type Query_RootWorkspace_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "question" */
export type Question = {
  __typename?: 'question';
  correctAnswerId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  dnd?: Maybe<Dnd>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  fill_blank?: Maybe<Fill_Blank>;
  hasMath: Scalars['Boolean'];
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  question_option?: Maybe<Question_Option>;
  /** An array relationship */
  question_options: Array<Question_Option>;
  /** An aggregate relationship */
  question_options_aggregate: Question_Option_Aggregate;
  /** An array relationship */
  question_quizzes: Array<Question_Quiz>;
  /** An aggregate relationship */
  question_quizzes_aggregate: Question_Quiz_Aggregate;
  /** An array relationship */
  question_tags: Array<Question_Tag>;
  /** An aggregate relationship */
  question_tags_aggregate: Question_Tag_Aggregate;
  /** An array relationship */
  question_workspaces: Array<Question_Workspace>;
  /** An aggregate relationship */
  question_workspaces_aggregate: Question_Workspace_Aggregate;
  /** An object relationship */
  quiz?: Maybe<Quiz>;
  quizId?: Maybe<Scalars['Int']>;
  type: Scalars['question_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  weight: Scalars['Int'];
};


/** columns and relationships of "question" */
export type QuestionQuestion_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_TagsArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


/** columns and relationships of "question" */
export type QuestionQuestion_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};

/** aggregated selection of "question" */
export type Question_Aggregate = {
  __typename?: 'question_aggregate';
  aggregate?: Maybe<Question_Aggregate_Fields>;
  nodes: Array<Question>;
};

export type Question_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Question_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Question_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Question_Aggregate_Bool_Exp_Count>;
};

export type Question_Aggregate_Bool_Exp_Bool_And = {
  arguments: Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question" */
export type Question_Aggregate_Fields = {
  __typename?: 'question_aggregate_fields';
  avg?: Maybe<Question_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Question_Max_Fields>;
  min?: Maybe<Question_Min_Fields>;
  stddev?: Maybe<Question_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Sum_Fields>;
  var_pop?: Maybe<Question_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Var_Samp_Fields>;
  variance?: Maybe<Question_Variance_Fields>;
};


/** aggregate fields of "question" */
export type Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question" */
export type Question_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Max_Order_By>;
  min?: InputMaybe<Question_Min_Order_By>;
  stddev?: InputMaybe<Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question" */
export type Question_Arr_Rel_Insert_Input = {
  data: Array<Question_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Avg_Fields = {
  __typename?: 'question_avg_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question" */
export type Question_Avg_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question". All fields are combined with a logical 'AND'. */
export type Question_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Bool_Exp>>;
  _not?: InputMaybe<Question_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Bool_Exp>>;
  correctAnswerId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  dnd?: InputMaybe<Dnd_Bool_Exp>;
  dndId?: InputMaybe<Int_Comparison_Exp>;
  fillBlankId?: InputMaybe<Int_Comparison_Exp>;
  fill_blank?: InputMaybe<Fill_Blank_Bool_Exp>;
  hasMath?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  mediaId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_option?: InputMaybe<Question_Option_Bool_Exp>;
  question_options?: InputMaybe<Question_Option_Bool_Exp>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Bool_Exp>;
  question_quizzes?: InputMaybe<Question_Quiz_Bool_Exp>;
  question_quizzes_aggregate?: InputMaybe<Question_Quiz_Aggregate_Bool_Exp>;
  question_tags?: InputMaybe<Question_Tag_Bool_Exp>;
  question_tags_aggregate?: InputMaybe<Question_Tag_Aggregate_Bool_Exp>;
  question_workspaces?: InputMaybe<Question_Workspace_Bool_Exp>;
  question_workspaces_aggregate?: InputMaybe<Question_Workspace_Aggregate_Bool_Exp>;
  quiz?: InputMaybe<Quiz_Bool_Exp>;
  quizId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Question_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "question" */
export const enum Question_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_21e5786aa0ea704ae185a79b2d5 = 'PK_21e5786aa0ea704ae185a79b2d5',
  /** unique or primary key constraint on columns "uid" */
  Uq_4320302ff37e4ded3fe363ca630 = 'UQ_4320302ff37e4ded3fe363ca630'
};

/** input type for incrementing numeric columns in table "question" */
export type Question_Inc_Input = {
  correctAnswerId?: InputMaybe<Scalars['Int']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question" */
export type Question_Insert_Input = {
  correctAnswerId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dnd?: InputMaybe<Dnd_Obj_Rel_Insert_Input>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  fill_blank?: InputMaybe<Fill_Blank_Obj_Rel_Insert_Input>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_option?: InputMaybe<Question_Option_Obj_Rel_Insert_Input>;
  question_options?: InputMaybe<Question_Option_Arr_Rel_Insert_Input>;
  question_quizzes?: InputMaybe<Question_Quiz_Arr_Rel_Insert_Input>;
  question_tags?: InputMaybe<Question_Tag_Arr_Rel_Insert_Input>;
  question_workspaces?: InputMaybe<Question_Workspace_Arr_Rel_Insert_Input>;
  quiz?: InputMaybe<Quiz_Obj_Rel_Insert_Input>;
  quizId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['question_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Question_Max_Fields = {
  __typename?: 'question_max_fields';
  correctAnswerId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['question_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "question" */
export type Question_Max_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Min_Fields = {
  __typename?: 'question_min_fields';
  correctAnswerId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['question_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "question" */
export type Question_Min_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question" */
export type Question_Mutation_Response = {
  __typename?: 'question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question>;
};

/** input type for inserting object relation for remote table "question" */
export type Question_Obj_Rel_Insert_Input = {
  data: Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_On_Conflict>;
};

/** on_conflict condition type for table "question" */
export type Question_On_Conflict = {
  constraint: Question_Constraint;
  update_columns?: Array<Question_Update_Column>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** columns and relationships of "question_option" */
export type Question_Option = {
  __typename?: 'question_option';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  dnd?: Maybe<Dnd>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  fill_blank?: Maybe<Fill_Blank>;
  hasMath: Scalars['Boolean'];
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']>;
  order: Scalars['String'];
  /** An object relationship */
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  rightAnswer: Scalars['Boolean'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  weight: Scalars['Int'];
};


/** columns and relationships of "question_option" */
export type Question_OptionQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "question_option" */
export type Question_OptionQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** aggregated selection of "question_option" */
export type Question_Option_Aggregate = {
  __typename?: 'question_option_aggregate';
  aggregate?: Maybe<Question_Option_Aggregate_Fields>;
  nodes: Array<Question_Option>;
};

export type Question_Option_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Question_Option_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Question_Option_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Question_Option_Aggregate_Bool_Exp_Count>;
};

export type Question_Option_Aggregate_Bool_Exp_Bool_And = {
  arguments: Question_Option_Select_Column_Question_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Option_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Question_Option_Select_Column_Question_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Option_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Option_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question_option" */
export type Question_Option_Aggregate_Fields = {
  __typename?: 'question_option_aggregate_fields';
  avg?: Maybe<Question_Option_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Question_Option_Max_Fields>;
  min?: Maybe<Question_Option_Min_Fields>;
  stddev?: Maybe<Question_Option_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Option_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Option_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Option_Sum_Fields>;
  var_pop?: Maybe<Question_Option_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Option_Var_Samp_Fields>;
  variance?: Maybe<Question_Option_Variance_Fields>;
};


/** aggregate fields of "question_option" */
export type Question_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_option" */
export type Question_Option_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Option_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Option_Max_Order_By>;
  min?: InputMaybe<Question_Option_Min_Order_By>;
  stddev?: InputMaybe<Question_Option_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Option_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Option_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Option_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Option_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Option_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Option_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_option" */
export type Question_Option_Arr_Rel_Insert_Input = {
  data: Array<Question_Option_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Option_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Option_Avg_Fields = {
  __typename?: 'question_option_avg_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_option" */
export type Question_Option_Avg_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_option". All fields are combined with a logical 'AND'. */
export type Question_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Option_Bool_Exp>>;
  _not?: InputMaybe<Question_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Option_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  dnd?: InputMaybe<Dnd_Bool_Exp>;
  dndId?: InputMaybe<Int_Comparison_Exp>;
  fillBlankId?: InputMaybe<Int_Comparison_Exp>;
  fill_blank?: InputMaybe<Fill_Blank_Bool_Exp>;
  hasMath?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  mediaId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<String_Comparison_Exp>;
  question?: InputMaybe<Question_Bool_Exp>;
  questionId?: InputMaybe<Int_Comparison_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  rightAnswer?: InputMaybe<Boolean_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_option" */
export const enum Question_Option_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_64f8e42188891f2b0610017c8f9 = 'PK_64f8e42188891f2b0610017c8f9',
  /** unique or primary key constraint on columns "uid" */
  Uq_6d5803f20971e895ba05340074d = 'UQ_6d5803f20971e895ba05340074d'
};

/** input type for incrementing numeric columns in table "question_option" */
export type Question_Option_Inc_Input = {
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_option" */
export type Question_Option_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dnd?: InputMaybe<Dnd_Obj_Rel_Insert_Input>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  fill_blank?: InputMaybe<Fill_Blank_Obj_Rel_Insert_Input>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  rightAnswer?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Question_Option_Max_Fields = {
  __typename?: 'question_option_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "question_option" */
export type Question_Option_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Option_Min_Fields = {
  __typename?: 'question_option_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "question_option" */
export type Question_Option_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_option" */
export type Question_Option_Mutation_Response = {
  __typename?: 'question_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Option>;
};

/** input type for inserting object relation for remote table "question_option" */
export type Question_Option_Obj_Rel_Insert_Input = {
  data: Question_Option_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Option_On_Conflict>;
};

/** on_conflict condition type for table "question_option" */
export type Question_Option_On_Conflict = {
  constraint: Question_Option_Constraint;
  update_columns?: Array<Question_Option_Update_Column>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "question_option". */
export type Question_Option_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  dnd?: InputMaybe<Dnd_Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  fill_blank?: InputMaybe<Fill_Blank_Order_By>;
  hasMath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Question_Order_By>;
  questionId?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  rightAnswer?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_option */
export type Question_Option_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "question_option" */
export const enum Question_Option_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  RightAnswer = 'rightAnswer',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
};

/** select "question_option_aggregate_bool_exp_bool_and_arguments_columns" columns of table "question_option" */
export const enum Question_Option_Select_Column_Question_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  RightAnswer = 'rightAnswer'
};

/** select "question_option_aggregate_bool_exp_bool_or_arguments_columns" columns of table "question_option" */
export const enum Question_Option_Select_Column_Question_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  RightAnswer = 'rightAnswer'
};

/** input type for updating data in table "question_option" */
export type Question_Option_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['Int']>;
  rightAnswer?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Question_Option_Stddev_Fields = {
  __typename?: 'question_option_stddev_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_option" */
export type Question_Option_Stddev_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Option_Stddev_Pop_Fields = {
  __typename?: 'question_option_stddev_pop_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_option" */
export type Question_Option_Stddev_Pop_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Option_Stddev_Samp_Fields = {
  __typename?: 'question_option_stddev_samp_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_option" */
export type Question_Option_Stddev_Samp_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question_option" */
export type Question_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Option_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['Int']>;
  rightAnswer?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Question_Option_Sum_Fields = {
  __typename?: 'question_option_sum_fields';
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_option" */
export type Question_Option_Sum_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "question_option" */
export const enum Question_Option_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  RightAnswer = 'rightAnswer',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
};

export type Question_Option_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Option_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Option_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Option_Var_Pop_Fields = {
  __typename?: 'question_option_var_pop_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_option" */
export type Question_Option_Var_Pop_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Option_Var_Samp_Fields = {
  __typename?: 'question_option_var_samp_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_option" */
export type Question_Option_Var_Samp_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Option_Variance_Fields = {
  __typename?: 'question_option_variance_fields';
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_option" */
export type Question_Option_Variance_Order_By = {
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "question". */
export type Question_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  dnd?: InputMaybe<Dnd_Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  fill_blank?: InputMaybe<Fill_Blank_Order_By>;
  hasMath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  mediaId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_option?: InputMaybe<Question_Option_Order_By>;
  question_options_aggregate?: InputMaybe<Question_Option_Aggregate_Order_By>;
  question_quizzes_aggregate?: InputMaybe<Question_Quiz_Aggregate_Order_By>;
  question_tags_aggregate?: InputMaybe<Question_Tag_Aggregate_Order_By>;
  question_workspaces_aggregate?: InputMaybe<Question_Workspace_Aggregate_Order_By>;
  quiz?: InputMaybe<Quiz_Order_By>;
  quizId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question */
export type Question_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "question_quiz" */
export type Question_Quiz = {
  __typename?: 'question_quiz';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  /** An object relationship */
  question: Question;
  questionId: Scalars['Int'];
  /** An object relationship */
  quiz: Quiz;
  quizId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "question_quiz" */
export type Question_Quiz_Aggregate = {
  __typename?: 'question_quiz_aggregate';
  aggregate?: Maybe<Question_Quiz_Aggregate_Fields>;
  nodes: Array<Question_Quiz>;
};

export type Question_Quiz_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Question_Quiz_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Question_Quiz_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Question_Quiz_Aggregate_Bool_Exp_Count>;
};

export type Question_Quiz_Aggregate_Bool_Exp_Bool_And = {
  arguments: Question_Quiz_Select_Column_Question_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Quiz_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Question_Quiz_Select_Column_Question_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Quiz_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Quiz_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question_quiz" */
export type Question_Quiz_Aggregate_Fields = {
  __typename?: 'question_quiz_aggregate_fields';
  avg?: Maybe<Question_Quiz_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Question_Quiz_Max_Fields>;
  min?: Maybe<Question_Quiz_Min_Fields>;
  stddev?: Maybe<Question_Quiz_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Quiz_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Quiz_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Quiz_Sum_Fields>;
  var_pop?: Maybe<Question_Quiz_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Quiz_Var_Samp_Fields>;
  variance?: Maybe<Question_Quiz_Variance_Fields>;
};


/** aggregate fields of "question_quiz" */
export type Question_Quiz_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_quiz" */
export type Question_Quiz_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Quiz_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Quiz_Max_Order_By>;
  min?: InputMaybe<Question_Quiz_Min_Order_By>;
  stddev?: InputMaybe<Question_Quiz_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Quiz_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Quiz_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Quiz_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Quiz_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Quiz_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Quiz_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_quiz" */
export type Question_Quiz_Arr_Rel_Insert_Input = {
  data: Array<Question_Quiz_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Quiz_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Quiz_Avg_Fields = {
  __typename?: 'question_quiz_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_quiz" */
export type Question_Quiz_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_quiz". All fields are combined with a logical 'AND'. */
export type Question_Quiz_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Quiz_Bool_Exp>>;
  _not?: InputMaybe<Question_Quiz_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Quiz_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Question_Bool_Exp>;
  questionId?: InputMaybe<Int_Comparison_Exp>;
  quiz?: InputMaybe<Quiz_Bool_Exp>;
  quizId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_quiz" */
export const enum Question_Quiz_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAecfc55f7d8e7bb703193e03118 = 'PK_aecfc55f7d8e7bb703193e03118',
  /** unique or primary key constraint on columns "uid" */
  Uq_15729db3dcc732df43cc364beb4 = 'UQ_15729db3dcc732df43cc364beb4'
};

/** input type for incrementing numeric columns in table "question_quiz" */
export type Question_Quiz_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_quiz" */
export type Question_Quiz_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['Int']>;
  quiz?: InputMaybe<Quiz_Obj_Rel_Insert_Input>;
  quizId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Question_Quiz_Max_Fields = {
  __typename?: 'question_quiz_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "question_quiz" */
export type Question_Quiz_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Quiz_Min_Fields = {
  __typename?: 'question_quiz_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "question_quiz" */
export type Question_Quiz_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_quiz" */
export type Question_Quiz_Mutation_Response = {
  __typename?: 'question_quiz_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Quiz>;
};

/** on_conflict condition type for table "question_quiz" */
export type Question_Quiz_On_Conflict = {
  constraint: Question_Quiz_Constraint;
  update_columns?: Array<Question_Quiz_Update_Column>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};

/** Ordering options when selecting data from "question_quiz". */
export type Question_Quiz_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Question_Order_By>;
  questionId?: InputMaybe<Order_By>;
  quiz?: InputMaybe<Quiz_Order_By>;
  quizId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_quiz */
export type Question_Quiz_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "question_quiz" */
export const enum Question_Quiz_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "question_quiz_aggregate_bool_exp_bool_and_arguments_columns" columns of table "question_quiz" */
export const enum Question_Quiz_Select_Column_Question_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "question_quiz_aggregate_bool_exp_bool_or_arguments_columns" columns of table "question_quiz" */
export const enum Question_Quiz_Select_Column_Question_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "question_quiz" */
export type Question_Quiz_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Question_Quiz_Stddev_Fields = {
  __typename?: 'question_quiz_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_quiz" */
export type Question_Quiz_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Quiz_Stddev_Pop_Fields = {
  __typename?: 'question_quiz_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_quiz" */
export type Question_Quiz_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Quiz_Stddev_Samp_Fields = {
  __typename?: 'question_quiz_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_quiz" */
export type Question_Quiz_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question_quiz" */
export type Question_Quiz_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Quiz_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Quiz_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Question_Quiz_Sum_Fields = {
  __typename?: 'question_quiz_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_quiz" */
export type Question_Quiz_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** update columns of table "question_quiz" */
export const enum Question_Quiz_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Question_Quiz_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Quiz_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Quiz_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Quiz_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Quiz_Var_Pop_Fields = {
  __typename?: 'question_quiz_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_quiz" */
export type Question_Quiz_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Quiz_Var_Samp_Fields = {
  __typename?: 'question_quiz_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_quiz" */
export type Question_Quiz_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Quiz_Variance_Fields = {
  __typename?: 'question_quiz_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_quiz" */
export type Question_Quiz_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
};

/** select columns of table "question" */
export const enum Question_Select_Column {
  /** column name */
  CorrectAnswerId = 'correctAnswerId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
};

/** select "question_aggregate_bool_exp_bool_and_arguments_columns" columns of table "question" */
export const enum Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HasMath = 'hasMath'
};

/** select "question_aggregate_bool_exp_bool_or_arguments_columns" columns of table "question" */
export const enum Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HasMath = 'hasMath'
};

/** input type for updating data in table "question" */
export type Question_Set_Input = {
  correctAnswerId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['question_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Question_Stddev_Fields = {
  __typename?: 'question_stddev_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question" */
export type Question_Stddev_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Stddev_Pop_Fields = {
  __typename?: 'question_stddev_pop_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question" */
export type Question_Stddev_Pop_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Stddev_Samp_Fields = {
  __typename?: 'question_stddev_samp_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question" */
export type Question_Stddev_Samp_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question" */
export type Question_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Stream_Cursor_Value_Input = {
  correctAnswerId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  dndId?: InputMaybe<Scalars['Int']>;
  fillBlankId?: InputMaybe<Scalars['Int']>;
  hasMath?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['question_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Question_Sum_Fields = {
  __typename?: 'question_sum_fields';
  correctAnswerId?: Maybe<Scalars['Int']>;
  dndId?: Maybe<Scalars['Int']>;
  fillBlankId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mediaId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question" */
export type Question_Sum_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_tag" */
export type Question_Tag = {
  __typename?: 'question_tag';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  tag: Tag;
  tagId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "question_tag" */
export type Question_Tag_Aggregate = {
  __typename?: 'question_tag_aggregate';
  aggregate?: Maybe<Question_Tag_Aggregate_Fields>;
  nodes: Array<Question_Tag>;
};

export type Question_Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Question_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Question_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Question_Tag_Aggregate_Bool_Exp_Count>;
};

export type Question_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Question_Tag_Select_Column_Question_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Question_Tag_Select_Column_Question_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question_tag" */
export type Question_Tag_Aggregate_Fields = {
  __typename?: 'question_tag_aggregate_fields';
  avg?: Maybe<Question_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Question_Tag_Max_Fields>;
  min?: Maybe<Question_Tag_Min_Fields>;
  stddev?: Maybe<Question_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Tag_Sum_Fields>;
  var_pop?: Maybe<Question_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Tag_Var_Samp_Fields>;
  variance?: Maybe<Question_Tag_Variance_Fields>;
};


/** aggregate fields of "question_tag" */
export type Question_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_tag" */
export type Question_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Tag_Max_Order_By>;
  min?: InputMaybe<Question_Tag_Min_Order_By>;
  stddev?: InputMaybe<Question_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_tag" */
export type Question_Tag_Arr_Rel_Insert_Input = {
  data: Array<Question_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Tag_Avg_Fields = {
  __typename?: 'question_tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_tag" */
export type Question_Tag_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_tag". All fields are combined with a logical 'AND'. */
export type Question_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Tag_Bool_Exp>>;
  _not?: InputMaybe<Question_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Tag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Question_Bool_Exp>;
  questionId?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tagId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_tag" */
export const enum Question_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_0d8cbbfa2442b3bcc54b81fcb8b = 'PK_0d8cbbfa2442b3bcc54b81fcb8b',
  /** unique or primary key constraint on columns "uid" */
  Uq_4267e8677d3e25778f8ae18015b = 'UQ_4267e8677d3e25778f8ae18015b'
};

/** input type for incrementing numeric columns in table "question_tag" */
export type Question_Tag_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_tag" */
export type Question_Tag_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Question_Tag_Max_Fields = {
  __typename?: 'question_tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "question_tag" */
export type Question_Tag_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Tag_Min_Fields = {
  __typename?: 'question_tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "question_tag" */
export type Question_Tag_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_tag" */
export type Question_Tag_Mutation_Response = {
  __typename?: 'question_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Tag>;
};

/** on_conflict condition type for table "question_tag" */
export type Question_Tag_On_Conflict = {
  constraint: Question_Tag_Constraint;
  update_columns?: Array<Question_Tag_Update_Column>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "question_tag". */
export type Question_Tag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Question_Order_By>;
  questionId?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tagId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_tag */
export type Question_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "question_tag" */
export const enum Question_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "question_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "question_tag" */
export const enum Question_Tag_Select_Column_Question_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "question_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "question_tag" */
export const enum Question_Tag_Select_Column_Question_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "question_tag" */
export type Question_Tag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Question_Tag_Stddev_Fields = {
  __typename?: 'question_tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_tag" */
export type Question_Tag_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Tag_Stddev_Pop_Fields = {
  __typename?: 'question_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_tag" */
export type Question_Tag_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Tag_Stddev_Samp_Fields = {
  __typename?: 'question_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_tag" */
export type Question_Tag_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question_tag" */
export type Question_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Question_Tag_Sum_Fields = {
  __typename?: 'question_tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_tag" */
export type Question_Tag_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** update columns of table "question_tag" */
export const enum Question_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  TagId = 'tagId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Question_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Tag_Var_Pop_Fields = {
  __typename?: 'question_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_tag" */
export type Question_Tag_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Tag_Var_Samp_Fields = {
  __typename?: 'question_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_tag" */
export type Question_Tag_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Tag_Variance_Fields = {
  __typename?: 'question_tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_tag" */
export type Question_Tag_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "question_type_enum". All fields are combined with logical 'AND'. */
export type Question_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['question_type_enum']>;
  _gt?: InputMaybe<Scalars['question_type_enum']>;
  _gte?: InputMaybe<Scalars['question_type_enum']>;
  _in?: InputMaybe<Array<Scalars['question_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['question_type_enum']>;
  _lte?: InputMaybe<Scalars['question_type_enum']>;
  _neq?: InputMaybe<Scalars['question_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['question_type_enum']>>;
};

/** update columns of table "question" */
export const enum Question_Update_Column {
  /** column name */
  CorrectAnswerId = 'correctAnswerId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DndId = 'dndId',
  /** column name */
  FillBlankId = 'fillBlankId',
  /** column name */
  HasMath = 'hasMath',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
};

export type Question_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Var_Pop_Fields = {
  __typename?: 'question_var_pop_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question" */
export type Question_Var_Pop_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Var_Samp_Fields = {
  __typename?: 'question_var_samp_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question" */
export type Question_Var_Samp_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Variance_Fields = {
  __typename?: 'question_variance_fields';
  correctAnswerId?: Maybe<Scalars['Float']>;
  dndId?: Maybe<Scalars['Float']>;
  fillBlankId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mediaId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question" */
export type Question_Variance_Order_By = {
  correctAnswerId?: InputMaybe<Order_By>;
  dndId?: InputMaybe<Order_By>;
  fillBlankId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaId?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  quizId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_workspace" */
export type Question_Workspace = {
  __typename?: 'question_workspace';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  question: Question;
  questionId: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspace;
  workspaceId: Scalars['Int'];
};

/** aggregated selection of "question_workspace" */
export type Question_Workspace_Aggregate = {
  __typename?: 'question_workspace_aggregate';
  aggregate?: Maybe<Question_Workspace_Aggregate_Fields>;
  nodes: Array<Question_Workspace>;
};

export type Question_Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Question_Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Question_Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Question_Workspace_Aggregate_Bool_Exp_Count>;
};

export type Question_Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: Question_Workspace_Select_Column_Question_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Question_Workspace_Select_Column_Question_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Question_Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Question_Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question_workspace" */
export type Question_Workspace_Aggregate_Fields = {
  __typename?: 'question_workspace_aggregate_fields';
  avg?: Maybe<Question_Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Question_Workspace_Max_Fields>;
  min?: Maybe<Question_Workspace_Min_Fields>;
  stddev?: Maybe<Question_Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Workspace_Sum_Fields>;
  var_pop?: Maybe<Question_Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Workspace_Var_Samp_Fields>;
  variance?: Maybe<Question_Workspace_Variance_Fields>;
};


/** aggregate fields of "question_workspace" */
export type Question_Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_workspace" */
export type Question_Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Workspace_Max_Order_By>;
  min?: InputMaybe<Question_Workspace_Min_Order_By>;
  stddev?: InputMaybe<Question_Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_workspace" */
export type Question_Workspace_Arr_Rel_Insert_Input = {
  data: Array<Question_Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Workspace_Avg_Fields = {
  __typename?: 'question_workspace_avg_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_workspace" */
export type Question_Workspace_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_workspace". All fields are combined with a logical 'AND'. */
export type Question_Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Workspace_Bool_Exp>>;
  _not?: InputMaybe<Question_Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Workspace_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Question_Bool_Exp>;
  questionId?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workspace?: InputMaybe<Workspace_Bool_Exp>;
  workspaceId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_workspace" */
export const enum Question_Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_9f05d11124122694345527e829c = 'PK_9f05d11124122694345527e829c',
  /** unique or primary key constraint on columns "uid" */
  Uq_37d164de1acc514b9433e534191 = 'UQ_37d164de1acc514b9433e534191',
  /** unique or primary key constraint on columns "questionId", "workspaceId" */
  IndexQuestionWorkspace = 'index_question_workspace'
};

/** input type for incrementing numeric columns in table "question_workspace" */
export type Question_Workspace_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_workspace" */
export type Question_Workspace_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace?: InputMaybe<Workspace_Obj_Rel_Insert_Input>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Question_Workspace_Max_Fields = {
  __typename?: 'question_workspace_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "question_workspace" */
export type Question_Workspace_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Workspace_Min_Fields = {
  __typename?: 'question_workspace_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "question_workspace" */
export type Question_Workspace_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_workspace" */
export type Question_Workspace_Mutation_Response = {
  __typename?: 'question_workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Workspace>;
};

/** on_conflict condition type for table "question_workspace" */
export type Question_Workspace_On_Conflict = {
  constraint: Question_Workspace_Constraint;
  update_columns?: Array<Question_Workspace_Update_Column>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "question_workspace". */
export type Question_Workspace_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Question_Order_By>;
  questionId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workspace?: InputMaybe<Workspace_Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_workspace */
export type Question_Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "question_workspace" */
export const enum Question_Workspace_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

/** select "question_workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "question_workspace" */
export const enum Question_Workspace_Select_Column_Question_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "question_workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "question_workspace" */
export const enum Question_Workspace_Select_Column_Question_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "question_workspace" */
export type Question_Workspace_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Question_Workspace_Stddev_Fields = {
  __typename?: 'question_workspace_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_workspace" */
export type Question_Workspace_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Workspace_Stddev_Pop_Fields = {
  __typename?: 'question_workspace_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_workspace" */
export type Question_Workspace_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Workspace_Stddev_Samp_Fields = {
  __typename?: 'question_workspace_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_workspace" */
export type Question_Workspace_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question_workspace" */
export type Question_Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Workspace_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Question_Workspace_Sum_Fields = {
  __typename?: 'question_workspace_sum_fields';
  id?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_workspace" */
export type Question_Workspace_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** update columns of table "question_workspace" */
export const enum Question_Workspace_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkspaceId = 'workspaceId'
};

export type Question_Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Workspace_Var_Pop_Fields = {
  __typename?: 'question_workspace_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_workspace" */
export type Question_Workspace_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Workspace_Var_Samp_Fields = {
  __typename?: 'question_workspace_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_workspace" */
export type Question_Workspace_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Workspace_Variance_Fields = {
  __typename?: 'question_workspace_variance_fields';
  id?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_workspace" */
export type Question_Workspace_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz" */
export type Quiz = {
  __typename?: 'quiz';
  /** An array relationship */
  assignment_blocks: Array<Assignment_Block>;
  /** An aggregate relationship */
  assignment_blocks_aggregate: Assignment_Block_Aggregate;
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  question_quizzes: Array<Question_Quiz>;
  /** An aggregate relationship */
  question_quizzes_aggregate: Question_Quiz_Aggregate;
  /** An array relationship */
  questions: Array<Question>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "quiz" */
export type QuizAssignment_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizAssignment_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizQuestion_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizQuestion_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


/** columns and relationships of "quiz" */
export type QuizQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};

/** aggregated selection of "quiz" */
export type Quiz_Aggregate = {
  __typename?: 'quiz_aggregate';
  aggregate?: Maybe<Quiz_Aggregate_Fields>;
  nodes: Array<Quiz>;
};

export type Quiz_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Select_Column_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Select_Column_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quiz_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz" */
export type Quiz_Aggregate_Fields = {
  __typename?: 'quiz_aggregate_fields';
  avg?: Maybe<Quiz_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quiz_Max_Fields>;
  min?: Maybe<Quiz_Min_Fields>;
  stddev?: Maybe<Quiz_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Sum_Fields>;
  var_pop?: Maybe<Quiz_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Variance_Fields>;
};


/** aggregate fields of "quiz" */
export type Quiz_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quiz" */
export type Quiz_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Max_Order_By>;
  min?: InputMaybe<Quiz_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz" */
export type Quiz_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Avg_Fields = {
  __typename?: 'quiz_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quiz" */
export type Quiz_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz". All fields are combined with a logical 'AND'. */
export type Quiz_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Bool_Exp>>;
  assignment_blocks?: InputMaybe<Assignment_Block_Bool_Exp>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_quizzes?: InputMaybe<Question_Quiz_Bool_Exp>;
  question_quizzes_aggregate?: InputMaybe<Question_Quiz_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz" */
export const enum Quiz_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_422d974e7217414e029b3e641d0 = 'PK_422d974e7217414e029b3e641d0',
  /** unique or primary key constraint on columns "uid" */
  Uq_11c9b04c22213d8f6d3ae456663 = 'UQ_11c9b04c22213d8f6d3ae456663'
};

/** input type for incrementing numeric columns in table "quiz" */
export type Quiz_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quiz" */
export type Quiz_Insert_Input = {
  assignment_blocks?: InputMaybe<Assignment_Block_Arr_Rel_Insert_Input>;
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_quizzes?: InputMaybe<Question_Quiz_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Quiz_Max_Fields = {
  __typename?: 'quiz_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "quiz" */
export type Quiz_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Min_Fields = {
  __typename?: 'quiz_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "quiz" */
export type Quiz_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz" */
export type Quiz_Mutation_Response = {
  __typename?: 'quiz_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz>;
};

/** input type for inserting object relation for remote table "quiz" */
export type Quiz_Obj_Rel_Insert_Input = {
  data: Quiz_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_On_Conflict>;
};

/** on_conflict condition type for table "quiz" */
export type Quiz_On_Conflict = {
  constraint: Quiz_Constraint;
  update_columns?: Array<Quiz_Update_Column>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz". */
export type Quiz_Order_By = {
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Order_By>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_quizzes_aggregate?: InputMaybe<Question_Quiz_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz */
export type Quiz_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "quiz" */
export const enum Quiz_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "quiz_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz" */
export const enum Quiz_Select_Column_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "quiz_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz" */
export const enum Quiz_Select_Column_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "quiz" */
export type Quiz_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Quiz_Stddev_Fields = {
  __typename?: 'quiz_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quiz" */
export type Quiz_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Stddev_Pop_Fields = {
  __typename?: 'quiz_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quiz" */
export type Quiz_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Stddev_Samp_Fields = {
  __typename?: 'quiz_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quiz" */
export type Quiz_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz" */
export type Quiz_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Quiz_Sum_Fields = {
  __typename?: 'quiz_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "quiz" */
export type Quiz_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "quiz" */
export const enum Quiz_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Quiz_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Var_Pop_Fields = {
  __typename?: 'quiz_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quiz" */
export type Quiz_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Var_Samp_Fields = {
  __typename?: 'quiz_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quiz" */
export type Quiz_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Variance_Fields = {
  __typename?: 'quiz_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quiz" */
export type Quiz_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "recurring_event" */
export type Recurring_Event = {
  __typename?: 'recurring_event';
  calendarEventId: Scalars['Int'];
  /** An object relationship */
  calendar_event: Calendar_Event;
  /** An array relationship */
  calendar_events: Array<Calendar_Event>;
  /** An aggregate relationship */
  calendar_events_aggregate: Calendar_Event_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  frequency: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  stop_date: Scalars['timestamptz'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "recurring_event" */
export type Recurring_EventCalendar_EventsArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


/** columns and relationships of "recurring_event" */
export type Recurring_EventCalendar_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};

/** aggregated selection of "recurring_event" */
export type Recurring_Event_Aggregate = {
  __typename?: 'recurring_event_aggregate';
  aggregate?: Maybe<Recurring_Event_Aggregate_Fields>;
  nodes: Array<Recurring_Event>;
};

export type Recurring_Event_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Recurring_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Recurring_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Recurring_Event_Aggregate_Bool_Exp_Count>;
};

export type Recurring_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: Recurring_Event_Select_Column_Recurring_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Recurring_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Recurring_Event_Select_Column_Recurring_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Recurring_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "recurring_event" */
export type Recurring_Event_Aggregate_Fields = {
  __typename?: 'recurring_event_aggregate_fields';
  avg?: Maybe<Recurring_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Recurring_Event_Max_Fields>;
  min?: Maybe<Recurring_Event_Min_Fields>;
  stddev?: Maybe<Recurring_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Recurring_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Recurring_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Recurring_Event_Sum_Fields>;
  var_pop?: Maybe<Recurring_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Recurring_Event_Var_Samp_Fields>;
  variance?: Maybe<Recurring_Event_Variance_Fields>;
};


/** aggregate fields of "recurring_event" */
export type Recurring_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recurring_event" */
export type Recurring_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Recurring_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Recurring_Event_Max_Order_By>;
  min?: InputMaybe<Recurring_Event_Min_Order_By>;
  stddev?: InputMaybe<Recurring_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Recurring_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Recurring_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Recurring_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Recurring_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Recurring_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Recurring_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "recurring_event" */
export type Recurring_Event_Arr_Rel_Insert_Input = {
  data: Array<Recurring_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Recurring_Event_On_Conflict>;
};

/** aggregate avg on columns */
export type Recurring_Event_Avg_Fields = {
  __typename?: 'recurring_event_avg_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recurring_event" */
export type Recurring_Event_Avg_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "recurring_event". All fields are combined with a logical 'AND'. */
export type Recurring_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Recurring_Event_Bool_Exp>>;
  _not?: InputMaybe<Recurring_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Recurring_Event_Bool_Exp>>;
  calendarEventId?: InputMaybe<Int_Comparison_Exp>;
  calendar_event?: InputMaybe<Calendar_Event_Bool_Exp>;
  calendar_events?: InputMaybe<Calendar_Event_Bool_Exp>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  frequency?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  stop_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "recurring_event" */
export const enum Recurring_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_3bc9ec3ad1b7ef3b98a25f18ac9 = 'PK_3bc9ec3ad1b7ef3b98a25f18ac9',
  /** unique or primary key constraint on columns "uid" */
  Uq_21bc14532aacc74f3f5b80d00b3 = 'UQ_21bc14532aacc74f3f5b80d00b3',
  /** unique or primary key constraint on columns "calendarEventId" */
  UqF711d1eb6cb5adb0c3fe7abf9fc = 'UQ_f711d1eb6cb5adb0c3fe7abf9fc'
};

/** input type for incrementing numeric columns in table "recurring_event" */
export type Recurring_Event_Inc_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "recurring_event" */
export type Recurring_Event_Insert_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  calendar_event?: InputMaybe<Calendar_Event_Obj_Rel_Insert_Input>;
  calendar_events?: InputMaybe<Calendar_Event_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  stop_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Recurring_Event_Max_Fields = {
  __typename?: 'recurring_event_max_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  stop_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "recurring_event" */
export type Recurring_Event_Max_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  stop_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Recurring_Event_Min_Fields = {
  __typename?: 'recurring_event_min_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  stop_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "recurring_event" */
export type Recurring_Event_Min_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  stop_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "recurring_event" */
export type Recurring_Event_Mutation_Response = {
  __typename?: 'recurring_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recurring_Event>;
};

/** input type for inserting object relation for remote table "recurring_event" */
export type Recurring_Event_Obj_Rel_Insert_Input = {
  data: Recurring_Event_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Recurring_Event_On_Conflict>;
};

/** on_conflict condition type for table "recurring_event" */
export type Recurring_Event_On_Conflict = {
  constraint: Recurring_Event_Constraint;
  update_columns?: Array<Recurring_Event_Update_Column>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "recurring_event". */
export type Recurring_Event_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  calendar_event?: InputMaybe<Calendar_Event_Order_By>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  stop_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: recurring_event */
export type Recurring_Event_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "recurring_event" */
export const enum Recurring_Event_Select_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  StopDate = 'stop_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "recurring_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "recurring_event" */
export const enum Recurring_Event_Select_Column_Recurring_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "recurring_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "recurring_event" */
export const enum Recurring_Event_Select_Column_Recurring_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "recurring_event" */
export type Recurring_Event_Set_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  stop_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Recurring_Event_Stddev_Fields = {
  __typename?: 'recurring_event_stddev_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recurring_event" */
export type Recurring_Event_Stddev_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Recurring_Event_Stddev_Pop_Fields = {
  __typename?: 'recurring_event_stddev_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recurring_event" */
export type Recurring_Event_Stddev_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Recurring_Event_Stddev_Samp_Fields = {
  __typename?: 'recurring_event_stddev_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recurring_event" */
export type Recurring_Event_Stddev_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "recurring_event" */
export type Recurring_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recurring_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recurring_Event_Stream_Cursor_Value_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  stop_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Recurring_Event_Sum_Fields = {
  __typename?: 'recurring_event_sum_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  frequency?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recurring_event" */
export type Recurring_Event_Sum_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "recurring_event" */
export const enum Recurring_Event_Update_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  StopDate = 'stop_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Recurring_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recurring_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recurring_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Recurring_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Recurring_Event_Var_Pop_Fields = {
  __typename?: 'recurring_event_var_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recurring_event" */
export type Recurring_Event_Var_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Recurring_Event_Var_Samp_Fields = {
  __typename?: 'recurring_event_var_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recurring_event" */
export type Recurring_Event_Var_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Recurring_Event_Variance_Fields = {
  __typename?: 'recurring_event_variance_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recurring_event" */
export type Recurring_Event_Variance_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "school_fee" */
export type School_Fee = {
  __typename?: 'school_fee';
  cost: Scalars['numeric'];
  createdById?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An array relationship */
  installments: Array<Installment>;
  /** An aggregate relationship */
  installments_aggregate: Installment_Aggregate;
  interval: Scalars['float8'];
  label: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  schoolPeriodId: Scalars['Int'];
  /** An object relationship */
  school_period: School_Period;
  start_date: Scalars['timestamptz'];
  type: Scalars['school_fee_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
};


/** columns and relationships of "school_fee" */
export type School_FeeInstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "school_fee" */
export type School_FeeInstallments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};

/** aggregated selection of "school_fee" */
export type School_Fee_Aggregate = {
  __typename?: 'school_fee_aggregate';
  aggregate?: Maybe<School_Fee_Aggregate_Fields>;
  nodes: Array<School_Fee>;
};

export type School_Fee_Aggregate_Bool_Exp = {
  avg?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<School_Fee_Aggregate_Bool_Exp_Var_Samp>;
};

export type School_Fee_Aggregate_Bool_Exp_Avg = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Bool_And = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Bool_Or = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Corr = {
  arguments: School_Fee_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Corr_Arguments = {
  X: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type School_Fee_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<School_Fee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: School_Fee_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type School_Fee_Aggregate_Bool_Exp_Max = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Min = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Sum = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type School_Fee_Aggregate_Bool_Exp_Var_Samp = {
  arguments: School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Fee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "school_fee" */
export type School_Fee_Aggregate_Fields = {
  __typename?: 'school_fee_aggregate_fields';
  avg?: Maybe<School_Fee_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<School_Fee_Max_Fields>;
  min?: Maybe<School_Fee_Min_Fields>;
  stddev?: Maybe<School_Fee_Stddev_Fields>;
  stddev_pop?: Maybe<School_Fee_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<School_Fee_Stddev_Samp_Fields>;
  sum?: Maybe<School_Fee_Sum_Fields>;
  var_pop?: Maybe<School_Fee_Var_Pop_Fields>;
  var_samp?: Maybe<School_Fee_Var_Samp_Fields>;
  variance?: Maybe<School_Fee_Variance_Fields>;
};


/** aggregate fields of "school_fee" */
export type School_Fee_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<School_Fee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "school_fee" */
export type School_Fee_Aggregate_Order_By = {
  avg?: InputMaybe<School_Fee_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<School_Fee_Max_Order_By>;
  min?: InputMaybe<School_Fee_Min_Order_By>;
  stddev?: InputMaybe<School_Fee_Stddev_Order_By>;
  stddev_pop?: InputMaybe<School_Fee_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<School_Fee_Stddev_Samp_Order_By>;
  sum?: InputMaybe<School_Fee_Sum_Order_By>;
  var_pop?: InputMaybe<School_Fee_Var_Pop_Order_By>;
  var_samp?: InputMaybe<School_Fee_Var_Samp_Order_By>;
  variance?: InputMaybe<School_Fee_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "school_fee" */
export type School_Fee_Arr_Rel_Insert_Input = {
  data: Array<School_Fee_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<School_Fee_On_Conflict>;
};

/** aggregate avg on columns */
export type School_Fee_Avg_Fields = {
  __typename?: 'school_fee_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "school_fee" */
export type School_Fee_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "school_fee". All fields are combined with a logical 'AND'. */
export type School_Fee_Bool_Exp = {
  _and?: InputMaybe<Array<School_Fee_Bool_Exp>>;
  _not?: InputMaybe<School_Fee_Bool_Exp>;
  _or?: InputMaybe<Array<School_Fee_Bool_Exp>>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  createdById?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  installments?: InputMaybe<Installment_Bool_Exp>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Bool_Exp>;
  interval?: InputMaybe<Float8_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  schoolPeriodId?: InputMaybe<Int_Comparison_Exp>;
  school_period?: InputMaybe<School_Period_Bool_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<School_Fee_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "school_fee" */
export const enum School_Fee_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_5a7f3123f92c583e89c0a9f9c4d = 'PK_5a7f3123f92c583e89c0a9f9c4d',
  /** unique or primary key constraint on columns "uid" */
  Uq_5fa0fed40764ae78deb77826ee9 = 'UQ_5fa0fed40764ae78deb77826ee9'
};

/** input type for incrementing numeric columns in table "school_fee" */
export type School_Fee_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "school_fee" */
export type School_Fee_Insert_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  installments?: InputMaybe<Installment_Arr_Rel_Insert_Input>;
  interval?: InputMaybe<Scalars['float8']>;
  label?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  school_period?: InputMaybe<School_Period_Obj_Rel_Insert_Input>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['school_fee_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type School_Fee_Max_Fields = {
  __typename?: 'school_fee_max_fields';
  cost?: Maybe<Scalars['numeric']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['float8']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['school_fee_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "school_fee" */
export type School_Fee_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type School_Fee_Min_Fields = {
  __typename?: 'school_fee_min_fields';
  cost?: Maybe<Scalars['numeric']>;
  createdById?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['float8']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['school_fee_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "school_fee" */
export type School_Fee_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "school_fee" */
export type School_Fee_Mutation_Response = {
  __typename?: 'school_fee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<School_Fee>;
};

/** input type for inserting object relation for remote table "school_fee" */
export type School_Fee_Obj_Rel_Insert_Input = {
  data: School_Fee_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<School_Fee_On_Conflict>;
};

/** on_conflict condition type for table "school_fee" */
export type School_Fee_On_Conflict = {
  constraint: School_Fee_Constraint;
  update_columns?: Array<School_Fee_Update_Column>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};

/** Ordering options when selecting data from "school_fee". */
export type School_Fee_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Order_By>;
  interval?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
  school_period?: InputMaybe<School_Period_Order_By>;
  start_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: school_fee */
export type School_Fee_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "school_fee" */
export const enum School_Fee_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "school_fee_aggregate_bool_exp_avg_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_bool_and_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "school_fee_aggregate_bool_exp_bool_or_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "school_fee_aggregate_bool_exp_corr_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_max_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_min_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_sum_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** select "school_fee_aggregate_bool_exp_var_samp_arguments_columns" columns of table "school_fee" */
export const enum School_Fee_Select_Column_School_Fee_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Interval = 'interval'
};

/** input type for updating data in table "school_fee" */
export type School_Fee_Set_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['float8']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['school_fee_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type School_Fee_Stddev_Fields = {
  __typename?: 'school_fee_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "school_fee" */
export type School_Fee_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type School_Fee_Stddev_Pop_Fields = {
  __typename?: 'school_fee_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "school_fee" */
export type School_Fee_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type School_Fee_Stddev_Samp_Fields = {
  __typename?: 'school_fee_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "school_fee" */
export type School_Fee_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "school_fee" */
export type School_Fee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: School_Fee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type School_Fee_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdById?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['float8']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  schoolPeriodId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['school_fee_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type School_Fee_Sum_Fields = {
  __typename?: 'school_fee_sum_fields';
  cost?: Maybe<Scalars['numeric']>;
  createdById?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['float8']>;
  organizationId?: Maybe<Scalars['Int']>;
  schoolPeriodId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "school_fee" */
export type School_Fee_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "school_fee_type_enum". All fields are combined with logical 'AND'. */
export type School_Fee_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['school_fee_type_enum']>;
  _gt?: InputMaybe<Scalars['school_fee_type_enum']>;
  _gte?: InputMaybe<Scalars['school_fee_type_enum']>;
  _in?: InputMaybe<Array<Scalars['school_fee_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['school_fee_type_enum']>;
  _lte?: InputMaybe<Scalars['school_fee_type_enum']>;
  _neq?: InputMaybe<Scalars['school_fee_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['school_fee_type_enum']>>;
};

/** update columns of table "school_fee" */
export const enum School_Fee_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SchoolPeriodId = 'schoolPeriodId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type School_Fee_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<School_Fee_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<School_Fee_Set_Input>;
  /** filter the rows which have to be updated */
  where: School_Fee_Bool_Exp;
};

/** aggregate var_pop on columns */
export type School_Fee_Var_Pop_Fields = {
  __typename?: 'school_fee_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "school_fee" */
export type School_Fee_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type School_Fee_Var_Samp_Fields = {
  __typename?: 'school_fee_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "school_fee" */
export type School_Fee_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type School_Fee_Variance_Fields = {
  __typename?: 'school_fee_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  schoolPeriodId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "school_fee" */
export type School_Fee_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  schoolPeriodId?: InputMaybe<Order_By>;
};

/** columns and relationships of "school_period" */
export type School_Period = {
  __typename?: 'school_period';
  /** An array relationship */
  classes: Array<Class>;
  /** An aggregate relationship */
  classes_aggregate: Class_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  end_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  /** An array relationship */
  school_fees: Array<School_Fee>;
  /** An aggregate relationship */
  school_fees_aggregate: School_Fee_Aggregate;
  start_date: Scalars['timestamptz'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "school_period" */
export type School_PeriodClassesArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


/** columns and relationships of "school_period" */
export type School_PeriodClasses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


/** columns and relationships of "school_period" */
export type School_PeriodInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "school_period" */
export type School_PeriodInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "school_period" */
export type School_PeriodSchool_FeesArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


/** columns and relationships of "school_period" */
export type School_PeriodSchool_Fees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};

/** aggregated selection of "school_period" */
export type School_Period_Aggregate = {
  __typename?: 'school_period_aggregate';
  aggregate?: Maybe<School_Period_Aggregate_Fields>;
  nodes: Array<School_Period>;
};

export type School_Period_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<School_Period_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<School_Period_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<School_Period_Aggregate_Bool_Exp_Count>;
};

export type School_Period_Aggregate_Bool_Exp_Bool_And = {
  arguments: School_Period_Select_Column_School_Period_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Period_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type School_Period_Aggregate_Bool_Exp_Bool_Or = {
  arguments: School_Period_Select_Column_School_Period_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Period_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type School_Period_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<School_Period_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<School_Period_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "school_period" */
export type School_Period_Aggregate_Fields = {
  __typename?: 'school_period_aggregate_fields';
  avg?: Maybe<School_Period_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<School_Period_Max_Fields>;
  min?: Maybe<School_Period_Min_Fields>;
  stddev?: Maybe<School_Period_Stddev_Fields>;
  stddev_pop?: Maybe<School_Period_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<School_Period_Stddev_Samp_Fields>;
  sum?: Maybe<School_Period_Sum_Fields>;
  var_pop?: Maybe<School_Period_Var_Pop_Fields>;
  var_samp?: Maybe<School_Period_Var_Samp_Fields>;
  variance?: Maybe<School_Period_Variance_Fields>;
};


/** aggregate fields of "school_period" */
export type School_Period_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<School_Period_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "school_period" */
export type School_Period_Aggregate_Order_By = {
  avg?: InputMaybe<School_Period_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<School_Period_Max_Order_By>;
  min?: InputMaybe<School_Period_Min_Order_By>;
  stddev?: InputMaybe<School_Period_Stddev_Order_By>;
  stddev_pop?: InputMaybe<School_Period_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<School_Period_Stddev_Samp_Order_By>;
  sum?: InputMaybe<School_Period_Sum_Order_By>;
  var_pop?: InputMaybe<School_Period_Var_Pop_Order_By>;
  var_samp?: InputMaybe<School_Period_Var_Samp_Order_By>;
  variance?: InputMaybe<School_Period_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "school_period" */
export type School_Period_Arr_Rel_Insert_Input = {
  data: Array<School_Period_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<School_Period_On_Conflict>;
};

/** aggregate avg on columns */
export type School_Period_Avg_Fields = {
  __typename?: 'school_period_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "school_period" */
export type School_Period_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "school_period". All fields are combined with a logical 'AND'. */
export type School_Period_Bool_Exp = {
  _and?: InputMaybe<Array<School_Period_Bool_Exp>>;
  _not?: InputMaybe<School_Period_Bool_Exp>;
  _or?: InputMaybe<Array<School_Period_Bool_Exp>>;
  classes?: InputMaybe<Class_Bool_Exp>;
  classes_aggregate?: InputMaybe<Class_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  school_fees?: InputMaybe<School_Fee_Bool_Exp>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Bool_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "school_period" */
export const enum School_Period_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_05f7e93cd334679ac4b78717522 = 'PK_05f7e93cd334679ac4b78717522',
  /** unique or primary key constraint on columns "uid" */
  UqB50c17836a8eab982ac292b43ad = 'UQ_b50c17836a8eab982ac292b43ad'
};

/** input type for incrementing numeric columns in table "school_period" */
export type School_Period_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "school_period" */
export type School_Period_Insert_Input = {
  classes?: InputMaybe<Class_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  invoices?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  school_fees?: InputMaybe<School_Fee_Arr_Rel_Insert_Input>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type School_Period_Max_Fields = {
  __typename?: 'school_period_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "school_period" */
export type School_Period_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type School_Period_Min_Fields = {
  __typename?: 'school_period_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "school_period" */
export type School_Period_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "school_period" */
export type School_Period_Mutation_Response = {
  __typename?: 'school_period_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<School_Period>;
};

/** input type for inserting object relation for remote table "school_period" */
export type School_Period_Obj_Rel_Insert_Input = {
  data: School_Period_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<School_Period_On_Conflict>;
};

/** on_conflict condition type for table "school_period" */
export type School_Period_On_Conflict = {
  constraint: School_Period_Constraint;
  update_columns?: Array<School_Period_Update_Column>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};

/** Ordering options when selecting data from "school_period". */
export type School_Period_Order_By = {
  classes_aggregate?: InputMaybe<Class_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Order_By>;
  start_date?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: school_period */
export type School_Period_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "school_period" */
export const enum School_Period_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "school_period_aggregate_bool_exp_bool_and_arguments_columns" columns of table "school_period" */
export const enum School_Period_Select_Column_School_Period_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "school_period_aggregate_bool_exp_bool_or_arguments_columns" columns of table "school_period" */
export const enum School_Period_Select_Column_School_Period_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "school_period" */
export type School_Period_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type School_Period_Stddev_Fields = {
  __typename?: 'school_period_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "school_period" */
export type School_Period_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type School_Period_Stddev_Pop_Fields = {
  __typename?: 'school_period_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "school_period" */
export type School_Period_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type School_Period_Stddev_Samp_Fields = {
  __typename?: 'school_period_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "school_period" */
export type School_Period_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "school_period" */
export type School_Period_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: School_Period_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type School_Period_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type School_Period_Sum_Fields = {
  __typename?: 'school_period_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "school_period" */
export type School_Period_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "school_period" */
export const enum School_Period_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type School_Period_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<School_Period_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<School_Period_Set_Input>;
  /** filter the rows which have to be updated */
  where: School_Period_Bool_Exp;
};

/** aggregate var_pop on columns */
export type School_Period_Var_Pop_Fields = {
  __typename?: 'school_period_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "school_period" */
export type School_Period_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type School_Period_Var_Samp_Fields = {
  __typename?: 'school_period_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "school_period" */
export type School_Period_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type School_Period_Variance_Fields = {
  __typename?: 'school_period_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "school_period" */
export type School_Period_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** fetch data from the table: "activity_layout" */
  activity_layout: Array<Activity_Layout>;
  /** fetch aggregated fields from the table: "activity_layout" */
  activity_layout_aggregate: Activity_Layout_Aggregate;
  /** fetch data from the table: "activity_layout" using primary key columns */
  activity_layout_by_pk?: Maybe<Activity_Layout>;
  /** fetch data from the table in a streaming manner: "activity_layout" */
  activity_layout_stream: Array<Activity_Layout>;
  /** fetch data from the table in a streaming manner: "activity" */
  activity_stream: Array<Activity>;
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch data from the table: "assignment_activity" */
  assignment_activity: Array<Assignment_Activity>;
  /** fetch aggregated fields from the table: "assignment_activity" */
  assignment_activity_aggregate: Assignment_Activity_Aggregate;
  /** fetch data from the table: "assignment_activity" using primary key columns */
  assignment_activity_by_pk?: Maybe<Assignment_Activity>;
  /** fetch data from the table in a streaming manner: "assignment_activity" */
  assignment_activity_stream: Array<Assignment_Activity>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment_block" */
  assignment_block: Array<Assignment_Block>;
  /** fetch aggregated fields from the table: "assignment_block" */
  assignment_block_aggregate: Assignment_Block_Aggregate;
  /** fetch data from the table: "assignment_block" using primary key columns */
  assignment_block_by_pk?: Maybe<Assignment_Block>;
  /** fetch data from the table in a streaming manner: "assignment_block" */
  assignment_block_stream: Array<Assignment_Block>;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table in a streaming manner: "assignment" */
  assignment_stream: Array<Assignment>;
  /** fetch data from the table: "block" */
  block: Array<Block>;
  /** fetch aggregated fields from the table: "block" */
  block_aggregate: Block_Aggregate;
  /** fetch data from the table: "block" using primary key columns */
  block_by_pk?: Maybe<Block>;
  /** fetch data from the table: "block_list_item" */
  block_list_item: Array<Block_List_Item>;
  /** fetch aggregated fields from the table: "block_list_item" */
  block_list_item_aggregate: Block_List_Item_Aggregate;
  /** fetch data from the table: "block_list_item" using primary key columns */
  block_list_item_by_pk?: Maybe<Block_List_Item>;
  /** fetch data from the table in a streaming manner: "block_list_item" */
  block_list_item_stream: Array<Block_List_Item>;
  /** fetch data from the table: "block_list_item_workspace" */
  block_list_item_workspace: Array<Block_List_Item_Workspace>;
  /** fetch aggregated fields from the table: "block_list_item_workspace" */
  block_list_item_workspace_aggregate: Block_List_Item_Workspace_Aggregate;
  /** fetch data from the table: "block_list_item_workspace" using primary key columns */
  block_list_item_workspace_by_pk?: Maybe<Block_List_Item_Workspace>;
  /** fetch data from the table in a streaming manner: "block_list_item_workspace" */
  block_list_item_workspace_stream: Array<Block_List_Item_Workspace>;
  /** fetch data from the table in a streaming manner: "block" */
  block_stream: Array<Block>;
  /** fetch data from the table: "block_tag" */
  block_tag: Array<Block_Tag>;
  /** fetch aggregated fields from the table: "block_tag" */
  block_tag_aggregate: Block_Tag_Aggregate;
  /** fetch data from the table: "block_tag" using primary key columns */
  block_tag_by_pk?: Maybe<Block_Tag>;
  /** fetch data from the table in a streaming manner: "block_tag" */
  block_tag_stream: Array<Block_Tag>;
  /** fetch data from the table: "calendar_event" */
  calendar_event: Array<Calendar_Event>;
  /** fetch aggregated fields from the table: "calendar_event" */
  calendar_event_aggregate: Calendar_Event_Aggregate;
  /** fetch data from the table: "calendar_event" using primary key columns */
  calendar_event_by_pk?: Maybe<Calendar_Event>;
  /** fetch data from the table in a streaming manner: "calendar_event" */
  calendar_event_stream: Array<Calendar_Event>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table in a streaming manner: "category" */
  category_stream: Array<Category>;
  /** fetch data from the table: "checkpoint" */
  checkpoint: Array<Checkpoint>;
  /** fetch aggregated fields from the table: "checkpoint" */
  checkpoint_aggregate: Checkpoint_Aggregate;
  /** An array relationship */
  checkpoint_attempts: Array<Checkpoint_Attempts>;
  /** An aggregate relationship */
  checkpoint_attempts_aggregate: Checkpoint_Attempts_Aggregate;
  /** fetch data from the table: "checkpoint_attempts" using primary key columns */
  checkpoint_attempts_by_pk?: Maybe<Checkpoint_Attempts>;
  /** fetch data from the table in a streaming manner: "checkpoint_attempts" */
  checkpoint_attempts_stream: Array<Checkpoint_Attempts>;
  /** fetch data from the table: "checkpoint" using primary key columns */
  checkpoint_by_pk?: Maybe<Checkpoint>;
  /** fetch data from the table in a streaming manner: "checkpoint" */
  checkpoint_stream: Array<Checkpoint>;
  /** fetch data from the table: "class" */
  class: Array<Class>;
  /** fetch aggregated fields from the table: "class" */
  class_aggregate: Class_Aggregate;
  /** fetch data from the table: "class" using primary key columns */
  class_by_pk?: Maybe<Class>;
  /** fetch data from the table: "class_course" */
  class_course: Array<Class_Course>;
  /** fetch aggregated fields from the table: "class_course" */
  class_course_aggregate: Class_Course_Aggregate;
  /** fetch data from the table: "class_course" using primary key columns */
  class_course_by_pk?: Maybe<Class_Course>;
  /** fetch data from the table: "class_course_note" */
  class_course_note: Array<Class_Course_Note>;
  /** fetch aggregated fields from the table: "class_course_note" */
  class_course_note_aggregate: Class_Course_Note_Aggregate;
  /** fetch data from the table: "class_course_note" using primary key columns */
  class_course_note_by_pk?: Maybe<Class_Course_Note>;
  /** fetch data from the table in a streaming manner: "class_course_note" */
  class_course_note_stream: Array<Class_Course_Note>;
  /** fetch data from the table: "class_course_resource" */
  class_course_resource: Array<Class_Course_Resource>;
  /** fetch aggregated fields from the table: "class_course_resource" */
  class_course_resource_aggregate: Class_Course_Resource_Aggregate;
  /** fetch data from the table: "class_course_resource" using primary key columns */
  class_course_resource_by_pk?: Maybe<Class_Course_Resource>;
  /** fetch data from the table in a streaming manner: "class_course_resource" */
  class_course_resource_stream: Array<Class_Course_Resource>;
  /** fetch data from the table in a streaming manner: "class_course" */
  class_course_stream: Array<Class_Course>;
  /** fetch data from the table in a streaming manner: "class" */
  class_stream: Array<Class>;
  /** fetch data from the table: "classroom" */
  classroom: Array<Classroom>;
  /** fetch aggregated fields from the table: "classroom" */
  classroom_aggregate: Classroom_Aggregate;
  /** fetch data from the table: "classroom" using primary key columns */
  classroom_by_pk?: Maybe<Classroom>;
  /** fetch data from the table: "classroom_group" */
  classroom_group: Array<Classroom_Group>;
  /** fetch aggregated fields from the table: "classroom_group" */
  classroom_group_aggregate: Classroom_Group_Aggregate;
  /** fetch data from the table: "classroom_group" using primary key columns */
  classroom_group_by_pk?: Maybe<Classroom_Group>;
  /** fetch data from the table in a streaming manner: "classroom_group" */
  classroom_group_stream: Array<Classroom_Group>;
  /** fetch data from the table in a streaming manner: "classroom" */
  classroom_stream: Array<Classroom>;
  /** fetch data from the table: "course" */
  course: Array<Course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: Course_Aggregate;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<Course>;
  /** fetch data from the table: "course_category" */
  course_category: Array<Course_Category>;
  /** fetch aggregated fields from the table: "course_category" */
  course_category_aggregate: Course_Category_Aggregate;
  /** fetch data from the table: "course_category" using primary key columns */
  course_category_by_pk?: Maybe<Course_Category>;
  /** fetch data from the table in a streaming manner: "course_category" */
  course_category_stream: Array<Course_Category>;
  /** fetch data from the table: "course_grade_level" */
  course_grade_level: Array<Course_Grade_Level>;
  /** fetch aggregated fields from the table: "course_grade_level" */
  course_grade_level_aggregate: Course_Grade_Level_Aggregate;
  /** fetch data from the table: "course_grade_level" using primary key columns */
  course_grade_level_by_pk?: Maybe<Course_Grade_Level>;
  /** fetch data from the table in a streaming manner: "course_grade_level" */
  course_grade_level_stream: Array<Course_Grade_Level>;
  /** fetch data from the table: "course_instructor" */
  course_instructor: Array<Course_Instructor>;
  /** fetch aggregated fields from the table: "course_instructor" */
  course_instructor_aggregate: Course_Instructor_Aggregate;
  /** fetch data from the table: "course_instructor" using primary key columns */
  course_instructor_by_pk?: Maybe<Course_Instructor>;
  /** fetch data from the table in a streaming manner: "course_instructor" */
  course_instructor_stream: Array<Course_Instructor>;
  /** fetch data from the table in a streaming manner: "course" */
  course_stream: Array<Course>;
  /** fetch data from the table: "course_tag" */
  course_tag: Array<Course_Tag>;
  /** fetch aggregated fields from the table: "course_tag" */
  course_tag_aggregate: Course_Tag_Aggregate;
  /** fetch data from the table: "course_tag" using primary key columns */
  course_tag_by_pk?: Maybe<Course_Tag>;
  /** fetch data from the table in a streaming manner: "course_tag" */
  course_tag_stream: Array<Course_Tag>;
  /** fetch data from the table: "course_workspace" */
  course_workspace: Array<Course_Workspace>;
  /** fetch aggregated fields from the table: "course_workspace" */
  course_workspace_aggregate: Course_Workspace_Aggregate;
  /** fetch data from the table: "course_workspace" using primary key columns */
  course_workspace_by_pk?: Maybe<Course_Workspace>;
  /** fetch data from the table in a streaming manner: "course_workspace" */
  course_workspace_stream: Array<Course_Workspace>;
  /** fetch data from the table: "dnd" */
  dnd: Array<Dnd>;
  /** fetch aggregated fields from the table: "dnd" */
  dnd_aggregate: Dnd_Aggregate;
  /** fetch data from the table: "dnd" using primary key columns */
  dnd_by_pk?: Maybe<Dnd>;
  /** fetch data from the table in a streaming manner: "dnd" */
  dnd_stream: Array<Dnd>;
  /** fetch data from the table: "event_classroom" */
  event_classroom: Array<Event_Classroom>;
  /** fetch aggregated fields from the table: "event_classroom" */
  event_classroom_aggregate: Event_Classroom_Aggregate;
  /** fetch data from the table: "event_classroom" using primary key columns */
  event_classroom_by_pk?: Maybe<Event_Classroom>;
  /** fetch data from the table in a streaming manner: "event_classroom" */
  event_classroom_stream: Array<Event_Classroom>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table in a streaming manner: "feedback" */
  feedback_stream: Array<Feedback>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<File>;
  /** fetch data from the table: "fill_blank" */
  fill_blank: Array<Fill_Blank>;
  /** fetch aggregated fields from the table: "fill_blank" */
  fill_blank_aggregate: Fill_Blank_Aggregate;
  /** fetch data from the table: "fill_blank" using primary key columns */
  fill_blank_by_pk?: Maybe<Fill_Blank>;
  /** fetch data from the table in a streaming manner: "fill_blank" */
  fill_blank_stream: Array<Fill_Blank>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table: "grade_level" */
  grade_level: Array<Grade_Level>;
  /** fetch aggregated fields from the table: "grade_level" */
  grade_level_aggregate: Grade_Level_Aggregate;
  /** fetch data from the table: "grade_level" using primary key columns */
  grade_level_by_pk?: Maybe<Grade_Level>;
  /** fetch data from the table: "grade_level_group" */
  grade_level_group: Array<Grade_Level_Group>;
  /** fetch aggregated fields from the table: "grade_level_group" */
  grade_level_group_aggregate: Grade_Level_Group_Aggregate;
  /** fetch data from the table: "grade_level_group" using primary key columns */
  grade_level_group_by_pk?: Maybe<Grade_Level_Group>;
  /** fetch data from the table in a streaming manner: "grade_level_group" */
  grade_level_group_stream: Array<Grade_Level_Group>;
  /** fetch data from the table in a streaming manner: "grade_level" */
  grade_level_stream: Array<Grade_Level>;
  /** fetch data from the table in a streaming manner: "grade" */
  grade_stream: Array<Grade>;
  /** fetch data from the table: "grade_value" */
  grade_value: Array<Grade_Value>;
  /** fetch aggregated fields from the table: "grade_value" */
  grade_value_aggregate: Grade_Value_Aggregate;
  /** fetch data from the table: "grade_value" using primary key columns */
  grade_value_by_pk?: Maybe<Grade_Value>;
  /** fetch data from the table in a streaming manner: "grade_value" */
  grade_value_stream: Array<Grade_Value>;
  /** fetch data from the table: "gradebook" */
  gradebook: Array<Gradebook>;
  /** fetch aggregated fields from the table: "gradebook" */
  gradebook_aggregate: Gradebook_Aggregate;
  /** fetch data from the table: "gradebook" using primary key columns */
  gradebook_by_pk?: Maybe<Gradebook>;
  /** fetch data from the table in a streaming manner: "gradebook" */
  gradebook_stream: Array<Gradebook>;
  /** fetch data from the table: "group" */
  group: Array<Group>;
  /** fetch aggregated fields from the table: "group" */
  group_aggregate: Group_Aggregate;
  /** fetch data from the table: "group" using primary key columns */
  group_by_pk?: Maybe<Group>;
  /** fetch data from the table: "group_course" */
  group_course: Array<Group_Course>;
  /** fetch aggregated fields from the table: "group_course" */
  group_course_aggregate: Group_Course_Aggregate;
  /** fetch data from the table: "group_course" using primary key columns */
  group_course_by_pk?: Maybe<Group_Course>;
  /** fetch data from the table in a streaming manner: "group_course" */
  group_course_stream: Array<Group_Course>;
  /** fetch data from the table in a streaming manner: "group" */
  group_stream: Array<Group>;
  /** fetch data from the table: "group_workspace" */
  group_workspace: Array<Group_Workspace>;
  /** fetch aggregated fields from the table: "group_workspace" */
  group_workspace_aggregate: Group_Workspace_Aggregate;
  /** fetch data from the table: "group_workspace" using primary key columns */
  group_workspace_by_pk?: Maybe<Group_Workspace>;
  /** fetch data from the table in a streaming manner: "group_workspace" */
  group_workspace_stream: Array<Group_Workspace>;
  /** fetch data from the table: "installment" */
  installment: Array<Installment>;
  /** fetch aggregated fields from the table: "installment" */
  installment_aggregate: Installment_Aggregate;
  /** fetch data from the table: "installment" using primary key columns */
  installment_by_pk?: Maybe<Installment>;
  /** fetch data from the table in a streaming manner: "installment" */
  installment_stream: Array<Installment>;
  /** fetch data from the table: "instructor" */
  instructor: Array<Instructor>;
  /** fetch aggregated fields from the table: "instructor" */
  instructor_aggregate: Instructor_Aggregate;
  /** fetch data from the table: "instructor" using primary key columns */
  instructor_by_pk?: Maybe<Instructor>;
  /** fetch data from the table in a streaming manner: "instructor" */
  instructor_stream: Array<Instructor>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "invoice_installment" */
  invoice_installment: Array<Invoice_Installment>;
  /** fetch aggregated fields from the table: "invoice_installment" */
  invoice_installment_aggregate: Invoice_Installment_Aggregate;
  /** fetch data from the table: "invoice_installment" using primary key columns */
  invoice_installment_by_pk?: Maybe<Invoice_Installment>;
  /** fetch data from the table in a streaming manner: "invoice_installment" */
  invoice_installment_stream: Array<Invoice_Installment>;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "lecture" */
  lecture: Array<Lecture>;
  /** fetch aggregated fields from the table: "lecture" */
  lecture_aggregate: Lecture_Aggregate;
  /** fetch data from the table: "lecture" using primary key columns */
  lecture_by_pk?: Maybe<Lecture>;
  /** fetch data from the table: "lecture_note" */
  lecture_note: Array<Lecture_Note>;
  /** fetch aggregated fields from the table: "lecture_note" */
  lecture_note_aggregate: Lecture_Note_Aggregate;
  /** fetch data from the table: "lecture_note" using primary key columns */
  lecture_note_by_pk?: Maybe<Lecture_Note>;
  /** fetch data from the table in a streaming manner: "lecture_note" */
  lecture_note_stream: Array<Lecture_Note>;
  /** fetch data from the table: "lecture_resource" */
  lecture_resource: Array<Lecture_Resource>;
  /** fetch aggregated fields from the table: "lecture_resource" */
  lecture_resource_aggregate: Lecture_Resource_Aggregate;
  /** fetch data from the table: "lecture_resource" using primary key columns */
  lecture_resource_by_pk?: Maybe<Lecture_Resource>;
  /** fetch data from the table in a streaming manner: "lecture_resource" */
  lecture_resource_stream: Array<Lecture_Resource>;
  /** fetch data from the table in a streaming manner: "lecture" */
  lecture_stream: Array<Lecture>;
  /** fetch data from the table: "lesson" */
  lesson: Array<Lesson>;
  /** fetch aggregated fields from the table: "lesson" */
  lesson_aggregate: Lesson_Aggregate;
  /** fetch data from the table: "lesson" using primary key columns */
  lesson_by_pk?: Maybe<Lesson>;
  /** fetch data from the table in a streaming manner: "lesson" */
  lesson_stream: Array<Lesson>;
  /** fetch data from the table: "level" */
  level: Array<Level>;
  /** fetch aggregated fields from the table: "level" */
  level_aggregate: Level_Aggregate;
  /** fetch data from the table: "level" using primary key columns */
  level_by_pk?: Maybe<Level>;
  /** fetch data from the table in a streaming manner: "level" */
  level_stream: Array<Level>;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner: "media" */
  media_stream: Array<Media>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table in a streaming manner: "payment" */
  payment_stream: Array<Payment>;
  /** fetch data from the table: "progression" */
  progression: Array<Progression>;
  /** fetch aggregated fields from the table: "progression" */
  progression_aggregate: Progression_Aggregate;
  /** fetch data from the table: "progression" using primary key columns */
  progression_by_pk?: Maybe<Progression>;
  /** fetch data from the table in a streaming manner: "progression" */
  progression_stream: Array<Progression>;
  /** fetch data from the table: "question" */
  question: Array<Question>;
  /** fetch aggregated fields from the table: "question" */
  question_aggregate: Question_Aggregate;
  /** fetch data from the table: "question" using primary key columns */
  question_by_pk?: Maybe<Question>;
  /** fetch data from the table: "question_option" */
  question_option: Array<Question_Option>;
  /** fetch aggregated fields from the table: "question_option" */
  question_option_aggregate: Question_Option_Aggregate;
  /** fetch data from the table: "question_option" using primary key columns */
  question_option_by_pk?: Maybe<Question_Option>;
  /** fetch data from the table in a streaming manner: "question_option" */
  question_option_stream: Array<Question_Option>;
  /** fetch data from the table: "question_quiz" */
  question_quiz: Array<Question_Quiz>;
  /** fetch aggregated fields from the table: "question_quiz" */
  question_quiz_aggregate: Question_Quiz_Aggregate;
  /** fetch data from the table: "question_quiz" using primary key columns */
  question_quiz_by_pk?: Maybe<Question_Quiz>;
  /** fetch data from the table in a streaming manner: "question_quiz" */
  question_quiz_stream: Array<Question_Quiz>;
  /** fetch data from the table in a streaming manner: "question" */
  question_stream: Array<Question>;
  /** fetch data from the table: "question_tag" */
  question_tag: Array<Question_Tag>;
  /** fetch aggregated fields from the table: "question_tag" */
  question_tag_aggregate: Question_Tag_Aggregate;
  /** fetch data from the table: "question_tag" using primary key columns */
  question_tag_by_pk?: Maybe<Question_Tag>;
  /** fetch data from the table in a streaming manner: "question_tag" */
  question_tag_stream: Array<Question_Tag>;
  /** fetch data from the table: "question_workspace" */
  question_workspace: Array<Question_Workspace>;
  /** fetch aggregated fields from the table: "question_workspace" */
  question_workspace_aggregate: Question_Workspace_Aggregate;
  /** fetch data from the table: "question_workspace" using primary key columns */
  question_workspace_by_pk?: Maybe<Question_Workspace>;
  /** fetch data from the table in a streaming manner: "question_workspace" */
  question_workspace_stream: Array<Question_Workspace>;
  /** fetch data from the table: "quiz" */
  quiz: Array<Quiz>;
  /** fetch aggregated fields from the table: "quiz" */
  quiz_aggregate: Quiz_Aggregate;
  /** fetch data from the table: "quiz" using primary key columns */
  quiz_by_pk?: Maybe<Quiz>;
  /** fetch data from the table in a streaming manner: "quiz" */
  quiz_stream: Array<Quiz>;
  /** fetch data from the table: "recurring_event" */
  recurring_event: Array<Recurring_Event>;
  /** fetch aggregated fields from the table: "recurring_event" */
  recurring_event_aggregate: Recurring_Event_Aggregate;
  /** fetch data from the table: "recurring_event" using primary key columns */
  recurring_event_by_pk?: Maybe<Recurring_Event>;
  /** fetch data from the table in a streaming manner: "recurring_event" */
  recurring_event_stream: Array<Recurring_Event>;
  /** fetch data from the table: "school_fee" */
  school_fee: Array<School_Fee>;
  /** fetch aggregated fields from the table: "school_fee" */
  school_fee_aggregate: School_Fee_Aggregate;
  /** fetch data from the table: "school_fee" using primary key columns */
  school_fee_by_pk?: Maybe<School_Fee>;
  /** fetch data from the table in a streaming manner: "school_fee" */
  school_fee_stream: Array<School_Fee>;
  /** fetch data from the table: "school_period" */
  school_period: Array<School_Period>;
  /** fetch aggregated fields from the table: "school_period" */
  school_period_aggregate: School_Period_Aggregate;
  /** fetch data from the table: "school_period" using primary key columns */
  school_period_by_pk?: Maybe<School_Period>;
  /** fetch data from the table in a streaming manner: "school_period" */
  school_period_stream: Array<School_Period>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table in a streaming manner: "tag" */
  tag_stream: Array<Tag>;
  /** fetch data from the table: "text" */
  text: Array<Text>;
  /** fetch aggregated fields from the table: "text" */
  text_aggregate: Text_Aggregate;
  /** fetch data from the table: "text" using primary key columns */
  text_by_pk?: Maybe<Text>;
  /** fetch data from the table in a streaming manner: "text" */
  text_stream: Array<Text>;
  /** fetch data from the table: "typeorm_metadata" */
  typeorm_metadata: Array<Typeorm_Metadata>;
  /** fetch aggregated fields from the table: "typeorm_metadata" */
  typeorm_metadata_aggregate: Typeorm_Metadata_Aggregate;
  /** fetch data from the table in a streaming manner: "typeorm_metadata" */
  typeorm_metadata_stream: Array<Typeorm_Metadata>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table in a streaming manner: "unit" */
  unit_stream: Array<Unit>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_activity" */
  user_activity: Array<User_Activity>;
  /** fetch aggregated fields from the table: "user_activity" */
  user_activity_aggregate: User_Activity_Aggregate;
  /** fetch data from the table: "user_activity" using primary key columns */
  user_activity_by_pk?: Maybe<User_Activity>;
  /** fetch data from the table in a streaming manner: "user_activity" */
  user_activity_stream: Array<User_Activity>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_assignment" */
  user_assignment: Array<User_Assignment>;
  /** fetch data from the table: "user_assignment_activity" */
  user_assignment_activity: Array<User_Assignment_Activity>;
  /** fetch aggregated fields from the table: "user_assignment_activity" */
  user_assignment_activity_aggregate: User_Assignment_Activity_Aggregate;
  /** fetch data from the table: "user_assignment_activity" using primary key columns */
  user_assignment_activity_by_pk?: Maybe<User_Assignment_Activity>;
  /** fetch data from the table in a streaming manner: "user_assignment_activity" */
  user_assignment_activity_stream: Array<User_Assignment_Activity>;
  /** fetch aggregated fields from the table: "user_assignment" */
  user_assignment_aggregate: User_Assignment_Aggregate;
  /** fetch data from the table: "user_assignment" using primary key columns */
  user_assignment_by_pk?: Maybe<User_Assignment>;
  /** fetch data from the table in a streaming manner: "user_assignment" */
  user_assignment_stream: Array<User_Assignment>;
  /** fetch data from the table: "user_block" */
  user_block: Array<User_Block>;
  /** fetch aggregated fields from the table: "user_block" */
  user_block_aggregate: User_Block_Aggregate;
  /** fetch data from the table: "user_block" using primary key columns */
  user_block_by_pk?: Maybe<User_Block>;
  /** fetch data from the table in a streaming manner: "user_block" */
  user_block_stream: Array<User_Block>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_checkpoint" */
  user_checkpoint: Array<User_Checkpoint>;
  /** fetch aggregated fields from the table: "user_checkpoint" */
  user_checkpoint_aggregate: User_Checkpoint_Aggregate;
  /** fetch data from the table: "user_checkpoint" using primary key columns */
  user_checkpoint_by_pk?: Maybe<User_Checkpoint>;
  /** fetch data from the table in a streaming manner: "user_checkpoint" */
  user_checkpoint_stream: Array<User_Checkpoint>;
  /** fetch data from the table: "user_class" */
  user_class: Array<User_Class>;
  /** fetch aggregated fields from the table: "user_class" */
  user_class_aggregate: User_Class_Aggregate;
  /** fetch data from the table: "user_class" using primary key columns */
  user_class_by_pk?: Maybe<User_Class>;
  /** fetch data from the table in a streaming manner: "user_class" */
  user_class_stream: Array<User_Class>;
  /** fetch data from the table: "user_course" */
  user_course: Array<User_Course>;
  /** fetch aggregated fields from the table: "user_course" */
  user_course_aggregate: User_Course_Aggregate;
  /** fetch data from the table: "user_course" using primary key columns */
  user_course_by_pk?: Maybe<User_Course>;
  /** fetch data from the table in a streaming manner: "user_course" */
  user_course_stream: Array<User_Course>;
  /** fetch data from the table: "user_event" */
  user_event: Array<User_Event>;
  /** fetch aggregated fields from the table: "user_event" */
  user_event_aggregate: User_Event_Aggregate;
  /** fetch data from the table: "user_event" using primary key columns */
  user_event_by_pk?: Maybe<User_Event>;
  /** fetch data from the table in a streaming manner: "user_event" */
  user_event_stream: Array<User_Event>;
  /** fetch data from the table: "user_group" */
  user_group: Array<User_Group>;
  /** fetch aggregated fields from the table: "user_group" */
  user_group_aggregate: User_Group_Aggregate;
  /** fetch data from the table: "user_group" using primary key columns */
  user_group_by_pk?: Maybe<User_Group>;
  /** fetch data from the table in a streaming manner: "user_group" */
  user_group_stream: Array<User_Group>;
  /** fetch data from the table: "user_lecture" */
  user_lecture: Array<User_Lecture>;
  /** fetch aggregated fields from the table: "user_lecture" */
  user_lecture_aggregate: User_Lecture_Aggregate;
  /** fetch data from the table: "user_lecture" using primary key columns */
  user_lecture_by_pk?: Maybe<User_Lecture>;
  /** fetch data from the table in a streaming manner: "user_lecture" */
  user_lecture_stream: Array<User_Lecture>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_workspace" */
  user_workspace: Array<User_Workspace>;
  /** fetch aggregated fields from the table: "user_workspace" */
  user_workspace_aggregate: User_Workspace_Aggregate;
  /** fetch data from the table: "user_workspace" using primary key columns */
  user_workspace_by_pk?: Maybe<User_Workspace>;
  /** fetch data from the table in a streaming manner: "user_workspace" */
  user_workspace_stream: Array<User_Workspace>;
  /** fetch data from the table: "workspace" */
  workspace: Array<Workspace>;
  /** fetch aggregated fields from the table: "workspace" */
  workspace_aggregate: Workspace_Aggregate;
  /** fetch data from the table: "workspace" using primary key columns */
  workspace_by_pk?: Maybe<Workspace>;
  /** fetch data from the table in a streaming manner: "workspace" */
  workspace_stream: Array<Workspace>;
};


export type Subscription_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActivity_LayoutArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


export type Subscription_RootActivity_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


export type Subscription_RootActivity_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActivity_Layout_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Activity_Layout_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
};


export type Subscription_RootActivity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootAssignment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Activity_Order_By>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootAssignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAssignment_Activity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_BlockArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


export type Subscription_RootAssignment_Block_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


export type Subscription_RootAssignment_Block_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAssignment_Block_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Block_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


export type Subscription_RootAssignment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAssignment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootBlockArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


export type Subscription_RootBlock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


export type Subscription_RootBlock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBlock_List_ItemArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


export type Subscription_RootBlock_List_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


export type Subscription_RootBlock_List_Item_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBlock_List_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Block_List_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


export type Subscription_RootBlock_List_Item_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


export type Subscription_RootBlock_List_Item_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


export type Subscription_RootBlock_List_Item_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBlock_List_Item_Workspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Block_List_Item_Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


export type Subscription_RootBlock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Block_Stream_Cursor_Input>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


export type Subscription_RootBlock_TagArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


export type Subscription_RootBlock_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


export type Subscription_RootBlock_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBlock_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Block_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


export type Subscription_RootCalendar_EventArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


export type Subscription_RootCalendar_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


export type Subscription_RootCalendar_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCalendar_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Calendar_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


export type Subscription_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCheckpointArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


export type Subscription_RootCheckpoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Order_By>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


export type Subscription_RootCheckpoint_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


export type Subscription_RootCheckpoint_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


export type Subscription_RootCheckpoint_Attempts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCheckpoint_Attempts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Checkpoint_Attempts_Stream_Cursor_Input>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


export type Subscription_RootCheckpoint_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCheckpoint_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Checkpoint_Stream_Cursor_Input>>;
  where?: InputMaybe<Checkpoint_Bool_Exp>;
};


export type Subscription_RootClassArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


export type Subscription_RootClass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Order_By>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


export type Subscription_RootClass_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClass_CourseArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


export type Subscription_RootClass_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Order_By>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


export type Subscription_RootClass_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClass_Course_NoteArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


export type Subscription_RootClass_Course_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


export type Subscription_RootClass_Course_Note_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClass_Course_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Course_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


export type Subscription_RootClass_Course_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


export type Subscription_RootClass_Course_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


export type Subscription_RootClass_Course_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClass_Course_Resource_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Course_Resource_Stream_Cursor_Input>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


export type Subscription_RootClass_Course_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Course_Stream_Cursor_Input>>;
  where?: InputMaybe<Class_Course_Bool_Exp>;
};


export type Subscription_RootClass_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Stream_Cursor_Input>>;
  where?: InputMaybe<Class_Bool_Exp>;
};


export type Subscription_RootClassroomArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


export type Subscription_RootClassroom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Order_By>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


export type Subscription_RootClassroom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClassroom_GroupArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


export type Subscription_RootClassroom_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Classroom_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classroom_Group_Order_By>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


export type Subscription_RootClassroom_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClassroom_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Classroom_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Classroom_Group_Bool_Exp>;
};


export type Subscription_RootClassroom_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Classroom_Stream_Cursor_Input>>;
  where?: InputMaybe<Classroom_Bool_Exp>;
};


export type Subscription_RootCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


export type Subscription_RootCourse_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Category_Order_By>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


export type Subscription_RootCourse_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Category_Bool_Exp>;
};


export type Subscription_RootCourse_Grade_LevelArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


export type Subscription_RootCourse_Grade_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Grade_Level_Order_By>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


export type Subscription_RootCourse_Grade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Grade_Level_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Grade_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Grade_Level_Bool_Exp>;
};


export type Subscription_RootCourse_InstructorArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


export type Subscription_RootCourse_Instructor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Instructor_Order_By>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


export type Subscription_RootCourse_Instructor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Instructor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Instructor_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Instructor_Bool_Exp>;
};


export type Subscription_RootCourse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_TagArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


export type Subscription_RootCourse_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


export type Subscription_RootCourse_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


export type Subscription_RootCourse_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


export type Subscription_RootCourse_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


export type Subscription_RootCourse_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Workspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


export type Subscription_RootDndArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


export type Subscription_RootDnd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnd_Order_By>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


export type Subscription_RootDnd_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDnd_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dnd_Stream_Cursor_Input>>;
  where?: InputMaybe<Dnd_Bool_Exp>;
};


export type Subscription_RootEvent_ClassroomArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


export type Subscription_RootEvent_Classroom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Classroom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Classroom_Order_By>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


export type Subscription_RootEvent_Classroom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEvent_Classroom_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Classroom_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Classroom_Bool_Exp>;
};


export type Subscription_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFeedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFill_BlankArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


export type Subscription_RootFill_Blank_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fill_Blank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fill_Blank_Order_By>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


export type Subscription_RootFill_Blank_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFill_Blank_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fill_Blank_Stream_Cursor_Input>>;
  where?: InputMaybe<Fill_Blank_Bool_Exp>;
};


export type Subscription_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_LevelArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


export type Subscription_RootGrade_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


export type Subscription_RootGrade_Level_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_Level_GroupArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


export type Subscription_RootGrade_Level_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Group_Order_By>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


export type Subscription_RootGrade_Level_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_Level_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Level_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Level_Group_Bool_Exp>;
};


export type Subscription_RootGrade_Level_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


export type Subscription_RootGrade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_ValueArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


export type Subscription_RootGrade_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


export type Subscription_RootGrade_Value_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_Value_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


export type Subscription_RootGradebookArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


export type Subscription_RootGradebook_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


export type Subscription_RootGradebook_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGradebook_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gradebook_Stream_Cursor_Input>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


export type Subscription_RootGroupArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


export type Subscription_RootGroup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Order_By>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


export type Subscription_RootGroup_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGroup_CourseArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


export type Subscription_RootGroup_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Course_Order_By>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


export type Subscription_RootGroup_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGroup_Course_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Group_Course_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Course_Bool_Exp>;
};


export type Subscription_RootGroup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Bool_Exp>;
};


export type Subscription_RootGroup_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


export type Subscription_RootGroup_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


export type Subscription_RootGroup_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGroup_Workspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Group_Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


export type Subscription_RootInstallmentArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


export type Subscription_RootInstallment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


export type Subscription_RootInstallment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInstallment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Installment_Stream_Cursor_Input>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


export type Subscription_RootInstructorArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


export type Subscription_RootInstructor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instructor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instructor_Order_By>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


export type Subscription_RootInstructor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInstructor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Instructor_Stream_Cursor_Input>>;
  where?: InputMaybe<Instructor_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInvoice_InstallmentArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


export type Subscription_RootInvoice_Installment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


export type Subscription_RootInvoice_Installment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInvoice_Installment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Installment_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootLectureArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


export type Subscription_RootLecture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


export type Subscription_RootLecture_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLecture_NoteArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


export type Subscription_RootLecture_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Note_Order_By>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


export type Subscription_RootLecture_Note_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLecture_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lecture_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Lecture_Note_Bool_Exp>;
};


export type Subscription_RootLecture_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


export type Subscription_RootLecture_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Resource_Order_By>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


export type Subscription_RootLecture_Resource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLecture_Resource_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lecture_Resource_Stream_Cursor_Input>>;
  where?: InputMaybe<Lecture_Resource_Bool_Exp>;
};


export type Subscription_RootLecture_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lecture_Stream_Cursor_Input>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


export type Subscription_RootLessonArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


export type Subscription_RootLesson_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


export type Subscription_RootLesson_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLesson_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lesson_Stream_Cursor_Input>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


export type Subscription_RootLevelArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


export type Subscription_RootLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Level_Order_By>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


export type Subscription_RootLevel_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLevel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Level_Bool_Exp>;
};


export type Subscription_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMedia_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootProgressionArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


export type Subscription_RootProgression_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


export type Subscription_RootProgression_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProgression_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Progression_Stream_Cursor_Input>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


export type Subscription_RootQuestionArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


export type Subscription_RootQuestion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Order_By>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


export type Subscription_RootQuestion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestion_OptionArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


export type Subscription_RootQuestion_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Option_Order_By>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


export type Subscription_RootQuestion_Option_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestion_Option_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Option_Bool_Exp>;
};


export type Subscription_RootQuestion_QuizArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


export type Subscription_RootQuestion_Quiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


export type Subscription_RootQuestion_Quiz_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestion_Quiz_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Quiz_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
};


export type Subscription_RootQuestion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Bool_Exp>;
};


export type Subscription_RootQuestion_TagArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


export type Subscription_RootQuestion_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


export type Subscription_RootQuestion_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestion_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


export type Subscription_RootQuestion_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


export type Subscription_RootQuestion_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


export type Subscription_RootQuestion_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestion_Workspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


export type Subscription_RootQuizArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


export type Subscription_RootQuiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


export type Subscription_RootQuiz_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuiz_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quiz_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Bool_Exp>;
};


export type Subscription_RootRecurring_EventArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


export type Subscription_RootRecurring_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Event_Order_By>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


export type Subscription_RootRecurring_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRecurring_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Recurring_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Recurring_Event_Bool_Exp>;
};


export type Subscription_RootSchool_FeeArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


export type Subscription_RootSchool_Fee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


export type Subscription_RootSchool_Fee_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSchool_Fee_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<School_Fee_Stream_Cursor_Input>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


export type Subscription_RootSchool_PeriodArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


export type Subscription_RootSchool_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Period_Order_By>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


export type Subscription_RootSchool_Period_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSchool_Period_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<School_Period_Stream_Cursor_Input>>;
  where?: InputMaybe<School_Period_Bool_Exp>;
};


export type Subscription_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTextArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


export type Subscription_RootText_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Order_By>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


export type Subscription_RootText_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootText_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Text_Stream_Cursor_Input>>;
  where?: InputMaybe<Text_Bool_Exp>;
};


export type Subscription_RootTypeorm_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Typeorm_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Typeorm_Metadata_Order_By>>;
  where?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
};


export type Subscription_RootTypeorm_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Typeorm_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Typeorm_Metadata_Order_By>>;
  where?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
};


export type Subscription_RootTypeorm_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Typeorm_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
};


export type Subscription_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUnit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type Subscription_RootUser_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type Subscription_RootUser_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Activity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


export type Subscription_RootUser_Assignment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootUser_Assignment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootUser_Assignment_Activity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Assignment_Activity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Assignment_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


export type Subscription_RootUser_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


export type Subscription_RootUser_Assignment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Assignment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


export type Subscription_RootUser_BlockArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


export type Subscription_RootUser_Block_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


export type Subscription_RootUser_Block_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Block_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Block_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_CheckpointArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


export type Subscription_RootUser_Checkpoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


export type Subscription_RootUser_Checkpoint_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Checkpoint_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Checkpoint_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


export type Subscription_RootUser_ClassArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


export type Subscription_RootUser_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


export type Subscription_RootUser_Class_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Class_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Class_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


export type Subscription_RootUser_CourseArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


export type Subscription_RootUser_Course_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


export type Subscription_RootUser_Course_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Course_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Course_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


export type Subscription_RootUser_EventArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


export type Subscription_RootUser_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


export type Subscription_RootUser_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


export type Subscription_RootUser_GroupArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Subscription_RootUser_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Subscription_RootUser_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Subscription_RootUser_LectureArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


export type Subscription_RootUser_Lecture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


export type Subscription_RootUser_Lecture_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Lecture_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Lecture_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_WorkspaceArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


export type Subscription_RootUser_Workspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


export type Subscription_RootUser_Workspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Workspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


export type Subscription_RootWorkspaceArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};


export type Subscription_RootWorkspace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workspace_Order_By>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};


export type Subscription_RootWorkspace_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWorkspace_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Workspace_Stream_Cursor_Input>>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};

/** columns and relationships of "tag" */
export type Tag = {
  __typename?: 'tag';
  /** An array relationship */
  block_tags: Array<Block_Tag>;
  /** An aggregate relationship */
  block_tags_aggregate: Block_Tag_Aggregate;
  /** An array relationship */
  course_tags: Array<Course_Tag>;
  /** An aggregate relationship */
  course_tags_aggregate: Course_Tag_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  grade_levels: Array<Grade_Level>;
  /** An aggregate relationship */
  grade_levels_aggregate: Grade_Level_Aggregate;
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  question_tags: Array<Question_Tag>;
  /** An aggregate relationship */
  question_tags_aggregate: Question_Tag_Aggregate;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "tag" */
export type TagBlock_TagsArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagBlock_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Tag_Order_By>>;
  where?: InputMaybe<Block_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagCourse_TagsArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagCourse_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Tag_Order_By>>;
  where?: InputMaybe<Course_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagGrade_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagGrade_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Level_Order_By>>;
  where?: InputMaybe<Grade_Level_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagQuestion_TagsArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagQuestion_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tag_Order_By>>;
  where?: InputMaybe<Question_Tag_Bool_Exp>;
};

/** aggregated selection of "tag" */
export type Tag_Aggregate = {
  __typename?: 'tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields>;
  nodes: Array<Tag>;
};

export type Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tag_Aggregate_Bool_Exp_Count>;
};

export type Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tag_Select_Column_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tag_Select_Column_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tag" */
export type Tag_Aggregate_Fields = {
  __typename?: 'tag_aggregate_fields';
  avg?: Maybe<Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Max_Fields>;
  min?: Maybe<Tag_Min_Fields>;
  stddev?: Maybe<Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Sum_Fields>;
  var_pop?: Maybe<Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Var_Samp_Fields>;
  variance?: Maybe<Tag_Variance_Fields>;
};


/** aggregate fields of "tag" */
export type Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tag" */
export type Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Max_Order_By>;
  min?: InputMaybe<Tag_Min_Order_By>;
  stddev?: InputMaybe<Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tag" */
export type Tag_Arr_Rel_Insert_Input = {
  data: Array<Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Tag_Avg_Fields = {
  __typename?: 'tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tag" */
export type Tag_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Bool_Exp>>;
  _not?: InputMaybe<Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Bool_Exp>>;
  block_tags?: InputMaybe<Block_Tag_Bool_Exp>;
  block_tags_aggregate?: InputMaybe<Block_Tag_Aggregate_Bool_Exp>;
  course_tags?: InputMaybe<Course_Tag_Bool_Exp>;
  course_tags_aggregate?: InputMaybe<Course_Tag_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  grade_levels?: InputMaybe<Grade_Level_Bool_Exp>;
  grade_levels_aggregate?: InputMaybe<Grade_Level_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_tags?: InputMaybe<Question_Tag_Bool_Exp>;
  question_tags_aggregate?: InputMaybe<Question_Tag_Aggregate_Bool_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag" */
export const enum Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_8e4052373c579afc1471f526760 = 'PK_8e4052373c579afc1471f526760',
  /** unique or primary key constraint on columns "label" */
  Uq_647c189a51deb35bc452751bc4a = 'UQ_647c189a51deb35bc452751bc4a',
  /** unique or primary key constraint on columns "uid" */
  Uq_158402c9d19e5c07edbc15a10fe = 'UQ_158402c9d19e5c07edbc15a10fe'
};

/** input type for incrementing numeric columns in table "tag" */
export type Tag_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag" */
export type Tag_Insert_Input = {
  block_tags?: InputMaybe<Block_Tag_Arr_Rel_Insert_Input>;
  course_tags?: InputMaybe<Course_Tag_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  grade_levels?: InputMaybe<Grade_Level_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_tags?: InputMaybe<Question_Tag_Arr_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tag_Max_Fields = {
  __typename?: 'tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tag" */
export type Tag_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tag_Min_Fields = {
  __typename?: 'tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tag" */
export type Tag_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tag" */
export type Tag_Mutation_Response = {
  __typename?: 'tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag>;
};

/** input type for inserting object relation for remote table "tag" */
export type Tag_Obj_Rel_Insert_Input = {
  data: Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** on_conflict condition type for table "tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "tag". */
export type Tag_Order_By = {
  block_tags_aggregate?: InputMaybe<Block_Tag_Aggregate_Order_By>;
  course_tags_aggregate?: InputMaybe<Course_Tag_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  grade_levels_aggregate?: InputMaybe<Grade_Level_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_tags_aggregate?: InputMaybe<Question_Tag_Aggregate_Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag */
export type Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tag" */
export const enum Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tag" */
export const enum Tag_Select_Column_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tag" */
export const enum Tag_Select_Column_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "tag" */
export type Tag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Tag_Stddev_Fields = {
  __typename?: 'tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tag" */
export type Tag_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tag_Stddev_Pop_Fields = {
  __typename?: 'tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tag" */
export type Tag_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tag_Stddev_Samp_Fields = {
  __typename?: 'tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tag" */
export type Tag_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tag" */
export type Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Tag_Sum_Fields = {
  __typename?: 'tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tag" */
export type Tag_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "tag" */
export const enum Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tag_Var_Pop_Fields = {
  __typename?: 'tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tag" */
export type Tag_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tag_Var_Samp_Fields = {
  __typename?: 'tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tag" */
export type Tag_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tag_Variance_Fields = {
  __typename?: 'tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tag" */
export type Tag_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "text" */
export type Text = {
  __typename?: 'text';
  /** An array relationship */
  assignment_blocks: Array<Assignment_Block>;
  /** An aggregate relationship */
  assignment_blocks_aggregate: Assignment_Block_Aggregate;
  /** An array relationship */
  block_list_items: Array<Block_List_Item>;
  /** An aggregate relationship */
  block_list_items_aggregate: Block_List_Item_Aggregate;
  /** An array relationship */
  blocks: Array<Block>;
  /** An aggregate relationship */
  blocks_aggregate: Block_Aggregate;
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "text" */
export type TextAssignment_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "text" */
export type TextAssignment_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Block_Order_By>>;
  where?: InputMaybe<Assignment_Block_Bool_Exp>;
};


/** columns and relationships of "text" */
export type TextBlock_List_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "text" */
export type TextBlock_List_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By>>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
};


/** columns and relationships of "text" */
export type TextBlocksArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};


/** columns and relationships of "text" */
export type TextBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_Order_By>>;
  where?: InputMaybe<Block_Bool_Exp>;
};

/** aggregated selection of "text" */
export type Text_Aggregate = {
  __typename?: 'text_aggregate';
  aggregate?: Maybe<Text_Aggregate_Fields>;
  nodes: Array<Text>;
};

export type Text_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Text_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Text_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Text_Aggregate_Bool_Exp_Count>;
};

export type Text_Aggregate_Bool_Exp_Bool_And = {
  arguments: Text_Select_Column_Text_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Text_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Text_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Text_Select_Column_Text_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Text_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Text_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Text_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "text" */
export type Text_Aggregate_Fields = {
  __typename?: 'text_aggregate_fields';
  avg?: Maybe<Text_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Text_Max_Fields>;
  min?: Maybe<Text_Min_Fields>;
  stddev?: Maybe<Text_Stddev_Fields>;
  stddev_pop?: Maybe<Text_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Text_Stddev_Samp_Fields>;
  sum?: Maybe<Text_Sum_Fields>;
  var_pop?: Maybe<Text_Var_Pop_Fields>;
  var_samp?: Maybe<Text_Var_Samp_Fields>;
  variance?: Maybe<Text_Variance_Fields>;
};


/** aggregate fields of "text" */
export type Text_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "text" */
export type Text_Aggregate_Order_By = {
  avg?: InputMaybe<Text_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Text_Max_Order_By>;
  min?: InputMaybe<Text_Min_Order_By>;
  stddev?: InputMaybe<Text_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Text_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Text_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Text_Sum_Order_By>;
  var_pop?: InputMaybe<Text_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Text_Var_Samp_Order_By>;
  variance?: InputMaybe<Text_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "text" */
export type Text_Arr_Rel_Insert_Input = {
  data: Array<Text_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Text_On_Conflict>;
};

/** aggregate avg on columns */
export type Text_Avg_Fields = {
  __typename?: 'text_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "text" */
export type Text_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "text". All fields are combined with a logical 'AND'. */
export type Text_Bool_Exp = {
  _and?: InputMaybe<Array<Text_Bool_Exp>>;
  _not?: InputMaybe<Text_Bool_Exp>;
  _or?: InputMaybe<Array<Text_Bool_Exp>>;
  assignment_blocks?: InputMaybe<Assignment_Block_Bool_Exp>;
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Bool_Exp>;
  block_list_items?: InputMaybe<Block_List_Item_Bool_Exp>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Bool_Exp>;
  blocks?: InputMaybe<Block_Bool_Exp>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "text" */
export const enum Text_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEf734161ea7c326fedf699309f9 = 'PK_ef734161ea7c326fedf699309f9',
  /** unique or primary key constraint on columns "uid" */
  UqDcc5e7701c23ae11865ff938aba = 'UQ_dcc5e7701c23ae11865ff938aba'
};

/** input type for incrementing numeric columns in table "text" */
export type Text_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "text" */
export type Text_Insert_Input = {
  assignment_blocks?: InputMaybe<Assignment_Block_Arr_Rel_Insert_Input>;
  block_list_items?: InputMaybe<Block_List_Item_Arr_Rel_Insert_Input>;
  blocks?: InputMaybe<Block_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Text_Max_Fields = {
  __typename?: 'text_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "text" */
export type Text_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Text_Min_Fields = {
  __typename?: 'text_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "text" */
export type Text_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "text" */
export type Text_Mutation_Response = {
  __typename?: 'text_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Text>;
};

/** input type for inserting object relation for remote table "text" */
export type Text_Obj_Rel_Insert_Input = {
  data: Text_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Text_On_Conflict>;
};

/** on_conflict condition type for table "text" */
export type Text_On_Conflict = {
  constraint: Text_Constraint;
  update_columns?: Array<Text_Update_Column>;
  where?: InputMaybe<Text_Bool_Exp>;
};

/** Ordering options when selecting data from "text". */
export type Text_Order_By = {
  assignment_blocks_aggregate?: InputMaybe<Assignment_Block_Aggregate_Order_By>;
  block_list_items_aggregate?: InputMaybe<Block_List_Item_Aggregate_Order_By>;
  blocks_aggregate?: InputMaybe<Block_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: text */
export type Text_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "text" */
export const enum Text_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "text_aggregate_bool_exp_bool_and_arguments_columns" columns of table "text" */
export const enum Text_Select_Column_Text_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "text_aggregate_bool_exp_bool_or_arguments_columns" columns of table "text" */
export const enum Text_Select_Column_Text_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "text" */
export type Text_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Text_Stddev_Fields = {
  __typename?: 'text_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "text" */
export type Text_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Text_Stddev_Pop_Fields = {
  __typename?: 'text_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "text" */
export type Text_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Text_Stddev_Samp_Fields = {
  __typename?: 'text_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "text" */
export type Text_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "text" */
export type Text_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Text_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Text_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Text_Sum_Fields = {
  __typename?: 'text_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "text" */
export type Text_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "text" */
export const enum Text_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Text_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Text_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Text_Set_Input>;
  /** filter the rows which have to be updated */
  where: Text_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Text_Var_Pop_Fields = {
  __typename?: 'text_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "text" */
export type Text_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Text_Var_Samp_Fields = {
  __typename?: 'text_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "text" */
export type Text_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Text_Variance_Fields = {
  __typename?: 'text_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "text" */
export type Text_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "typeorm_metadata" */
export type Typeorm_Metadata = {
  __typename?: 'typeorm_metadata';
  database?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "typeorm_metadata" */
export type Typeorm_Metadata_Aggregate = {
  __typename?: 'typeorm_metadata_aggregate';
  aggregate?: Maybe<Typeorm_Metadata_Aggregate_Fields>;
  nodes: Array<Typeorm_Metadata>;
};

/** aggregate fields of "typeorm_metadata" */
export type Typeorm_Metadata_Aggregate_Fields = {
  __typename?: 'typeorm_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Typeorm_Metadata_Max_Fields>;
  min?: Maybe<Typeorm_Metadata_Min_Fields>;
};


/** aggregate fields of "typeorm_metadata" */
export type Typeorm_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Typeorm_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "typeorm_metadata". All fields are combined with a logical 'AND'. */
export type Typeorm_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Typeorm_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Typeorm_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Typeorm_Metadata_Bool_Exp>>;
  database?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  schema?: InputMaybe<String_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "typeorm_metadata" */
export type Typeorm_Metadata_Insert_Input = {
  database?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Typeorm_Metadata_Max_Fields = {
  __typename?: 'typeorm_metadata_max_fields';
  database?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Typeorm_Metadata_Min_Fields = {
  __typename?: 'typeorm_metadata_min_fields';
  database?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "typeorm_metadata" */
export type Typeorm_Metadata_Mutation_Response = {
  __typename?: 'typeorm_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Typeorm_Metadata>;
};

/** Ordering options when selecting data from "typeorm_metadata". */
export type Typeorm_Metadata_Order_By = {
  database?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  schema?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "typeorm_metadata" */
export const enum Typeorm_Metadata_Select_Column {
  /** column name */
  Database = 'database',
  /** column name */
  Name = 'name',
  /** column name */
  Schema = 'schema',
  /** column name */
  Table = 'table',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
};

/** input type for updating data in table "typeorm_metadata" */
export type Typeorm_Metadata_Set_Input = {
  database?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "typeorm_metadata" */
export type Typeorm_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Typeorm_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Typeorm_Metadata_Stream_Cursor_Value_Input = {
  database?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Typeorm_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Typeorm_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Typeorm_Metadata_Bool_Exp;
};

/** columns and relationships of "unit" */
export type Unit = {
  __typename?: 'unit';
  coefficient: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An array relationship */
  lessons: Array<Lesson>;
  /** An aggregate relationship */
  lessons_aggregate: Lesson_Aggregate;
  /** An object relationship */
  level: Level;
  levelId: Scalars['Int'];
  order: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  title: Scalars['String'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "unit" */
export type UnitLessonsArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitLessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lesson_Order_By>>;
  where?: InputMaybe<Lesson_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};

/** aggregated selection of "unit" */
export type Unit_Aggregate = {
  __typename?: 'unit_aggregate';
  aggregate?: Maybe<Unit_Aggregate_Fields>;
  nodes: Array<Unit>;
};

export type Unit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Unit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Unit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Unit_Aggregate_Bool_Exp_Count>;
};

export type Unit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Unit_Select_Column_Unit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Unit_Select_Column_Unit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unit" */
export type Unit_Aggregate_Fields = {
  __typename?: 'unit_aggregate_fields';
  avg?: Maybe<Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Max_Fields>;
  min?: Maybe<Unit_Min_Fields>;
  stddev?: Maybe<Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Sum_Fields>;
  var_pop?: Maybe<Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Var_Samp_Fields>;
  variance?: Maybe<Unit_Variance_Fields>;
};


/** aggregate fields of "unit" */
export type Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit" */
export type Unit_Aggregate_Order_By = {
  avg?: InputMaybe<Unit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Max_Order_By>;
  min?: InputMaybe<Unit_Min_Order_By>;
  stddev?: InputMaybe<Unit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unit_Sum_Order_By>;
  var_pop?: InputMaybe<Unit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unit_Var_Samp_Order_By>;
  variance?: InputMaybe<Unit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unit" */
export type Unit_Arr_Rel_Insert_Input = {
  data: Array<Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** aggregate avg on columns */
export type Unit_Avg_Fields = {
  __typename?: 'unit_avg_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unit" */
export type Unit_Avg_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unit". All fields are combined with a logical 'AND'. */
export type Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bool_Exp>>;
  coefficient?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lessons?: InputMaybe<Lesson_Bool_Exp>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Bool_Exp>;
  level?: InputMaybe<Level_Bool_Exp>;
  levelId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  overview?: InputMaybe<String_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit" */
export const enum Unit_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_4252c4be609041e559f0c80f58a = 'PK_4252c4be609041e559f0c80f58a',
  /** unique or primary key constraint on columns "uid" */
  Uq_78722734dddcfdc4826bcb5d6a6 = 'UQ_78722734dddcfdc4826bcb5d6a6'
};

/** input type for incrementing numeric columns in table "unit" */
export type Unit_Inc_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "unit" */
export type Unit_Insert_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lessons?: InputMaybe<Lesson_Arr_Rel_Insert_Input>;
  level?: InputMaybe<Level_Obj_Rel_Insert_Input>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Unit_Max_Fields = {
  __typename?: 'unit_max_fields';
  coefficient?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "unit" */
export type Unit_Max_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Min_Fields = {
  __typename?: 'unit_min_fields';
  coefficient?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "unit" */
export type Unit_Min_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unit" */
export type Unit_Mutation_Response = {
  __typename?: 'unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "unit" */
export type Unit_Obj_Rel_Insert_Input = {
  data: Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** on_conflict condition type for table "unit" */
export type Unit_On_Conflict = {
  constraint: Unit_Constraint;
  update_columns?: Array<Unit_Update_Column>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "unit". */
export type Unit_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessons_aggregate?: InputMaybe<Lesson_Aggregate_Order_By>;
  level?: InputMaybe<Level_Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  overview?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit */
export type Unit_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "unit" */
export const enum Unit_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "unit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "unit" */
export const enum Unit_Select_Column_Unit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "unit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "unit" */
export const enum Unit_Select_Column_Unit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "unit" */
export type Unit_Set_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Unit_Stddev_Fields = {
  __typename?: 'unit_stddev_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unit" */
export type Unit_Stddev_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unit_Stddev_Pop_Fields = {
  __typename?: 'unit_stddev_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unit" */
export type Unit_Stddev_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unit_Stddev_Samp_Fields = {
  __typename?: 'unit_stddev_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unit" */
export type Unit_Stddev_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unit" */
export type Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  levelId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  overview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Unit_Sum_Fields = {
  __typename?: 'unit_sum_fields';
  coefficient?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  levelId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "unit" */
export type Unit_Sum_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "unit" */
export const enum Unit_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Order = 'order',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Overview = 'overview',
  /** column name */
  Title = 'title',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unit_Var_Pop_Fields = {
  __typename?: 'unit_var_pop_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unit" */
export type Unit_Var_Pop_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unit_Var_Samp_Fields = {
  __typename?: 'unit_var_samp_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unit" */
export type Unit_Var_Samp_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unit_Variance_Fields = {
  __typename?: 'unit_variance_fields';
  coefficient?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  levelId?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unit" */
export type Unit_Variance_Order_By = {
  coefficient?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levelId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  address?: Maybe<Scalars['String']>;
  birth_date?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  calendar_events: Array<Calendar_Event>;
  /** An aggregate relationship */
  calendar_events_aggregate: Calendar_Event_Aggregate;
  /** An array relationship */
  checkpoint_attempts: Array<Checkpoint_Attempts>;
  /** An aggregate relationship */
  checkpoint_attempts_aggregate: Checkpoint_Attempts_Aggregate;
  city?: Maybe<Scalars['String']>;
  /** An array relationship */
  class_course_notes: Array<Class_Course_Note>;
  /** An aggregate relationship */
  class_course_notes_aggregate: Class_Course_Note_Aggregate;
  /** An array relationship */
  class_course_resources: Array<Class_Course_Resource>;
  /** An aggregate relationship */
  class_course_resources_aggregate: Class_Course_Resource_Aggregate;
  confirmed: Scalars['Boolean'];
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** An array relationship */
  files: Array<File>;
  /** An aggregate relationship */
  files_aggregate: File_Aggregate;
  first_name: Scalars['String'];
  gender?: Maybe<Scalars['user_gender_enum']>;
  /** An array relationship */
  gradeValuesByCreatedbyid: Array<Grade_Value>;
  /** An aggregate relationship */
  gradeValuesByCreatedbyid_aggregate: Grade_Value_Aggregate;
  /** An array relationship */
  gradeValuesByUpdatedbyid: Array<Grade_Value>;
  /** An aggregate relationship */
  gradeValuesByUpdatedbyid_aggregate: Grade_Value_Aggregate;
  /** An array relationship */
  grade_values: Array<Grade_Value>;
  /** An aggregate relationship */
  grade_values_aggregate: Grade_Value_Aggregate;
  /** An array relationship */
  gradebooks: Array<Gradebook>;
  /** An aggregate relationship */
  gradebooks_aggregate: Gradebook_Aggregate;
  /** An array relationship */
  grades: Array<Grade>;
  /** An aggregate relationship */
  grades_aggregate: Grade_Aggregate;
  id: Scalars['Int'];
  id_number?: Maybe<Scalars['String']>;
  id_student?: Maybe<Scalars['String']>;
  /** An array relationship */
  installments: Array<Installment>;
  /** An array relationship */
  installmentsByCreatedbyid: Array<Installment>;
  /** An aggregate relationship */
  installmentsByCreatedbyid_aggregate: Installment_Aggregate;
  /** An aggregate relationship */
  installments_aggregate: Installment_Aggregate;
  /** An array relationship */
  invoice_installments: Array<Invoice_Installment>;
  /** An aggregate relationship */
  invoice_installments_aggregate: Invoice_Installment_Aggregate;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An array relationship */
  invoicesByCreatedbyid: Array<Invoice>;
  /** An aggregate relationship */
  invoicesByCreatedbyid_aggregate: Invoice_Aggregate;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  language: Scalars['user_language_enum'];
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name: Scalars['String'];
  /** An array relationship */
  lectures: Array<Lecture>;
  /** An aggregate relationship */
  lectures_aggregate: Lecture_Aggregate;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  place_birth?: Maybe<Scalars['String']>;
  /** An array relationship */
  progressions: Array<Progression>;
  /** An aggregate relationship */
  progressions_aggregate: Progression_Aggregate;
  role: Scalars['user_role_enum'];
  /** An array relationship */
  school_fees: Array<School_Fee>;
  /** An aggregate relationship */
  school_fees_aggregate: School_Fee_Aggregate;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  /** An array relationship */
  user_assignment_activities: Array<User_Assignment_Activity>;
  /** An aggregate relationship */
  user_assignment_activities_aggregate: User_Assignment_Activity_Aggregate;
  /** An array relationship */
  user_assignments: Array<User_Assignment>;
  /** An aggregate relationship */
  user_assignments_aggregate: User_Assignment_Aggregate;
  /** An array relationship */
  user_blocks: Array<User_Block>;
  /** An aggregate relationship */
  user_blocks_aggregate: User_Block_Aggregate;
  /** An array relationship */
  user_checkpoints: Array<User_Checkpoint>;
  /** An aggregate relationship */
  user_checkpoints_aggregate: User_Checkpoint_Aggregate;
  /** An array relationship */
  user_classes: Array<User_Class>;
  /** An aggregate relationship */
  user_classes_aggregate: User_Class_Aggregate;
  /** An array relationship */
  user_courses: Array<User_Course>;
  /** An aggregate relationship */
  user_courses_aggregate: User_Course_Aggregate;
  /** An array relationship */
  user_events: Array<User_Event>;
  /** An aggregate relationship */
  user_events_aggregate: User_Event_Aggregate;
  /** An array relationship */
  user_groups: Array<User_Group>;
  /** An aggregate relationship */
  user_groups_aggregate: User_Group_Aggregate;
  /** An array relationship */
  user_lectures: Array<User_Lecture>;
  /** An aggregate relationship */
  user_lectures_aggregate: User_Lecture_Aggregate;
  /** An array relationship */
  user_workspaces: Array<User_Workspace>;
  /** An aggregate relationship */
  user_workspaces_aggregate: User_Workspace_Aggregate;
};


/** columns and relationships of "user" */
export type UserCalendar_EventsArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCalendar_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calendar_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Calendar_Event_Order_By>>;
  where?: InputMaybe<Calendar_Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCheckpoint_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCheckpoint_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkpoint_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkpoint_Attempts_Order_By>>;
  where?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserClass_Course_NotesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserClass_Course_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Note_Order_By>>;
  where?: InputMaybe<Class_Course_Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserClass_Course_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserClass_Course_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Class_Course_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Course_Resource_Order_By>>;
  where?: InputMaybe<Class_Course_Resource_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFilesArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradeValuesByCreatedbyidArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradeValuesByCreatedbyid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradeValuesByUpdatedbyidArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradeValuesByUpdatedbyid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGrade_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGrade_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Value_Order_By>>;
  where?: InputMaybe<Grade_Value_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradebooksArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradebooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gradebook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gradebook_Order_By>>;
  where?: InputMaybe<Gradebook_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGradesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInstallmentsByCreatedbyidArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInstallmentsByCreatedbyid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInstallments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Installment_Order_By>>;
  where?: InputMaybe<Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoice_InstallmentsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoice_Installments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Installment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Installment_Order_By>>;
  where?: InputMaybe<Invoice_Installment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicesByCreatedbyidArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicesByCreatedbyid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLecturesArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLectures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lecture_Order_By>>;
  where?: InputMaybe<Lecture_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProgressionsArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProgressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Progression_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Progression_Order_By>>;
  where?: InputMaybe<Progression_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSchool_FeesArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSchool_Fees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Fee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Fee_Order_By>>;
  where?: InputMaybe<School_Fee_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Assignment_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Assignment_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Activity_Order_By>>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assignment_Order_By>>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_BlocksArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Blocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Block_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Block_Order_By>>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_CheckpointsArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Checkpoints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Checkpoint_Order_By>>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_ClassesArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Class_Order_By>>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_CoursesArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Course_Order_By>>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_EventsArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Event_Order_By>>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_GroupsArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_LecturesArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Lectures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lecture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Lecture_Order_By>>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};

/** columns and relationships of "user_activity" */
export type User_Activity = {
  __typename?: 'user_activity';
  /** An object relationship */
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  answers: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  infos: Scalars['jsonb'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "user_activity" */
export type User_ActivityAnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_activity" */
export type User_ActivityInfosArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_activity" */
export type User_Activity_Aggregate = {
  __typename?: 'user_activity_aggregate';
  aggregate?: Maybe<User_Activity_Aggregate_Fields>;
  nodes: Array<User_Activity>;
};

export type User_Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Count>;
};

export type User_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_activity" */
export type User_Activity_Aggregate_Fields = {
  __typename?: 'user_activity_aggregate_fields';
  avg?: Maybe<User_Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Activity_Max_Fields>;
  min?: Maybe<User_Activity_Min_Fields>;
  stddev?: Maybe<User_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<User_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<User_Activity_Sum_Fields>;
  var_pop?: Maybe<User_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<User_Activity_Var_Samp_Fields>;
  variance?: Maybe<User_Activity_Variance_Fields>;
};


/** aggregate fields of "user_activity" */
export type User_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_activity" */
export type User_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<User_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Activity_Max_Order_By>;
  min?: InputMaybe<User_Activity_Min_Order_By>;
  stddev?: InputMaybe<User_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<User_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Activity_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Activity_Append_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  infos?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_activity" */
export type User_Activity_Arr_Rel_Insert_Input = {
  data: Array<User_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Activity_Avg_Fields = {
  __typename?: 'user_activity_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_activity" */
export type User_Activity_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_activity". All fields are combined with a logical 'AND'. */
export type User_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<User_Activity_Bool_Exp>>;
  _not?: InputMaybe<User_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<User_Activity_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  answers?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  infos?: InputMaybe<Jsonb_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_activity" */
export const enum User_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDaec6d19443689bda7d7785dff5 = 'PK_daec6d19443689bda7d7785dff5',
  /** unique or primary key constraint on columns "uid" */
  UqB1f5b12d2f934243c9f9eb59273 = 'UQ_b1f5b12d2f934243c9f9eb59273',
  /** unique or primary key constraint on columns "activityId", "userId" */
  IndexUserActivity = 'index_user_activity'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Activity_Delete_At_Path_Input = {
  answers?: InputMaybe<Array<Scalars['String']>>;
  infos?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Activity_Delete_Elem_Input = {
  answers?: InputMaybe<Scalars['Int']>;
  infos?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Activity_Delete_Key_Input = {
  answers?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_activity" */
export type User_Activity_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_activity" */
export type User_Activity_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  infos?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Activity_Max_Fields = {
  __typename?: 'user_activity_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_activity" */
export type User_Activity_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Activity_Min_Fields = {
  __typename?: 'user_activity_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_activity" */
export type User_Activity_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_activity" */
export type User_Activity_Mutation_Response = {
  __typename?: 'user_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Activity>;
};

/** on_conflict condition type for table "user_activity" */
export type User_Activity_On_Conflict = {
  constraint: User_Activity_Constraint;
  update_columns?: Array<User_Activity_Update_Column>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "user_activity". */
export type User_Activity_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityId?: InputMaybe<Order_By>;
  answers?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infos?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_activity */
export type User_Activity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Activity_Prepend_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  infos?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_activity" */
export const enum User_Activity_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Infos = 'infos',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_activity" */
export const enum User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_activity" */
export const enum User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_activity" */
export type User_Activity_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  infos?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Activity_Stddev_Fields = {
  __typename?: 'user_activity_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_activity" */
export type User_Activity_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Activity_Stddev_Pop_Fields = {
  __typename?: 'user_activity_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_activity" */
export type User_Activity_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Activity_Stddev_Samp_Fields = {
  __typename?: 'user_activity_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_activity" */
export type User_Activity_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_activity" */
export type User_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Activity_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  infos?: InputMaybe<Scalars['jsonb']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Activity_Sum_Fields = {
  __typename?: 'user_activity_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_activity" */
export type User_Activity_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_activity" */
export const enum User_Activity_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Infos = 'infos',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Activity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Activity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Activity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Activity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Activity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Activity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Activity_Var_Pop_Fields = {
  __typename?: 'user_activity_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_activity" */
export type User_Activity_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Activity_Var_Samp_Fields = {
  __typename?: 'user_activity_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_activity" */
export type User_Activity_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Activity_Variance_Fields = {
  __typename?: 'user_activity_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_activity" */
export type User_Activity_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

export type User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Aggregate_Bool_Exp_Count>;
};

export type User_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  avg?: InputMaybe<User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
  stddev?: InputMaybe<User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Sum_Order_By>;
  var_pop?: InputMaybe<User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** columns and relationships of "user_assignment" */
export type User_Assignment = {
  __typename?: 'user_assignment';
  /** An object relationship */
  assignment: Assignment;
  assignmentId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  score: Scalars['float8'];
  submitted: Scalars['Boolean'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};

/** columns and relationships of "user_assignment_activity" */
export type User_Assignment_Activity = {
  __typename?: 'user_assignment_activity';
  activityId: Scalars['Int'];
  answers: Scalars['jsonb'];
  /** An object relationship */
  assignment_activity: Assignment_Activity;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  score: Scalars['float8'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};


/** columns and relationships of "user_assignment_activity" */
export type User_Assignment_ActivityAnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_assignment_activity" */
export type User_Assignment_Activity_Aggregate = {
  __typename?: 'user_assignment_activity_aggregate';
  aggregate?: Maybe<User_Assignment_Activity_Aggregate_Fields>;
  nodes: Array<User_Assignment_Activity>;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Avg = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Corr = {
  arguments: User_Assignment_Activity_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Max = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Min = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Sum = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Activity_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_assignment_activity" */
export type User_Assignment_Activity_Aggregate_Fields = {
  __typename?: 'user_assignment_activity_aggregate_fields';
  avg?: Maybe<User_Assignment_Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Assignment_Activity_Max_Fields>;
  min?: Maybe<User_Assignment_Activity_Min_Fields>;
  stddev?: Maybe<User_Assignment_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<User_Assignment_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Assignment_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<User_Assignment_Activity_Sum_Fields>;
  var_pop?: Maybe<User_Assignment_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<User_Assignment_Activity_Var_Samp_Fields>;
  variance?: Maybe<User_Assignment_Activity_Variance_Fields>;
};


/** aggregate fields of "user_assignment_activity" */
export type User_Assignment_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Assignment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_assignment_activity" */
export type User_Assignment_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<User_Assignment_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Assignment_Activity_Max_Order_By>;
  min?: InputMaybe<User_Assignment_Activity_Min_Order_By>;
  stddev?: InputMaybe<User_Assignment_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Assignment_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Assignment_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Assignment_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<User_Assignment_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Assignment_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Assignment_Activity_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Assignment_Activity_Append_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_assignment_activity" */
export type User_Assignment_Activity_Arr_Rel_Insert_Input = {
  data: Array<User_Assignment_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assignment_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Assignment_Activity_Avg_Fields = {
  __typename?: 'user_assignment_activity_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_assignment_activity". All fields are combined with a logical 'AND'. */
export type User_Assignment_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<User_Assignment_Activity_Bool_Exp>>;
  _not?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<User_Assignment_Activity_Bool_Exp>>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  answers?: InputMaybe<Jsonb_Comparison_Exp>;
  assignment_activity?: InputMaybe<Assignment_Activity_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_assignment_activity" */
export const enum User_Assignment_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_5082edcc8c4bd3304b25784e9e5 = 'PK_5082edcc8c4bd3304b25784e9e5',
  /** unique or primary key constraint on columns "uid" */
  UqBad7b99d00bac355a21a43c0379 = 'UQ_bad7b99d00bac355a21a43c0379',
  /** unique or primary key constraint on columns "activityId", "userId" */
  IndexUserAssignmentActivity = 'index_user_assignment_activity'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Assignment_Activity_Delete_At_Path_Input = {
  answers?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Assignment_Activity_Delete_Elem_Input = {
  answers?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Assignment_Activity_Delete_Key_Input = {
  answers?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_assignment_activity" */
export type User_Assignment_Activity_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_assignment_activity" */
export type User_Assignment_Activity_Insert_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  assignment_activity?: InputMaybe<Assignment_Activity_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Assignment_Activity_Max_Fields = {
  __typename?: 'user_assignment_activity_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Assignment_Activity_Min_Fields = {
  __typename?: 'user_assignment_activity_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_assignment_activity" */
export type User_Assignment_Activity_Mutation_Response = {
  __typename?: 'user_assignment_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Assignment_Activity>;
};

/** on_conflict condition type for table "user_assignment_activity" */
export type User_Assignment_Activity_On_Conflict = {
  constraint: User_Assignment_Activity_Constraint;
  update_columns?: Array<User_Assignment_Activity_Update_Column>;
  where?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "user_assignment_activity". */
export type User_Assignment_Activity_Order_By = {
  activityId?: InputMaybe<Order_By>;
  answers?: InputMaybe<Order_By>;
  assignment_activity?: InputMaybe<Assignment_Activity_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_assignment_activity */
export type User_Assignment_Activity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Assignment_Activity_Prepend_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Score = 'score',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_assignment_activity_aggregate_bool_exp_avg_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_assignment_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_assignment_activity_aggregate_bool_exp_corr_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_max_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_min_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_sum_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_activity_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Select_Column_User_Assignment_Activity_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** input type for updating data in table "user_assignment_activity" */
export type User_Assignment_Activity_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Assignment_Activity_Stddev_Fields = {
  __typename?: 'user_assignment_activity_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Assignment_Activity_Stddev_Pop_Fields = {
  __typename?: 'user_assignment_activity_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Assignment_Activity_Stddev_Samp_Fields = {
  __typename?: 'user_assignment_activity_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_assignment_activity" */
export type User_Assignment_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Assignment_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Assignment_Activity_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Assignment_Activity_Sum_Fields = {
  __typename?: 'user_assignment_activity_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_assignment_activity" */
export const enum User_Assignment_Activity_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Score = 'score',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Assignment_Activity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Assignment_Activity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Assignment_Activity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Assignment_Activity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Assignment_Activity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Assignment_Activity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Assignment_Activity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Assignment_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Assignment_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Assignment_Activity_Var_Pop_Fields = {
  __typename?: 'user_assignment_activity_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Assignment_Activity_Var_Samp_Fields = {
  __typename?: 'user_assignment_activity_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Assignment_Activity_Variance_Fields = {
  __typename?: 'user_assignment_activity_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_assignment_activity" */
export type User_Assignment_Activity_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregated selection of "user_assignment" */
export type User_Assignment_Aggregate = {
  __typename?: 'user_assignment_aggregate';
  aggregate?: Maybe<User_Assignment_Aggregate_Fields>;
  nodes: Array<User_Assignment>;
};

export type User_Assignment_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Assignment_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Assignment_Aggregate_Bool_Exp_Avg = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Corr = {
  arguments: User_Assignment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Assignment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Assignment_Aggregate_Bool_Exp_Max = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Min = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Sum = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Assignment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Assignment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_assignment" */
export type User_Assignment_Aggregate_Fields = {
  __typename?: 'user_assignment_aggregate_fields';
  avg?: Maybe<User_Assignment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Assignment_Max_Fields>;
  min?: Maybe<User_Assignment_Min_Fields>;
  stddev?: Maybe<User_Assignment_Stddev_Fields>;
  stddev_pop?: Maybe<User_Assignment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Assignment_Stddev_Samp_Fields>;
  sum?: Maybe<User_Assignment_Sum_Fields>;
  var_pop?: Maybe<User_Assignment_Var_Pop_Fields>;
  var_samp?: Maybe<User_Assignment_Var_Samp_Fields>;
  variance?: Maybe<User_Assignment_Variance_Fields>;
};


/** aggregate fields of "user_assignment" */
export type User_Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_assignment" */
export type User_Assignment_Aggregate_Order_By = {
  avg?: InputMaybe<User_Assignment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Assignment_Max_Order_By>;
  min?: InputMaybe<User_Assignment_Min_Order_By>;
  stddev?: InputMaybe<User_Assignment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Assignment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Assignment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Assignment_Sum_Order_By>;
  var_pop?: InputMaybe<User_Assignment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Assignment_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Assignment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_assignment" */
export type User_Assignment_Arr_Rel_Insert_Input = {
  data: Array<User_Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assignment_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Assignment_Avg_Fields = {
  __typename?: 'user_assignment_avg_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_assignment" */
export type User_Assignment_Avg_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_assignment". All fields are combined with a logical 'AND'. */
export type User_Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<User_Assignment_Bool_Exp>>;
  _not?: InputMaybe<User_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<User_Assignment_Bool_Exp>>;
  assignment?: InputMaybe<Assignment_Bool_Exp>;
  assignmentId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  submitted?: InputMaybe<Boolean_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_assignment" */
export const enum User_Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_910c7f8df4aa071110ed74e6878 = 'PK_910c7f8df4aa071110ed74e6878',
  /** unique or primary key constraint on columns "uid" */
  Uq_5ce67ab2fce129f244b64d14edb = 'UQ_5ce67ab2fce129f244b64d14edb',
  /** unique or primary key constraint on columns "assignmentId", "userId" */
  IndexUserAssignment = 'index_user_assignment'
};

/** input type for incrementing numeric columns in table "user_assignment" */
export type User_Assignment_Inc_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_assignment" */
export type User_Assignment_Insert_Input = {
  assignment?: InputMaybe<Assignment_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Assignment_Max_Fields = {
  __typename?: 'user_assignment_max_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_assignment" */
export type User_Assignment_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Assignment_Min_Fields = {
  __typename?: 'user_assignment_min_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_assignment" */
export type User_Assignment_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_assignment" */
export type User_Assignment_Mutation_Response = {
  __typename?: 'user_assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Assignment>;
};

/** on_conflict condition type for table "user_assignment" */
export type User_Assignment_On_Conflict = {
  constraint: User_Assignment_Constraint;
  update_columns?: Array<User_Assignment_Update_Column>;
  where?: InputMaybe<User_Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "user_assignment". */
export type User_Assignment_Order_By = {
  assignment?: InputMaybe<Assignment_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  submitted?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_assignment */
export type User_Assignment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_assignment" */
export const enum User_Assignment_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Score = 'score',
  /** column name */
  Submitted = 'submitted',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_assignment_aggregate_bool_exp_avg_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Submitted = 'submitted'
};

/** select "user_assignment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Submitted = 'submitted'
};

/** select "user_assignment_aggregate_bool_exp_corr_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_max_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_min_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_sum_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_assignment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_assignment" */
export const enum User_Assignment_Select_Column_User_Assignment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** input type for updating data in table "user_assignment" */
export type User_Assignment_Set_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Assignment_Stddev_Fields = {
  __typename?: 'user_assignment_stddev_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_assignment" */
export type User_Assignment_Stddev_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Assignment_Stddev_Pop_Fields = {
  __typename?: 'user_assignment_stddev_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_assignment" */
export type User_Assignment_Stddev_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Assignment_Stddev_Samp_Fields = {
  __typename?: 'user_assignment_stddev_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_assignment" */
export type User_Assignment_Stddev_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_assignment" */
export type User_Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Assignment_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Assignment_Sum_Fields = {
  __typename?: 'user_assignment_sum_fields';
  assignmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_assignment" */
export type User_Assignment_Sum_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_assignment" */
export const enum User_Assignment_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Score = 'score',
  /** column name */
  Submitted = 'submitted',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Assignment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Assignment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Assignment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Assignment_Var_Pop_Fields = {
  __typename?: 'user_assignment_var_pop_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_assignment" */
export type User_Assignment_Var_Pop_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Assignment_Var_Samp_Fields = {
  __typename?: 'user_assignment_var_samp_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_assignment" */
export type User_Assignment_Var_Samp_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Assignment_Variance_Fields = {
  __typename?: 'user_assignment_variance_fields';
  assignmentId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_assignment" */
export type User_Assignment_Variance_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user" */
export type User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_block" */
export type User_Block = {
  __typename?: 'user_block';
  /** An object relationship */
  activity: Activity;
  activityId: Scalars['Int'];
  answers: Scalars['jsonb'];
  /** An object relationship */
  block: Block;
  blockId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  score: Scalars['float8'];
  type: Scalars['user_block_type_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};


/** columns and relationships of "user_block" */
export type User_BlockAnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_block" */
export type User_Block_Aggregate = {
  __typename?: 'user_block_aggregate';
  aggregate?: Maybe<User_Block_Aggregate_Fields>;
  nodes: Array<User_Block>;
};

export type User_Block_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Block_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<User_Block_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Block_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<User_Block_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Block_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Block_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Block_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Block_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Block_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Block_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Block_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Block_Aggregate_Bool_Exp_Avg = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Corr = {
  arguments: User_Block_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Block_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Block_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Block_Aggregate_Bool_Exp_Max = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Min = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Sum = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Block_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Block_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_block" */
export type User_Block_Aggregate_Fields = {
  __typename?: 'user_block_aggregate_fields';
  avg?: Maybe<User_Block_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Block_Max_Fields>;
  min?: Maybe<User_Block_Min_Fields>;
  stddev?: Maybe<User_Block_Stddev_Fields>;
  stddev_pop?: Maybe<User_Block_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Block_Stddev_Samp_Fields>;
  sum?: Maybe<User_Block_Sum_Fields>;
  var_pop?: Maybe<User_Block_Var_Pop_Fields>;
  var_samp?: Maybe<User_Block_Var_Samp_Fields>;
  variance?: Maybe<User_Block_Variance_Fields>;
};


/** aggregate fields of "user_block" */
export type User_Block_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_block" */
export type User_Block_Aggregate_Order_By = {
  avg?: InputMaybe<User_Block_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Block_Max_Order_By>;
  min?: InputMaybe<User_Block_Min_Order_By>;
  stddev?: InputMaybe<User_Block_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Block_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Block_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Block_Sum_Order_By>;
  var_pop?: InputMaybe<User_Block_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Block_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Block_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Block_Append_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_block" */
export type User_Block_Arr_Rel_Insert_Input = {
  data: Array<User_Block_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Block_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Block_Avg_Fields = {
  __typename?: 'user_block_avg_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_block" */
export type User_Block_Avg_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_block". All fields are combined with a logical 'AND'. */
export type User_Block_Bool_Exp = {
  _and?: InputMaybe<Array<User_Block_Bool_Exp>>;
  _not?: InputMaybe<User_Block_Bool_Exp>;
  _or?: InputMaybe<Array<User_Block_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityId?: InputMaybe<Int_Comparison_Exp>;
  answers?: InputMaybe<Jsonb_Comparison_Exp>;
  block?: InputMaybe<Block_Bool_Exp>;
  blockId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  type?: InputMaybe<User_Block_Type_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_block" */
export const enum User_Block_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_4ccc8015091b2f9054ce0e40db5 = 'PK_4ccc8015091b2f9054ce0e40db5',
  /** unique or primary key constraint on columns "uid" */
  Uq_52d35759bb597cefceaecd5c60e = 'UQ_52d35759bb597cefceaecd5c60e',
  /** unique or primary key constraint on columns "userId", "blockId" */
  IndexUserBlock = 'index_user_block'
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Block_Delete_At_Path_Input = {
  answers?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Block_Delete_Elem_Input = {
  answers?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Block_Delete_Key_Input = {
  answers?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_block" */
export type User_Block_Inc_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  blockId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_block" */
export type User_Block_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  block?: InputMaybe<Block_Obj_Rel_Insert_Input>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  type?: InputMaybe<Scalars['user_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Block_Max_Fields = {
  __typename?: 'user_block_max_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['user_block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_block" */
export type User_Block_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Block_Min_Fields = {
  __typename?: 'user_block_min_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['user_block_type_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_block" */
export type User_Block_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_block" */
export type User_Block_Mutation_Response = {
  __typename?: 'user_block_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Block>;
};

/** on_conflict condition type for table "user_block" */
export type User_Block_On_Conflict = {
  constraint: User_Block_Constraint;
  update_columns?: Array<User_Block_Update_Column>;
  where?: InputMaybe<User_Block_Bool_Exp>;
};

/** Ordering options when selecting data from "user_block". */
export type User_Block_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityId?: InputMaybe<Order_By>;
  answers?: InputMaybe<Order_By>;
  block?: InputMaybe<Block_Order_By>;
  blockId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_block */
export type User_Block_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Block_Prepend_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_block" */
export const enum User_Block_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  BlockId = 'blockId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_block_aggregate_bool_exp_avg_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_block_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_block_aggregate_bool_exp_corr_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_max_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_min_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_sum_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_block_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_block" */
export const enum User_Block_Select_Column_User_Block_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** input type for updating data in table "user_block" */
export type User_Block_Set_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  type?: InputMaybe<Scalars['user_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Block_Stddev_Fields = {
  __typename?: 'user_block_stddev_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_block" */
export type User_Block_Stddev_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Block_Stddev_Pop_Fields = {
  __typename?: 'user_block_stddev_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_block" */
export type User_Block_Stddev_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Block_Stddev_Samp_Fields = {
  __typename?: 'user_block_stddev_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_block" */
export type User_Block_Stddev_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_block" */
export type User_Block_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Block_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Block_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['Int']>;
  answers?: InputMaybe<Scalars['jsonb']>;
  blockId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  type?: InputMaybe<Scalars['user_block_type_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Block_Sum_Fields = {
  __typename?: 'user_block_sum_fields';
  activityId?: Maybe<Scalars['Int']>;
  blockId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_block" */
export type User_Block_Sum_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "user_block_type_enum". All fields are combined with logical 'AND'. */
export type User_Block_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_block_type_enum']>;
  _gt?: InputMaybe<Scalars['user_block_type_enum']>;
  _gte?: InputMaybe<Scalars['user_block_type_enum']>;
  _in?: InputMaybe<Array<Scalars['user_block_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_block_type_enum']>;
  _lte?: InputMaybe<Scalars['user_block_type_enum']>;
  _neq?: InputMaybe<Scalars['user_block_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['user_block_type_enum']>>;
};

/** update columns of table "user_block" */
export const enum User_Block_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Answers = 'answers',
  /** column name */
  BlockId = 'blockId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Type = 'type',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Block_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Block_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Block_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Block_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Block_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Block_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Block_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Block_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Block_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Block_Var_Pop_Fields = {
  __typename?: 'user_block_var_pop_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_block" */
export type User_Block_Var_Pop_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Block_Var_Samp_Fields = {
  __typename?: 'user_block_var_samp_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_block" */
export type User_Block_Var_Samp_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Block_Variance_Fields = {
  __typename?: 'user_block_variance_fields';
  activityId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_block" */
export type User_Block_Variance_Order_By = {
  activityId?: InputMaybe<Order_By>;
  blockId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  birth_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  calendar_events?: InputMaybe<Calendar_Event_Bool_Exp>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Bool_Exp>;
  checkpoint_attempts?: InputMaybe<Checkpoint_Attempts_Bool_Exp>;
  checkpoint_attempts_aggregate?: InputMaybe<Checkpoint_Attempts_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  class_course_notes?: InputMaybe<Class_Course_Note_Bool_Exp>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Bool_Exp>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Bool_Exp>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Bool_Exp>;
  confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  files?: InputMaybe<File_Bool_Exp>;
  files_aggregate?: InputMaybe<File_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<User_Gender_Enum_Comparison_Exp>;
  gradeValuesByCreatedbyid?: InputMaybe<Grade_Value_Bool_Exp>;
  gradeValuesByCreatedbyid_aggregate?: InputMaybe<Grade_Value_Aggregate_Bool_Exp>;
  gradeValuesByUpdatedbyid?: InputMaybe<Grade_Value_Bool_Exp>;
  gradeValuesByUpdatedbyid_aggregate?: InputMaybe<Grade_Value_Aggregate_Bool_Exp>;
  grade_values?: InputMaybe<Grade_Value_Bool_Exp>;
  grade_values_aggregate?: InputMaybe<Grade_Value_Aggregate_Bool_Exp>;
  gradebooks?: InputMaybe<Gradebook_Bool_Exp>;
  gradebooks_aggregate?: InputMaybe<Gradebook_Aggregate_Bool_Exp>;
  grades?: InputMaybe<Grade_Bool_Exp>;
  grades_aggregate?: InputMaybe<Grade_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  id_number?: InputMaybe<String_Comparison_Exp>;
  id_student?: InputMaybe<String_Comparison_Exp>;
  installments?: InputMaybe<Installment_Bool_Exp>;
  installmentsByCreatedbyid?: InputMaybe<Installment_Bool_Exp>;
  installmentsByCreatedbyid_aggregate?: InputMaybe<Installment_Aggregate_Bool_Exp>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Bool_Exp>;
  invoice_installments?: InputMaybe<Invoice_Installment_Bool_Exp>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Bool_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoicesByCreatedbyid?: InputMaybe<Invoice_Bool_Exp>;
  invoicesByCreatedbyid_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  language?: InputMaybe<User_Language_Enum_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lectures?: InputMaybe<Lecture_Bool_Exp>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  place_birth?: InputMaybe<String_Comparison_Exp>;
  progressions?: InputMaybe<Progression_Bool_Exp>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Bool_Exp>;
  role?: InputMaybe<User_Role_Enum_Comparison_Exp>;
  school_fees?: InputMaybe<School_Fee_Bool_Exp>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Bool_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Bool_Exp>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Bool_Exp>;
  user_assignments?: InputMaybe<User_Assignment_Bool_Exp>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Bool_Exp>;
  user_blocks?: InputMaybe<User_Block_Bool_Exp>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Bool_Exp>;
  user_checkpoints?: InputMaybe<User_Checkpoint_Bool_Exp>;
  user_checkpoints_aggregate?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp>;
  user_classes?: InputMaybe<User_Class_Bool_Exp>;
  user_classes_aggregate?: InputMaybe<User_Class_Aggregate_Bool_Exp>;
  user_courses?: InputMaybe<User_Course_Bool_Exp>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Bool_Exp>;
  user_events?: InputMaybe<User_Event_Bool_Exp>;
  user_events_aggregate?: InputMaybe<User_Event_Aggregate_Bool_Exp>;
  user_groups?: InputMaybe<User_Group_Bool_Exp>;
  user_groups_aggregate?: InputMaybe<User_Group_Aggregate_Bool_Exp>;
  user_lectures?: InputMaybe<User_Lecture_Bool_Exp>;
  user_lectures_aggregate?: InputMaybe<User_Lecture_Aggregate_Bool_Exp>;
  user_workspaces?: InputMaybe<User_Workspace_Bool_Exp>;
  user_workspaces_aggregate?: InputMaybe<User_Workspace_Aggregate_Bool_Exp>;
};

/** columns and relationships of "user_checkpoint" */
export type User_Checkpoint = {
  __typename?: 'user_checkpoint';
  /** An object relationship */
  checkpoint?: Maybe<Checkpoint>;
  checkpointId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  score: Scalars['float8'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_checkpoint" */
export type User_Checkpoint_Aggregate = {
  __typename?: 'user_checkpoint_aggregate';
  aggregate?: Maybe<User_Checkpoint_Aggregate_Fields>;
  nodes: Array<User_Checkpoint>;
};

export type User_Checkpoint_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Checkpoint_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Avg = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Corr = {
  arguments: User_Checkpoint_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Max = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Min = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Sum = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Checkpoint_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Checkpoint_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_checkpoint" */
export type User_Checkpoint_Aggregate_Fields = {
  __typename?: 'user_checkpoint_aggregate_fields';
  avg?: Maybe<User_Checkpoint_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Checkpoint_Max_Fields>;
  min?: Maybe<User_Checkpoint_Min_Fields>;
  stddev?: Maybe<User_Checkpoint_Stddev_Fields>;
  stddev_pop?: Maybe<User_Checkpoint_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Checkpoint_Stddev_Samp_Fields>;
  sum?: Maybe<User_Checkpoint_Sum_Fields>;
  var_pop?: Maybe<User_Checkpoint_Var_Pop_Fields>;
  var_samp?: Maybe<User_Checkpoint_Var_Samp_Fields>;
  variance?: Maybe<User_Checkpoint_Variance_Fields>;
};


/** aggregate fields of "user_checkpoint" */
export type User_Checkpoint_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Checkpoint_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_checkpoint" */
export type User_Checkpoint_Aggregate_Order_By = {
  avg?: InputMaybe<User_Checkpoint_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Checkpoint_Max_Order_By>;
  min?: InputMaybe<User_Checkpoint_Min_Order_By>;
  stddev?: InputMaybe<User_Checkpoint_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Checkpoint_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Checkpoint_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Checkpoint_Sum_Order_By>;
  var_pop?: InputMaybe<User_Checkpoint_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Checkpoint_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Checkpoint_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_checkpoint" */
export type User_Checkpoint_Arr_Rel_Insert_Input = {
  data: Array<User_Checkpoint_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Checkpoint_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Checkpoint_Avg_Fields = {
  __typename?: 'user_checkpoint_avg_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_checkpoint" */
export type User_Checkpoint_Avg_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_checkpoint". All fields are combined with a logical 'AND'. */
export type User_Checkpoint_Bool_Exp = {
  _and?: InputMaybe<Array<User_Checkpoint_Bool_Exp>>;
  _not?: InputMaybe<User_Checkpoint_Bool_Exp>;
  _or?: InputMaybe<Array<User_Checkpoint_Bool_Exp>>;
  checkpoint?: InputMaybe<Checkpoint_Bool_Exp>;
  checkpointId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_checkpoint" */
export const enum User_Checkpoint_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkA026bf01f396aeae309085aa6f8 = 'PK_a026bf01f396aeae309085aa6f8',
  /** unique or primary key constraint on columns "uid" */
  UqC2b9cf03674b865beedb2e16aaf = 'UQ_c2b9cf03674b865beedb2e16aaf',
  /** unique or primary key constraint on columns "userId", "checkpointId" */
  IndexUserCheckpoint = 'index_user_checkpoint'
};

/** input type for incrementing numeric columns in table "user_checkpoint" */
export type User_Checkpoint_Inc_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_checkpoint" */
export type User_Checkpoint_Insert_Input = {
  checkpoint?: InputMaybe<Checkpoint_Obj_Rel_Insert_Input>;
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Checkpoint_Max_Fields = {
  __typename?: 'user_checkpoint_max_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_checkpoint" */
export type User_Checkpoint_Max_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Checkpoint_Min_Fields = {
  __typename?: 'user_checkpoint_min_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_checkpoint" */
export type User_Checkpoint_Min_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_checkpoint" */
export type User_Checkpoint_Mutation_Response = {
  __typename?: 'user_checkpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Checkpoint>;
};

/** on_conflict condition type for table "user_checkpoint" */
export type User_Checkpoint_On_Conflict = {
  constraint: User_Checkpoint_Constraint;
  update_columns?: Array<User_Checkpoint_Update_Column>;
  where?: InputMaybe<User_Checkpoint_Bool_Exp>;
};

/** Ordering options when selecting data from "user_checkpoint". */
export type User_Checkpoint_Order_By = {
  checkpoint?: InputMaybe<Checkpoint_Order_By>;
  checkpointId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_checkpoint */
export type User_Checkpoint_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_checkpoint_aggregate_bool_exp_avg_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_checkpoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_checkpoint_aggregate_bool_exp_corr_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_max_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_min_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_sum_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** select "user_checkpoint_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_checkpoint" */
export const enum User_Checkpoint_Select_Column_User_Checkpoint_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Score = 'score'
};

/** input type for updating data in table "user_checkpoint" */
export type User_Checkpoint_Set_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Checkpoint_Stddev_Fields = {
  __typename?: 'user_checkpoint_stddev_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_checkpoint" */
export type User_Checkpoint_Stddev_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Checkpoint_Stddev_Pop_Fields = {
  __typename?: 'user_checkpoint_stddev_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_checkpoint" */
export type User_Checkpoint_Stddev_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Checkpoint_Stddev_Samp_Fields = {
  __typename?: 'user_checkpoint_stddev_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_checkpoint" */
export type User_Checkpoint_Stddev_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_checkpoint" */
export type User_Checkpoint_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Checkpoint_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Checkpoint_Stream_Cursor_Value_Input = {
  checkpointId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['float8']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Checkpoint_Sum_Fields = {
  __typename?: 'user_checkpoint_sum_fields';
  checkpointId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_checkpoint" */
export type User_Checkpoint_Sum_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_checkpoint" */
export const enum User_Checkpoint_Update_Column {
  /** column name */
  CheckpointId = 'checkpointId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Checkpoint_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Checkpoint_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Checkpoint_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Checkpoint_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Checkpoint_Var_Pop_Fields = {
  __typename?: 'user_checkpoint_var_pop_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_checkpoint" */
export type User_Checkpoint_Var_Pop_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Checkpoint_Var_Samp_Fields = {
  __typename?: 'user_checkpoint_var_samp_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_checkpoint" */
export type User_Checkpoint_Var_Samp_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Checkpoint_Variance_Fields = {
  __typename?: 'user_checkpoint_variance_fields';
  checkpointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_checkpoint" */
export type User_Checkpoint_Variance_Order_By = {
  checkpointId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_class" */
export type User_Class = {
  __typename?: 'user_class';
  /** An object relationship */
  class: Class;
  classId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};

/** aggregated selection of "user_class" */
export type User_Class_Aggregate = {
  __typename?: 'user_class_aggregate';
  aggregate?: Maybe<User_Class_Aggregate_Fields>;
  nodes: Array<User_Class>;
};

export type User_Class_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Class_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Class_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Class_Aggregate_Bool_Exp_Count>;
};

export type User_Class_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Class_Select_Column_User_Class_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Class_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Class_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Class_Select_Column_User_Class_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Class_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Class_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Class_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_class" */
export type User_Class_Aggregate_Fields = {
  __typename?: 'user_class_aggregate_fields';
  avg?: Maybe<User_Class_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Class_Max_Fields>;
  min?: Maybe<User_Class_Min_Fields>;
  stddev?: Maybe<User_Class_Stddev_Fields>;
  stddev_pop?: Maybe<User_Class_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Class_Stddev_Samp_Fields>;
  sum?: Maybe<User_Class_Sum_Fields>;
  var_pop?: Maybe<User_Class_Var_Pop_Fields>;
  var_samp?: Maybe<User_Class_Var_Samp_Fields>;
  variance?: Maybe<User_Class_Variance_Fields>;
};


/** aggregate fields of "user_class" */
export type User_Class_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_class" */
export type User_Class_Aggregate_Order_By = {
  avg?: InputMaybe<User_Class_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Class_Max_Order_By>;
  min?: InputMaybe<User_Class_Min_Order_By>;
  stddev?: InputMaybe<User_Class_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Class_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Class_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Class_Sum_Order_By>;
  var_pop?: InputMaybe<User_Class_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Class_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Class_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_class" */
export type User_Class_Arr_Rel_Insert_Input = {
  data: Array<User_Class_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Class_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Class_Avg_Fields = {
  __typename?: 'user_class_avg_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_class" */
export type User_Class_Avg_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_class". All fields are combined with a logical 'AND'. */
export type User_Class_Bool_Exp = {
  _and?: InputMaybe<Array<User_Class_Bool_Exp>>;
  _not?: InputMaybe<User_Class_Bool_Exp>;
  _or?: InputMaybe<Array<User_Class_Bool_Exp>>;
  class?: InputMaybe<Class_Bool_Exp>;
  classId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_class" */
export const enum User_Class_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_241fcc163fef37b7105a3038615 = 'PK_241fcc163fef37b7105a3038615',
  /** unique or primary key constraint on columns "uid" */
  Uq_9c69dee18f7a75fa0d6c7a624e4 = 'UQ_9c69dee18f7a75fa0d6c7a624e4',
  /** unique or primary key constraint on columns "userId", "classId" */
  IndexUserClass = 'index_user_class'
};

/** input type for incrementing numeric columns in table "user_class" */
export type User_Class_Inc_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_class" */
export type User_Class_Insert_Input = {
  class?: InputMaybe<Class_Obj_Rel_Insert_Input>;
  classId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Class_Max_Fields = {
  __typename?: 'user_class_max_fields';
  classId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_class" */
export type User_Class_Max_Order_By = {
  classId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Class_Min_Fields = {
  __typename?: 'user_class_min_fields';
  classId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_class" */
export type User_Class_Min_Order_By = {
  classId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_class" */
export type User_Class_Mutation_Response = {
  __typename?: 'user_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Class>;
};

/** on_conflict condition type for table "user_class" */
export type User_Class_On_Conflict = {
  constraint: User_Class_Constraint;
  update_columns?: Array<User_Class_Update_Column>;
  where?: InputMaybe<User_Class_Bool_Exp>;
};

/** Ordering options when selecting data from "user_class". */
export type User_Class_Order_By = {
  class?: InputMaybe<Class_Order_By>;
  classId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_class */
export type User_Class_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_class" */
export const enum User_Class_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_class_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_class" */
export const enum User_Class_Select_Column_User_Class_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_class_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_class" */
export const enum User_Class_Select_Column_User_Class_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_class" */
export type User_Class_Set_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Class_Stddev_Fields = {
  __typename?: 'user_class_stddev_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_class" */
export type User_Class_Stddev_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Class_Stddev_Pop_Fields = {
  __typename?: 'user_class_stddev_pop_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_class" */
export type User_Class_Stddev_Pop_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Class_Stddev_Samp_Fields = {
  __typename?: 'user_class_stddev_samp_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_class" */
export type User_Class_Stddev_Samp_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_class" */
export type User_Class_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Class_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Class_Stream_Cursor_Value_Input = {
  classId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Class_Sum_Fields = {
  __typename?: 'user_class_sum_fields';
  classId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_class" */
export type User_Class_Sum_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_class" */
export const enum User_Class_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Class_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Class_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Class_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Class_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Class_Var_Pop_Fields = {
  __typename?: 'user_class_var_pop_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_class" */
export type User_Class_Var_Pop_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Class_Var_Samp_Fields = {
  __typename?: 'user_class_var_samp_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_class" */
export type User_Class_Var_Samp_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Class_Variance_Fields = {
  __typename?: 'user_class_variance_fields';
  classId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_class" */
export type User_Class_Variance_Order_By = {
  classId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "user" */
export const enum User_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCace4a159ff9f2512dd42373760 = 'PK_cace4a159ff9f2512dd42373760',
  /** unique or primary key constraint on columns "uid" */
  UqDf955cae05f17b2bcf5045cc021 = 'UQ_df955cae05f17b2bcf5045cc021',
  /** unique or primary key constraint on columns "email" */
  UqE12875dfb3b1d92d7d7c5377e22 = 'UQ_e12875dfb3b1d92d7d7c5377e22'
};

/** columns and relationships of "user_course" */
export type User_Course = {
  __typename?: 'user_course';
  /** An object relationship */
  class: Class;
  classCourseId?: Maybe<Scalars['Int']>;
  classId: Scalars['Int'];
  /** An object relationship */
  class_course?: Maybe<Class_Course>;
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};

/** aggregated selection of "user_course" */
export type User_Course_Aggregate = {
  __typename?: 'user_course_aggregate';
  aggregate?: Maybe<User_Course_Aggregate_Fields>;
  nodes: Array<User_Course>;
};

export type User_Course_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Course_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Course_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Course_Aggregate_Bool_Exp_Count>;
};

export type User_Course_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Course_Select_Column_User_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Course_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Course_Select_Column_User_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Course_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Course_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_course" */
export type User_Course_Aggregate_Fields = {
  __typename?: 'user_course_aggregate_fields';
  avg?: Maybe<User_Course_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Course_Max_Fields>;
  min?: Maybe<User_Course_Min_Fields>;
  stddev?: Maybe<User_Course_Stddev_Fields>;
  stddev_pop?: Maybe<User_Course_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Course_Stddev_Samp_Fields>;
  sum?: Maybe<User_Course_Sum_Fields>;
  var_pop?: Maybe<User_Course_Var_Pop_Fields>;
  var_samp?: Maybe<User_Course_Var_Samp_Fields>;
  variance?: Maybe<User_Course_Variance_Fields>;
};


/** aggregate fields of "user_course" */
export type User_Course_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_course" */
export type User_Course_Aggregate_Order_By = {
  avg?: InputMaybe<User_Course_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Course_Max_Order_By>;
  min?: InputMaybe<User_Course_Min_Order_By>;
  stddev?: InputMaybe<User_Course_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Course_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Course_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Course_Sum_Order_By>;
  var_pop?: InputMaybe<User_Course_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Course_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Course_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_course" */
export type User_Course_Arr_Rel_Insert_Input = {
  data: Array<User_Course_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Course_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Course_Avg_Fields = {
  __typename?: 'user_course_avg_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_course" */
export type User_Course_Avg_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_course". All fields are combined with a logical 'AND'. */
export type User_Course_Bool_Exp = {
  _and?: InputMaybe<Array<User_Course_Bool_Exp>>;
  _not?: InputMaybe<User_Course_Bool_Exp>;
  _or?: InputMaybe<Array<User_Course_Bool_Exp>>;
  class?: InputMaybe<Class_Bool_Exp>;
  classCourseId?: InputMaybe<Int_Comparison_Exp>;
  classId?: InputMaybe<Int_Comparison_Exp>;
  class_course?: InputMaybe<Class_Course_Bool_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_course" */
export const enum User_Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_10687f04aeb9fbcb6a6c744ef73 = 'PK_10687f04aeb9fbcb6a6c744ef73',
  /** unique or primary key constraint on columns "uid" */
  Uq_5212ccd03b0d80918d60e04ecc0 = 'UQ_5212ccd03b0d80918d60e04ecc0',
  /** unique or primary key constraint on columns "userId", "classId", "courseId" */
  IndexUserCourse = 'index_user_course'
};

/** input type for incrementing numeric columns in table "user_course" */
export type User_Course_Inc_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_course" */
export type User_Course_Insert_Input = {
  class?: InputMaybe<Class_Obj_Rel_Insert_Input>;
  classCourseId?: InputMaybe<Scalars['Int']>;
  classId?: InputMaybe<Scalars['Int']>;
  class_course?: InputMaybe<Class_Course_Obj_Rel_Insert_Input>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Course_Max_Fields = {
  __typename?: 'user_course_max_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_course" */
export type User_Course_Max_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Course_Min_Fields = {
  __typename?: 'user_course_min_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_course" */
export type User_Course_Min_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_course" */
export type User_Course_Mutation_Response = {
  __typename?: 'user_course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Course>;
};

/** on_conflict condition type for table "user_course" */
export type User_Course_On_Conflict = {
  constraint: User_Course_Constraint;
  update_columns?: Array<User_Course_Update_Column>;
  where?: InputMaybe<User_Course_Bool_Exp>;
};

/** Ordering options when selecting data from "user_course". */
export type User_Course_Order_By = {
  class?: InputMaybe<Class_Order_By>;
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  class_course?: InputMaybe<Class_Course_Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_course */
export type User_Course_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_course" */
export const enum User_Course_Select_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_course" */
export const enum User_Course_Select_Column_User_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_course" */
export const enum User_Course_Select_Column_User_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_course" */
export type User_Course_Set_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Course_Stddev_Fields = {
  __typename?: 'user_course_stddev_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_course" */
export type User_Course_Stddev_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Course_Stddev_Pop_Fields = {
  __typename?: 'user_course_stddev_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_course" */
export type User_Course_Stddev_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Course_Stddev_Samp_Fields = {
  __typename?: 'user_course_stddev_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_course" */
export type User_Course_Stddev_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_course" */
export type User_Course_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Course_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Course_Stream_Cursor_Value_Input = {
  classCourseId?: InputMaybe<Scalars['Int']>;
  classId?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Course_Sum_Fields = {
  __typename?: 'user_course_sum_fields';
  classCourseId?: Maybe<Scalars['Int']>;
  classId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_course" */
export type User_Course_Sum_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_course" */
export const enum User_Course_Update_Column {
  /** column name */
  ClassCourseId = 'classCourseId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Course_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Course_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Course_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Course_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Course_Var_Pop_Fields = {
  __typename?: 'user_course_var_pop_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_course" */
export type User_Course_Var_Pop_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Course_Var_Samp_Fields = {
  __typename?: 'user_course_var_samp_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_course" */
export type User_Course_Var_Samp_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Course_Variance_Fields = {
  __typename?: 'user_course_variance_fields';
  classCourseId?: Maybe<Scalars['Float']>;
  classId?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_course" */
export type User_Course_Variance_Order_By = {
  classCourseId?: InputMaybe<Order_By>;
  classId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_event" */
export type User_Event = {
  __typename?: 'user_event';
  calendarEventId: Scalars['Int'];
  /** An object relationship */
  calendar_event: Calendar_Event;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
  /** An object relationship */
  user_lecture?: Maybe<User_Lecture>;
};

/** aggregated selection of "user_event" */
export type User_Event_Aggregate = {
  __typename?: 'user_event_aggregate';
  aggregate?: Maybe<User_Event_Aggregate_Fields>;
  nodes: Array<User_Event>;
};

export type User_Event_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Event_Aggregate_Bool_Exp_Count>;
};

export type User_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Event_Select_Column_User_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Event_Select_Column_User_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_event" */
export type User_Event_Aggregate_Fields = {
  __typename?: 'user_event_aggregate_fields';
  avg?: Maybe<User_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Event_Max_Fields>;
  min?: Maybe<User_Event_Min_Fields>;
  stddev?: Maybe<User_Event_Stddev_Fields>;
  stddev_pop?: Maybe<User_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Event_Stddev_Samp_Fields>;
  sum?: Maybe<User_Event_Sum_Fields>;
  var_pop?: Maybe<User_Event_Var_Pop_Fields>;
  var_samp?: Maybe<User_Event_Var_Samp_Fields>;
  variance?: Maybe<User_Event_Variance_Fields>;
};


/** aggregate fields of "user_event" */
export type User_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_event" */
export type User_Event_Aggregate_Order_By = {
  avg?: InputMaybe<User_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Event_Max_Order_By>;
  min?: InputMaybe<User_Event_Min_Order_By>;
  stddev?: InputMaybe<User_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Event_Sum_Order_By>;
  var_pop?: InputMaybe<User_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_event" */
export type User_Event_Arr_Rel_Insert_Input = {
  data: Array<User_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Event_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Event_Avg_Fields = {
  __typename?: 'user_event_avg_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_event" */
export type User_Event_Avg_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_event". All fields are combined with a logical 'AND'. */
export type User_Event_Bool_Exp = {
  _and?: InputMaybe<Array<User_Event_Bool_Exp>>;
  _not?: InputMaybe<User_Event_Bool_Exp>;
  _or?: InputMaybe<Array<User_Event_Bool_Exp>>;
  calendarEventId?: InputMaybe<Int_Comparison_Exp>;
  calendar_event?: InputMaybe<Calendar_Event_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  user_lecture?: InputMaybe<User_Lecture_Bool_Exp>;
};

/** unique or primary key constraints on table "user_event" */
export const enum User_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_4245a6b002b13f12e426d9db3ff = 'PK_4245a6b002b13f12e426d9db3ff',
  /** unique or primary key constraint on columns "uid" */
  Uq_5140f2d1d29701048d8c13e308c = 'UQ_5140f2d1d29701048d8c13e308c',
  /** unique or primary key constraint on columns "calendarEventId", "userId" */
  IndexUserEvent = 'index_user_event'
};

/** input type for incrementing numeric columns in table "user_event" */
export type User_Event_Inc_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_event" */
export type User_Event_Insert_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  calendar_event?: InputMaybe<Calendar_Event_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
  user_lecture?: InputMaybe<User_Lecture_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Event_Max_Fields = {
  __typename?: 'user_event_max_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_event" */
export type User_Event_Max_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Event_Min_Fields = {
  __typename?: 'user_event_min_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_event" */
export type User_Event_Min_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_event" */
export type User_Event_Mutation_Response = {
  __typename?: 'user_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Event>;
};

/** input type for inserting object relation for remote table "user_event" */
export type User_Event_Obj_Rel_Insert_Input = {
  data: User_Event_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Event_On_Conflict>;
};

/** on_conflict condition type for table "user_event" */
export type User_Event_On_Conflict = {
  constraint: User_Event_Constraint;
  update_columns?: Array<User_Event_Update_Column>;
  where?: InputMaybe<User_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "user_event". */
export type User_Event_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  calendar_event?: InputMaybe<Calendar_Event_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
  user_lecture?: InputMaybe<User_Lecture_Order_By>;
};

/** primary key columns input for table: user_event */
export type User_Event_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_event" */
export const enum User_Event_Select_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_event" */
export const enum User_Event_Select_Column_User_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_event" */
export const enum User_Event_Select_Column_User_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_event" */
export type User_Event_Set_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Event_Stddev_Fields = {
  __typename?: 'user_event_stddev_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_event" */
export type User_Event_Stddev_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Event_Stddev_Pop_Fields = {
  __typename?: 'user_event_stddev_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_event" */
export type User_Event_Stddev_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Event_Stddev_Samp_Fields = {
  __typename?: 'user_event_stddev_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_event" */
export type User_Event_Stddev_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_event" */
export type User_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Event_Stream_Cursor_Value_Input = {
  calendarEventId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Event_Sum_Fields = {
  __typename?: 'user_event_sum_fields';
  calendarEventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_event" */
export type User_Event_Sum_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_event" */
export const enum User_Event_Update_Column {
  /** column name */
  CalendarEventId = 'calendarEventId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Event_Var_Pop_Fields = {
  __typename?: 'user_event_var_pop_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_event" */
export type User_Event_Var_Pop_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Event_Var_Samp_Fields = {
  __typename?: 'user_event_var_samp_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_event" */
export type User_Event_Var_Samp_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Event_Variance_Fields = {
  __typename?: 'user_event_variance_fields';
  calendarEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_event" */
export type User_Event_Variance_Order_By = {
  calendarEventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "user_gender_enum". All fields are combined with logical 'AND'. */
export type User_Gender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_gender_enum']>;
  _gt?: InputMaybe<Scalars['user_gender_enum']>;
  _gte?: InputMaybe<Scalars['user_gender_enum']>;
  _in?: InputMaybe<Array<Scalars['user_gender_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_gender_enum']>;
  _lte?: InputMaybe<Scalars['user_gender_enum']>;
  _neq?: InputMaybe<Scalars['user_gender_enum']>;
  _nin?: InputMaybe<Array<Scalars['user_gender_enum']>>;
};

/** columns and relationships of "user_group" */
export type User_Group = {
  __typename?: 'user_group';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An object relationship */
  group: Group;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
};

/** aggregated selection of "user_group" */
export type User_Group_Aggregate = {
  __typename?: 'user_group_aggregate';
  aggregate?: Maybe<User_Group_Aggregate_Fields>;
  nodes: Array<User_Group>;
};

export type User_Group_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Group_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Group_Aggregate_Bool_Exp_Count>;
};

export type User_Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Group_Select_Column_User_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Group_Select_Column_User_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_group" */
export type User_Group_Aggregate_Fields = {
  __typename?: 'user_group_aggregate_fields';
  avg?: Maybe<User_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Group_Max_Fields>;
  min?: Maybe<User_Group_Min_Fields>;
  stddev?: Maybe<User_Group_Stddev_Fields>;
  stddev_pop?: Maybe<User_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Group_Stddev_Samp_Fields>;
  sum?: Maybe<User_Group_Sum_Fields>;
  var_pop?: Maybe<User_Group_Var_Pop_Fields>;
  var_samp?: Maybe<User_Group_Var_Samp_Fields>;
  variance?: Maybe<User_Group_Variance_Fields>;
};


/** aggregate fields of "user_group" */
export type User_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_group" */
export type User_Group_Aggregate_Order_By = {
  avg?: InputMaybe<User_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Group_Max_Order_By>;
  min?: InputMaybe<User_Group_Min_Order_By>;
  stddev?: InputMaybe<User_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Group_Sum_Order_By>;
  var_pop?: InputMaybe<User_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_group" */
export type User_Group_Arr_Rel_Insert_Input = {
  data: Array<User_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Group_Avg_Fields = {
  __typename?: 'user_group_avg_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_group" */
export type User_Group_Avg_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_group". All fields are combined with a logical 'AND'. */
export type User_Group_Bool_Exp = {
  _and?: InputMaybe<Array<User_Group_Bool_Exp>>;
  _not?: InputMaybe<User_Group_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  group?: InputMaybe<Group_Bool_Exp>;
  groupId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_group" */
export const enum User_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_3c29fba6fe013ec8724378ce7c9 = 'PK_3c29fba6fe013ec8724378ce7c9',
  /** unique or primary key constraint on columns "uid" */
  Uq_650a4ff0d453e1409a0d3dc9e2c = 'UQ_650a4ff0d453e1409a0d3dc9e2c',
  /** unique or primary key constraint on columns "groupId", "userId" */
  IndexUserGroup = 'index_user_group'
};

/** input type for incrementing numeric columns in table "user_group" */
export type User_Group_Inc_Input = {
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_group" */
export type User_Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Group_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Group_Max_Fields = {
  __typename?: 'user_group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_group" */
export type User_Group_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Group_Min_Fields = {
  __typename?: 'user_group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_group" */
export type User_Group_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_group" */
export type User_Group_Mutation_Response = {
  __typename?: 'user_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Group>;
};

/** on_conflict condition type for table "user_group" */
export type User_Group_On_Conflict = {
  constraint: User_Group_Constraint;
  update_columns?: Array<User_Group_Update_Column>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "user_group". */
export type User_Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  group?: InputMaybe<Group_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_group */
export type User_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_group" */
export const enum User_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

/** select "user_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_group" */
export const enum User_Group_Select_Column_User_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_group" */
export const enum User_Group_Select_Column_User_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_group" */
export type User_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Group_Stddev_Fields = {
  __typename?: 'user_group_stddev_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_group" */
export type User_Group_Stddev_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Group_Stddev_Pop_Fields = {
  __typename?: 'user_group_stddev_pop_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_group" */
export type User_Group_Stddev_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Group_Stddev_Samp_Fields = {
  __typename?: 'user_group_stddev_samp_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_group" */
export type User_Group_Stddev_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_group" */
export type User_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Group_Sum_Fields = {
  __typename?: 'user_group_sum_fields';
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_group" */
export type User_Group_Sum_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_group" */
export const enum User_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
};

export type User_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Group_Var_Pop_Fields = {
  __typename?: 'user_group_var_pop_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_group" */
export type User_Group_Var_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Group_Var_Samp_Fields = {
  __typename?: 'user_group_var_samp_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_group" */
export type User_Group_Var_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Group_Variance_Fields = {
  __typename?: 'user_group_variance_fields';
  groupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_group" */
export type User_Group_Variance_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  birth_date?: InputMaybe<Scalars['timestamptz']>;
  calendar_events?: InputMaybe<Calendar_Event_Arr_Rel_Insert_Input>;
  checkpoint_attempts?: InputMaybe<Checkpoint_Attempts_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  class_course_notes?: InputMaybe<Class_Course_Note_Arr_Rel_Insert_Input>;
  class_course_resources?: InputMaybe<Class_Course_Resource_Arr_Rel_Insert_Input>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<File_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['user_gender_enum']>;
  gradeValuesByCreatedbyid?: InputMaybe<Grade_Value_Arr_Rel_Insert_Input>;
  gradeValuesByUpdatedbyid?: InputMaybe<Grade_Value_Arr_Rel_Insert_Input>;
  grade_values?: InputMaybe<Grade_Value_Arr_Rel_Insert_Input>;
  gradebooks?: InputMaybe<Gradebook_Arr_Rel_Insert_Input>;
  grades?: InputMaybe<Grade_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  id_student?: InputMaybe<Scalars['String']>;
  installments?: InputMaybe<Installment_Arr_Rel_Insert_Input>;
  installmentsByCreatedbyid?: InputMaybe<Installment_Arr_Rel_Insert_Input>;
  invoice_installments?: InputMaybe<Invoice_Installment_Arr_Rel_Insert_Input>;
  invoices?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  invoicesByCreatedbyid?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  language?: InputMaybe<Scalars['user_language_enum']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  lectures?: InputMaybe<Lecture_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  place_birth?: InputMaybe<Scalars['String']>;
  progressions?: InputMaybe<Progression_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Scalars['user_role_enum']>;
  school_fees?: InputMaybe<School_Fee_Arr_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_assignment_activities?: InputMaybe<User_Assignment_Activity_Arr_Rel_Insert_Input>;
  user_assignments?: InputMaybe<User_Assignment_Arr_Rel_Insert_Input>;
  user_blocks?: InputMaybe<User_Block_Arr_Rel_Insert_Input>;
  user_checkpoints?: InputMaybe<User_Checkpoint_Arr_Rel_Insert_Input>;
  user_classes?: InputMaybe<User_Class_Arr_Rel_Insert_Input>;
  user_courses?: InputMaybe<User_Course_Arr_Rel_Insert_Input>;
  user_events?: InputMaybe<User_Event_Arr_Rel_Insert_Input>;
  user_groups?: InputMaybe<User_Group_Arr_Rel_Insert_Input>;
  user_lectures?: InputMaybe<User_Lecture_Arr_Rel_Insert_Input>;
  user_workspaces?: InputMaybe<User_Workspace_Arr_Rel_Insert_Input>;
};

/** Boolean expression to compare columns of type "user_language_enum". All fields are combined with logical 'AND'. */
export type User_Language_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_language_enum']>;
  _gt?: InputMaybe<Scalars['user_language_enum']>;
  _gte?: InputMaybe<Scalars['user_language_enum']>;
  _in?: InputMaybe<Array<Scalars['user_language_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_language_enum']>;
  _lte?: InputMaybe<Scalars['user_language_enum']>;
  _neq?: InputMaybe<Scalars['user_language_enum']>;
  _nin?: InputMaybe<Array<Scalars['user_language_enum']>>;
};

/** columns and relationships of "user_lecture" */
export type User_Lecture = {
  __typename?: 'user_lecture';
  comment?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  lecture: Lecture;
  lectureId: Scalars['Int'];
  status: Scalars['user_lecture_status_enum'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userEventId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  /** An object relationship */
  user_event?: Maybe<User_Event>;
};

/** aggregated selection of "user_lecture" */
export type User_Lecture_Aggregate = {
  __typename?: 'user_lecture_aggregate';
  aggregate?: Maybe<User_Lecture_Aggregate_Fields>;
  nodes: Array<User_Lecture>;
};

export type User_Lecture_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Lecture_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Lecture_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Lecture_Aggregate_Bool_Exp_Count>;
};

export type User_Lecture_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Lecture_Select_Column_User_Lecture_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Lecture_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Lecture_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Lecture_Select_Column_User_Lecture_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Lecture_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Lecture_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Lecture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Lecture_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_lecture" */
export type User_Lecture_Aggregate_Fields = {
  __typename?: 'user_lecture_aggregate_fields';
  avg?: Maybe<User_Lecture_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Lecture_Max_Fields>;
  min?: Maybe<User_Lecture_Min_Fields>;
  stddev?: Maybe<User_Lecture_Stddev_Fields>;
  stddev_pop?: Maybe<User_Lecture_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Lecture_Stddev_Samp_Fields>;
  sum?: Maybe<User_Lecture_Sum_Fields>;
  var_pop?: Maybe<User_Lecture_Var_Pop_Fields>;
  var_samp?: Maybe<User_Lecture_Var_Samp_Fields>;
  variance?: Maybe<User_Lecture_Variance_Fields>;
};


/** aggregate fields of "user_lecture" */
export type User_Lecture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Lecture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_lecture" */
export type User_Lecture_Aggregate_Order_By = {
  avg?: InputMaybe<User_Lecture_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Lecture_Max_Order_By>;
  min?: InputMaybe<User_Lecture_Min_Order_By>;
  stddev?: InputMaybe<User_Lecture_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Lecture_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Lecture_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Lecture_Sum_Order_By>;
  var_pop?: InputMaybe<User_Lecture_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Lecture_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Lecture_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_lecture" */
export type User_Lecture_Arr_Rel_Insert_Input = {
  data: Array<User_Lecture_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Lecture_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Lecture_Avg_Fields = {
  __typename?: 'user_lecture_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_lecture" */
export type User_Lecture_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_lecture". All fields are combined with a logical 'AND'. */
export type User_Lecture_Bool_Exp = {
  _and?: InputMaybe<Array<User_Lecture_Bool_Exp>>;
  _not?: InputMaybe<User_Lecture_Bool_Exp>;
  _or?: InputMaybe<Array<User_Lecture_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lecture?: InputMaybe<Lecture_Bool_Exp>;
  lectureId?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<User_Lecture_Status_Enum_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userEventId?: InputMaybe<Int_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  user_event?: InputMaybe<User_Event_Bool_Exp>;
};

/** unique or primary key constraints on table "user_lecture" */
export const enum User_Lecture_Constraint {
  /** unique or primary key constraint on columns "id" */
  Pk_8dfe6236dbda21e9acb10151702 = 'PK_8dfe6236dbda21e9acb10151702',
  /** unique or primary key constraint on columns "userEventId" */
  Uq_918df0316490e48e2f9ced1d785 = 'UQ_918df0316490e48e2f9ced1d785',
  /** unique or primary key constraint on columns "uid" */
  UqB264000fe1b2cbb2333bc1749c1 = 'UQ_b264000fe1b2cbb2333bc1749c1',
  /** unique or primary key constraint on columns "userId", "lectureId" */
  IndexUserLecture = 'index_user_lecture'
};

/** input type for incrementing numeric columns in table "user_lecture" */
export type User_Lecture_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  userEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_lecture" */
export type User_Lecture_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lecture?: InputMaybe<Lecture_Obj_Rel_Insert_Input>;
  lectureId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['user_lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  user_event?: InputMaybe<User_Event_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Lecture_Max_Fields = {
  __typename?: 'user_lecture_max_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['user_lecture_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_lecture" */
export type User_Lecture_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Lecture_Min_Fields = {
  __typename?: 'user_lecture_min_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['user_lecture_status_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_lecture" */
export type User_Lecture_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_lecture" */
export type User_Lecture_Mutation_Response = {
  __typename?: 'user_lecture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Lecture>;
};

/** input type for inserting object relation for remote table "user_lecture" */
export type User_Lecture_Obj_Rel_Insert_Input = {
  data: User_Lecture_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Lecture_On_Conflict>;
};

/** on_conflict condition type for table "user_lecture" */
export type User_Lecture_On_Conflict = {
  constraint: User_Lecture_Constraint;
  update_columns?: Array<User_Lecture_Update_Column>;
  where?: InputMaybe<User_Lecture_Bool_Exp>;
};

/** Ordering options when selecting data from "user_lecture". */
export type User_Lecture_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lecture?: InputMaybe<Lecture_Order_By>;
  lectureId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  user_event?: InputMaybe<User_Event_Order_By>;
};

/** primary key columns input for table: user_lecture */
export type User_Lecture_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_lecture" */
export const enum User_Lecture_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEventId = 'userEventId',
  /** column name */
  UserId = 'userId'
};

/** select "user_lecture_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_lecture" */
export const enum User_Lecture_Select_Column_User_Lecture_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_lecture_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_lecture" */
export const enum User_Lecture_Select_Column_User_Lecture_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_lecture" */
export type User_Lecture_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['user_lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "user_lecture_status_enum". All fields are combined with logical 'AND'. */
export type User_Lecture_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _gt?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _gte?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _in?: InputMaybe<Array<Scalars['user_lecture_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _lte?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _neq?: InputMaybe<Scalars['user_lecture_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['user_lecture_status_enum']>>;
};

/** aggregate stddev on columns */
export type User_Lecture_Stddev_Fields = {
  __typename?: 'user_lecture_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_lecture" */
export type User_Lecture_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Lecture_Stddev_Pop_Fields = {
  __typename?: 'user_lecture_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_lecture" */
export type User_Lecture_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Lecture_Stddev_Samp_Fields = {
  __typename?: 'user_lecture_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_lecture" */
export type User_Lecture_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_lecture" */
export type User_Lecture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Lecture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Lecture_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lectureId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['user_lecture_status_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Lecture_Sum_Fields = {
  __typename?: 'user_lecture_sum_fields';
  id?: Maybe<Scalars['Int']>;
  lectureId?: Maybe<Scalars['Int']>;
  userEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_lecture" */
export type User_Lecture_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "user_lecture" */
export const enum User_Lecture_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lectureId',
  /** column name */
  Status = 'status',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEventId = 'userEventId',
  /** column name */
  UserId = 'userId'
};

export type User_Lecture_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Lecture_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Lecture_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Lecture_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Lecture_Var_Pop_Fields = {
  __typename?: 'user_lecture_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_lecture" */
export type User_Lecture_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Lecture_Var_Samp_Fields = {
  __typename?: 'user_lecture_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_lecture" */
export type User_Lecture_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Lecture_Variance_Fields = {
  __typename?: 'user_lecture_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lectureId?: Maybe<Scalars['Float']>;
  userEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_lecture" */
export type User_Lecture_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  lectureId?: InputMaybe<Order_By>;
  userEventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  address?: Maybe<Scalars['String']>;
  birth_date?: Maybe<Scalars['timestamptz']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  id_student?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['user_language_enum']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  place_birth?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['user_role_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  birth_date?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  id_student?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  place_birth?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  address?: Maybe<Scalars['String']>;
  birth_date?: Maybe<Scalars['timestamptz']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  id_student?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['user_language_enum']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  place_birth?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['user_role_enum']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  birth_date?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  id_student?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  place_birth?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  address?: InputMaybe<Order_By>;
  birth_date?: InputMaybe<Order_By>;
  calendar_events_aggregate?: InputMaybe<Calendar_Event_Aggregate_Order_By>;
  checkpoint_attempts_aggregate?: InputMaybe<Checkpoint_Attempts_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  class_course_notes_aggregate?: InputMaybe<Class_Course_Note_Aggregate_Order_By>;
  class_course_resources_aggregate?: InputMaybe<Class_Course_Resource_Aggregate_Order_By>;
  confirmed?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<File_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  gradeValuesByCreatedbyid_aggregate?: InputMaybe<Grade_Value_Aggregate_Order_By>;
  gradeValuesByUpdatedbyid_aggregate?: InputMaybe<Grade_Value_Aggregate_Order_By>;
  grade_values_aggregate?: InputMaybe<Grade_Value_Aggregate_Order_By>;
  gradebooks_aggregate?: InputMaybe<Gradebook_Aggregate_Order_By>;
  grades_aggregate?: InputMaybe<Grade_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  id_student?: InputMaybe<Order_By>;
  installmentsByCreatedbyid_aggregate?: InputMaybe<Installment_Aggregate_Order_By>;
  installments_aggregate?: InputMaybe<Installment_Aggregate_Order_By>;
  invoice_installments_aggregate?: InputMaybe<Invoice_Installment_Aggregate_Order_By>;
  invoicesByCreatedbyid_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  language?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lectures_aggregate?: InputMaybe<Lecture_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  place_birth?: InputMaybe<Order_By>;
  progressions_aggregate?: InputMaybe<Progression_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  school_fees_aggregate?: InputMaybe<School_Fee_Aggregate_Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_assignment_activities_aggregate?: InputMaybe<User_Assignment_Activity_Aggregate_Order_By>;
  user_assignments_aggregate?: InputMaybe<User_Assignment_Aggregate_Order_By>;
  user_blocks_aggregate?: InputMaybe<User_Block_Aggregate_Order_By>;
  user_checkpoints_aggregate?: InputMaybe<User_Checkpoint_Aggregate_Order_By>;
  user_classes_aggregate?: InputMaybe<User_Class_Aggregate_Order_By>;
  user_courses_aggregate?: InputMaybe<User_Course_Aggregate_Order_By>;
  user_events_aggregate?: InputMaybe<User_Event_Aggregate_Order_By>;
  user_groups_aggregate?: InputMaybe<User_Group_Aggregate_Order_By>;
  user_lectures_aggregate?: InputMaybe<User_Lecture_Aggregate_Order_By>;
  user_workspaces_aggregate?: InputMaybe<User_Workspace_Aggregate_Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** Boolean expression to compare columns of type "user_role_enum". All fields are combined with logical 'AND'. */
export type User_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_role_enum']>;
  _gt?: InputMaybe<Scalars['user_role_enum']>;
  _gte?: InputMaybe<Scalars['user_role_enum']>;
  _in?: InputMaybe<Array<Scalars['user_role_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_role_enum']>;
  _lte?: InputMaybe<Scalars['user_role_enum']>;
  _neq?: InputMaybe<Scalars['user_role_enum']>;
  _nin?: InputMaybe<Array<Scalars['user_role_enum']>>;
};

/** select columns of table "user" */
export const enum User_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  City = 'city',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IdStudent = 'id_student',
  /** column name */
  Language = 'language',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Phone = 'phone',
  /** column name */
  Picture = 'picture',
  /** column name */
  PlaceBirth = 'place_birth',
  /** column name */
  Role = 'role',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user" */
export const enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** select "user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user" */
export const enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Enabled = 'enabled'
};

/** input type for updating data in table "user" */
export type User_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  birth_date?: InputMaybe<Scalars['timestamptz']>;
  city?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['user_gender_enum']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  id_student?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['user_language_enum']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  place_birth?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['user_role_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user" */
export type User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user" */
export type User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user" */
export type User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  birth_date?: InputMaybe<Scalars['timestamptz']>;
  city?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['user_gender_enum']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  id_student?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['user_language_enum']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  place_birth?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['user_role_enum']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user" */
export type User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "user" */
export const enum User_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  City = 'city',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IdStudent = 'id_student',
  /** column name */
  Language = 'language',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Phone = 'phone',
  /** column name */
  Picture = 'picture',
  /** column name */
  PlaceBirth = 'place_birth',
  /** column name */
  Role = 'role',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user" */
export type User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user" */
export type User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user" */
export type User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_workspace" */
export type User_Workspace = {
  __typename?: 'user_workspace';
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['Int'];
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['Int'];
  /** An object relationship */
  workspace: Workspace;
  workspaceId: Scalars['Int'];
};

/** aggregated selection of "user_workspace" */
export type User_Workspace_Aggregate = {
  __typename?: 'user_workspace_aggregate';
  aggregate?: Maybe<User_Workspace_Aggregate_Fields>;
  nodes: Array<User_Workspace>;
};

export type User_Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Workspace_Aggregate_Bool_Exp_Count>;
};

export type User_Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Workspace_Select_Column_User_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Workspace_Select_Column_User_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_workspace" */
export type User_Workspace_Aggregate_Fields = {
  __typename?: 'user_workspace_aggregate_fields';
  avg?: Maybe<User_Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Workspace_Max_Fields>;
  min?: Maybe<User_Workspace_Min_Fields>;
  stddev?: Maybe<User_Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<User_Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<User_Workspace_Sum_Fields>;
  var_pop?: Maybe<User_Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<User_Workspace_Var_Samp_Fields>;
  variance?: Maybe<User_Workspace_Variance_Fields>;
};


/** aggregate fields of "user_workspace" */
export type User_Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_workspace" */
export type User_Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<User_Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Workspace_Max_Order_By>;
  min?: InputMaybe<User_Workspace_Min_Order_By>;
  stddev?: InputMaybe<User_Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<User_Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_workspace" */
export type User_Workspace_Arr_Rel_Insert_Input = {
  data: Array<User_Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Workspace_Avg_Fields = {
  __typename?: 'user_workspace_avg_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_workspace" */
export type User_Workspace_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_workspace". All fields are combined with a logical 'AND'. */
export type User_Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<User_Workspace_Bool_Exp>>;
  _not?: InputMaybe<User_Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<User_Workspace_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  workspace?: InputMaybe<Workspace_Bool_Exp>;
  workspaceId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_workspace" */
export const enum User_Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBaa0fec25dab9d73a98f607458d = 'PK_baa0fec25dab9d73a98f607458d',
  /** unique or primary key constraint on columns "uid" */
  Uq_6fc3b5c256be148b1b2b0873cbc = 'UQ_6fc3b5c256be148b1b2b0873cbc',
  /** unique or primary key constraint on columns "userId", "workspaceId" */
  IndexUserWorkspace = 'index_user_workspace'
};

/** input type for incrementing numeric columns in table "user_workspace" */
export type User_Workspace_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_workspace" */
export type User_Workspace_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
  workspace?: InputMaybe<Workspace_Obj_Rel_Insert_Input>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Workspace_Max_Fields = {
  __typename?: 'user_workspace_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_workspace" */
export type User_Workspace_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Workspace_Min_Fields = {
  __typename?: 'user_workspace_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_workspace" */
export type User_Workspace_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_workspace" */
export type User_Workspace_Mutation_Response = {
  __typename?: 'user_workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Workspace>;
};

/** on_conflict condition type for table "user_workspace" */
export type User_Workspace_On_Conflict = {
  constraint: User_Workspace_Constraint;
  update_columns?: Array<User_Workspace_Update_Column>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "user_workspace". */
export type User_Workspace_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
  workspace?: InputMaybe<Workspace_Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_workspace */
export type User_Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_workspace" */
export const enum User_Workspace_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  WorkspaceId = 'workspaceId'
};

/** select "user_workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_workspace" */
export const enum User_Workspace_Select_Column_User_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "user_workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_workspace" */
export const enum User_Workspace_Select_Column_User_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "user_workspace" */
export type User_Workspace_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Workspace_Stddev_Fields = {
  __typename?: 'user_workspace_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_workspace" */
export type User_Workspace_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Workspace_Stddev_Pop_Fields = {
  __typename?: 'user_workspace_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_workspace" */
export type User_Workspace_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Workspace_Stddev_Samp_Fields = {
  __typename?: 'user_workspace_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_workspace" */
export type User_Workspace_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_workspace" */
export type User_Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Workspace_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Workspace_Sum_Fields = {
  __typename?: 'user_workspace_sum_fields';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  workspaceId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_workspace" */
export type User_Workspace_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** update columns of table "user_workspace" */
export const enum User_Workspace_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  WorkspaceId = 'workspaceId'
};

export type User_Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Workspace_Var_Pop_Fields = {
  __typename?: 'user_workspace_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_workspace" */
export type User_Workspace_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Workspace_Var_Samp_Fields = {
  __typename?: 'user_workspace_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_workspace" */
export type User_Workspace_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Workspace_Variance_Fields = {
  __typename?: 'user_workspace_variance_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_workspace" */
export type User_Workspace_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  workspaceId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "workspace" */
export type Workspace = {
  __typename?: 'workspace';
  /** An array relationship */
  block_list_item_workspaces: Array<Block_List_Item_Workspace>;
  /** An aggregate relationship */
  block_list_item_workspaces_aggregate: Block_List_Item_Workspace_Aggregate;
  /** An array relationship */
  course_workspaces: Array<Course_Workspace>;
  /** An aggregate relationship */
  course_workspaces_aggregate: Course_Workspace_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  /** An array relationship */
  group_workspaces: Array<Group_Workspace>;
  /** An aggregate relationship */
  group_workspaces_aggregate: Group_Workspace_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['Int'];
  /** An array relationship */
  question_workspaces: Array<Question_Workspace>;
  /** An aggregate relationship */
  question_workspaces_aggregate: Question_Workspace_Aggregate;
  uid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_workspaces: Array<User_Workspace>;
  /** An aggregate relationship */
  user_workspaces_aggregate: User_Workspace_Aggregate;
};


/** columns and relationships of "workspace" */
export type WorkspaceBlock_List_Item_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceBlock_List_Item_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Block_List_Item_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Block_List_Item_Workspace_Order_By>>;
  where?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceCourse_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceCourse_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Workspace_Order_By>>;
  where?: InputMaybe<Course_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceGroup_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceGroup_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By>>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceQuestion_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceQuestion_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Workspace_Order_By>>;
  where?: InputMaybe<Question_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceUser_WorkspacesArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};


/** columns and relationships of "workspace" */
export type WorkspaceUser_Workspaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Workspace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By>>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
};

/** aggregated selection of "workspace" */
export type Workspace_Aggregate = {
  __typename?: 'workspace_aggregate';
  aggregate?: Maybe<Workspace_Aggregate_Fields>;
  nodes: Array<Workspace>;
};

export type Workspace_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Workspace_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Workspace_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Workspace_Aggregate_Bool_Exp_Count>;
};

export type Workspace_Aggregate_Bool_Exp_Bool_And = {
  arguments: Workspace_Select_Column_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Workspace_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Workspace_Select_Column_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Workspace_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Workspace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Workspace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "workspace" */
export type Workspace_Aggregate_Fields = {
  __typename?: 'workspace_aggregate_fields';
  avg?: Maybe<Workspace_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workspace_Max_Fields>;
  min?: Maybe<Workspace_Min_Fields>;
  stddev?: Maybe<Workspace_Stddev_Fields>;
  stddev_pop?: Maybe<Workspace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workspace_Stddev_Samp_Fields>;
  sum?: Maybe<Workspace_Sum_Fields>;
  var_pop?: Maybe<Workspace_Var_Pop_Fields>;
  var_samp?: Maybe<Workspace_Var_Samp_Fields>;
  variance?: Maybe<Workspace_Variance_Fields>;
};


/** aggregate fields of "workspace" */
export type Workspace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workspace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workspace" */
export type Workspace_Aggregate_Order_By = {
  avg?: InputMaybe<Workspace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workspace_Max_Order_By>;
  min?: InputMaybe<Workspace_Min_Order_By>;
  stddev?: InputMaybe<Workspace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workspace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workspace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workspace_Sum_Order_By>;
  var_pop?: InputMaybe<Workspace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workspace_Var_Samp_Order_By>;
  variance?: InputMaybe<Workspace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workspace" */
export type Workspace_Arr_Rel_Insert_Input = {
  data: Array<Workspace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workspace_On_Conflict>;
};

/** aggregate avg on columns */
export type Workspace_Avg_Fields = {
  __typename?: 'workspace_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workspace" */
export type Workspace_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workspace". All fields are combined with a logical 'AND'. */
export type Workspace_Bool_Exp = {
  _and?: InputMaybe<Array<Workspace_Bool_Exp>>;
  _not?: InputMaybe<Workspace_Bool_Exp>;
  _or?: InputMaybe<Array<Workspace_Bool_Exp>>;
  block_list_item_workspaces?: InputMaybe<Block_List_Item_Workspace_Bool_Exp>;
  block_list_item_workspaces_aggregate?: InputMaybe<Block_List_Item_Workspace_Aggregate_Bool_Exp>;
  course_workspaces?: InputMaybe<Course_Workspace_Bool_Exp>;
  course_workspaces_aggregate?: InputMaybe<Course_Workspace_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  group_workspaces?: InputMaybe<Group_Workspace_Bool_Exp>;
  group_workspaces_aggregate?: InputMaybe<Group_Workspace_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Int_Comparison_Exp>;
  question_workspaces?: InputMaybe<Question_Workspace_Bool_Exp>;
  question_workspaces_aggregate?: InputMaybe<Question_Workspace_Aggregate_Bool_Exp>;
  uid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_workspaces?: InputMaybe<User_Workspace_Bool_Exp>;
  user_workspaces_aggregate?: InputMaybe<User_Workspace_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workspace" */
export const enum Workspace_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCa86b6f9b3be5fe26d307d09b49 = 'PK_ca86b6f9b3be5fe26d307d09b49',
  /** unique or primary key constraint on columns "uid" */
  Uq_077dec0e70a9b6b102f863e1b34 = 'UQ_077dec0e70a9b6b102f863e1b34',
  /** unique or primary key constraint on columns "name" */
  Uq_406f56fc2a42ad5f541973cdbee = 'UQ_406f56fc2a42ad5f541973cdbee'
};

/** input type for incrementing numeric columns in table "workspace" */
export type Workspace_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workspace" */
export type Workspace_Insert_Input = {
  block_list_item_workspaces?: InputMaybe<Block_List_Item_Workspace_Arr_Rel_Insert_Input>;
  course_workspaces?: InputMaybe<Course_Workspace_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  group_workspaces?: InputMaybe<Group_Workspace_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['Int']>;
  question_workspaces?: InputMaybe<Question_Workspace_Arr_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_workspaces?: InputMaybe<User_Workspace_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Workspace_Max_Fields = {
  __typename?: 'workspace_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "workspace" */
export type Workspace_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workspace_Min_Fields = {
  __typename?: 'workspace_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "workspace" */
export type Workspace_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workspace" */
export type Workspace_Mutation_Response = {
  __typename?: 'workspace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workspace>;
};

/** input type for inserting object relation for remote table "workspace" */
export type Workspace_Obj_Rel_Insert_Input = {
  data: Workspace_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workspace_On_Conflict>;
};

/** on_conflict condition type for table "workspace" */
export type Workspace_On_Conflict = {
  constraint: Workspace_Constraint;
  update_columns?: Array<Workspace_Update_Column>;
  where?: InputMaybe<Workspace_Bool_Exp>;
};

/** Ordering options when selecting data from "workspace". */
export type Workspace_Order_By = {
  block_list_item_workspaces_aggregate?: InputMaybe<Block_List_Item_Workspace_Aggregate_Order_By>;
  course_workspaces_aggregate?: InputMaybe<Course_Workspace_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  group_workspaces_aggregate?: InputMaybe<Group_Workspace_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  question_workspaces_aggregate?: InputMaybe<Question_Workspace_Aggregate_Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_workspaces_aggregate?: InputMaybe<User_Workspace_Aggregate_Order_By>;
};

/** primary key columns input for table: workspace */
export type Workspace_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workspace" */
export const enum Workspace_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

/** select "workspace_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workspace" */
export const enum Workspace_Select_Column_Workspace_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** select "workspace_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workspace" */
export const enum Workspace_Select_Column_Workspace_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
};

/** input type for updating data in table "workspace" */
export type Workspace_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workspace_Stddev_Fields = {
  __typename?: 'workspace_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workspace" */
export type Workspace_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workspace_Stddev_Pop_Fields = {
  __typename?: 'workspace_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workspace" */
export type Workspace_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workspace_Stddev_Samp_Fields = {
  __typename?: 'workspace_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workspace" */
export type Workspace_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "workspace" */
export type Workspace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Workspace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Workspace_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Workspace_Sum_Fields = {
  __typename?: 'workspace_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workspace" */
export type Workspace_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** update columns of table "workspace" */
export const enum Workspace_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
};

export type Workspace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Workspace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Workspace_Set_Input>;
  /** filter the rows which have to be updated */
  where: Workspace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Workspace_Var_Pop_Fields = {
  __typename?: 'workspace_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workspace" */
export type Workspace_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workspace_Var_Samp_Fields = {
  __typename?: 'workspace_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workspace" */
export type Workspace_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workspace_Variance_Fields = {
  __typename?: 'workspace_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workspace" */
export type Workspace_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

export type Activity_FieldsFragment = { __typename?: 'activity', id: number, name?: string | null, order: number, blocks: Array<{ __typename?: 'block', type: any }> };

export type Activity_Layout_FieldsFragment = { __typename?: 'activity_layout', id: number, activityId: number, blockId?: number | null, size: string, order: number, isStatic: boolean, type?: any | null };

export type Block_FieldsFragment = { __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null };

export type Block_List_FieldsFragment = { __typename?: 'block_list_item', id: number, name: string, type: any, fillBlankId?: number | null, dndId?: number | null, quizId?: number | null, textId?: number | null, mediaId?: number | null, media?: { __typename?: 'media', id: number, type: any, path: string } | null, block_tags: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null, tag?: { __typename?: 'tag', label: string, id: number } | null }>, block_list_item_workspaces: Array<{ __typename?: 'block_list_item_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> };

export type Group_FieldsFragment = { __typename?: 'group', id: number, created_at: any, name: string, user_groups_aggregate: { __typename?: 'user_group_aggregate', aggregate?: { __typename?: 'user_group_aggregate_fields', count: number } | null } };

export type Media_FieldsFragment = { __typename?: 'media', id: number, label: string, type: any, path: string };

export type Question_FieldsFragment = { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> };

export type Question_Base_FieldsFragment = { __typename?: 'question', id: number, label: string, order?: string | null, type: any };

export type Question_Option_FieldsFragment = { __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null };

export type Question_Option_Base_FieldsFragment = { __typename?: 'question_option', id: number, label: string, order: string, questionId?: number | null, mediaId?: number | null, hasMath: boolean };

export type Question_Quiz_FieldsFragment = { __typename?: 'question', id: number, label: string, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> };

export type Quiz_FieldsFragment = { __typename?: 'quiz', id: number, title: string, type?: string | null };

export type Text_FieldsFragment = { __typename?: 'text', id: number, title: string, content?: string | null, created_at: any };

export type User_FieldsFragment = { __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null };

export type User_Activity_FieldsFragment = { __typename?: 'user_activity', id: number, answers: any, infos: any, activity?: { __typename?: 'activity', id: number } | null };

export type User_Group_FieldsFragment = { __typename?: 'user_group', id: number, user: { __typename?: 'user', id: number }, group: { __typename?: 'group', id: number, name: string } };

export type Workspace_FieldsFragment = { __typename?: 'workspace', id: number, name: string };

export type Insert_Activity_OneMutationVariables = Exact<{
  object: Activity_Insert_Input;
}>;


export type Insert_Activity_OneMutation = { __typename?: 'mutation_root', insert_activity_one?: { __typename?: 'activity', id: number, name?: string | null, order: number, lessonId?: number | null, blocks_aggregate: { __typename?: 'block_aggregate', aggregate?: { __typename?: 'block_aggregate_fields', count: number } | null }, blocks: Array<{ __typename?: 'block', activityId: number, id: number, name: string, type: any, textId?: number | null }> } | null };

export type Delete_Activity_By_PkMutationVariables = Exact<{
  deleteActivityByPkId: Scalars['Int'];
}>;


export type Delete_Activity_By_PkMutation = { __typename?: 'mutation_root', delete_activity_by_pk?: { __typename?: 'activity', id: number } | null };

export type Update_Activity_By_PkMutationVariables = Exact<{
  pkColumns: Activity_Pk_Columns_Input;
  set?: InputMaybe<Activity_Set_Input>;
}>;


export type Update_Activity_By_PkMutation = { __typename?: 'mutation_root', update_activity_by_pk?: { __typename?: 'activity', order: number, name?: string | null, id: number } | null };

export type Insert_Activity_Layout_OneMutationVariables = Exact<{
  object: Activity_Layout_Insert_Input;
}>;


export type Insert_Activity_Layout_OneMutation = { __typename?: 'mutation_root', insert_activity_layout_one?: { __typename?: 'activity_layout', id: number, activityId: number, blockId?: number | null, size: string, order: number, isStatic: boolean, type?: any | null } | null };

export type Update_Activity_Layout_By_PkMutationVariables = Exact<{
  pk_columns: Activity_Layout_Pk_Columns_Input;
  _set?: InputMaybe<Activity_Layout_Set_Input>;
}>;


export type Update_Activity_Layout_By_PkMutation = { __typename?: 'mutation_root', update_activity_layout_by_pk?: { __typename?: 'activity_layout', id: number, activityId: number, blockId?: number | null, size: string, order: number, isStatic: boolean, type?: any | null } | null };

export type Delete_Activity_Layout_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Activity_Layout_By_PkMutation = { __typename?: 'mutation_root', delete_activity_layout_by_pk?: { __typename?: 'activity_layout', id: number, activityId: number, blockId?: number | null, size: string, order: number, isStatic: boolean, type?: any | null } | null };

export type Insert_Block_OneMutationVariables = Exact<{
  object: Block_Insert_Input;
}>;


export type Insert_Block_OneMutation = { __typename?: 'mutation_root', insert_block_one?: { __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null } | null };

export type DeleteBlockMutationVariables = Exact<{
  where: Block_Bool_Exp;
}>;


export type DeleteBlockMutation = { __typename?: 'mutation_root', delete_block?: { __typename?: 'block_mutation_response', returning: Array<{ __typename?: 'block', id: number, name: string, type: any, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null }> } | null };

export type Delete_Block_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Block_By_PkMutation = { __typename?: 'mutation_root', delete_block_by_pk?: { __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null } | null };

export type Update_Block_By_PkMutationVariables = Exact<{
  pkColumns: Block_Pk_Columns_Input;
  set?: InputMaybe<Block_Set_Input>;
}>;


export type Update_Block_By_PkMutation = { __typename?: 'mutation_root', update_block_by_pk?: { __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null } | null };

export type Insert_Block_List_Item_OneMutationVariables = Exact<{
  object: Block_List_Item_Insert_Input;
}>;


export type Insert_Block_List_Item_OneMutation = { __typename?: 'mutation_root', insert_block_list_item_one?: { __typename?: 'block_list_item', id: number, name: string, type: any, fillBlankId?: number | null, dndId?: number | null, quizId?: number | null, textId?: number | null, mediaId?: number | null, media?: { __typename?: 'media', id: number, type: any, path: string } | null, block_tags: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null, tag?: { __typename?: 'tag', label: string, id: number } | null }>, block_list_item_workspaces: Array<{ __typename?: 'block_list_item_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> } | null };

export type Update_Block_List_Item_By_PkMutationVariables = Exact<{
  pkColumns: Block_List_Item_Pk_Columns_Input;
  set?: InputMaybe<Block_List_Item_Set_Input>;
}>;


export type Update_Block_List_Item_By_PkMutation = { __typename?: 'mutation_root', update_block_list_item_by_pk?: { __typename?: 'block_list_item', id: number, name: string, type: any, fillBlankId?: number | null, dndId?: number | null, quizId?: number | null, textId?: number | null, mediaId?: number | null, media?: { __typename?: 'media', id: number, type: any, path: string } | null, block_tags: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null, tag?: { __typename?: 'tag', label: string, id: number } | null }>, block_list_item_workspaces: Array<{ __typename?: 'block_list_item_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> } | null };

export type Insert_Block_TagMutationVariables = Exact<{
  objects: Array<Block_Tag_Insert_Input> | Block_Tag_Insert_Input;
}>;


export type Insert_Block_TagMutation = { __typename?: 'mutation_root', insert_block_tag?: { __typename?: 'block_tag_mutation_response', returning: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null, tag?: { __typename?: 'tag', label: string, id: number } | null }> } | null };

export type Delete_Block_TagMutationVariables = Exact<{
  where: Block_Tag_Bool_Exp;
}>;


export type Delete_Block_TagMutation = { __typename?: 'mutation_root', delete_block_tag?: { __typename?: 'block_tag_mutation_response', returning: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null }> } | null };

export type Delete_Block_Tag_By_PkMutationVariables = Exact<{
  deleteBlockTagByPkId: Scalars['Int'];
}>;


export type Delete_Block_Tag_By_PkMutation = { __typename?: 'mutation_root', delete_block_tag_by_pk?: { __typename?: 'block_tag', id: number, tagId?: number | null } | null };

export type Insert_Block_List_Item_WorkspaceMutationVariables = Exact<{
  objects: Array<Block_List_Item_Workspace_Insert_Input> | Block_List_Item_Workspace_Insert_Input;
}>;


export type Insert_Block_List_Item_WorkspaceMutation = { __typename?: 'mutation_root', insert_block_list_item_workspace?: { __typename?: 'block_list_item_workspace_mutation_response', returning: Array<{ __typename?: 'block_list_item_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> } | null };

export type Delete_Block_List_Item_WorkspaceMutationVariables = Exact<{
  where: Block_List_Item_Workspace_Bool_Exp;
}>;


export type Delete_Block_List_Item_WorkspaceMutation = { __typename?: 'mutation_root', delete_block_list_item_workspace?: { __typename?: 'block_list_item_workspace_mutation_response', returning: Array<{ __typename?: 'block_list_item_workspace', id: number, workspaceId: number, workspace: { __typename?: 'workspace', id: number } }> } | null };

export type Insert_Group_OneMutationVariables = Exact<{
  object: Group_Insert_Input;
}>;


export type Insert_Group_OneMutation = { __typename?: 'mutation_root', insert_group_one?: { __typename?: 'group', id: number, created_at: any, name: string, user_groups_aggregate: { __typename?: 'user_group_aggregate', aggregate?: { __typename?: 'user_group_aggregate_fields', count: number } | null } } | null };

export type Update_Group_By_PkMutationVariables = Exact<{
  pk_columns: Group_Pk_Columns_Input;
  _set?: InputMaybe<Group_Set_Input>;
}>;


export type Update_Group_By_PkMutation = { __typename?: 'mutation_root', update_group_by_pk?: { __typename?: 'group', id: number, created_at: any, name: string, user_groups_aggregate: { __typename?: 'user_group_aggregate', aggregate?: { __typename?: 'user_group_aggregate_fields', count: number } | null } } | null };

export type Insert_Group_Workspace_OneMutationVariables = Exact<{
  object: Group_Workspace_Insert_Input;
}>;


export type Insert_Group_Workspace_OneMutation = { __typename?: 'mutation_root', insert_group_workspace_one?: { __typename?: 'group_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } } | null };

export type Delete_Group_WorkspaceMutationVariables = Exact<{
  where: Group_Workspace_Bool_Exp;
}>;


export type Delete_Group_WorkspaceMutation = { __typename?: 'mutation_root', delete_group_workspace?: { __typename?: 'group_workspace_mutation_response', returning: Array<{ __typename?: 'group_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> } | null };

export type Insert_Media_OneMutationVariables = Exact<{
  object: Media_Insert_Input;
}>;


export type Insert_Media_OneMutation = { __typename?: 'mutation_root', insert_media_one?: { __typename?: 'media', id: number, path: string } | null };

export type Delete_Media_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Media_By_PkMutation = { __typename?: 'mutation_root', delete_media_by_pk?: { __typename?: 'media', id: number, path: string } | null };

export type Insert_Question_OneMutationVariables = Exact<{
  object: Question_Insert_Input;
}>;


export type Insert_Question_OneMutation = { __typename?: 'mutation_root', insert_question_one?: { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> } | null };

export type Update_Question_By_PkMutationVariables = Exact<{
  pk_columns: Question_Pk_Columns_Input;
  _set?: InputMaybe<Question_Set_Input>;
}>;


export type Update_Question_By_PkMutation = { __typename?: 'mutation_root', update_question_by_pk?: { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> } | null };

export type Delete_Question_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Question_By_PkMutation = { __typename?: 'mutation_root', delete_question_by_pk?: { __typename?: 'question', id: number } | null };

export type Insert_Question_Option_OneMutationVariables = Exact<{
  object: Question_Option_Insert_Input;
}>;


export type Insert_Question_Option_OneMutation = { __typename?: 'mutation_root', insert_question_option_one?: { __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null } | null };

export type Insert_Question_OptionMutationVariables = Exact<{
  objects: Array<Question_Option_Insert_Input> | Question_Option_Insert_Input;
}>;


export type Insert_Question_OptionMutation = { __typename?: 'mutation_root', insert_question_option?: { __typename?: 'question_option_mutation_response', returning: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null }> } | null };

export type Update_Question_Option_By_PkMutationVariables = Exact<{
  pk_columns: Question_Option_Pk_Columns_Input;
  _set?: InputMaybe<Question_Option_Set_Input>;
}>;


export type Update_Question_Option_By_PkMutation = { __typename?: 'mutation_root', update_question_option_by_pk?: { __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null } | null };

export type Delete_Question_Option_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Question_Option_By_PkMutation = { __typename?: 'mutation_root', delete_question_option_by_pk?: { __typename?: 'question_option', id: number } | null };

export type Insert_Question_Quiz_OneMutationVariables = Exact<{
  object: Question_Quiz_Insert_Input;
}>;


export type Insert_Question_Quiz_OneMutation = { __typename?: 'mutation_root', insert_question_quiz_one?: { __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }, quiz: { __typename?: 'quiz', id: number } } | null };

export type Update_Question_Quiz_By_PkMutationVariables = Exact<{
  pk_columns: Question_Quiz_Pk_Columns_Input;
  _set?: InputMaybe<Question_Quiz_Set_Input>;
}>;


export type Update_Question_Quiz_By_PkMutation = { __typename?: 'mutation_root', update_question_quiz_by_pk?: { __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }, quiz: { __typename?: 'quiz', id: number } } | null };

export type Delete_Question_Quiz_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Question_Quiz_By_PkMutation = { __typename?: 'mutation_root', delete_question_quiz_by_pk?: { __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }, quiz: { __typename?: 'quiz', id: number } } | null };

export type Insert_Quiz_OneMutationVariables = Exact<{
  object: Quiz_Insert_Input;
}>;


export type Insert_Quiz_OneMutation = { __typename?: 'mutation_root', insert_quiz_one?: { __typename?: 'quiz', id: number, title: string, type?: string | null } | null };

export type Update_Quiz_By_PkMutationVariables = Exact<{
  pk_columns: Quiz_Pk_Columns_Input;
  _set?: InputMaybe<Quiz_Set_Input>;
}>;


export type Update_Quiz_By_PkMutation = { __typename?: 'mutation_root', update_quiz_by_pk?: { __typename?: 'quiz', id: number, title: string, type?: string | null } | null };

export type Delete_Quiz_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Quiz_By_PkMutation = { __typename?: 'mutation_root', delete_quiz_by_pk?: { __typename?: 'quiz', id: number, title: string, type?: string | null } | null };

export type Insert_Tag_OneMutationVariables = Exact<{
  object: Tag_Insert_Input;
}>;


export type Insert_Tag_OneMutation = { __typename?: 'mutation_root', insert_tag_one?: { __typename?: 'tag', id: number, label: string } | null };

export type Insert_Text_OneMutationVariables = Exact<{
  object: Text_Insert_Input;
}>;


export type Insert_Text_OneMutation = { __typename?: 'mutation_root', insert_text_one?: { __typename?: 'text', id: number, title: string, content?: string | null, created_at: any } | null };

export type Update_Text_By_PkMutationVariables = Exact<{
  pk_columns: Text_Pk_Columns_Input;
  _set?: InputMaybe<Text_Set_Input>;
}>;


export type Update_Text_By_PkMutation = { __typename?: 'mutation_root', update_text_by_pk?: { __typename?: 'text', id: number, title: string, content?: string | null, created_at: any } | null };

export type Delete_Text_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_Text_By_PkMutation = { __typename?: 'mutation_root', delete_text_by_pk?: { __typename?: 'text', id: number, title: string, content?: string | null, created_at: any } | null };

export type Get_Image_Upload_LinkMutationVariables = Exact<{ [key: string]: never; }>;


export type Get_Image_Upload_LinkMutation = { __typename?: 'mutation_root', image_upload?: { __typename?: 'ImageUpload', uploadURL: string, id: string } | null };

export type Insert_User_OneMutationVariables = Exact<{
  object: User_Insert_Input;
}>;


export type Insert_User_OneMutation = { __typename?: 'mutation_root', insert_user_one?: { __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null } | null };

export type Insert_UserMutationVariables = Exact<{
  objects: Array<User_Insert_Input> | User_Insert_Input;
  on_conflict: User_On_Conflict;
}>;


export type Insert_UserMutation = { __typename?: 'mutation_root', insert_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null }> } | null };

export type Update_User_By_PkMutationVariables = Exact<{
  pk_columns: User_Pk_Columns_Input;
  _set?: InputMaybe<User_Set_Input>;
}>;


export type Update_User_By_PkMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null } | null };

export type Update_UserMutationVariables = Exact<{
  where: User_Bool_Exp;
}>;


export type Update_UserMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', returning: Array<{ __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, picture?: string | null, language: any }> } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'mutation_root', update_user_profile?: { __typename?: 'UserProfileOutput', id: number, email: string, first_name: string, last_name: string, role: string, picture?: string | null, language: string } | null };

export type ResendTemporaryPasswordMutationVariables = Exact<{
  Username: Scalars['String'];
}>;


export type ResendTemporaryPasswordMutation = { __typename?: 'mutation_root', reset_temporary_password: number };

export type Update_User_Activity_By_PkMutationVariables = Exact<{
  pk_columns: User_Activity_Pk_Columns_Input;
  _set?: InputMaybe<User_Activity_Set_Input>;
}>;


export type Update_User_Activity_By_PkMutation = { __typename?: 'mutation_root', update_user_activity_by_pk?: { __typename?: 'user_activity', id: number, answers: any, infos: any, activity?: { __typename?: 'activity', id: number } | null } | null };

export type UseDeleteUserBlockMutationVariables = Exact<{
  where: User_Block_Bool_Exp;
}>;


export type UseDeleteUserBlockMutation = { __typename?: 'mutation_root', delete_user_block?: { __typename?: 'user_block_mutation_response', returning: Array<{ __typename?: 'user_block', id: number }> } | null };

export type Insert_User_Group_OneMutationVariables = Exact<{
  object: User_Group_Insert_Input;
}>;


export type Insert_User_Group_OneMutation = { __typename?: 'mutation_root', insert_user_group_one?: { __typename?: 'user_group', id: number, user: { __typename?: 'user', id: number }, group: { __typename?: 'group', id: number, name: string } } | null };

export type Insert_User_Workspace_OneMutationVariables = Exact<{
  object: User_Workspace_Insert_Input;
}>;


export type Insert_User_Workspace_OneMutation = { __typename?: 'mutation_root', insert_user_workspace_one?: { __typename?: 'user_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } } | null };

export type Delete_User_WorkspaceMutationVariables = Exact<{
  where: User_Workspace_Bool_Exp;
}>;


export type Delete_User_WorkspaceMutation = { __typename?: 'mutation_root', delete_user_workspace?: { __typename?: 'user_workspace_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_workspace', id: number }> } | null };

export type Insert_Workspace_OneMutationVariables = Exact<{
  object: Workspace_Insert_Input;
}>;


export type Insert_Workspace_OneMutation = { __typename?: 'mutation_root', insert_workspace_one?: { __typename?: 'workspace', id: number, name: string } | null };

export type Update_Workspace_By_PkMutationVariables = Exact<{
  pk_columns: Workspace_Pk_Columns_Input;
  _set?: InputMaybe<Workspace_Set_Input>;
}>;


export type Update_Workspace_By_PkMutation = { __typename?: 'mutation_root', update_workspace_by_pk?: { __typename?: 'workspace', id: number, name: string } | null };

export type ActivityQueryVariables = Exact<{
  where?: InputMaybe<Activity_Bool_Exp>;
  order_by?: InputMaybe<Array<Activity_Order_By> | Activity_Order_By>;
}>;


export type ActivityQuery = { __typename?: 'query_root', activity: Array<{ __typename?: 'activity', id: number, name?: string | null, order: number, blocks: Array<{ __typename?: 'block', type: any }> }> };

export type GetActivityAggregateQueryVariables = Exact<{
  where?: InputMaybe<Activity_Bool_Exp>;
}>;


export type GetActivityAggregateQuery = { __typename?: 'query_root', activity_aggregate: { __typename?: 'activity_aggregate', aggregate?: { __typename?: 'activity_aggregate_fields', max?: { __typename?: 'activity_max_fields', order?: number | null } | null } | null } };

export type Activity_LayoutQueryVariables = Exact<{
  where?: InputMaybe<Activity_Layout_Bool_Exp>;
  order_by?: InputMaybe<Array<Activity_Layout_Order_By> | Activity_Layout_Order_By>;
}>;


export type Activity_LayoutQuery = { __typename?: 'query_root', activity_layout: Array<{ __typename?: 'activity_layout', id: number, activityId: number, blockId?: number | null, size: string, order: number, isStatic: boolean, type?: any | null }> };

export type BlockQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Block_Bool_Exp>;
  order_by?: InputMaybe<Array<Block_Order_By> | Block_Order_By>;
}>;


export type BlockQuery = { __typename?: 'query_root', block: Array<{ __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null }> };

export type Block_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Block_By_PkQuery = { __typename?: 'query_root', block_by_pk?: { __typename?: 'block', id: number, name: string, type: any, quizId?: number | null, fillBlankId?: number | null, textId?: number | null, mediaId?: number | null, quiz?: { __typename?: 'quiz', id: number, title: string, type?: string | null, questions: Array<{ __typename?: 'question', id: number, label: string, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, rightAnswer: boolean }> }> } | null, fill_blank?: { __typename?: 'fill_blank', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> }> } | null, dnd?: { __typename?: 'dnd', id: number, title: string, questions: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, order?: string | null, media?: { __typename?: 'media', id: number, path: string } | null }>, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string }> } | null, text?: { __typename?: 'text', id: number, title: string, content?: string | null } | null, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null } | null };

export type Block_List_ItemQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
  order_by?: InputMaybe<Array<Block_List_Item_Order_By> | Block_List_Item_Order_By>;
}>;


export type Block_List_ItemQuery = { __typename?: 'query_root', block_list_item: Array<{ __typename?: 'block_list_item', id: number, name: string, type: any, fillBlankId?: number | null, dndId?: number | null, quizId?: number | null, textId?: number | null, mediaId?: number | null, media?: { __typename?: 'media', id: number, type: any, path: string } | null, block_tags: Array<{ __typename?: 'block_tag', id: number, tagId?: number | null, tag?: { __typename?: 'tag', label: string, id: number } | null }>, block_list_item_workspaces: Array<{ __typename?: 'block_list_item_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> }> };

export type Block_List_Item_AggregateQueryVariables = Exact<{
  where?: InputMaybe<Block_List_Item_Bool_Exp>;
}>;


export type Block_List_Item_AggregateQuery = { __typename?: 'query_root', block_list_item_aggregate: { __typename?: 'block_list_item_aggregate', aggregate?: { __typename?: 'block_list_item_aggregate_fields', count: number } | null } };

export type GroupQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Group_Bool_Exp>;
  order_by?: InputMaybe<Array<Group_Order_By> | Group_Order_By>;
}>;


export type GroupQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'group', id: number, created_at: any, name: string, user_groups_aggregate: { __typename?: 'user_group_aggregate', aggregate?: { __typename?: 'user_group_aggregate_fields', count: number } | null } }> };

export type Group_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Group_By_PkQuery = { __typename?: 'query_root', group_by_pk?: { __typename?: 'group', id: number, created_at: any, name: string, user_groups_aggregate: { __typename?: 'user_group_aggregate', aggregate?: { __typename?: 'user_group_aggregate_fields', count: number } | null } } | null };

export type Group_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Group_AggregateQuery = { __typename?: 'query_root', group_aggregate: { __typename?: 'group_aggregate', aggregate?: { __typename?: 'group_aggregate_fields', count: number } | null } };

export type Group_WorkspaceQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Group_Workspace_Bool_Exp>;
  order_by?: InputMaybe<Array<Group_Workspace_Order_By> | Group_Workspace_Order_By>;
}>;


export type Group_WorkspaceQuery = { __typename?: 'query_root', group_workspace: Array<{ __typename?: 'group_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', config: any, tier: any, type: any, uid: any, name: string, id: number, gid?: any | null }> };

export type QuestionQueryVariables = Exact<{
  where?: InputMaybe<Question_Bool_Exp>;
  order_by?: InputMaybe<Array<Question_Order_By> | Question_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionQuery = { __typename?: 'query_root', question: Array<{ __typename?: 'question', id: number, label: string, correctAnswerId?: number | null, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }> };

export type Question_OptionQueryVariables = Exact<{
  where?: InputMaybe<Question_Option_Bool_Exp>;
  order_by?: InputMaybe<Array<Question_Option_Order_By> | Question_Option_Order_By>;
}>;


export type Question_OptionQuery = { __typename?: 'query_root', question_option: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null }> };

export type Question_Option_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Question_Option_By_PkQuery = { __typename?: 'query_root', question_option_by_pk?: { __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, mediaId?: number | null, rightAnswer: boolean, questionId?: number | null } | null };

export type Question_QuizQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By> | Question_Quiz_Order_By>;
}>;


export type Question_QuizQuery = { __typename?: 'query_root', question_quiz: Array<{ __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }, quiz: { __typename?: 'quiz', id: number } }> };

export type Question_Quiz_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Question_Quiz_By_PkQuery = { __typename?: 'query_root', question_quiz_by_pk?: { __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, hasMath: boolean, order?: string | null, created_at: any, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, hasMath: boolean, rightAnswer: boolean, questionId?: number | null, weight: number }>, media?: { __typename?: 'media', id: number, path: string } | null, question_workspaces: Array<{ __typename?: 'question_workspace', workspace: { __typename?: 'workspace', id: number, name: string } }>, question_tags: Array<{ __typename?: 'question_tag', tag: { __typename?: 'tag', id: number, label: string } }> }, quiz: { __typename?: 'quiz', id: number } } | null };

export type Question_Quiz_AggregateQueryVariables = Exact<{
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
}>;


export type Question_Quiz_AggregateQuery = { __typename?: 'query_root', question_quiz_aggregate: { __typename?: 'question_quiz_aggregate', aggregate?: { __typename?: 'question_quiz_aggregate_fields', count: number } | null } };

export type GetQuestionQuizManyForClientQueryVariables = Exact<{
  where?: InputMaybe<Question_Quiz_Bool_Exp>;
  order_by?: InputMaybe<Array<Question_Quiz_Order_By> | Question_Quiz_Order_By>;
}>;


export type GetQuestionQuizManyForClientQuery = { __typename?: 'query_root', question_quiz: Array<{ __typename?: 'question_quiz', id: number, order: number, question: { __typename?: 'question', id: number, label: string, order?: string | null, type: any, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null, question_options: Array<{ __typename?: 'question_option', id: number, label: string, order: string, questionId?: number | null, mediaId?: number | null, hasMath: boolean, media?: { __typename?: 'media', id: number, label: string, type: any, path: string } | null }> }, quiz: { __typename?: 'quiz', id: number } }> };

export type QuizQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Quiz_Bool_Exp>;
  order_by?: InputMaybe<Array<Quiz_Order_By> | Quiz_Order_By>;
}>;


export type QuizQuery = { __typename?: 'query_root', quiz: Array<{ __typename?: 'quiz', id: number, title: string, type?: string | null }> };

export type Quiz_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Quiz_By_PkQuery = { __typename?: 'query_root', quiz_by_pk?: { __typename?: 'quiz', id: number, title: string, type?: string | null } | null };

export type Quiz_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Quiz_AggregateQuery = { __typename?: 'query_root', quiz_aggregate: { __typename?: 'quiz_aggregate', aggregate?: { __typename?: 'quiz_aggregate_fields', count: number } | null } };

export type TagQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Tag_Bool_Exp>;
  order_by?: InputMaybe<Array<Tag_Order_By> | Tag_Order_By>;
}>;


export type TagQuery = { __typename?: 'query_root', tag: Array<{ __typename?: 'tag', id: number, label: string }> };

export type Text_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Text_By_PkQuery = { __typename?: 'query_root', text_by_pk?: { __typename?: 'text', id: number, title: string, content?: string | null, created_at: any } | null };

export type TextQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Text_Bool_Exp>;
  order_by?: InputMaybe<Array<Text_Order_By> | Text_Order_By>;
}>;


export type TextQuery = { __typename?: 'query_root', text: Array<{ __typename?: 'text', id: number, title: string, content?: string | null, created_at: any }> };

export type Text_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Text_AggregateQuery = { __typename?: 'query_root', text_aggregate: { __typename?: 'text_aggregate', aggregate?: { __typename?: 'text_aggregate_fields', count: number } | null } };

export type UserQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Order_By> | User_Order_By>;
}>;


export type UserQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null }> };

export type GetUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Order_By> | User_Order_By>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null }> };

export type User_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type User_By_PkQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', id: number, email: string, first_name: string, last_name: string, role: any, last_login?: any | null } | null };

export type Get_User_ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_User_ProfileQuery = { __typename?: 'query_root', get_user_profile?: { __typename?: 'UserProfileOutput', id: number, email: string, first_name: string, last_name: string, role: string, picture?: string | null, language: string, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'query_root', get_user_profile?: { __typename?: 'UserProfileOutput', id: number, email: string, first_name: string, last_name: string, role: string, picture?: string | null, language: string, organization?: { __typename?: 'Organization', id: number, name: string, tier: string, config: string } | null } | null };

export type User_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type User_AggregateQuery = { __typename?: 'query_root', user_aggregate: { __typename?: 'user_aggregate', aggregate?: { __typename?: 'user_aggregate_fields', count: number } | null } };

export type UserAggregateQueryVariables = Exact<{
  where?: InputMaybe<User_Bool_Exp>;
}>;


export type UserAggregateQuery = { __typename?: 'query_root', user_aggregate: { __typename?: 'user_aggregate', aggregate?: { __typename?: 'user_aggregate_fields', count: number } | null } };

export type GetUsersCountQueryVariables = Exact<{
  where: User_Bool_Exp;
}>;


export type GetUsersCountQuery = { __typename?: 'query_root', user_aggregate: { __typename?: 'user_aggregate', aggregate?: { __typename?: 'user_aggregate_fields', count: number } | null } };

export type GetUsersAccountQueryVariables = Exact<{
  Limit?: InputMaybe<Scalars['Int']>;
  UsernameFilter?: InputMaybe<Scalars['String']>;
  PaginationToken?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersAccountQuery = { __typename?: 'query_root', list_cognito_users?: { __typename?: 'ListCognitoOutput', PaginationToken?: string | null, users?: Array<{ __typename?: 'UsersCognitoOutput', Username: string, UserStatus: string, UserCreateDate?: any | null, UserLastModifiedDate?: any | null, Attributes?: Array<{ __typename?: 'UserCognitoAttributes', Name: string, Value: string } | null> | null } | null> | null } | null };

export type User_ActivityQueryVariables = Exact<{
  where?: InputMaybe<User_Activity_Bool_Exp>;
}>;


export type User_ActivityQuery = { __typename?: 'query_root', user_activity: Array<{ __typename?: 'user_activity', id: number, answers: any, infos: any, activity?: { __typename?: 'activity', id: number } | null }> };

export type User_GroupQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Group_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Group_Order_By> | User_Group_Order_By>;
}>;


export type User_GroupQuery = { __typename?: 'query_root', user_group: Array<{ __typename?: 'user_group', id: number, user: { __typename?: 'user', id: number }, group: { __typename?: 'group', id: number, name: string } }> };

export type User_WorkspaceQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Workspace_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Workspace_Order_By> | User_Workspace_Order_By>;
}>;


export type User_WorkspaceQuery = { __typename?: 'query_root', user_workspace: Array<{ __typename?: 'user_workspace', id: number, workspace: { __typename?: 'workspace', id: number, name: string } }> };

export type WorkspaceQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Workspace_Bool_Exp>;
  order_by?: InputMaybe<Array<Workspace_Order_By> | Workspace_Order_By>;
}>;


export type WorkspaceQuery = { __typename?: 'query_root', workspace: Array<{ __typename?: 'workspace', id: number, name: string }> };

export type Workspace_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Workspace_By_PkQuery = { __typename?: 'query_root', workspace_by_pk?: { __typename?: 'workspace', id: number, name: string } | null };

export type Workspace_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Workspace_AggregateQuery = { __typename?: 'query_root', workspace_aggregate: { __typename?: 'workspace_aggregate', aggregate?: { __typename?: 'workspace_aggregate_fields', count: number } | null } };

export const Activity_FieldsFragmentDoc = gql`
    fragment ACTIVITY_FIELDS on activity {
  id
  name
  order
  blocks {
    type
  }
}
    `;
export const Activity_Layout_FieldsFragmentDoc = gql`
    fragment ACTIVITY_LAYOUT_FIELDS on activity_layout {
  id
  activityId
  blockId
  size
  order
  isStatic
  type
}
    `;
export const Block_FieldsFragmentDoc = gql`
    fragment BLOCK_FIELDS on block {
  id
  name
  type
  quizId
  fillBlankId
  textId
  mediaId
  quiz {
    id
    title
    type
    questions {
      id
      label
      media {
        id
        path
      }
      order
      question_options {
        id
        label
        order
        rightAnswer
      }
    }
  }
  fill_blank {
    id
    title
    questions {
      id
      label
      correctAnswerId
      order
      question_options {
        id
        label
        order
      }
    }
  }
  dnd {
    id
    title
    questions {
      id
      label
      correctAnswerId
      media {
        id
        path
      }
      order
    }
    question_options {
      id
      label
      order
    }
  }
  text {
    id
    title
    content
  }
  media {
    id
    label
    type
    path
  }
}
    `;
export const Block_List_FieldsFragmentDoc = gql`
    fragment BLOCK_LIST_FIELDS on block_list_item {
  id
  name
  type
  fillBlankId
  dndId
  quizId
  textId
  mediaId
  media {
    id
    type
    path
  }
  block_tags {
    id
    tagId
    tag {
      label
      id
    }
  }
  block_list_item_workspaces {
    id
    workspace {
      id
      name
    }
  }
}
    `;
export const Group_FieldsFragmentDoc = gql`
    fragment GROUP_FIELDS on group {
  id
  created_at
  name
  user_groups_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const Media_FieldsFragmentDoc = gql`
    fragment MEDIA_FIELDS on media {
  id
  label
  type
  path
}
    `;
export const Question_FieldsFragmentDoc = gql`
    fragment QUESTION_FIELDS on question {
  id
  label
  correctAnswerId
  hasMath
  question_options {
    id
    label
    order
    hasMath
    rightAnswer
    questionId
    weight
  }
  media {
    id
    path
  }
  order
  created_at
  question_workspaces {
    workspace {
      id
      name
    }
  }
  question_tags {
    tag {
      id
      label
    }
  }
}
    `;
export const Question_Base_FieldsFragmentDoc = gql`
    fragment QUESTION_BASE_FIELDS on question {
  id
  label
  order
  type
}
    `;
export const Question_Option_FieldsFragmentDoc = gql`
    fragment QUESTION_OPTION_FIELDS on question_option {
  id
  label
  order
  hasMath
  mediaId
  rightAnswer
  questionId
}
    `;
export const Question_Option_Base_FieldsFragmentDoc = gql`
    fragment QUESTION_OPTION_BASE_FIELDS on question_option {
  id
  label
  order
  questionId
  mediaId
  hasMath
}
    `;
export const Question_Quiz_FieldsFragmentDoc = gql`
    fragment QUESTION_QUIZ_FIELDS on question {
  id
  label
  hasMath
  question_options {
    id
    label
    order
    hasMath
    rightAnswer
    questionId
    weight
  }
  media {
    id
    path
  }
  order
  created_at
  question_workspaces {
    workspace {
      id
      name
    }
  }
  question_tags {
    tag {
      id
      label
    }
  }
}
    `;
export const Quiz_FieldsFragmentDoc = gql`
    fragment QUIZ_FIELDS on quiz {
  id
  title
  type
}
    `;
export const Text_FieldsFragmentDoc = gql`
    fragment TEXT_FIELDS on text {
  id
  title
  content
  created_at
}
    `;
export const User_FieldsFragmentDoc = gql`
    fragment USER_FIELDS on user {
  id
  email
  first_name
  last_name
  role
  last_login
}
    `;
export const User_Activity_FieldsFragmentDoc = gql`
    fragment USER_ACTIVITY_FIELDS on user_activity {
  id
  answers
  infos
  activity {
    id
  }
}
    `;
export const User_Group_FieldsFragmentDoc = gql`
    fragment USER_GROUP_FIELDS on user_group {
  id
  user {
    id
  }
  group {
    id
    name
  }
}
    `;
export const Workspace_FieldsFragmentDoc = gql`
    fragment WORKSPACE_FIELDS on workspace {
  id
  name
}
    `;
export const Insert_Activity_OneDocument = gql`
    mutation Insert_activity_one($object: activity_insert_input!) {
  insert_activity_one(object: $object) {
    blocks_aggregate {
      aggregate {
        count
      }
    }
    blocks {
      activityId
      id
      name
      type
      textId
    }
    id
    name
    order
    lessonId
  }
}
    `;
export type Insert_Activity_OneMutationFn = Apollo.MutationFunction<Insert_Activity_OneMutation, Insert_Activity_OneMutationVariables>;

/**
 * __useInsert_Activity_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Activity_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Activity_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertActivityOneMutation, { data, loading, error }] = useInsert_Activity_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Activity_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Activity_OneMutation, Insert_Activity_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Activity_OneMutation, Insert_Activity_OneMutationVariables>(Insert_Activity_OneDocument, options);
      }
export type Insert_Activity_OneMutationHookResult = ReturnType<typeof useInsert_Activity_OneMutation>;
export type Insert_Activity_OneMutationResult = Apollo.MutationResult<Insert_Activity_OneMutation>;
export type Insert_Activity_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Activity_OneMutation, Insert_Activity_OneMutationVariables>;
export const Delete_Activity_By_PkDocument = gql`
    mutation Delete_activity_by_pk($deleteActivityByPkId: Int!) {
  delete_activity_by_pk(id: $deleteActivityByPkId) {
    id
  }
}
    `;
export type Delete_Activity_By_PkMutationFn = Apollo.MutationFunction<Delete_Activity_By_PkMutation, Delete_Activity_By_PkMutationVariables>;

/**
 * __useDelete_Activity_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Activity_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Activity_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityByPkMutation, { data, loading, error }] = useDelete_Activity_By_PkMutation({
 *   variables: {
 *      deleteActivityByPkId: // value for 'deleteActivityByPkId'
 *   },
 * });
 */
export function useDelete_Activity_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Activity_By_PkMutation, Delete_Activity_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Activity_By_PkMutation, Delete_Activity_By_PkMutationVariables>(Delete_Activity_By_PkDocument, options);
      }
export type Delete_Activity_By_PkMutationHookResult = ReturnType<typeof useDelete_Activity_By_PkMutation>;
export type Delete_Activity_By_PkMutationResult = Apollo.MutationResult<Delete_Activity_By_PkMutation>;
export type Delete_Activity_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Activity_By_PkMutation, Delete_Activity_By_PkMutationVariables>;
export const Update_Activity_By_PkDocument = gql`
    mutation Update_activity_by_pk($pkColumns: activity_pk_columns_input!, $set: activity_set_input) {
  update_activity_by_pk(pk_columns: $pkColumns, _set: $set) {
    order
    name
    id
  }
}
    `;
export type Update_Activity_By_PkMutationFn = Apollo.MutationFunction<Update_Activity_By_PkMutation, Update_Activity_By_PkMutationVariables>;

/**
 * __useUpdate_Activity_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Activity_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Activity_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityByPkMutation, { data, loading, error }] = useUpdate_Activity_By_PkMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_Activity_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Activity_By_PkMutation, Update_Activity_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Activity_By_PkMutation, Update_Activity_By_PkMutationVariables>(Update_Activity_By_PkDocument, options);
      }
export type Update_Activity_By_PkMutationHookResult = ReturnType<typeof useUpdate_Activity_By_PkMutation>;
export type Update_Activity_By_PkMutationResult = Apollo.MutationResult<Update_Activity_By_PkMutation>;
export type Update_Activity_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Activity_By_PkMutation, Update_Activity_By_PkMutationVariables>;
export const Insert_Activity_Layout_OneDocument = gql`
    mutation insert_activity_layout_one($object: activity_layout_insert_input!) {
  insert_activity_layout_one(object: $object) {
    ...ACTIVITY_LAYOUT_FIELDS
  }
}
    ${Activity_Layout_FieldsFragmentDoc}`;
export type Insert_Activity_Layout_OneMutationFn = Apollo.MutationFunction<Insert_Activity_Layout_OneMutation, Insert_Activity_Layout_OneMutationVariables>;

/**
 * __useInsert_Activity_Layout_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Activity_Layout_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Activity_Layout_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertActivityLayoutOneMutation, { data, loading, error }] = useInsert_Activity_Layout_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Activity_Layout_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Activity_Layout_OneMutation, Insert_Activity_Layout_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Activity_Layout_OneMutation, Insert_Activity_Layout_OneMutationVariables>(Insert_Activity_Layout_OneDocument, options);
      }
export type Insert_Activity_Layout_OneMutationHookResult = ReturnType<typeof useInsert_Activity_Layout_OneMutation>;
export type Insert_Activity_Layout_OneMutationResult = Apollo.MutationResult<Insert_Activity_Layout_OneMutation>;
export type Insert_Activity_Layout_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Activity_Layout_OneMutation, Insert_Activity_Layout_OneMutationVariables>;
export const Update_Activity_Layout_By_PkDocument = gql`
    mutation update_activity_layout_by_pk($pk_columns: activity_layout_pk_columns_input!, $_set: activity_layout_set_input) {
  update_activity_layout_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...ACTIVITY_LAYOUT_FIELDS
  }
}
    ${Activity_Layout_FieldsFragmentDoc}`;
export type Update_Activity_Layout_By_PkMutationFn = Apollo.MutationFunction<Update_Activity_Layout_By_PkMutation, Update_Activity_Layout_By_PkMutationVariables>;

/**
 * __useUpdate_Activity_Layout_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Activity_Layout_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Activity_Layout_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityLayoutByPkMutation, { data, loading, error }] = useUpdate_Activity_Layout_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Activity_Layout_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Activity_Layout_By_PkMutation, Update_Activity_Layout_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Activity_Layout_By_PkMutation, Update_Activity_Layout_By_PkMutationVariables>(Update_Activity_Layout_By_PkDocument, options);
      }
export type Update_Activity_Layout_By_PkMutationHookResult = ReturnType<typeof useUpdate_Activity_Layout_By_PkMutation>;
export type Update_Activity_Layout_By_PkMutationResult = Apollo.MutationResult<Update_Activity_Layout_By_PkMutation>;
export type Update_Activity_Layout_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Activity_Layout_By_PkMutation, Update_Activity_Layout_By_PkMutationVariables>;
export const Delete_Activity_Layout_By_PkDocument = gql`
    mutation delete_activity_layout_by_pk($id: Int!) {
  delete_activity_layout_by_pk(id: $id) {
    ...ACTIVITY_LAYOUT_FIELDS
  }
}
    ${Activity_Layout_FieldsFragmentDoc}`;
export type Delete_Activity_Layout_By_PkMutationFn = Apollo.MutationFunction<Delete_Activity_Layout_By_PkMutation, Delete_Activity_Layout_By_PkMutationVariables>;

/**
 * __useDelete_Activity_Layout_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Activity_Layout_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Activity_Layout_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityLayoutByPkMutation, { data, loading, error }] = useDelete_Activity_Layout_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Activity_Layout_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Activity_Layout_By_PkMutation, Delete_Activity_Layout_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Activity_Layout_By_PkMutation, Delete_Activity_Layout_By_PkMutationVariables>(Delete_Activity_Layout_By_PkDocument, options);
      }
export type Delete_Activity_Layout_By_PkMutationHookResult = ReturnType<typeof useDelete_Activity_Layout_By_PkMutation>;
export type Delete_Activity_Layout_By_PkMutationResult = Apollo.MutationResult<Delete_Activity_Layout_By_PkMutation>;
export type Delete_Activity_Layout_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Activity_Layout_By_PkMutation, Delete_Activity_Layout_By_PkMutationVariables>;
export const Insert_Block_OneDocument = gql`
    mutation insert_block_one($object: block_insert_input!) {
  insert_block_one(object: $object) {
    ...BLOCK_FIELDS
  }
}
    ${Block_FieldsFragmentDoc}`;
export type Insert_Block_OneMutationFn = Apollo.MutationFunction<Insert_Block_OneMutation, Insert_Block_OneMutationVariables>;

/**
 * __useInsert_Block_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Block_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Block_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlockOneMutation, { data, loading, error }] = useInsert_Block_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Block_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Block_OneMutation, Insert_Block_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Block_OneMutation, Insert_Block_OneMutationVariables>(Insert_Block_OneDocument, options);
      }
export type Insert_Block_OneMutationHookResult = ReturnType<typeof useInsert_Block_OneMutation>;
export type Insert_Block_OneMutationResult = Apollo.MutationResult<Insert_Block_OneMutation>;
export type Insert_Block_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Block_OneMutation, Insert_Block_OneMutationVariables>;
export const DeleteBlockDocument = gql`
    mutation deleteBlock($where: block_bool_exp!) {
  delete_block(where: $where) {
    returning {
      id
      name
      type
      quiz {
        id
        title
        type
        questions {
          id
          label
          order
          question_options {
            id
            label
            order
            rightAnswer
          }
        }
      }
    }
  }
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const Delete_Block_By_PkDocument = gql`
    mutation delete_block_by_pk($id: Int!) {
  delete_block_by_pk(id: $id) {
    ...BLOCK_FIELDS
  }
}
    ${Block_FieldsFragmentDoc}`;
export type Delete_Block_By_PkMutationFn = Apollo.MutationFunction<Delete_Block_By_PkMutation, Delete_Block_By_PkMutationVariables>;

/**
 * __useDelete_Block_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Block_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Block_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockByPkMutation, { data, loading, error }] = useDelete_Block_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Block_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Block_By_PkMutation, Delete_Block_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Block_By_PkMutation, Delete_Block_By_PkMutationVariables>(Delete_Block_By_PkDocument, options);
      }
export type Delete_Block_By_PkMutationHookResult = ReturnType<typeof useDelete_Block_By_PkMutation>;
export type Delete_Block_By_PkMutationResult = Apollo.MutationResult<Delete_Block_By_PkMutation>;
export type Delete_Block_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Block_By_PkMutation, Delete_Block_By_PkMutationVariables>;
export const Update_Block_By_PkDocument = gql`
    mutation Update_block_by_pk($pkColumns: block_pk_columns_input!, $set: block_set_input) {
  update_block_by_pk(pk_columns: $pkColumns, _set: $set) {
    ...BLOCK_FIELDS
  }
}
    ${Block_FieldsFragmentDoc}`;
export type Update_Block_By_PkMutationFn = Apollo.MutationFunction<Update_Block_By_PkMutation, Update_Block_By_PkMutationVariables>;

/**
 * __useUpdate_Block_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Block_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Block_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockByPkMutation, { data, loading, error }] = useUpdate_Block_By_PkMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_Block_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Block_By_PkMutation, Update_Block_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Block_By_PkMutation, Update_Block_By_PkMutationVariables>(Update_Block_By_PkDocument, options);
      }
export type Update_Block_By_PkMutationHookResult = ReturnType<typeof useUpdate_Block_By_PkMutation>;
export type Update_Block_By_PkMutationResult = Apollo.MutationResult<Update_Block_By_PkMutation>;
export type Update_Block_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Block_By_PkMutation, Update_Block_By_PkMutationVariables>;
export const Insert_Block_List_Item_OneDocument = gql`
    mutation insert_block_list_item_one($object: block_list_item_insert_input!) {
  insert_block_list_item_one(object: $object) {
    ...BLOCK_LIST_FIELDS
  }
}
    ${Block_List_FieldsFragmentDoc}`;
export type Insert_Block_List_Item_OneMutationFn = Apollo.MutationFunction<Insert_Block_List_Item_OneMutation, Insert_Block_List_Item_OneMutationVariables>;

/**
 * __useInsert_Block_List_Item_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Block_List_Item_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Block_List_Item_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlockListItemOneMutation, { data, loading, error }] = useInsert_Block_List_Item_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Block_List_Item_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Block_List_Item_OneMutation, Insert_Block_List_Item_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Block_List_Item_OneMutation, Insert_Block_List_Item_OneMutationVariables>(Insert_Block_List_Item_OneDocument, options);
      }
export type Insert_Block_List_Item_OneMutationHookResult = ReturnType<typeof useInsert_Block_List_Item_OneMutation>;
export type Insert_Block_List_Item_OneMutationResult = Apollo.MutationResult<Insert_Block_List_Item_OneMutation>;
export type Insert_Block_List_Item_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Block_List_Item_OneMutation, Insert_Block_List_Item_OneMutationVariables>;
export const Update_Block_List_Item_By_PkDocument = gql`
    mutation update_block_list_item_by_pk($pkColumns: block_list_item_pk_columns_input!, $set: block_list_item_set_input) {
  update_block_list_item_by_pk(pk_columns: $pkColumns, _set: $set) {
    ...BLOCK_LIST_FIELDS
  }
}
    ${Block_List_FieldsFragmentDoc}`;
export type Update_Block_List_Item_By_PkMutationFn = Apollo.MutationFunction<Update_Block_List_Item_By_PkMutation, Update_Block_List_Item_By_PkMutationVariables>;

/**
 * __useUpdate_Block_List_Item_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Block_List_Item_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Block_List_Item_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockListItemByPkMutation, { data, loading, error }] = useUpdate_Block_List_Item_By_PkMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_Block_List_Item_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Block_List_Item_By_PkMutation, Update_Block_List_Item_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Block_List_Item_By_PkMutation, Update_Block_List_Item_By_PkMutationVariables>(Update_Block_List_Item_By_PkDocument, options);
      }
export type Update_Block_List_Item_By_PkMutationHookResult = ReturnType<typeof useUpdate_Block_List_Item_By_PkMutation>;
export type Update_Block_List_Item_By_PkMutationResult = Apollo.MutationResult<Update_Block_List_Item_By_PkMutation>;
export type Update_Block_List_Item_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Block_List_Item_By_PkMutation, Update_Block_List_Item_By_PkMutationVariables>;
export const Insert_Block_TagDocument = gql`
    mutation Insert_block_tag($objects: [block_tag_insert_input!]!) {
  insert_block_tag(objects: $objects) {
    returning {
      id
      tagId
      tag {
        label
        id
      }
    }
  }
}
    `;
export type Insert_Block_TagMutationFn = Apollo.MutationFunction<Insert_Block_TagMutation, Insert_Block_TagMutationVariables>;

/**
 * __useInsert_Block_TagMutation__
 *
 * To run a mutation, you first call `useInsert_Block_TagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Block_TagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlockTagMutation, { data, loading, error }] = useInsert_Block_TagMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsert_Block_TagMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Block_TagMutation, Insert_Block_TagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Block_TagMutation, Insert_Block_TagMutationVariables>(Insert_Block_TagDocument, options);
      }
export type Insert_Block_TagMutationHookResult = ReturnType<typeof useInsert_Block_TagMutation>;
export type Insert_Block_TagMutationResult = Apollo.MutationResult<Insert_Block_TagMutation>;
export type Insert_Block_TagMutationOptions = Apollo.BaseMutationOptions<Insert_Block_TagMutation, Insert_Block_TagMutationVariables>;
export const Delete_Block_TagDocument = gql`
    mutation Delete_block_tag($where: block_tag_bool_exp!) {
  delete_block_tag(where: $where) {
    returning {
      id
      tagId
    }
  }
}
    `;
export type Delete_Block_TagMutationFn = Apollo.MutationFunction<Delete_Block_TagMutation, Delete_Block_TagMutationVariables>;

/**
 * __useDelete_Block_TagMutation__
 *
 * To run a mutation, you first call `useDelete_Block_TagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Block_TagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockTagMutation, { data, loading, error }] = useDelete_Block_TagMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDelete_Block_TagMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Block_TagMutation, Delete_Block_TagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Block_TagMutation, Delete_Block_TagMutationVariables>(Delete_Block_TagDocument, options);
      }
export type Delete_Block_TagMutationHookResult = ReturnType<typeof useDelete_Block_TagMutation>;
export type Delete_Block_TagMutationResult = Apollo.MutationResult<Delete_Block_TagMutation>;
export type Delete_Block_TagMutationOptions = Apollo.BaseMutationOptions<Delete_Block_TagMutation, Delete_Block_TagMutationVariables>;
export const Delete_Block_Tag_By_PkDocument = gql`
    mutation Delete_block_tag_by_pk($deleteBlockTagByPkId: Int!) {
  delete_block_tag_by_pk(id: $deleteBlockTagByPkId) {
    id
    tagId
  }
}
    `;
export type Delete_Block_Tag_By_PkMutationFn = Apollo.MutationFunction<Delete_Block_Tag_By_PkMutation, Delete_Block_Tag_By_PkMutationVariables>;

/**
 * __useDelete_Block_Tag_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Block_Tag_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Block_Tag_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockTagByPkMutation, { data, loading, error }] = useDelete_Block_Tag_By_PkMutation({
 *   variables: {
 *      deleteBlockTagByPkId: // value for 'deleteBlockTagByPkId'
 *   },
 * });
 */
export function useDelete_Block_Tag_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Block_Tag_By_PkMutation, Delete_Block_Tag_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Block_Tag_By_PkMutation, Delete_Block_Tag_By_PkMutationVariables>(Delete_Block_Tag_By_PkDocument, options);
      }
export type Delete_Block_Tag_By_PkMutationHookResult = ReturnType<typeof useDelete_Block_Tag_By_PkMutation>;
export type Delete_Block_Tag_By_PkMutationResult = Apollo.MutationResult<Delete_Block_Tag_By_PkMutation>;
export type Delete_Block_Tag_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Block_Tag_By_PkMutation, Delete_Block_Tag_By_PkMutationVariables>;
export const Insert_Block_List_Item_WorkspaceDocument = gql`
    mutation Insert_block_list_item_workspace($objects: [block_list_item_workspace_insert_input!]!) {
  insert_block_list_item_workspace(objects: $objects) {
    returning {
      id
      workspace {
        id
        name
      }
    }
  }
}
    `;
export type Insert_Block_List_Item_WorkspaceMutationFn = Apollo.MutationFunction<Insert_Block_List_Item_WorkspaceMutation, Insert_Block_List_Item_WorkspaceMutationVariables>;

/**
 * __useInsert_Block_List_Item_WorkspaceMutation__
 *
 * To run a mutation, you first call `useInsert_Block_List_Item_WorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Block_List_Item_WorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlockListItemWorkspaceMutation, { data, loading, error }] = useInsert_Block_List_Item_WorkspaceMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsert_Block_List_Item_WorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Block_List_Item_WorkspaceMutation, Insert_Block_List_Item_WorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Block_List_Item_WorkspaceMutation, Insert_Block_List_Item_WorkspaceMutationVariables>(Insert_Block_List_Item_WorkspaceDocument, options);
      }
export type Insert_Block_List_Item_WorkspaceMutationHookResult = ReturnType<typeof useInsert_Block_List_Item_WorkspaceMutation>;
export type Insert_Block_List_Item_WorkspaceMutationResult = Apollo.MutationResult<Insert_Block_List_Item_WorkspaceMutation>;
export type Insert_Block_List_Item_WorkspaceMutationOptions = Apollo.BaseMutationOptions<Insert_Block_List_Item_WorkspaceMutation, Insert_Block_List_Item_WorkspaceMutationVariables>;
export const Delete_Block_List_Item_WorkspaceDocument = gql`
    mutation delete_block_list_item_workspace($where: block_list_item_workspace_bool_exp!) {
  delete_block_list_item_workspace(where: $where) {
    returning {
      id
      workspaceId
      workspace {
        id
      }
    }
  }
}
    `;
export type Delete_Block_List_Item_WorkspaceMutationFn = Apollo.MutationFunction<Delete_Block_List_Item_WorkspaceMutation, Delete_Block_List_Item_WorkspaceMutationVariables>;

/**
 * __useDelete_Block_List_Item_WorkspaceMutation__
 *
 * To run a mutation, you first call `useDelete_Block_List_Item_WorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Block_List_Item_WorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockListItemWorkspaceMutation, { data, loading, error }] = useDelete_Block_List_Item_WorkspaceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDelete_Block_List_Item_WorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Block_List_Item_WorkspaceMutation, Delete_Block_List_Item_WorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Block_List_Item_WorkspaceMutation, Delete_Block_List_Item_WorkspaceMutationVariables>(Delete_Block_List_Item_WorkspaceDocument, options);
      }
export type Delete_Block_List_Item_WorkspaceMutationHookResult = ReturnType<typeof useDelete_Block_List_Item_WorkspaceMutation>;
export type Delete_Block_List_Item_WorkspaceMutationResult = Apollo.MutationResult<Delete_Block_List_Item_WorkspaceMutation>;
export type Delete_Block_List_Item_WorkspaceMutationOptions = Apollo.BaseMutationOptions<Delete_Block_List_Item_WorkspaceMutation, Delete_Block_List_Item_WorkspaceMutationVariables>;
export const Insert_Group_OneDocument = gql`
    mutation insert_group_one($object: group_insert_input!) {
  insert_group_one(object: $object) {
    ...GROUP_FIELDS
  }
}
    ${Group_FieldsFragmentDoc}`;
export type Insert_Group_OneMutationFn = Apollo.MutationFunction<Insert_Group_OneMutation, Insert_Group_OneMutationVariables>;

/**
 * __useInsert_Group_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Group_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Group_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGroupOneMutation, { data, loading, error }] = useInsert_Group_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Group_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Group_OneMutation, Insert_Group_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Group_OneMutation, Insert_Group_OneMutationVariables>(Insert_Group_OneDocument, options);
      }
export type Insert_Group_OneMutationHookResult = ReturnType<typeof useInsert_Group_OneMutation>;
export type Insert_Group_OneMutationResult = Apollo.MutationResult<Insert_Group_OneMutation>;
export type Insert_Group_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Group_OneMutation, Insert_Group_OneMutationVariables>;
export const Update_Group_By_PkDocument = gql`
    mutation update_group_by_pk($pk_columns: group_pk_columns_input!, $_set: group_set_input) {
  update_group_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...GROUP_FIELDS
  }
}
    ${Group_FieldsFragmentDoc}`;
export type Update_Group_By_PkMutationFn = Apollo.MutationFunction<Update_Group_By_PkMutation, Update_Group_By_PkMutationVariables>;

/**
 * __useUpdate_Group_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Group_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Group_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupByPkMutation, { data, loading, error }] = useUpdate_Group_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Group_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Group_By_PkMutation, Update_Group_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Group_By_PkMutation, Update_Group_By_PkMutationVariables>(Update_Group_By_PkDocument, options);
      }
export type Update_Group_By_PkMutationHookResult = ReturnType<typeof useUpdate_Group_By_PkMutation>;
export type Update_Group_By_PkMutationResult = Apollo.MutationResult<Update_Group_By_PkMutation>;
export type Update_Group_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Group_By_PkMutation, Update_Group_By_PkMutationVariables>;
export const Insert_Group_Workspace_OneDocument = gql`
    mutation insert_group_workspace_one($object: group_workspace_insert_input!) {
  insert_group_workspace_one(object: $object) {
    id
    workspace {
      id
      name
    }
  }
}
    `;
export type Insert_Group_Workspace_OneMutationFn = Apollo.MutationFunction<Insert_Group_Workspace_OneMutation, Insert_Group_Workspace_OneMutationVariables>;

/**
 * __useInsert_Group_Workspace_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Group_Workspace_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Group_Workspace_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGroupWorkspaceOneMutation, { data, loading, error }] = useInsert_Group_Workspace_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Group_Workspace_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Group_Workspace_OneMutation, Insert_Group_Workspace_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Group_Workspace_OneMutation, Insert_Group_Workspace_OneMutationVariables>(Insert_Group_Workspace_OneDocument, options);
      }
export type Insert_Group_Workspace_OneMutationHookResult = ReturnType<typeof useInsert_Group_Workspace_OneMutation>;
export type Insert_Group_Workspace_OneMutationResult = Apollo.MutationResult<Insert_Group_Workspace_OneMutation>;
export type Insert_Group_Workspace_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Group_Workspace_OneMutation, Insert_Group_Workspace_OneMutationVariables>;
export const Delete_Group_WorkspaceDocument = gql`
    mutation delete_group_workspace($where: group_workspace_bool_exp!) {
  delete_group_workspace(where: $where) {
    returning {
      id
      workspace {
        id
        name
      }
    }
  }
}
    `;
export type Delete_Group_WorkspaceMutationFn = Apollo.MutationFunction<Delete_Group_WorkspaceMutation, Delete_Group_WorkspaceMutationVariables>;

/**
 * __useDelete_Group_WorkspaceMutation__
 *
 * To run a mutation, you first call `useDelete_Group_WorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Group_WorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupWorkspaceMutation, { data, loading, error }] = useDelete_Group_WorkspaceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDelete_Group_WorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Group_WorkspaceMutation, Delete_Group_WorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Group_WorkspaceMutation, Delete_Group_WorkspaceMutationVariables>(Delete_Group_WorkspaceDocument, options);
      }
export type Delete_Group_WorkspaceMutationHookResult = ReturnType<typeof useDelete_Group_WorkspaceMutation>;
export type Delete_Group_WorkspaceMutationResult = Apollo.MutationResult<Delete_Group_WorkspaceMutation>;
export type Delete_Group_WorkspaceMutationOptions = Apollo.BaseMutationOptions<Delete_Group_WorkspaceMutation, Delete_Group_WorkspaceMutationVariables>;
export const Insert_Media_OneDocument = gql`
    mutation Insert_media_one($object: media_insert_input!) {
  insert_media_one(object: $object) {
    id
    path
  }
}
    `;
export type Insert_Media_OneMutationFn = Apollo.MutationFunction<Insert_Media_OneMutation, Insert_Media_OneMutationVariables>;

/**
 * __useInsert_Media_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Media_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Media_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMediaOneMutation, { data, loading, error }] = useInsert_Media_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Media_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Media_OneMutation, Insert_Media_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Media_OneMutation, Insert_Media_OneMutationVariables>(Insert_Media_OneDocument, options);
      }
export type Insert_Media_OneMutationHookResult = ReturnType<typeof useInsert_Media_OneMutation>;
export type Insert_Media_OneMutationResult = Apollo.MutationResult<Insert_Media_OneMutation>;
export type Insert_Media_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Media_OneMutation, Insert_Media_OneMutationVariables>;
export const Delete_Media_By_PkDocument = gql`
    mutation Delete_media_by_pk($id: Int!) {
  delete_media_by_pk(id: $id) {
    id
    path
  }
}
    `;
export type Delete_Media_By_PkMutationFn = Apollo.MutationFunction<Delete_Media_By_PkMutation, Delete_Media_By_PkMutationVariables>;

/**
 * __useDelete_Media_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Media_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Media_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaByPkMutation, { data, loading, error }] = useDelete_Media_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Media_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Media_By_PkMutation, Delete_Media_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Media_By_PkMutation, Delete_Media_By_PkMutationVariables>(Delete_Media_By_PkDocument, options);
      }
export type Delete_Media_By_PkMutationHookResult = ReturnType<typeof useDelete_Media_By_PkMutation>;
export type Delete_Media_By_PkMutationResult = Apollo.MutationResult<Delete_Media_By_PkMutation>;
export type Delete_Media_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Media_By_PkMutation, Delete_Media_By_PkMutationVariables>;
export const Insert_Question_OneDocument = gql`
    mutation insert_question_one($object: question_insert_input!) {
  insert_question_one(object: $object) {
    ...QUESTION_FIELDS
  }
}
    ${Question_FieldsFragmentDoc}`;
export type Insert_Question_OneMutationFn = Apollo.MutationFunction<Insert_Question_OneMutation, Insert_Question_OneMutationVariables>;

/**
 * __useInsert_Question_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Question_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Question_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuestionOneMutation, { data, loading, error }] = useInsert_Question_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Question_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Question_OneMutation, Insert_Question_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Question_OneMutation, Insert_Question_OneMutationVariables>(Insert_Question_OneDocument, options);
      }
export type Insert_Question_OneMutationHookResult = ReturnType<typeof useInsert_Question_OneMutation>;
export type Insert_Question_OneMutationResult = Apollo.MutationResult<Insert_Question_OneMutation>;
export type Insert_Question_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Question_OneMutation, Insert_Question_OneMutationVariables>;
export const Update_Question_By_PkDocument = gql`
    mutation update_question_by_pk($pk_columns: question_pk_columns_input!, $_set: question_set_input) {
  update_question_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...QUESTION_FIELDS
  }
}
    ${Question_FieldsFragmentDoc}`;
export type Update_Question_By_PkMutationFn = Apollo.MutationFunction<Update_Question_By_PkMutation, Update_Question_By_PkMutationVariables>;

/**
 * __useUpdate_Question_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Question_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Question_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionByPkMutation, { data, loading, error }] = useUpdate_Question_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Question_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Question_By_PkMutation, Update_Question_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Question_By_PkMutation, Update_Question_By_PkMutationVariables>(Update_Question_By_PkDocument, options);
      }
export type Update_Question_By_PkMutationHookResult = ReturnType<typeof useUpdate_Question_By_PkMutation>;
export type Update_Question_By_PkMutationResult = Apollo.MutationResult<Update_Question_By_PkMutation>;
export type Update_Question_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Question_By_PkMutation, Update_Question_By_PkMutationVariables>;
export const Delete_Question_By_PkDocument = gql`
    mutation delete_question_by_pk($id: Int!) {
  delete_question_by_pk(id: $id) {
    id
  }
}
    `;
export type Delete_Question_By_PkMutationFn = Apollo.MutationFunction<Delete_Question_By_PkMutation, Delete_Question_By_PkMutationVariables>;

/**
 * __useDelete_Question_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Question_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Question_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionByPkMutation, { data, loading, error }] = useDelete_Question_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Question_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Question_By_PkMutation, Delete_Question_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Question_By_PkMutation, Delete_Question_By_PkMutationVariables>(Delete_Question_By_PkDocument, options);
      }
export type Delete_Question_By_PkMutationHookResult = ReturnType<typeof useDelete_Question_By_PkMutation>;
export type Delete_Question_By_PkMutationResult = Apollo.MutationResult<Delete_Question_By_PkMutation>;
export type Delete_Question_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Question_By_PkMutation, Delete_Question_By_PkMutationVariables>;
export const Insert_Question_Option_OneDocument = gql`
    mutation insert_question_option_one($object: question_option_insert_input!) {
  insert_question_option_one(object: $object) {
    ...QUESTION_OPTION_FIELDS
  }
}
    ${Question_Option_FieldsFragmentDoc}`;
export type Insert_Question_Option_OneMutationFn = Apollo.MutationFunction<Insert_Question_Option_OneMutation, Insert_Question_Option_OneMutationVariables>;

/**
 * __useInsert_Question_Option_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Question_Option_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Question_Option_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuestionOptionOneMutation, { data, loading, error }] = useInsert_Question_Option_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Question_Option_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Question_Option_OneMutation, Insert_Question_Option_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Question_Option_OneMutation, Insert_Question_Option_OneMutationVariables>(Insert_Question_Option_OneDocument, options);
      }
export type Insert_Question_Option_OneMutationHookResult = ReturnType<typeof useInsert_Question_Option_OneMutation>;
export type Insert_Question_Option_OneMutationResult = Apollo.MutationResult<Insert_Question_Option_OneMutation>;
export type Insert_Question_Option_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Question_Option_OneMutation, Insert_Question_Option_OneMutationVariables>;
export const Insert_Question_OptionDocument = gql`
    mutation Insert_question_option($objects: [question_option_insert_input!]!) {
  insert_question_option(objects: $objects) {
    returning {
      ...QUESTION_OPTION_FIELDS
    }
  }
}
    ${Question_Option_FieldsFragmentDoc}`;
export type Insert_Question_OptionMutationFn = Apollo.MutationFunction<Insert_Question_OptionMutation, Insert_Question_OptionMutationVariables>;

/**
 * __useInsert_Question_OptionMutation__
 *
 * To run a mutation, you first call `useInsert_Question_OptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Question_OptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuestionOptionMutation, { data, loading, error }] = useInsert_Question_OptionMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsert_Question_OptionMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Question_OptionMutation, Insert_Question_OptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Question_OptionMutation, Insert_Question_OptionMutationVariables>(Insert_Question_OptionDocument, options);
      }
export type Insert_Question_OptionMutationHookResult = ReturnType<typeof useInsert_Question_OptionMutation>;
export type Insert_Question_OptionMutationResult = Apollo.MutationResult<Insert_Question_OptionMutation>;
export type Insert_Question_OptionMutationOptions = Apollo.BaseMutationOptions<Insert_Question_OptionMutation, Insert_Question_OptionMutationVariables>;
export const Update_Question_Option_By_PkDocument = gql`
    mutation update_question_option_by_pk($pk_columns: question_option_pk_columns_input!, $_set: question_option_set_input) {
  update_question_option_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...QUESTION_OPTION_FIELDS
  }
}
    ${Question_Option_FieldsFragmentDoc}`;
export type Update_Question_Option_By_PkMutationFn = Apollo.MutationFunction<Update_Question_Option_By_PkMutation, Update_Question_Option_By_PkMutationVariables>;

/**
 * __useUpdate_Question_Option_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Question_Option_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Question_Option_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionOptionByPkMutation, { data, loading, error }] = useUpdate_Question_Option_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Question_Option_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Question_Option_By_PkMutation, Update_Question_Option_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Question_Option_By_PkMutation, Update_Question_Option_By_PkMutationVariables>(Update_Question_Option_By_PkDocument, options);
      }
export type Update_Question_Option_By_PkMutationHookResult = ReturnType<typeof useUpdate_Question_Option_By_PkMutation>;
export type Update_Question_Option_By_PkMutationResult = Apollo.MutationResult<Update_Question_Option_By_PkMutation>;
export type Update_Question_Option_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Question_Option_By_PkMutation, Update_Question_Option_By_PkMutationVariables>;
export const Delete_Question_Option_By_PkDocument = gql`
    mutation delete_question_option_by_pk($id: Int!) {
  delete_question_option_by_pk(id: $id) {
    id
  }
}
    `;
export type Delete_Question_Option_By_PkMutationFn = Apollo.MutationFunction<Delete_Question_Option_By_PkMutation, Delete_Question_Option_By_PkMutationVariables>;

/**
 * __useDelete_Question_Option_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Question_Option_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Question_Option_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionOptionByPkMutation, { data, loading, error }] = useDelete_Question_Option_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Question_Option_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Question_Option_By_PkMutation, Delete_Question_Option_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Question_Option_By_PkMutation, Delete_Question_Option_By_PkMutationVariables>(Delete_Question_Option_By_PkDocument, options);
      }
export type Delete_Question_Option_By_PkMutationHookResult = ReturnType<typeof useDelete_Question_Option_By_PkMutation>;
export type Delete_Question_Option_By_PkMutationResult = Apollo.MutationResult<Delete_Question_Option_By_PkMutation>;
export type Delete_Question_Option_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Question_Option_By_PkMutation, Delete_Question_Option_By_PkMutationVariables>;
export const Insert_Question_Quiz_OneDocument = gql`
    mutation insert_question_quiz_one($object: question_quiz_insert_input!) {
  insert_question_quiz_one(object: $object) {
    id
    order
    question {
      ...QUESTION_FIELDS
    }
    quiz {
      id
    }
  }
}
    ${Question_FieldsFragmentDoc}`;
export type Insert_Question_Quiz_OneMutationFn = Apollo.MutationFunction<Insert_Question_Quiz_OneMutation, Insert_Question_Quiz_OneMutationVariables>;

/**
 * __useInsert_Question_Quiz_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Question_Quiz_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Question_Quiz_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuestionQuizOneMutation, { data, loading, error }] = useInsert_Question_Quiz_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Question_Quiz_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Question_Quiz_OneMutation, Insert_Question_Quiz_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Question_Quiz_OneMutation, Insert_Question_Quiz_OneMutationVariables>(Insert_Question_Quiz_OneDocument, options);
      }
export type Insert_Question_Quiz_OneMutationHookResult = ReturnType<typeof useInsert_Question_Quiz_OneMutation>;
export type Insert_Question_Quiz_OneMutationResult = Apollo.MutationResult<Insert_Question_Quiz_OneMutation>;
export type Insert_Question_Quiz_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Question_Quiz_OneMutation, Insert_Question_Quiz_OneMutationVariables>;
export const Update_Question_Quiz_By_PkDocument = gql`
    mutation update_question_quiz_by_pk($pk_columns: question_quiz_pk_columns_input!, $_set: question_quiz_set_input) {
  update_question_quiz_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    order
    question {
      ...QUESTION_FIELDS
    }
    quiz {
      id
    }
  }
}
    ${Question_FieldsFragmentDoc}`;
export type Update_Question_Quiz_By_PkMutationFn = Apollo.MutationFunction<Update_Question_Quiz_By_PkMutation, Update_Question_Quiz_By_PkMutationVariables>;

/**
 * __useUpdate_Question_Quiz_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Question_Quiz_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Question_Quiz_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionQuizByPkMutation, { data, loading, error }] = useUpdate_Question_Quiz_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Question_Quiz_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Question_Quiz_By_PkMutation, Update_Question_Quiz_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Question_Quiz_By_PkMutation, Update_Question_Quiz_By_PkMutationVariables>(Update_Question_Quiz_By_PkDocument, options);
      }
export type Update_Question_Quiz_By_PkMutationHookResult = ReturnType<typeof useUpdate_Question_Quiz_By_PkMutation>;
export type Update_Question_Quiz_By_PkMutationResult = Apollo.MutationResult<Update_Question_Quiz_By_PkMutation>;
export type Update_Question_Quiz_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Question_Quiz_By_PkMutation, Update_Question_Quiz_By_PkMutationVariables>;
export const Delete_Question_Quiz_By_PkDocument = gql`
    mutation delete_question_quiz_by_pk($id: Int!) {
  delete_question_quiz_by_pk(id: $id) {
    id
    order
    question {
      ...QUESTION_FIELDS
    }
    quiz {
      id
    }
  }
}
    ${Question_FieldsFragmentDoc}`;
export type Delete_Question_Quiz_By_PkMutationFn = Apollo.MutationFunction<Delete_Question_Quiz_By_PkMutation, Delete_Question_Quiz_By_PkMutationVariables>;

/**
 * __useDelete_Question_Quiz_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Question_Quiz_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Question_Quiz_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionQuizByPkMutation, { data, loading, error }] = useDelete_Question_Quiz_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Question_Quiz_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Question_Quiz_By_PkMutation, Delete_Question_Quiz_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Question_Quiz_By_PkMutation, Delete_Question_Quiz_By_PkMutationVariables>(Delete_Question_Quiz_By_PkDocument, options);
      }
export type Delete_Question_Quiz_By_PkMutationHookResult = ReturnType<typeof useDelete_Question_Quiz_By_PkMutation>;
export type Delete_Question_Quiz_By_PkMutationResult = Apollo.MutationResult<Delete_Question_Quiz_By_PkMutation>;
export type Delete_Question_Quiz_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Question_Quiz_By_PkMutation, Delete_Question_Quiz_By_PkMutationVariables>;
export const Insert_Quiz_OneDocument = gql`
    mutation insert_quiz_one($object: quiz_insert_input!) {
  insert_quiz_one(object: $object) {
    ...QUIZ_FIELDS
  }
}
    ${Quiz_FieldsFragmentDoc}`;
export type Insert_Quiz_OneMutationFn = Apollo.MutationFunction<Insert_Quiz_OneMutation, Insert_Quiz_OneMutationVariables>;

/**
 * __useInsert_Quiz_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Quiz_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Quiz_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuizOneMutation, { data, loading, error }] = useInsert_Quiz_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Quiz_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Quiz_OneMutation, Insert_Quiz_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Quiz_OneMutation, Insert_Quiz_OneMutationVariables>(Insert_Quiz_OneDocument, options);
      }
export type Insert_Quiz_OneMutationHookResult = ReturnType<typeof useInsert_Quiz_OneMutation>;
export type Insert_Quiz_OneMutationResult = Apollo.MutationResult<Insert_Quiz_OneMutation>;
export type Insert_Quiz_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Quiz_OneMutation, Insert_Quiz_OneMutationVariables>;
export const Update_Quiz_By_PkDocument = gql`
    mutation update_quiz_by_pk($pk_columns: quiz_pk_columns_input!, $_set: quiz_set_input) {
  update_quiz_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...QUIZ_FIELDS
  }
}
    ${Quiz_FieldsFragmentDoc}`;
export type Update_Quiz_By_PkMutationFn = Apollo.MutationFunction<Update_Quiz_By_PkMutation, Update_Quiz_By_PkMutationVariables>;

/**
 * __useUpdate_Quiz_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Quiz_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Quiz_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuizByPkMutation, { data, loading, error }] = useUpdate_Quiz_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Quiz_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Quiz_By_PkMutation, Update_Quiz_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Quiz_By_PkMutation, Update_Quiz_By_PkMutationVariables>(Update_Quiz_By_PkDocument, options);
      }
export type Update_Quiz_By_PkMutationHookResult = ReturnType<typeof useUpdate_Quiz_By_PkMutation>;
export type Update_Quiz_By_PkMutationResult = Apollo.MutationResult<Update_Quiz_By_PkMutation>;
export type Update_Quiz_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Quiz_By_PkMutation, Update_Quiz_By_PkMutationVariables>;
export const Delete_Quiz_By_PkDocument = gql`
    mutation delete_quiz_by_pk($id: Int!) {
  delete_quiz_by_pk(id: $id) {
    ...QUIZ_FIELDS
  }
}
    ${Quiz_FieldsFragmentDoc}`;
export type Delete_Quiz_By_PkMutationFn = Apollo.MutationFunction<Delete_Quiz_By_PkMutation, Delete_Quiz_By_PkMutationVariables>;

/**
 * __useDelete_Quiz_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Quiz_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Quiz_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuizByPkMutation, { data, loading, error }] = useDelete_Quiz_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Quiz_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Quiz_By_PkMutation, Delete_Quiz_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Quiz_By_PkMutation, Delete_Quiz_By_PkMutationVariables>(Delete_Quiz_By_PkDocument, options);
      }
export type Delete_Quiz_By_PkMutationHookResult = ReturnType<typeof useDelete_Quiz_By_PkMutation>;
export type Delete_Quiz_By_PkMutationResult = Apollo.MutationResult<Delete_Quiz_By_PkMutation>;
export type Delete_Quiz_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Quiz_By_PkMutation, Delete_Quiz_By_PkMutationVariables>;
export const Insert_Tag_OneDocument = gql`
    mutation Insert_tag_one($object: tag_insert_input!) {
  insert_tag_one(object: $object) {
    id
    label
  }
}
    `;
export type Insert_Tag_OneMutationFn = Apollo.MutationFunction<Insert_Tag_OneMutation, Insert_Tag_OneMutationVariables>;

/**
 * __useInsert_Tag_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Tag_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Tag_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTagOneMutation, { data, loading, error }] = useInsert_Tag_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Tag_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Tag_OneMutation, Insert_Tag_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Tag_OneMutation, Insert_Tag_OneMutationVariables>(Insert_Tag_OneDocument, options);
      }
export type Insert_Tag_OneMutationHookResult = ReturnType<typeof useInsert_Tag_OneMutation>;
export type Insert_Tag_OneMutationResult = Apollo.MutationResult<Insert_Tag_OneMutation>;
export type Insert_Tag_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Tag_OneMutation, Insert_Tag_OneMutationVariables>;
export const Insert_Text_OneDocument = gql`
    mutation insert_text_one($object: text_insert_input!) {
  insert_text_one(object: $object) {
    ...TEXT_FIELDS
  }
}
    ${Text_FieldsFragmentDoc}`;
export type Insert_Text_OneMutationFn = Apollo.MutationFunction<Insert_Text_OneMutation, Insert_Text_OneMutationVariables>;

/**
 * __useInsert_Text_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Text_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Text_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTextOneMutation, { data, loading, error }] = useInsert_Text_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Text_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Text_OneMutation, Insert_Text_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Text_OneMutation, Insert_Text_OneMutationVariables>(Insert_Text_OneDocument, options);
      }
export type Insert_Text_OneMutationHookResult = ReturnType<typeof useInsert_Text_OneMutation>;
export type Insert_Text_OneMutationResult = Apollo.MutationResult<Insert_Text_OneMutation>;
export type Insert_Text_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Text_OneMutation, Insert_Text_OneMutationVariables>;
export const Update_Text_By_PkDocument = gql`
    mutation update_text_by_pk($pk_columns: text_pk_columns_input!, $_set: text_set_input) {
  update_text_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...TEXT_FIELDS
  }
}
    ${Text_FieldsFragmentDoc}`;
export type Update_Text_By_PkMutationFn = Apollo.MutationFunction<Update_Text_By_PkMutation, Update_Text_By_PkMutationVariables>;

/**
 * __useUpdate_Text_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Text_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Text_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTextByPkMutation, { data, loading, error }] = useUpdate_Text_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Text_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Text_By_PkMutation, Update_Text_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Text_By_PkMutation, Update_Text_By_PkMutationVariables>(Update_Text_By_PkDocument, options);
      }
export type Update_Text_By_PkMutationHookResult = ReturnType<typeof useUpdate_Text_By_PkMutation>;
export type Update_Text_By_PkMutationResult = Apollo.MutationResult<Update_Text_By_PkMutation>;
export type Update_Text_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Text_By_PkMutation, Update_Text_By_PkMutationVariables>;
export const Delete_Text_By_PkDocument = gql`
    mutation delete_text_by_pk($id: Int!) {
  delete_text_by_pk(id: $id) {
    ...TEXT_FIELDS
  }
}
    ${Text_FieldsFragmentDoc}`;
export type Delete_Text_By_PkMutationFn = Apollo.MutationFunction<Delete_Text_By_PkMutation, Delete_Text_By_PkMutationVariables>;

/**
 * __useDelete_Text_By_PkMutation__
 *
 * To run a mutation, you first call `useDelete_Text_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Text_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTextByPkMutation, { data, loading, error }] = useDelete_Text_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Text_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Text_By_PkMutation, Delete_Text_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Text_By_PkMutation, Delete_Text_By_PkMutationVariables>(Delete_Text_By_PkDocument, options);
      }
export type Delete_Text_By_PkMutationHookResult = ReturnType<typeof useDelete_Text_By_PkMutation>;
export type Delete_Text_By_PkMutationResult = Apollo.MutationResult<Delete_Text_By_PkMutation>;
export type Delete_Text_By_PkMutationOptions = Apollo.BaseMutationOptions<Delete_Text_By_PkMutation, Delete_Text_By_PkMutationVariables>;
export const Get_Image_Upload_LinkDocument = gql`
    mutation GET_IMAGE_UPLOAD_LINK {
  image_upload {
    uploadURL
    id
  }
}
    `;
export type Get_Image_Upload_LinkMutationFn = Apollo.MutationFunction<Get_Image_Upload_LinkMutation, Get_Image_Upload_LinkMutationVariables>;

/**
 * __useGet_Image_Upload_LinkMutation__
 *
 * To run a mutation, you first call `useGet_Image_Upload_LinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGet_Image_Upload_LinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getImageUploadLinkMutation, { data, loading, error }] = useGet_Image_Upload_LinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useGet_Image_Upload_LinkMutation(baseOptions?: Apollo.MutationHookOptions<Get_Image_Upload_LinkMutation, Get_Image_Upload_LinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Get_Image_Upload_LinkMutation, Get_Image_Upload_LinkMutationVariables>(Get_Image_Upload_LinkDocument, options);
      }
export type Get_Image_Upload_LinkMutationHookResult = ReturnType<typeof useGet_Image_Upload_LinkMutation>;
export type Get_Image_Upload_LinkMutationResult = Apollo.MutationResult<Get_Image_Upload_LinkMutation>;
export type Get_Image_Upload_LinkMutationOptions = Apollo.BaseMutationOptions<Get_Image_Upload_LinkMutation, Get_Image_Upload_LinkMutationVariables>;
export const Insert_User_OneDocument = gql`
    mutation insert_user_one($object: user_insert_input!) {
  insert_user_one(object: $object) {
    ...USER_FIELDS
  }
}
    ${User_FieldsFragmentDoc}`;
export type Insert_User_OneMutationFn = Apollo.MutationFunction<Insert_User_OneMutation, Insert_User_OneMutationVariables>;

/**
 * __useInsert_User_OneMutation__
 *
 * To run a mutation, you first call `useInsert_User_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_User_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserOneMutation, { data, loading, error }] = useInsert_User_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_User_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_User_OneMutation, Insert_User_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_User_OneMutation, Insert_User_OneMutationVariables>(Insert_User_OneDocument, options);
      }
export type Insert_User_OneMutationHookResult = ReturnType<typeof useInsert_User_OneMutation>;
export type Insert_User_OneMutationResult = Apollo.MutationResult<Insert_User_OneMutation>;
export type Insert_User_OneMutationOptions = Apollo.BaseMutationOptions<Insert_User_OneMutation, Insert_User_OneMutationVariables>;
export const Insert_UserDocument = gql`
    mutation insert_user($objects: [user_insert_input!]!, $on_conflict: user_on_conflict!) {
  insert_user(objects: $objects, on_conflict: $on_conflict) {
    affected_rows
    returning {
      ...USER_FIELDS
    }
  }
}
    ${User_FieldsFragmentDoc}`;
export type Insert_UserMutationFn = Apollo.MutationFunction<Insert_UserMutation, Insert_UserMutationVariables>;

/**
 * __useInsert_UserMutation__
 *
 * To run a mutation, you first call `useInsert_UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserMutation, { data, loading, error }] = useInsert_UserMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      on_conflict: // value for 'on_conflict'
 *   },
 * });
 */
export function useInsert_UserMutation(baseOptions?: Apollo.MutationHookOptions<Insert_UserMutation, Insert_UserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_UserMutation, Insert_UserMutationVariables>(Insert_UserDocument, options);
      }
export type Insert_UserMutationHookResult = ReturnType<typeof useInsert_UserMutation>;
export type Insert_UserMutationResult = Apollo.MutationResult<Insert_UserMutation>;
export type Insert_UserMutationOptions = Apollo.BaseMutationOptions<Insert_UserMutation, Insert_UserMutationVariables>;
export const Update_User_By_PkDocument = gql`
    mutation update_user_by_pk($pk_columns: user_pk_columns_input!, $_set: user_set_input) {
  update_user_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...USER_FIELDS
  }
}
    ${User_FieldsFragmentDoc}`;
export type Update_User_By_PkMutationFn = Apollo.MutationFunction<Update_User_By_PkMutation, Update_User_By_PkMutationVariables>;

/**
 * __useUpdate_User_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_User_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_User_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByPkMutation, { data, loading, error }] = useUpdate_User_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_User_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_User_By_PkMutation, Update_User_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_User_By_PkMutation, Update_User_By_PkMutationVariables>(Update_User_By_PkDocument, options);
      }
export type Update_User_By_PkMutationHookResult = ReturnType<typeof useUpdate_User_By_PkMutation>;
export type Update_User_By_PkMutationResult = Apollo.MutationResult<Update_User_By_PkMutation>;
export type Update_User_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_User_By_PkMutation, Update_User_By_PkMutationVariables>;
export const Update_UserDocument = gql`
    mutation Update_user($where: user_bool_exp!) {
  update_user(where: $where) {
    returning {
      id
      email
      first_name
      last_name
      role
      picture
      language
    }
  }
}
    `;
export type Update_UserMutationFn = Apollo.MutationFunction<Update_UserMutation, Update_UserMutationVariables>;

/**
 * __useUpdate_UserMutation__
 *
 * To run a mutation, you first call `useUpdate_UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdate_UserMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdate_UserMutation(baseOptions?: Apollo.MutationHookOptions<Update_UserMutation, Update_UserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_UserMutation, Update_UserMutationVariables>(Update_UserDocument, options);
      }
export type Update_UserMutationHookResult = ReturnType<typeof useUpdate_UserMutation>;
export type Update_UserMutationResult = Apollo.MutationResult<Update_UserMutation>;
export type Update_UserMutationOptions = Apollo.BaseMutationOptions<Update_UserMutation, Update_UserMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($email: String, $first_name: String, $last_name: String, $picture: String, $language: String) {
  update_user_profile(
    email: $email
    first_name: $first_name
    last_name: $last_name
    picture: $picture
    language: $language
  ) {
    id
    email
    first_name
    last_name
    role
    picture
    language
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      email: // value for 'email'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      picture: // value for 'picture'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ResendTemporaryPasswordDocument = gql`
    mutation ResendTemporaryPassword($Username: String!) {
  reset_temporary_password(Username: $Username)
}
    `;
export type ResendTemporaryPasswordMutationFn = Apollo.MutationFunction<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>;

/**
 * __useResendTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useResendTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTemporaryPasswordMutation, { data, loading, error }] = useResendTemporaryPasswordMutation({
 *   variables: {
 *      Username: // value for 'Username'
 *   },
 * });
 */
export function useResendTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>(ResendTemporaryPasswordDocument, options);
      }
export type ResendTemporaryPasswordMutationHookResult = ReturnType<typeof useResendTemporaryPasswordMutation>;
export type ResendTemporaryPasswordMutationResult = Apollo.MutationResult<ResendTemporaryPasswordMutation>;
export type ResendTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>;
export const Update_User_Activity_By_PkDocument = gql`
    mutation update_user_activity_by_pk($pk_columns: user_activity_pk_columns_input!, $_set: user_activity_set_input) {
  update_user_activity_by_pk(pk_columns: $pk_columns, _set: $_set) {
    ...USER_ACTIVITY_FIELDS
  }
}
    ${User_Activity_FieldsFragmentDoc}`;
export type Update_User_Activity_By_PkMutationFn = Apollo.MutationFunction<Update_User_Activity_By_PkMutation, Update_User_Activity_By_PkMutationVariables>;

/**
 * __useUpdate_User_Activity_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_User_Activity_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_User_Activity_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActivityByPkMutation, { data, loading, error }] = useUpdate_User_Activity_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_User_Activity_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_User_Activity_By_PkMutation, Update_User_Activity_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_User_Activity_By_PkMutation, Update_User_Activity_By_PkMutationVariables>(Update_User_Activity_By_PkDocument, options);
      }
export type Update_User_Activity_By_PkMutationHookResult = ReturnType<typeof useUpdate_User_Activity_By_PkMutation>;
export type Update_User_Activity_By_PkMutationResult = Apollo.MutationResult<Update_User_Activity_By_PkMutation>;
export type Update_User_Activity_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_User_Activity_By_PkMutation, Update_User_Activity_By_PkMutationVariables>;
export const UseDeleteUserBlockDocument = gql`
    mutation useDeleteUserBlock($where: user_block_bool_exp!) {
  delete_user_block(where: $where) {
    returning {
      id
    }
  }
}
    `;
export type UseDeleteUserBlockMutationFn = Apollo.MutationFunction<UseDeleteUserBlockMutation, UseDeleteUserBlockMutationVariables>;

/**
 * __useUseDeleteUserBlockMutation__
 *
 * To run a mutation, you first call `useUseDeleteUserBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseDeleteUserBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useDeleteUserBlockMutation, { data, loading, error }] = useUseDeleteUserBlockMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseDeleteUserBlockMutation(baseOptions?: Apollo.MutationHookOptions<UseDeleteUserBlockMutation, UseDeleteUserBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseDeleteUserBlockMutation, UseDeleteUserBlockMutationVariables>(UseDeleteUserBlockDocument, options);
      }
export type UseDeleteUserBlockMutationHookResult = ReturnType<typeof useUseDeleteUserBlockMutation>;
export type UseDeleteUserBlockMutationResult = Apollo.MutationResult<UseDeleteUserBlockMutation>;
export type UseDeleteUserBlockMutationOptions = Apollo.BaseMutationOptions<UseDeleteUserBlockMutation, UseDeleteUserBlockMutationVariables>;
export const Insert_User_Group_OneDocument = gql`
    mutation insert_user_group_one($object: user_group_insert_input!) {
  insert_user_group_one(object: $object) {
    ...USER_GROUP_FIELDS
  }
}
    ${User_Group_FieldsFragmentDoc}`;
export type Insert_User_Group_OneMutationFn = Apollo.MutationFunction<Insert_User_Group_OneMutation, Insert_User_Group_OneMutationVariables>;

/**
 * __useInsert_User_Group_OneMutation__
 *
 * To run a mutation, you first call `useInsert_User_Group_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_User_Group_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserGroupOneMutation, { data, loading, error }] = useInsert_User_Group_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_User_Group_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_User_Group_OneMutation, Insert_User_Group_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_User_Group_OneMutation, Insert_User_Group_OneMutationVariables>(Insert_User_Group_OneDocument, options);
      }
export type Insert_User_Group_OneMutationHookResult = ReturnType<typeof useInsert_User_Group_OneMutation>;
export type Insert_User_Group_OneMutationResult = Apollo.MutationResult<Insert_User_Group_OneMutation>;
export type Insert_User_Group_OneMutationOptions = Apollo.BaseMutationOptions<Insert_User_Group_OneMutation, Insert_User_Group_OneMutationVariables>;
export const Insert_User_Workspace_OneDocument = gql`
    mutation insert_user_workspace_one($object: user_workspace_insert_input!) {
  insert_user_workspace_one(object: $object) {
    id
    workspace {
      id
      name
    }
  }
}
    `;
export type Insert_User_Workspace_OneMutationFn = Apollo.MutationFunction<Insert_User_Workspace_OneMutation, Insert_User_Workspace_OneMutationVariables>;

/**
 * __useInsert_User_Workspace_OneMutation__
 *
 * To run a mutation, you first call `useInsert_User_Workspace_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_User_Workspace_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserWorkspaceOneMutation, { data, loading, error }] = useInsert_User_Workspace_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_User_Workspace_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_User_Workspace_OneMutation, Insert_User_Workspace_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_User_Workspace_OneMutation, Insert_User_Workspace_OneMutationVariables>(Insert_User_Workspace_OneDocument, options);
      }
export type Insert_User_Workspace_OneMutationHookResult = ReturnType<typeof useInsert_User_Workspace_OneMutation>;
export type Insert_User_Workspace_OneMutationResult = Apollo.MutationResult<Insert_User_Workspace_OneMutation>;
export type Insert_User_Workspace_OneMutationOptions = Apollo.BaseMutationOptions<Insert_User_Workspace_OneMutation, Insert_User_Workspace_OneMutationVariables>;
export const Delete_User_WorkspaceDocument = gql`
    mutation Delete_user_workspace($where: user_workspace_bool_exp!) {
  delete_user_workspace(where: $where) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type Delete_User_WorkspaceMutationFn = Apollo.MutationFunction<Delete_User_WorkspaceMutation, Delete_User_WorkspaceMutationVariables>;

/**
 * __useDelete_User_WorkspaceMutation__
 *
 * To run a mutation, you first call `useDelete_User_WorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_User_WorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserWorkspaceMutation, { data, loading, error }] = useDelete_User_WorkspaceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDelete_User_WorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<Delete_User_WorkspaceMutation, Delete_User_WorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_User_WorkspaceMutation, Delete_User_WorkspaceMutationVariables>(Delete_User_WorkspaceDocument, options);
      }
export type Delete_User_WorkspaceMutationHookResult = ReturnType<typeof useDelete_User_WorkspaceMutation>;
export type Delete_User_WorkspaceMutationResult = Apollo.MutationResult<Delete_User_WorkspaceMutation>;
export type Delete_User_WorkspaceMutationOptions = Apollo.BaseMutationOptions<Delete_User_WorkspaceMutation, Delete_User_WorkspaceMutationVariables>;
export const Insert_Workspace_OneDocument = gql`
    mutation insert_workspace_one($object: workspace_insert_input!) {
  insert_workspace_one(object: $object) {
    id
    name
  }
}
    `;
export type Insert_Workspace_OneMutationFn = Apollo.MutationFunction<Insert_Workspace_OneMutation, Insert_Workspace_OneMutationVariables>;

/**
 * __useInsert_Workspace_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Workspace_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Workspace_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertWorkspaceOneMutation, { data, loading, error }] = useInsert_Workspace_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Workspace_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Workspace_OneMutation, Insert_Workspace_OneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Workspace_OneMutation, Insert_Workspace_OneMutationVariables>(Insert_Workspace_OneDocument, options);
      }
export type Insert_Workspace_OneMutationHookResult = ReturnType<typeof useInsert_Workspace_OneMutation>;
export type Insert_Workspace_OneMutationResult = Apollo.MutationResult<Insert_Workspace_OneMutation>;
export type Insert_Workspace_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Workspace_OneMutation, Insert_Workspace_OneMutationVariables>;
export const Update_Workspace_By_PkDocument = gql`
    mutation update_workspace_by_pk($pk_columns: workspace_pk_columns_input!, $_set: workspace_set_input) {
  update_workspace_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    name
  }
}
    `;
export type Update_Workspace_By_PkMutationFn = Apollo.MutationFunction<Update_Workspace_By_PkMutation, Update_Workspace_By_PkMutationVariables>;

/**
 * __useUpdate_Workspace_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Workspace_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Workspace_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceByPkMutation, { data, loading, error }] = useUpdate_Workspace_By_PkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_Workspace_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Workspace_By_PkMutation, Update_Workspace_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Workspace_By_PkMutation, Update_Workspace_By_PkMutationVariables>(Update_Workspace_By_PkDocument, options);
      }
export type Update_Workspace_By_PkMutationHookResult = ReturnType<typeof useUpdate_Workspace_By_PkMutation>;
export type Update_Workspace_By_PkMutationResult = Apollo.MutationResult<Update_Workspace_By_PkMutation>;
export type Update_Workspace_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Workspace_By_PkMutation, Update_Workspace_By_PkMutationVariables>;
export const ActivityDocument = gql`
    query activity($where: activity_bool_exp, $order_by: [activity_order_by!]) {
  activity(where: $where, order_by: $order_by) {
    ...ACTIVITY_FIELDS
  }
}
    ${Activity_FieldsFragmentDoc}`;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useActivityQuery(baseOptions?: Apollo.QueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
      }
export function useActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
        }
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityLazyQueryHookResult = ReturnType<typeof useActivityLazyQuery>;
export type ActivityQueryResult = Apollo.QueryResult<ActivityQuery, ActivityQueryVariables>;
export function refetchActivityQuery(variables?: ActivityQueryVariables) {
      return { query: ActivityDocument, variables: variables }
    }
export const GetActivityAggregateDocument = gql`
    query GetActivityAggregate($where: activity_bool_exp) {
  activity_aggregate(where: $where) {
    aggregate {
      max {
        order
      }
    }
  }
}
    `;

/**
 * __useGetActivityAggregateQuery__
 *
 * To run a query within a React component, call `useGetActivityAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityAggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetActivityAggregateQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityAggregateQuery, GetActivityAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityAggregateQuery, GetActivityAggregateQueryVariables>(GetActivityAggregateDocument, options);
      }
export function useGetActivityAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityAggregateQuery, GetActivityAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityAggregateQuery, GetActivityAggregateQueryVariables>(GetActivityAggregateDocument, options);
        }
export type GetActivityAggregateQueryHookResult = ReturnType<typeof useGetActivityAggregateQuery>;
export type GetActivityAggregateLazyQueryHookResult = ReturnType<typeof useGetActivityAggregateLazyQuery>;
export type GetActivityAggregateQueryResult = Apollo.QueryResult<GetActivityAggregateQuery, GetActivityAggregateQueryVariables>;
export function refetchGetActivityAggregateQuery(variables?: GetActivityAggregateQueryVariables) {
      return { query: GetActivityAggregateDocument, variables: variables }
    }
export const Activity_LayoutDocument = gql`
    query activity_layout($where: activity_layout_bool_exp, $order_by: [activity_layout_order_by!]) {
  activity_layout(where: $where, order_by: $order_by) {
    ...ACTIVITY_LAYOUT_FIELDS
  }
}
    ${Activity_Layout_FieldsFragmentDoc}`;

/**
 * __useActivity_LayoutQuery__
 *
 * To run a query within a React component, call `useActivity_LayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivity_LayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivity_LayoutQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useActivity_LayoutQuery(baseOptions?: Apollo.QueryHookOptions<Activity_LayoutQuery, Activity_LayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Activity_LayoutQuery, Activity_LayoutQueryVariables>(Activity_LayoutDocument, options);
      }
export function useActivity_LayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Activity_LayoutQuery, Activity_LayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Activity_LayoutQuery, Activity_LayoutQueryVariables>(Activity_LayoutDocument, options);
        }
export type Activity_LayoutQueryHookResult = ReturnType<typeof useActivity_LayoutQuery>;
export type Activity_LayoutLazyQueryHookResult = ReturnType<typeof useActivity_LayoutLazyQuery>;
export type Activity_LayoutQueryResult = Apollo.QueryResult<Activity_LayoutQuery, Activity_LayoutQueryVariables>;
export function refetchActivity_LayoutQuery(variables?: Activity_LayoutQueryVariables) {
      return { query: Activity_LayoutDocument, variables: variables }
    }
export const BlockDocument = gql`
    query block($limit: Int, $offset: Int, $where: block_bool_exp, $order_by: [block_order_by!]) {
  block(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...BLOCK_FIELDS
  }
}
    ${Block_FieldsFragmentDoc}`;

/**
 * __useBlockQuery__
 *
 * To run a query within a React component, call `useBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useBlockQuery(baseOptions?: Apollo.QueryHookOptions<BlockQuery, BlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
      }
export function useBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockQuery, BlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
        }
export type BlockQueryHookResult = ReturnType<typeof useBlockQuery>;
export type BlockLazyQueryHookResult = ReturnType<typeof useBlockLazyQuery>;
export type BlockQueryResult = Apollo.QueryResult<BlockQuery, BlockQueryVariables>;
export function refetchBlockQuery(variables?: BlockQueryVariables) {
      return { query: BlockDocument, variables: variables }
    }
export const Block_By_PkDocument = gql`
    query block_by_pk($id: Int!) {
  block_by_pk(id: $id) {
    ...BLOCK_FIELDS
  }
}
    ${Block_FieldsFragmentDoc}`;

/**
 * __useBlock_By_PkQuery__
 *
 * To run a query within a React component, call `useBlock_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlock_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlock_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlock_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Block_By_PkQuery, Block_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Block_By_PkQuery, Block_By_PkQueryVariables>(Block_By_PkDocument, options);
      }
export function useBlock_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Block_By_PkQuery, Block_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Block_By_PkQuery, Block_By_PkQueryVariables>(Block_By_PkDocument, options);
        }
export type Block_By_PkQueryHookResult = ReturnType<typeof useBlock_By_PkQuery>;
export type Block_By_PkLazyQueryHookResult = ReturnType<typeof useBlock_By_PkLazyQuery>;
export type Block_By_PkQueryResult = Apollo.QueryResult<Block_By_PkQuery, Block_By_PkQueryVariables>;
export function refetchBlock_By_PkQuery(variables: Block_By_PkQueryVariables) {
      return { query: Block_By_PkDocument, variables: variables }
    }
export const Block_List_ItemDocument = gql`
    query block_list_item($limit: Int, $offset: Int, $where: block_list_item_bool_exp, $order_by: [block_list_item_order_by!]) {
  block_list_item(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...BLOCK_LIST_FIELDS
  }
}
    ${Block_List_FieldsFragmentDoc}`;

/**
 * __useBlock_List_ItemQuery__
 *
 * To run a query within a React component, call `useBlock_List_ItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlock_List_ItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlock_List_ItemQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useBlock_List_ItemQuery(baseOptions?: Apollo.QueryHookOptions<Block_List_ItemQuery, Block_List_ItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Block_List_ItemQuery, Block_List_ItemQueryVariables>(Block_List_ItemDocument, options);
      }
export function useBlock_List_ItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Block_List_ItemQuery, Block_List_ItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Block_List_ItemQuery, Block_List_ItemQueryVariables>(Block_List_ItemDocument, options);
        }
export type Block_List_ItemQueryHookResult = ReturnType<typeof useBlock_List_ItemQuery>;
export type Block_List_ItemLazyQueryHookResult = ReturnType<typeof useBlock_List_ItemLazyQuery>;
export type Block_List_ItemQueryResult = Apollo.QueryResult<Block_List_ItemQuery, Block_List_ItemQueryVariables>;
export function refetchBlock_List_ItemQuery(variables?: Block_List_ItemQueryVariables) {
      return { query: Block_List_ItemDocument, variables: variables }
    }
export const Block_List_Item_AggregateDocument = gql`
    query block_list_item_aggregate($where: block_list_item_bool_exp) {
  block_list_item_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useBlock_List_Item_AggregateQuery__
 *
 * To run a query within a React component, call `useBlock_List_Item_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlock_List_Item_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlock_List_Item_AggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBlock_List_Item_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Block_List_Item_AggregateQuery, Block_List_Item_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Block_List_Item_AggregateQuery, Block_List_Item_AggregateQueryVariables>(Block_List_Item_AggregateDocument, options);
      }
export function useBlock_List_Item_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Block_List_Item_AggregateQuery, Block_List_Item_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Block_List_Item_AggregateQuery, Block_List_Item_AggregateQueryVariables>(Block_List_Item_AggregateDocument, options);
        }
export type Block_List_Item_AggregateQueryHookResult = ReturnType<typeof useBlock_List_Item_AggregateQuery>;
export type Block_List_Item_AggregateLazyQueryHookResult = ReturnType<typeof useBlock_List_Item_AggregateLazyQuery>;
export type Block_List_Item_AggregateQueryResult = Apollo.QueryResult<Block_List_Item_AggregateQuery, Block_List_Item_AggregateQueryVariables>;
export function refetchBlock_List_Item_AggregateQuery(variables?: Block_List_Item_AggregateQueryVariables) {
      return { query: Block_List_Item_AggregateDocument, variables: variables }
    }
export const GroupDocument = gql`
    query group($limit: Int, $offset: Int, $where: group_bool_exp, $order_by: [group_order_by!]) {
  group(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...GROUP_FIELDS
  }
}
    ${Group_FieldsFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGroupQuery(baseOptions?: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export function refetchGroupQuery(variables?: GroupQueryVariables) {
      return { query: GroupDocument, variables: variables }
    }
export const Group_By_PkDocument = gql`
    query group_by_pk($id: Int!) {
  group_by_pk(id: $id) {
    ...GROUP_FIELDS
  }
}
    ${Group_FieldsFragmentDoc}`;

/**
 * __useGroup_By_PkQuery__
 *
 * To run a query within a React component, call `useGroup_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroup_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroup_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroup_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Group_By_PkQuery, Group_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Group_By_PkQuery, Group_By_PkQueryVariables>(Group_By_PkDocument, options);
      }
export function useGroup_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Group_By_PkQuery, Group_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Group_By_PkQuery, Group_By_PkQueryVariables>(Group_By_PkDocument, options);
        }
export type Group_By_PkQueryHookResult = ReturnType<typeof useGroup_By_PkQuery>;
export type Group_By_PkLazyQueryHookResult = ReturnType<typeof useGroup_By_PkLazyQuery>;
export type Group_By_PkQueryResult = Apollo.QueryResult<Group_By_PkQuery, Group_By_PkQueryVariables>;
export function refetchGroup_By_PkQuery(variables: Group_By_PkQueryVariables) {
      return { query: Group_By_PkDocument, variables: variables }
    }
export const Group_AggregateDocument = gql`
    query group_aggregate {
  group_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGroup_AggregateQuery__
 *
 * To run a query within a React component, call `useGroup_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroup_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroup_AggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroup_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Group_AggregateQuery, Group_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Group_AggregateQuery, Group_AggregateQueryVariables>(Group_AggregateDocument, options);
      }
export function useGroup_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Group_AggregateQuery, Group_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Group_AggregateQuery, Group_AggregateQueryVariables>(Group_AggregateDocument, options);
        }
export type Group_AggregateQueryHookResult = ReturnType<typeof useGroup_AggregateQuery>;
export type Group_AggregateLazyQueryHookResult = ReturnType<typeof useGroup_AggregateLazyQuery>;
export type Group_AggregateQueryResult = Apollo.QueryResult<Group_AggregateQuery, Group_AggregateQueryVariables>;
export function refetchGroup_AggregateQuery(variables?: Group_AggregateQueryVariables) {
      return { query: Group_AggregateDocument, variables: variables }
    }
export const Group_WorkspaceDocument = gql`
    query group_workspace($limit: Int, $offset: Int, $where: group_workspace_bool_exp, $order_by: [group_workspace_order_by!]) {
  group_workspace(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    id
    workspace {
      id
      name
    }
  }
}
    `;

/**
 * __useGroup_WorkspaceQuery__
 *
 * To run a query within a React component, call `useGroup_WorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroup_WorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroup_WorkspaceQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGroup_WorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<Group_WorkspaceQuery, Group_WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Group_WorkspaceQuery, Group_WorkspaceQueryVariables>(Group_WorkspaceDocument, options);
      }
export function useGroup_WorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Group_WorkspaceQuery, Group_WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Group_WorkspaceQuery, Group_WorkspaceQueryVariables>(Group_WorkspaceDocument, options);
        }
export type Group_WorkspaceQueryHookResult = ReturnType<typeof useGroup_WorkspaceQuery>;
export type Group_WorkspaceLazyQueryHookResult = ReturnType<typeof useGroup_WorkspaceLazyQuery>;
export type Group_WorkspaceQueryResult = Apollo.QueryResult<Group_WorkspaceQuery, Group_WorkspaceQueryVariables>;
export function refetchGroup_WorkspaceQuery(variables?: Group_WorkspaceQueryVariables) {
      return { query: Group_WorkspaceDocument, variables: variables }
    }
export const GetOrganizationDocument = gql`
    query GetOrganization {
  organization {
    config
    tier
    type
    uid
    name
    id
    gid
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function refetchGetOrganizationQuery(variables?: GetOrganizationQueryVariables) {
      return { query: GetOrganizationDocument, variables: variables }
    }
export const QuestionDocument = gql`
    query question($where: question_bool_exp, $order_by: [question_order_by!], $limit: Int, $offset: Int) {
  question(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
    ...QUESTION_FIELDS
  }
}
    ${Question_FieldsFragmentDoc}`;

/**
 * __useQuestionQuery__
 *
 * To run a query within a React component, call `useQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQuestionQuery(baseOptions?: Apollo.QueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
      }
export function useQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export type QuestionQueryHookResult = ReturnType<typeof useQuestionQuery>;
export type QuestionLazyQueryHookResult = ReturnType<typeof useQuestionLazyQuery>;
export type QuestionQueryResult = Apollo.QueryResult<QuestionQuery, QuestionQueryVariables>;
export function refetchQuestionQuery(variables?: QuestionQueryVariables) {
      return { query: QuestionDocument, variables: variables }
    }
export const Question_OptionDocument = gql`
    query question_option($where: question_option_bool_exp, $order_by: [question_option_order_by!]) {
  question_option(where: $where, order_by: $order_by) {
    ...QUESTION_OPTION_FIELDS
  }
}
    ${Question_Option_FieldsFragmentDoc}`;

/**
 * __useQuestion_OptionQuery__
 *
 * To run a query within a React component, call `useQuestion_OptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion_OptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion_OptionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useQuestion_OptionQuery(baseOptions?: Apollo.QueryHookOptions<Question_OptionQuery, Question_OptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question_OptionQuery, Question_OptionQueryVariables>(Question_OptionDocument, options);
      }
export function useQuestion_OptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question_OptionQuery, Question_OptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question_OptionQuery, Question_OptionQueryVariables>(Question_OptionDocument, options);
        }
export type Question_OptionQueryHookResult = ReturnType<typeof useQuestion_OptionQuery>;
export type Question_OptionLazyQueryHookResult = ReturnType<typeof useQuestion_OptionLazyQuery>;
export type Question_OptionQueryResult = Apollo.QueryResult<Question_OptionQuery, Question_OptionQueryVariables>;
export function refetchQuestion_OptionQuery(variables?: Question_OptionQueryVariables) {
      return { query: Question_OptionDocument, variables: variables }
    }
export const Question_Option_By_PkDocument = gql`
    query question_option_by_pk($id: Int!) {
  question_option_by_pk(id: $id) {
    ...QUESTION_OPTION_FIELDS
  }
}
    ${Question_Option_FieldsFragmentDoc}`;

/**
 * __useQuestion_Option_By_PkQuery__
 *
 * To run a query within a React component, call `useQuestion_Option_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion_Option_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion_Option_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuestion_Option_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Question_Option_By_PkQuery, Question_Option_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question_Option_By_PkQuery, Question_Option_By_PkQueryVariables>(Question_Option_By_PkDocument, options);
      }
export function useQuestion_Option_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question_Option_By_PkQuery, Question_Option_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question_Option_By_PkQuery, Question_Option_By_PkQueryVariables>(Question_Option_By_PkDocument, options);
        }
export type Question_Option_By_PkQueryHookResult = ReturnType<typeof useQuestion_Option_By_PkQuery>;
export type Question_Option_By_PkLazyQueryHookResult = ReturnType<typeof useQuestion_Option_By_PkLazyQuery>;
export type Question_Option_By_PkQueryResult = Apollo.QueryResult<Question_Option_By_PkQuery, Question_Option_By_PkQueryVariables>;
export function refetchQuestion_Option_By_PkQuery(variables: Question_Option_By_PkQueryVariables) {
      return { query: Question_Option_By_PkDocument, variables: variables }
    }
export const Question_QuizDocument = gql`
    query question_quiz($limit: Int, $offset: Int, $where: question_quiz_bool_exp, $order_by: [question_quiz_order_by!]) {
  question_quiz(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    id
    order
    question {
      ...QUESTION_QUIZ_FIELDS
    }
    quiz {
      id
    }
  }
}
    ${Question_Quiz_FieldsFragmentDoc}`;

/**
 * __useQuestion_QuizQuery__
 *
 * To run a query within a React component, call `useQuestion_QuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion_QuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion_QuizQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useQuestion_QuizQuery(baseOptions?: Apollo.QueryHookOptions<Question_QuizQuery, Question_QuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question_QuizQuery, Question_QuizQueryVariables>(Question_QuizDocument, options);
      }
export function useQuestion_QuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question_QuizQuery, Question_QuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question_QuizQuery, Question_QuizQueryVariables>(Question_QuizDocument, options);
        }
export type Question_QuizQueryHookResult = ReturnType<typeof useQuestion_QuizQuery>;
export type Question_QuizLazyQueryHookResult = ReturnType<typeof useQuestion_QuizLazyQuery>;
export type Question_QuizQueryResult = Apollo.QueryResult<Question_QuizQuery, Question_QuizQueryVariables>;
export function refetchQuestion_QuizQuery(variables?: Question_QuizQueryVariables) {
      return { query: Question_QuizDocument, variables: variables }
    }
export const Question_Quiz_By_PkDocument = gql`
    query Question_quiz_by_pk($id: Int!) {
  question_quiz_by_pk(id: $id) {
    id
    order
    question {
      ...QUESTION_QUIZ_FIELDS
    }
    quiz {
      id
    }
  }
}
    ${Question_Quiz_FieldsFragmentDoc}`;

/**
 * __useQuestion_Quiz_By_PkQuery__
 *
 * To run a query within a React component, call `useQuestion_Quiz_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion_Quiz_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion_Quiz_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuestion_Quiz_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Question_Quiz_By_PkQuery, Question_Quiz_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question_Quiz_By_PkQuery, Question_Quiz_By_PkQueryVariables>(Question_Quiz_By_PkDocument, options);
      }
export function useQuestion_Quiz_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question_Quiz_By_PkQuery, Question_Quiz_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question_Quiz_By_PkQuery, Question_Quiz_By_PkQueryVariables>(Question_Quiz_By_PkDocument, options);
        }
export type Question_Quiz_By_PkQueryHookResult = ReturnType<typeof useQuestion_Quiz_By_PkQuery>;
export type Question_Quiz_By_PkLazyQueryHookResult = ReturnType<typeof useQuestion_Quiz_By_PkLazyQuery>;
export type Question_Quiz_By_PkQueryResult = Apollo.QueryResult<Question_Quiz_By_PkQuery, Question_Quiz_By_PkQueryVariables>;
export function refetchQuestion_Quiz_By_PkQuery(variables: Question_Quiz_By_PkQueryVariables) {
      return { query: Question_Quiz_By_PkDocument, variables: variables }
    }
export const Question_Quiz_AggregateDocument = gql`
    query Question_quiz_aggregate($where: question_quiz_bool_exp) {
  question_quiz_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useQuestion_Quiz_AggregateQuery__
 *
 * To run a query within a React component, call `useQuestion_Quiz_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion_Quiz_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion_Quiz_AggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuestion_Quiz_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Question_Quiz_AggregateQuery, Question_Quiz_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question_Quiz_AggregateQuery, Question_Quiz_AggregateQueryVariables>(Question_Quiz_AggregateDocument, options);
      }
export function useQuestion_Quiz_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question_Quiz_AggregateQuery, Question_Quiz_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question_Quiz_AggregateQuery, Question_Quiz_AggregateQueryVariables>(Question_Quiz_AggregateDocument, options);
        }
export type Question_Quiz_AggregateQueryHookResult = ReturnType<typeof useQuestion_Quiz_AggregateQuery>;
export type Question_Quiz_AggregateLazyQueryHookResult = ReturnType<typeof useQuestion_Quiz_AggregateLazyQuery>;
export type Question_Quiz_AggregateQueryResult = Apollo.QueryResult<Question_Quiz_AggregateQuery, Question_Quiz_AggregateQueryVariables>;
export function refetchQuestion_Quiz_AggregateQuery(variables?: Question_Quiz_AggregateQueryVariables) {
      return { query: Question_Quiz_AggregateDocument, variables: variables }
    }
export const GetQuestionQuizManyForClientDocument = gql`
    query GetQuestionQuizManyForClient($where: question_quiz_bool_exp, $order_by: [question_quiz_order_by!]) {
  question_quiz(where: $where, order_by: $order_by) {
    id
    order
    question {
      ...QUESTION_BASE_FIELDS
      media {
        ...MEDIA_FIELDS
      }
      question_options {
        ...QUESTION_OPTION_BASE_FIELDS
        media {
          ...MEDIA_FIELDS
        }
      }
    }
    quiz {
      id
    }
  }
}
    ${Question_Base_FieldsFragmentDoc}
${Media_FieldsFragmentDoc}
${Question_Option_Base_FieldsFragmentDoc}`;

/**
 * __useGetQuestionQuizManyForClientQuery__
 *
 * To run a query within a React component, call `useGetQuestionQuizManyForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuizManyForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionQuizManyForClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetQuestionQuizManyForClientQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionQuizManyForClientQuery, GetQuestionQuizManyForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionQuizManyForClientQuery, GetQuestionQuizManyForClientQueryVariables>(GetQuestionQuizManyForClientDocument, options);
      }
export function useGetQuestionQuizManyForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionQuizManyForClientQuery, GetQuestionQuizManyForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionQuizManyForClientQuery, GetQuestionQuizManyForClientQueryVariables>(GetQuestionQuizManyForClientDocument, options);
        }
export type GetQuestionQuizManyForClientQueryHookResult = ReturnType<typeof useGetQuestionQuizManyForClientQuery>;
export type GetQuestionQuizManyForClientLazyQueryHookResult = ReturnType<typeof useGetQuestionQuizManyForClientLazyQuery>;
export type GetQuestionQuizManyForClientQueryResult = Apollo.QueryResult<GetQuestionQuizManyForClientQuery, GetQuestionQuizManyForClientQueryVariables>;
export function refetchGetQuestionQuizManyForClientQuery(variables?: GetQuestionQuizManyForClientQueryVariables) {
      return { query: GetQuestionQuizManyForClientDocument, variables: variables }
    }
export const QuizDocument = gql`
    query quiz($limit: Int, $offset: Int, $where: quiz_bool_exp, $order_by: [quiz_order_by!]) {
  quiz(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...QUIZ_FIELDS
  }
}
    ${Quiz_FieldsFragmentDoc}`;

/**
 * __useQuizQuery__
 *
 * To run a query within a React component, call `useQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useQuizQuery(baseOptions?: Apollo.QueryHookOptions<QuizQuery, QuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizQuery, QuizQueryVariables>(QuizDocument, options);
      }
export function useQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizQuery, QuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizQuery, QuizQueryVariables>(QuizDocument, options);
        }
export type QuizQueryHookResult = ReturnType<typeof useQuizQuery>;
export type QuizLazyQueryHookResult = ReturnType<typeof useQuizLazyQuery>;
export type QuizQueryResult = Apollo.QueryResult<QuizQuery, QuizQueryVariables>;
export function refetchQuizQuery(variables?: QuizQueryVariables) {
      return { query: QuizDocument, variables: variables }
    }
export const Quiz_By_PkDocument = gql`
    query quiz_by_pk($id: Int!) {
  quiz_by_pk(id: $id) {
    ...QUIZ_FIELDS
  }
}
    ${Quiz_FieldsFragmentDoc}`;

/**
 * __useQuiz_By_PkQuery__
 *
 * To run a query within a React component, call `useQuiz_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuiz_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuiz_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuiz_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Quiz_By_PkQuery, Quiz_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Quiz_By_PkQuery, Quiz_By_PkQueryVariables>(Quiz_By_PkDocument, options);
      }
export function useQuiz_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Quiz_By_PkQuery, Quiz_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Quiz_By_PkQuery, Quiz_By_PkQueryVariables>(Quiz_By_PkDocument, options);
        }
export type Quiz_By_PkQueryHookResult = ReturnType<typeof useQuiz_By_PkQuery>;
export type Quiz_By_PkLazyQueryHookResult = ReturnType<typeof useQuiz_By_PkLazyQuery>;
export type Quiz_By_PkQueryResult = Apollo.QueryResult<Quiz_By_PkQuery, Quiz_By_PkQueryVariables>;
export function refetchQuiz_By_PkQuery(variables: Quiz_By_PkQueryVariables) {
      return { query: Quiz_By_PkDocument, variables: variables }
    }
export const Quiz_AggregateDocument = gql`
    query quiz_aggregate {
  quiz_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useQuiz_AggregateQuery__
 *
 * To run a query within a React component, call `useQuiz_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuiz_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuiz_AggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuiz_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Quiz_AggregateQuery, Quiz_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Quiz_AggregateQuery, Quiz_AggregateQueryVariables>(Quiz_AggregateDocument, options);
      }
export function useQuiz_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Quiz_AggregateQuery, Quiz_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Quiz_AggregateQuery, Quiz_AggregateQueryVariables>(Quiz_AggregateDocument, options);
        }
export type Quiz_AggregateQueryHookResult = ReturnType<typeof useQuiz_AggregateQuery>;
export type Quiz_AggregateLazyQueryHookResult = ReturnType<typeof useQuiz_AggregateLazyQuery>;
export type Quiz_AggregateQueryResult = Apollo.QueryResult<Quiz_AggregateQuery, Quiz_AggregateQueryVariables>;
export function refetchQuiz_AggregateQuery(variables?: Quiz_AggregateQueryVariables) {
      return { query: Quiz_AggregateDocument, variables: variables }
    }
export const TagDocument = gql`
    query tag($limit: Int, $offset: Int, $where: tag_bool_exp, $order_by: [tag_order_by!]) {
  tag(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    label
  }
}
    `;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useTagQuery(baseOptions?: Apollo.QueryHookOptions<TagQuery, TagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export function refetchTagQuery(variables?: TagQueryVariables) {
      return { query: TagDocument, variables: variables }
    }
export const Text_By_PkDocument = gql`
    query text_by_pk($id: Int!) {
  text_by_pk(id: $id) {
    ...TEXT_FIELDS
  }
}
    ${Text_FieldsFragmentDoc}`;

/**
 * __useText_By_PkQuery__
 *
 * To run a query within a React component, call `useText_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useText_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useText_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useText_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Text_By_PkQuery, Text_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Text_By_PkQuery, Text_By_PkQueryVariables>(Text_By_PkDocument, options);
      }
export function useText_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Text_By_PkQuery, Text_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Text_By_PkQuery, Text_By_PkQueryVariables>(Text_By_PkDocument, options);
        }
export type Text_By_PkQueryHookResult = ReturnType<typeof useText_By_PkQuery>;
export type Text_By_PkLazyQueryHookResult = ReturnType<typeof useText_By_PkLazyQuery>;
export type Text_By_PkQueryResult = Apollo.QueryResult<Text_By_PkQuery, Text_By_PkQueryVariables>;
export function refetchText_By_PkQuery(variables: Text_By_PkQueryVariables) {
      return { query: Text_By_PkDocument, variables: variables }
    }
export const TextDocument = gql`
    query text($limit: Int, $offset: Int, $where: text_bool_exp, $order_by: [text_order_by!]) {
  text(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...TEXT_FIELDS
  }
}
    ${Text_FieldsFragmentDoc}`;

/**
 * __useTextQuery__
 *
 * To run a query within a React component, call `useTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTextQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useTextQuery(baseOptions?: Apollo.QueryHookOptions<TextQuery, TextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TextQuery, TextQueryVariables>(TextDocument, options);
      }
export function useTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TextQuery, TextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TextQuery, TextQueryVariables>(TextDocument, options);
        }
export type TextQueryHookResult = ReturnType<typeof useTextQuery>;
export type TextLazyQueryHookResult = ReturnType<typeof useTextLazyQuery>;
export type TextQueryResult = Apollo.QueryResult<TextQuery, TextQueryVariables>;
export function refetchTextQuery(variables?: TextQueryVariables) {
      return { query: TextDocument, variables: variables }
    }
export const Text_AggregateDocument = gql`
    query text_aggregate {
  text_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useText_AggregateQuery__
 *
 * To run a query within a React component, call `useText_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useText_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useText_AggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useText_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Text_AggregateQuery, Text_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Text_AggregateQuery, Text_AggregateQueryVariables>(Text_AggregateDocument, options);
      }
export function useText_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Text_AggregateQuery, Text_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Text_AggregateQuery, Text_AggregateQueryVariables>(Text_AggregateDocument, options);
        }
export type Text_AggregateQueryHookResult = ReturnType<typeof useText_AggregateQuery>;
export type Text_AggregateLazyQueryHookResult = ReturnType<typeof useText_AggregateLazyQuery>;
export type Text_AggregateQueryResult = Apollo.QueryResult<Text_AggregateQuery, Text_AggregateQueryVariables>;
export function refetchText_AggregateQuery(variables?: Text_AggregateQueryVariables) {
      return { query: Text_AggregateDocument, variables: variables }
    }
export const UserDocument = gql`
    query user($limit: Int, $offset: Int, $where: user_bool_exp, $order_by: [user_order_by!]) {
  user(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...USER_FIELDS
  }
}
    ${User_FieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables?: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query GetUsers($limit: Int, $offset: Int, $where: user_bool_exp, $order_by: [user_order_by!]) {
  user(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...USER_FIELDS
  }
}
    ${User_FieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const User_By_PkDocument = gql`
    query user_by_pk($id: Int!) {
  user_by_pk(id: $id) {
    ...USER_FIELDS
  }
}
    ${User_FieldsFragmentDoc}`;

/**
 * __useUser_By_PkQuery__
 *
 * To run a query within a React component, call `useUser_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUser_By_PkQuery(baseOptions: Apollo.QueryHookOptions<User_By_PkQuery, User_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_By_PkQuery, User_By_PkQueryVariables>(User_By_PkDocument, options);
      }
export function useUser_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_By_PkQuery, User_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_By_PkQuery, User_By_PkQueryVariables>(User_By_PkDocument, options);
        }
export type User_By_PkQueryHookResult = ReturnType<typeof useUser_By_PkQuery>;
export type User_By_PkLazyQueryHookResult = ReturnType<typeof useUser_By_PkLazyQuery>;
export type User_By_PkQueryResult = Apollo.QueryResult<User_By_PkQuery, User_By_PkQueryVariables>;
export function refetchUser_By_PkQuery(variables: User_By_PkQueryVariables) {
      return { query: User_By_PkDocument, variables: variables }
    }
export const Get_User_ProfileDocument = gql`
    query get_user_profile {
  get_user_profile {
    id
    email
    first_name
    last_name
    role
    picture
    language
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGet_User_ProfileQuery__
 *
 * To run a query within a React component, call `useGet_User_ProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_User_ProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_User_ProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_User_ProfileQuery(baseOptions?: Apollo.QueryHookOptions<Get_User_ProfileQuery, Get_User_ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_User_ProfileQuery, Get_User_ProfileQueryVariables>(Get_User_ProfileDocument, options);
      }
export function useGet_User_ProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_User_ProfileQuery, Get_User_ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_User_ProfileQuery, Get_User_ProfileQueryVariables>(Get_User_ProfileDocument, options);
        }
export type Get_User_ProfileQueryHookResult = ReturnType<typeof useGet_User_ProfileQuery>;
export type Get_User_ProfileLazyQueryHookResult = ReturnType<typeof useGet_User_ProfileLazyQuery>;
export type Get_User_ProfileQueryResult = Apollo.QueryResult<Get_User_ProfileQuery, Get_User_ProfileQueryVariables>;
export function refetchGet_User_ProfileQuery(variables?: Get_User_ProfileQueryVariables) {
      return { query: Get_User_ProfileDocument, variables: variables }
    }
export const GetUserProfileDocument = gql`
    query GetUserProfile {
  get_user_profile {
    id
    email
    first_name
    last_name
    role
    picture
    language
    organization {
      id
      name
      tier
      config
    }
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export function refetchGetUserProfileQuery(variables?: GetUserProfileQueryVariables) {
      return { query: GetUserProfileDocument, variables: variables }
    }
export const User_AggregateDocument = gql`
    query user_aggregate {
  user_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUser_AggregateQuery__
 *
 * To run a query within a React component, call `useUser_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_AggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useUser_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<User_AggregateQuery, User_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_AggregateQuery, User_AggregateQueryVariables>(User_AggregateDocument, options);
      }
export function useUser_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_AggregateQuery, User_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_AggregateQuery, User_AggregateQueryVariables>(User_AggregateDocument, options);
        }
export type User_AggregateQueryHookResult = ReturnType<typeof useUser_AggregateQuery>;
export type User_AggregateLazyQueryHookResult = ReturnType<typeof useUser_AggregateLazyQuery>;
export type User_AggregateQueryResult = Apollo.QueryResult<User_AggregateQuery, User_AggregateQueryVariables>;
export function refetchUser_AggregateQuery(variables?: User_AggregateQueryVariables) {
      return { query: User_AggregateDocument, variables: variables }
    }
export const UserAggregateDocument = gql`
    query UserAggregate($where: user_bool_exp) {
  user_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUserAggregateQuery__
 *
 * To run a query within a React component, call `useUserAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserAggregateQuery(baseOptions?: Apollo.QueryHookOptions<UserAggregateQuery, UserAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAggregateQuery, UserAggregateQueryVariables>(UserAggregateDocument, options);
      }
export function useUserAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAggregateQuery, UserAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAggregateQuery, UserAggregateQueryVariables>(UserAggregateDocument, options);
        }
export type UserAggregateQueryHookResult = ReturnType<typeof useUserAggregateQuery>;
export type UserAggregateLazyQueryHookResult = ReturnType<typeof useUserAggregateLazyQuery>;
export type UserAggregateQueryResult = Apollo.QueryResult<UserAggregateQuery, UserAggregateQueryVariables>;
export function refetchUserAggregateQuery(variables?: UserAggregateQueryVariables) {
      return { query: UserAggregateDocument, variables: variables }
    }
export const GetUsersCountDocument = gql`
    query getUsersCount($where: user_bool_exp!) {
  user_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUsersCountQuery__
 *
 * To run a query within a React component, call `useGetUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersCountQuery(baseOptions: Apollo.QueryHookOptions<GetUsersCountQuery, GetUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersCountQuery, GetUsersCountQueryVariables>(GetUsersCountDocument, options);
      }
export function useGetUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersCountQuery, GetUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersCountQuery, GetUsersCountQueryVariables>(GetUsersCountDocument, options);
        }
export type GetUsersCountQueryHookResult = ReturnType<typeof useGetUsersCountQuery>;
export type GetUsersCountLazyQueryHookResult = ReturnType<typeof useGetUsersCountLazyQuery>;
export type GetUsersCountQueryResult = Apollo.QueryResult<GetUsersCountQuery, GetUsersCountQueryVariables>;
export function refetchGetUsersCountQuery(variables: GetUsersCountQueryVariables) {
      return { query: GetUsersCountDocument, variables: variables }
    }
export const GetUsersAccountDocument = gql`
    query GetUsersAccount($Limit: Int = 10, $UsernameFilter: String, $PaginationToken: String) {
  list_cognito_users(
    Limit: $Limit
    UsernameFilter: $UsernameFilter
    PaginationToken: $PaginationToken
  ) {
    PaginationToken
    users {
      Username
      UserStatus
      UserCreateDate
      UserLastModifiedDate
      Attributes {
        Name
        Value
      }
    }
  }
}
    `;

/**
 * __useGetUsersAccountQuery__
 *
 * To run a query within a React component, call `useGetUsersAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersAccountQuery({
 *   variables: {
 *      Limit: // value for 'Limit'
 *      UsernameFilter: // value for 'UsernameFilter'
 *      PaginationToken: // value for 'PaginationToken'
 *   },
 * });
 */
export function useGetUsersAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersAccountQuery, GetUsersAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersAccountQuery, GetUsersAccountQueryVariables>(GetUsersAccountDocument, options);
      }
export function useGetUsersAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersAccountQuery, GetUsersAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersAccountQuery, GetUsersAccountQueryVariables>(GetUsersAccountDocument, options);
        }
export type GetUsersAccountQueryHookResult = ReturnType<typeof useGetUsersAccountQuery>;
export type GetUsersAccountLazyQueryHookResult = ReturnType<typeof useGetUsersAccountLazyQuery>;
export type GetUsersAccountQueryResult = Apollo.QueryResult<GetUsersAccountQuery, GetUsersAccountQueryVariables>;
export function refetchGetUsersAccountQuery(variables?: GetUsersAccountQueryVariables) {
      return { query: GetUsersAccountDocument, variables: variables }
    }
export const User_ActivityDocument = gql`
    query user_activity($where: user_activity_bool_exp) {
  user_activity(where: $where) {
    ...USER_ACTIVITY_FIELDS
  }
}
    ${User_Activity_FieldsFragmentDoc}`;

/**
 * __useUser_ActivityQuery__
 *
 * To run a query within a React component, call `useUser_ActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_ActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_ActivityQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUser_ActivityQuery(baseOptions?: Apollo.QueryHookOptions<User_ActivityQuery, User_ActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_ActivityQuery, User_ActivityQueryVariables>(User_ActivityDocument, options);
      }
export function useUser_ActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_ActivityQuery, User_ActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_ActivityQuery, User_ActivityQueryVariables>(User_ActivityDocument, options);
        }
export type User_ActivityQueryHookResult = ReturnType<typeof useUser_ActivityQuery>;
export type User_ActivityLazyQueryHookResult = ReturnType<typeof useUser_ActivityLazyQuery>;
export type User_ActivityQueryResult = Apollo.QueryResult<User_ActivityQuery, User_ActivityQueryVariables>;
export function refetchUser_ActivityQuery(variables?: User_ActivityQueryVariables) {
      return { query: User_ActivityDocument, variables: variables }
    }
export const User_GroupDocument = gql`
    query user_group($limit: Int, $offset: Int, $where: user_group_bool_exp, $order_by: [user_group_order_by!]) {
  user_group(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...USER_GROUP_FIELDS
  }
}
    ${User_Group_FieldsFragmentDoc}`;

/**
 * __useUser_GroupQuery__
 *
 * To run a query within a React component, call `useUser_GroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_GroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_GroupQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useUser_GroupQuery(baseOptions?: Apollo.QueryHookOptions<User_GroupQuery, User_GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_GroupQuery, User_GroupQueryVariables>(User_GroupDocument, options);
      }
export function useUser_GroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_GroupQuery, User_GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_GroupQuery, User_GroupQueryVariables>(User_GroupDocument, options);
        }
export type User_GroupQueryHookResult = ReturnType<typeof useUser_GroupQuery>;
export type User_GroupLazyQueryHookResult = ReturnType<typeof useUser_GroupLazyQuery>;
export type User_GroupQueryResult = Apollo.QueryResult<User_GroupQuery, User_GroupQueryVariables>;
export function refetchUser_GroupQuery(variables?: User_GroupQueryVariables) {
      return { query: User_GroupDocument, variables: variables }
    }
export const User_WorkspaceDocument = gql`
    query user_workspace($limit: Int, $offset: Int, $where: user_workspace_bool_exp, $order_by: [user_workspace_order_by!]) {
  user_workspace(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    id
    workspace {
      id
      name
    }
  }
}
    `;

/**
 * __useUser_WorkspaceQuery__
 *
 * To run a query within a React component, call `useUser_WorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_WorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_WorkspaceQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useUser_WorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<User_WorkspaceQuery, User_WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_WorkspaceQuery, User_WorkspaceQueryVariables>(User_WorkspaceDocument, options);
      }
export function useUser_WorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_WorkspaceQuery, User_WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_WorkspaceQuery, User_WorkspaceQueryVariables>(User_WorkspaceDocument, options);
        }
export type User_WorkspaceQueryHookResult = ReturnType<typeof useUser_WorkspaceQuery>;
export type User_WorkspaceLazyQueryHookResult = ReturnType<typeof useUser_WorkspaceLazyQuery>;
export type User_WorkspaceQueryResult = Apollo.QueryResult<User_WorkspaceQuery, User_WorkspaceQueryVariables>;
export function refetchUser_WorkspaceQuery(variables?: User_WorkspaceQueryVariables) {
      return { query: User_WorkspaceDocument, variables: variables }
    }
export const WorkspaceDocument = gql`
    query workspace($limit: Int, $offset: Int, $where: workspace_bool_exp, $order_by: [workspace_order_by!]) {
  workspace(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    name
  }
}
    `;

/**
 * __useWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
      }
export function useWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export type WorkspaceQueryHookResult = ReturnType<typeof useWorkspaceQuery>;
export type WorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceLazyQuery>;
export type WorkspaceQueryResult = Apollo.QueryResult<WorkspaceQuery, WorkspaceQueryVariables>;
export function refetchWorkspaceQuery(variables?: WorkspaceQueryVariables) {
      return { query: WorkspaceDocument, variables: variables }
    }
export const Workspace_By_PkDocument = gql`
    query workspace_by_pk($id: Int!) {
  workspace_by_pk(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useWorkspace_By_PkQuery__
 *
 * To run a query within a React component, call `useWorkspace_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspace_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspace_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspace_By_PkQuery(baseOptions: Apollo.QueryHookOptions<Workspace_By_PkQuery, Workspace_By_PkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Workspace_By_PkQuery, Workspace_By_PkQueryVariables>(Workspace_By_PkDocument, options);
      }
export function useWorkspace_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Workspace_By_PkQuery, Workspace_By_PkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Workspace_By_PkQuery, Workspace_By_PkQueryVariables>(Workspace_By_PkDocument, options);
        }
export type Workspace_By_PkQueryHookResult = ReturnType<typeof useWorkspace_By_PkQuery>;
export type Workspace_By_PkLazyQueryHookResult = ReturnType<typeof useWorkspace_By_PkLazyQuery>;
export type Workspace_By_PkQueryResult = Apollo.QueryResult<Workspace_By_PkQuery, Workspace_By_PkQueryVariables>;
export function refetchWorkspace_By_PkQuery(variables: Workspace_By_PkQueryVariables) {
      return { query: Workspace_By_PkDocument, variables: variables }
    }
export const Workspace_AggregateDocument = gql`
    query workspace_aggregate {
  workspace_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useWorkspace_AggregateQuery__
 *
 * To run a query within a React component, call `useWorkspace_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspace_AggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspace_AggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspace_AggregateQuery(baseOptions?: Apollo.QueryHookOptions<Workspace_AggregateQuery, Workspace_AggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Workspace_AggregateQuery, Workspace_AggregateQueryVariables>(Workspace_AggregateDocument, options);
      }
export function useWorkspace_AggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Workspace_AggregateQuery, Workspace_AggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Workspace_AggregateQuery, Workspace_AggregateQueryVariables>(Workspace_AggregateDocument, options);
        }
export type Workspace_AggregateQueryHookResult = ReturnType<typeof useWorkspace_AggregateQuery>;
export type Workspace_AggregateLazyQueryHookResult = ReturnType<typeof useWorkspace_AggregateLazyQuery>;
export type Workspace_AggregateQueryResult = Apollo.QueryResult<Workspace_AggregateQuery, Workspace_AggregateQueryVariables>;
export function refetchWorkspace_AggregateQuery(variables?: Workspace_AggregateQueryVariables) {
      return { query: Workspace_AggregateDocument, variables: variables }
    }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    